(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7005],{

/***/ 65637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _image_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39489);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70542);
/* harmony import */ var _ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69152);
/* harmony import */ var _services_upgradeService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70098);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64036);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18517);
/* harmony import */ var _Redux_actions_cartAction__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35311);
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);















var ErrorInformation = function ErrorInformation(_ref) {
  var type = _ref.type,
      title = _ref.title,
      subtitle = _ref.subtitle,
      desc = _ref.desc,
      btnLabel = _ref.btnLabel,
      className = _ref.className,
      id = _ref.id,
      onClickHandler = _ref.onClickHandler,
      formName = _ref.formName,
      multicartFlag = _ref.multicartFlag,
      phoneNumber = _ref.phoneNumber,
      selectedPreference = _ref.selectedPreference,
      dealProducts = _ref.dealProducts,
      showGuestCart = _ref.showGuestCart;
  var cartId = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_6__/* .getCookieValue */ .Do)("cart_id");
  var defaultTitle,
      defaultBtnLabel,
      secondaryBtnLabel,
      btnType,
      btnTypeSecondary,
      primaryUrl = "/",
      secondaryUrl = "/";

  switch (type) {
    case "default":
      defaultTitle = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].errors.lbl_something_went_wrong */ .Z.errors.lbl_something_went_wrong;
      defaultBtnLabel = "Try again";
      break;

    case "success":
      if (multicartFlag || selectedPreference === "all-above") {
        btnType = null;

        if (selectedPreference === "all-above") {
          primaryUrl = "/checkout";
          defaultBtnLabel = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_continue_with_checkout */ .Z.lbl_continue_with_checkout;
          secondaryBtnLabel = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_exit_checkout.desktop */ .Z.lbl_exit_checkout.desktop;
          btnTypeSecondary = "success-exit";
        } else {
          primaryUrl = "/";
          defaultBtnLabel = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_exit_checkout.desktop */ .Z.lbl_exit_checkout.desktop;
        }
      } else {
        defaultTitle = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].errors.lbl_contact_soon */ .Z.errors.lbl_contact_soon;
        defaultBtnLabel = "Go to home page";
        btnType = "success-btn";
      }

      break;

    case "submit-error":
      defaultTitle = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].errors.lbl_form_not_submitted */ .Z.errors.lbl_form_not_submitted;
      desc = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].errors.lbl_try_again */ .Z.errors.lbl_try_again;
      defaultBtnLabel = "Go to home page";
      btnType = "outline-black";
      break;

    case "otp-error":
      defaultTitle = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.lbl_invalid_otp_try_3_title */ .Z.upgrade.lbl_invalid_otp_try_3_title;
      desc = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].upgrade.lbl_invalid_otp_try_3_btn_title */ .Z.upgrade.lbl_invalid_otp_try_3_btn_title;
      defaultBtnLabel = "Go to home page";
      btnType = "outline-black";
      break;

    default:
      defaultTitle = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].errors.lbl_technical_issue */ .Z.errors.lbl_technical_issue;
      defaultBtnLabel = "Exit";
      break;
  }

  var env = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().envConfigs)[env].imagePrefix;
  var formType = type === "success" ? type : "error";

  var buttonClicked = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event, url, btnType) {
      var dealProductsIds, query;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_4__/* .link */ .p4({
                link_type: "o",
                link_name: "shopping: forms: ".concat(formName, ": ").concat(formType, ": ").concat(defaultBtnLabel),
                page_name: "shopping: forms: ".concat(formName, ": ").concat(formType),
                page_form_name: "shopping: forms: ".concat(formName)
              });

              if (!(btnType == "primary" && dealProducts && dealProducts.length > 0 && multicartFlag && selectedPreference === "all-above")) {
                _context.next = 11;
                break;
              }

              //delete deals products before redirecting user to normal checkout page
              dealProductsIds = dealProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_6__/* .showSpinner */ .yh)();
              query = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_6__/* .getClearCartQuery */ .Bn)(dealProductsIds);
              _context.next = 8;
              return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_7__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(query);

            case 8:
              _context.next = 10;
              return showGuestCart(cartId);

            case 10:
              (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_6__/* .hideSpinner */ .v3)();

            case 11:
              if (onClickHandler) {
                onClickHandler({
                  type: type,
                  url: url
                });
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function buttonClicked(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  if (type === "success") {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_4__/* .view */ .ei({
      page_event: "view",
      page_name: "shopping: forms: ".concat(formName, ": success"),
      page_form_name: "shopping: forms: ".concat(formName),
      page_form_event: "success",
      multicart_flag: multicartFlag ? true : false
    });
  } else {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_4__/* .view */ .ei({
      page_event: "view",
      page_name: "shopping: forms: ".concat(formName, ": error"),
      page_errors: "".concat(title ? title : defaultTitle, ". ").concat(desc),
      page_error_type: "form",
      page_form_name: "shopping: forms: ".concat(formName),
      page_form_event: "error",
      multicart_flag: multicartFlag ? true : false
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: "".concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["main-container"]), " ").concat(className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_image_image__WEBPACK_IMPORTED_MODULE_2__["default"], {
        img_path: type === "success" ? "".concat(imagePrefix, "/assets/images/success-circle.svg") : "".concat(imagePrefix, "/assets/images/error-warning-red.svg")
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
      children: title ? title : defaultTitle
    }), desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().desc),
      children: [desc, " ", (0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_5__/* .maskMsisdn */ .Ly)(phoneNumber)]
    }), subtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().subtitle),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("hr", {
        className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["subtitle-separator"])
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
        className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().subtitle),
        children: subtitle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["button-wrapper"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
        id: "error-btn-".concat(type, "-").concat(id),
        className: "".concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().button), " ").concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[type], " ").concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[btnType]),
        onClick: function onClick(event) {
          buttonClicked(event, primaryUrl, "primary");
        },
        children: btnLabel ? btnLabel : defaultBtnLabel
      }), secondaryBtnLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
        id: "error-btn-".concat(type, "-").concat(id, "-secondary"),
        className: "".concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default().button), " ").concat((_ErrorInformation_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[btnTypeSecondary]),
        onClick: function onClick(event) {
          buttonClicked(event, secondaryUrl, "secondary");
        },
        children: secondaryBtnLabel
      })]
    })]
  });
};

ErrorInformation.defaultProps = {
  type: "default",
  id: "0"
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_9__.connect)(null, {
  showGuestCart: _Redux_actions_cartAction__WEBPACK_IMPORTED_MODULE_8__/* .showGuestCart */ .cD
})(ErrorInformation));

/***/ }),

/***/ 90685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93171);
/* harmony import */ var _NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38975);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39489);
/* harmony import */ var _atoms_linkRoute_LinkRoute__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80286);
/* harmony import */ var _utils_miniAppUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21909);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);












var NotificationBox = function NotificationBox(_ref) {
  var img_path = _ref.img_path,
      labelBold = _ref.labelBold,
      labelNormal = _ref.labelNormal,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? true : _ref$link,
      img_width = _ref.img_width,
      img_height = _ref.img_height,
      labelStyling = _ref.labelStyling,
      textStyle = _ref.textStyle,
      className = _ref.className;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().env);
  var vodaComTermUrlPrefix = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().envConfigs)[env].vodaComTermUrlPrefix;
  var isMiniApp = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .getCookieValue */ .Do)("miniApp") === "true";

  var linkRoute = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {});

  if (link) {
    linkRoute = isMiniApp ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
      onClick: function onClick() {
        return (0,_utils_miniAppUtil__WEBPACK_IMPORTED_MODULE_6__/* .openBreakoutUrl */ .W)("".concat(_config_index__WEBPACK_IMPORTED_MODULE_3__.EnvConfig.serverDomain).concat(vodaComTermUrlPrefix, "/terms-and-conditions"));
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_linkRoute_LinkRoute__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: "javascript:void(0)",
        className: (_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default().terms),
        text: "T&Cs apply."
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_linkRoute_LinkRoute__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      href: "".concat(vodaComTermUrlPrefix, "/terms-and-conditions"),
      as: "".concat(vodaComTermUrlPrefix, "/terms-and-conditions"),
      className: (_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default().terms),
      text: "T&Cs apply."
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat((_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["delivery-container"]), " ").concat(className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
      img_path: img_path,
      img_width: img_width,
      img_height: img_height
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_2__["default"], {
      className: "".concat((_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default().msg), " ").concat(labelStyling),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(labelBold)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Text, {
        className: "".concat((_NotificationBox_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["text-style"]), " ").concat(textStyle),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .createMarkup */ .KU)(labelNormal)
        })
      }), " ", linkRoute]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NotificationBox);

/***/ }),

/***/ 26329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FlagsContext": function() { return /* binding */ FlagsContext; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ post_checkout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
// EXTERNAL MODULE: ./components/organisms/checkoutPage/CheckoutPage.jsx + 7 modules
var CheckoutPage = __webpack_require__(27024);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/deliveryTitle/DeliveryTitle.jsx
var DeliveryTitle = __webpack_require__(41759);
// EXTERNAL MODULE: ./components/atoms/newLineForms/NewLineForms.module.scss
var NewLineForms_module = __webpack_require__(57470);
var NewLineForms_module_default = /*#__PURE__*/__webpack_require__.n(NewLineForms_module);
// EXTERNAL MODULE: ./components/atoms/newLineForms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(67061);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/authenticationForm/AuthenticationForm.jsx








var AuthenticationForm = function AuthenticationForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      idTypesOptions = _ref.idTypesOptions,
      countryTypesOptions = _ref.countryTypesOptions,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      onResetHandler = _ref.onResetHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var dropdownChangeHandler = function dropdownChangeHandler(event) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var formName = arguments.length > 2 ? arguments[2] : undefined;
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf101",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf101-label",
            children: "ID type"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "idType",
            label: "ID type",
            data: idTypesOptions,
            handleSelect: onChangeHandler,
            handleReset: onResetHandler,
            resetRequired: true,
            selectedId: fieldValues["idType"],
            customId: "validationFormaf101",
            fieldError: fieldErrors["idType"]
          }), fieldErrors["idType"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["idType"]
          })]
        }), fieldValues["idType"] == "PASSPORT" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf102",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf102-label",
            children: "Passport number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "passportNumber",
            value: fieldValues["passportNumber"],
            placeholder: "Enter your passport number",
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["passportNumber"],
            className: fieldErrors["passportNumber"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["passportNumber"]
          })]
        }), fieldValues["idType"] == "PASSPORT" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf103",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf103-label",
            children: "Passport expiry date"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "passportExpiry",
            maxLength: "14",
            value: fieldValues["passportExpiry"],
            placeholder: "DD / MM / YYYY",
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["passportExpiry"],
            className: fieldErrors["passportExpiry"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["passportExpiry"]
          })]
        }), fieldValues["idType"] == "PASSPORT" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf104",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf104-label",
            children: "Country of origin"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            label: "Country of origin",
            name: "countryOrigin",
            data: countryTypesOptions,
            handleSelect: dropdownChangeHandler,
            handleReset: onResetHandler,
            resetRequired: true,
            selectedId: fieldValues["countryOrigin"],
            customId: "validationFormaf104",
            fieldError: fieldErrors["countryOrigin"]
          }), fieldErrors["countryOrigin"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " d-block"),
            children: fieldErrorsMessage["countryOrigin"]
          })]
        }), fieldValues["idType"] == "SAID" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf105",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf105-label",
            children: "SA ID number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "idNumber",
            value: fieldValues["idNumber"],
            placeholder: "Enter your ID number",
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["idNumber"],
            className: fieldErrors["idNumber"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["idNumber"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormaf106",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormaf106-label",
            children: "Cellphone number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            maxLength: !(0,helperServices/* africaCountryCode */.xJ)(fieldValues["cellNumber"]) ? "10" : "11",
            name: "cellNumber",
            value: fieldValues["cellNumber"],
            placeholder: "Enter your cellphone number",
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["cellNumber"],
            className: fieldErrors["cellNumber"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["cellNumber"]
          }), !fieldErrors["cellNumber"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NewLineForms_module_default())["hint-text"],
            children: "This is the number we’ll use to contact you regarding your account and/or deliveries"
          })]
        })]
      })
    })
  });
};

AuthenticationForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  idTypesOptions: [],
  countryTypesOptions: []
};
/* harmony default export */ var authenticationForm_AuthenticationForm = (AuthenticationForm);
// EXTERNAL MODULE: ./components/atoms/errorInformation/ErrorInformation.jsx
var ErrorInformation = __webpack_require__(65637);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/organisms/checkoutAuthentication/CheckoutAuthentication.module.scss
var CheckoutAuthentication_module = __webpack_require__(845);
var CheckoutAuthentication_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutAuthentication_module);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/errorMessages.js
var errorMessages = __webpack_require__(72210);
// EXTERNAL MODULE: ./context/checkout-journey-context.js
var checkout_journey_context = __webpack_require__(62039);
// EXTERNAL MODULE: ./services/checkoutService.js
var checkoutService = __webpack_require__(34020);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./Redux/actions/checkoutAction.js
var checkoutAction = __webpack_require__(39166);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./utils/logger.js
var logger = __webpack_require__(21534);
;// CONCATENATED MODULE: ./components/organisms/checkoutAuthentication/CheckoutAuthentication.jsx




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























var idTypesOptions = [{
  id: "SAID",
  label: "SA ID number"
}, {
  id: "PASSPORT",
  label: "Passport number"
}];
var CheckoutAuthentication = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var formContent = _ref.formContent,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      navigate = _ref.navigate,
      setShowSnackBar = _ref.setShowSnackBar,
      setPageErr = _ref.setPageErr,
      profileLoading = _ref.profileLoading,
      isMiniApp = _ref.isMiniApp,
      dealID = _ref.dealID,
      contractType = _ref.contractType,
      setJourneyStepTracker = _ref.setJourneyStepTracker,
      authDetailsData = _ref.authDetailsData,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      features = _ref.features,
      deleteItemsFromCart = _ref.deleteItemsFromCart,
      cartProducts = _ref.cartProducts,
      multicartFlag = _ref.multicartFlag,
      handlePrimaryNxtLvlClick = _ref.handlePrimaryNxtLvlClick,
      selectedPreference = _ref.selectedPreference;
  var env = (config_default()).env;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;

  var _useState = (0,react.useState)(false),
      dataFail = _useState[0],
      setDataFail = _useState[1];

  var _useState2 = (0,react.useState)(false),
      dataLoaded = _useState2[0],
      setDataLoaded = _useState2[1];

  var _useContext = (0,react.useContext)(checkout_journey_context/* CheckoutJourneyContext */.m),
      setJourney = _useContext.setJourney;

  var _useState3 = (0,react.useState)(false),
      analytics = _useState3[0],
      setAnalytics = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      submitDisabled = _useState4[0],
      setSubmitDisabled = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      countryTypesOptions = _useState5[0],
      setCountryTypesOptions = _useState5[1];

  var titleContents = formContent ? formContent.items : [];
  var numRegEx = RegExp(/^[0-9]*$/);
  var cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
  var passportNumberRegEx = RegExp(/^[A-Za-z0-9]*$/);
  var passportExpiryRegEx = RegExp(/^([0][1-9]|[12][0-9]|3[01])[\s][\/][\s]([0][1-9]|1[012])[\s][\/][\s]\d{4}$/);
  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.checkoutAuthentication.errors */.Z.checkoutAuthentication.errors));
  var dispatch = (0,DependencyHelper.useDispatch)();
  var router = (0,DependencyHelper.useRouter)();
  var newRedirectURL = features !== null && features !== void 0 && features.shakaEnabled && (features === null || features === void 0 ? void 0 : features.shakaEnabled) !== undefined ? 'checkout' : 'shopping';
  (0,react.useImperativeHandle)(ref, function () {
    return {
      back: function back() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: lets get started: ".concat(customerStatus, ": back to cart")
        });
      }
    };
  });

  var _useState6 = (0,react.useState)({
    validationsOn: {
      auth: true
    },
    errorStatus: {
      auth: true
    },
    validations: {
      auth: {
        idType: true,
        idNumber: true,
        cellNumber: true,
        passportNumber: false,
        passportExpiry: false,
        countryOrigin: false
      }
    },
    fieldErrors: {
      auth: {
        idType: false,
        idNumber: false,
        cellNumber: false,
        passportNumber: false,
        passportExpiry: false,
        countryOrigin: false
      },
      fail: false
    },
    fieldValues: {
      auth: {
        idType: "SAID",
        idNumber: "",
        cellNumber: "",
        passportNumber: "",
        passportExpiry: "",
        countryOrigin: ""
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState6[0],
      setState = _useState6[1];

  var errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  var dealCartProduct = cartProducts.find(function (cartProduct) {
    var _cartProduct$product, _cartProduct$product2;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
  });
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var cartProductId = dealCartProduct === null || dealCartProduct === void 0 ? void 0 : dealCartProduct.id;
  /**
   * Return the selected id type
   *
   */

  function getIdType() {
    return fieldValues["auth"]["idType"] == "SAID" ? "id" : "passport";
  }

  (0,react.useEffect)(function () {
    // Add Event Listner to handle the click that happens outside
    document.addEventListener("mousedown", handleClickFaq);
    return function () {
      // Remove the event listner on component unmounting
      document.removeEventListener("mousedown", handleClickFaq);
    };
  }, []);

  var handleClickFaq = function handleClickFaq(e) {
    var _e$target, _e$target2;

    if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id) == "see-faq-question-link") {
      $("html, body").animate({
        scrollTop: $("#faqs").offset().top - 80
      }, 1200);
    }

    if (((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.id) == "main-account") {
      $("html, body").animate({
        scrollTop: $("#main-account-nav").offset().top - 25
      }, 1200);
    }
  };

  (0,react.useEffect)(function () {
    if (countryTypesOptions.length && customerStatus) {
      analyticsUtag/* view */.ei(_objectSpread({
        page_event: "view",
        page_name: "checkout: lets get started: ".concat(customerStatus),
        page_channel: "checkout",
        page_master_tab: "personal",
        authentication_id_type: "id",
        multicart_flag: multicartFlag ? true : false
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
    }
  }, [countryTypesOptions, customerStatus]);
  /**
   * Get the load lookup data
   */

  (0,react.useEffect)(function () {
    if (!profileLoading && customerStatus) {
      fetchLoadLookUpData();
    }
  }, [profileLoading, customerStatus]);

  var fetchLoadLookUpData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _responseData$respons, _responseData$respons2, _responseData$respons3, _responseData$respons4, _responseData$respons5, responseData, detailsParams, detailsParamsErrCode, detailsParamsPreferences;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context.prev = 1;
              _context.next = 4;
              return microServices/* default.get */.Z.get("api", "loadLookup", null, false);

            case 4:
              responseData = _context.sent;

              if ((_responseData$respons = responseData.response) !== null && _responseData$respons !== void 0 && (_responseData$respons2 = _responseData$respons.data) !== null && _responseData$respons2 !== void 0 && _responseData$respons2.result) {
                dispatch({
                  type: actionTypes/* SET_LOOKUP_DETAILS */.bL,
                  payload: responseData.response.data.result
                });
              }

              if ((_responseData$respons3 = responseData.response) !== null && _responseData$respons3 !== void 0 && (_responseData$respons4 = _responseData$respons3.data) !== null && _responseData$respons4 !== void 0 && (_responseData$respons5 = _responseData$respons4.result) !== null && _responseData$respons5 !== void 0 && _responseData$respons5.COUNTRY) {
                setCountryTypesOptions((0,helperServices/* replaceDropdownKeys */.qp)(responseData.response.data.result.COUNTRY, "description", "id", "country"), (0,helperServices/* hideSpinner */.v3)());
                setDataFail(false);
                setDataLoaded(true);
              } else {
                (0,helperServices/* hideSpinner */.v3)();
                detailsParams = ["checkout: lets get started: ".concat(customerStatus), "technical error", null];

                if (responseData.error) {
                  detailsParamsErrCode = "letsGetStarted_".concat(responseData.error.status);
                } else {
                  detailsParamsErrCode = labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out;
                  detailsParamsPreferences = labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values;
                }

                detailsParams.unshift(detailsParamsErrCode);
                detailsParamsPreferences && detailsParams.push(detailsParamsPreferences);
                fetchErrorDetails.apply(void 0, detailsParams);
              }

              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.checkout.lbl_invalid_attempt_title */.Z.checkout.lbl_invalid_attempt_title,
                  desc: labels/* default.checkout.lbl_invalid_attempt_desc */.Z.checkout.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, "call me back");
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(null, "exit checkout");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: "checkout: lets get started: ".concat(customerStatus),
                  pageErrorType: "technical error"
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function fetchLoadLookUpData() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, errMsg;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              _context2.next = 3;
              return fieldValidationCheck(event, val, form);

            case 3:
              _context2.next = 5;
              return checkFormError(form);

            case 5:
              errorStatus[form] = _context2.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                name = event.target.name;
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBlur(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @usage Set the state of form fieldValues
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      var idType;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.persist();
              idType = getIdType();

              if (!analytics) {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: lets get started: ".concat(customerStatus, ": form ").concat(idType)
                }));
                setAnalytics(true);
              }

              _context3.next = 5;
              return updateFieldValues(event, val, form);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleChange(_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Set the default ID type (SAID)
   * @usage Remove the selected country
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(name, form) {
      var errMsg;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(name == "idType")) {
                _context4.next = 15;
                break;
              }

              if (!(fieldValues[form].idType !== "SAID")) {
                _context4.next = 13;
                break;
              }

              validations[form].idNumber = true;
              validations[form].passportNumber = false;
              validations[form].passportExpiry = false;
              validations[form].countryOrigin = false;
              fieldValues[form].idType = "SAID";
              setState(_objectSpread(_objectSpread({}, state), {}, {
                validations: validations,
                fieldValues: fieldValues
              }));
              _context4.next = 10;
              return checkFormError(form);

            case 10:
              errorStatus[form] = _context4.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus[form]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 13:
              _context4.next = 16;
              break;

            case 15:
              if (name == "countryOrigin") {
                fieldValues[form].countryOrigin = "";

                if (state.validationsOn[form] && state.validations[form].countryOrigin) {
                  fieldErrors[form].countryOrigin = true;

                  if (fieldErrors[form].countryOrigin) {
                    fieldErrorsMessage[form].countryOrigin = errorMessages/* default.checkoutAuthentication.errors.auth.countryOrigin */.Z.checkoutAuthentication.errors.auth.countryOrigin;
                  }

                  fieldErrors.fail = fieldErrors[form].countryOrigin;
                }

                if (fieldErrors.fail) {
                  errorStatus[form] = true;
                  setSubmitDisabled(true);
                  errMsg = fieldErrorsMessage[form].countryOrigin;
                  inlineAnalytics(errMsg);
                }

                setState(_objectSpread(_objectSpread({}, state), {}, {
                  errorStatus: errorStatus,
                  fieldValues: fieldValues,
                  fieldErrors: fieldErrors,
                  fieldErrorsMessage: fieldErrorsMessage
                }));
              }

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleReset(_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context5.t0 = name;
              _context5.next = _context5.t0 === "idNumber" ? 5 : _context5.t0 === "cellNumber" ? 7 : _context5.t0 === "passportNumber" ? 9 : _context5.t0 === "passportExpiry" ? 11 : _context5.t0 === "countryOrigin" ? 13 : 15;
              break;

            case 5:
              if (state.validationsOn[form] && state.validations[form].idNumber) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].idNumber = true;
                    fieldErrorsMessage[form].idNumber = errorMessages/* default.checkoutAuthentication.idNumber.onlyNumber */.Z.checkoutAuthentication.idNumber.onlyNumber;
                  } else if (value.length < 13) {
                    fieldErrors[form].idNumber = true;
                    fieldErrorsMessage[form].idNumber = errorMessages/* default.checkoutAuthentication.idNumber.minCharacters */.Z.checkoutAuthentication.idNumber.minCharacters;
                  } else {
                    fieldErrors[form].idNumber = false;
                  }
                } else {
                  fieldErrors[form].idNumber = true;
                  fieldErrorsMessage[form].idNumber = errorMessages/* default.checkoutAuthentication.errors.auth.idNumber */.Z.checkoutAuthentication.errors.auth.idNumber;
                }

                fieldErrors.fail = fieldErrors[form].idNumber;
              } else {
                fieldErrors[form].idNumber = false;
              }

              return _context5.abrupt("break", 15);

            case 7:
              if (state.validationsOn[form] && state.validations[form].cellNumber) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkoutAuthentication.cellNumber.onlyNumber */.Z.checkoutAuthentication.cellNumber.onlyNumber;
                  } else if (!cellPhoneRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkoutAuthentication.cellNumber.startWith */.Z.checkoutAuthentication.cellNumber.startWith;
                  } else if ((0,helperServices/* africaCountryCode */.xJ)(value) && value.length < 11) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkoutAuthentication.errors.auth.cellNumber */.Z.checkoutAuthentication.errors.auth.cellNumber;
                  } else if (value.length < 10) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkoutAuthentication.errors.auth.cellNumber */.Z.checkoutAuthentication.errors.auth.cellNumber;
                  } else {
                    fieldErrors[form].cellNumber = false;
                  }
                } else {
                  fieldErrors[form].cellNumber = true;
                  fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkoutAuthentication.errors.auth.cellNumber */.Z.checkoutAuthentication.errors.auth.cellNumber;
                }

                fieldErrors.fail = fieldErrors[form].cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }

              return _context5.abrupt("break", 15);

            case 9:
              if (state.validationsOn[form] && state.validations[form].passportNumber) {
                if (value.length > 0) {
                  if (!passportNumberRegEx.test(value)) {
                    fieldErrors[form].passportNumber = true;
                    fieldErrorsMessage[form].passportNumber = errorMessages/* default.checkoutAuthentication.passportNumber.onlyValid */.Z.checkoutAuthentication.passportNumber.onlyValid;
                  } else {
                    fieldErrors[form].passportNumber = false;
                  }
                } else {
                  fieldErrors[form].passportNumber = true;
                  fieldErrorsMessage[form].passportNumber = errorMessages/* default.checkoutAuthentication.errors.auth.passportNumber */.Z.checkoutAuthentication.errors.auth.passportNumber;
                }

                fieldErrors.fail = fieldErrors[form].passportNumber;
              } else {
                fieldErrors[form].passportNumber = false;
              }

              return _context5.abrupt("break", 15);

            case 11:
              if (state.validationsOn[form] && state.validations[form].passportExpiry) {
                if (value.length > 0) {
                  if (!passportExpiryRegEx.test(value)) {
                    fieldErrors[form].passportExpiry = true;
                    fieldErrorsMessage[form].passportExpiry = errorMessages/* default.checkoutAuthentication.passportExpiry.onlyValid */.Z.checkoutAuthentication.passportExpiry.onlyValid;
                  } else if (expireInSixMonths(value)) {
                    fieldErrors[form].passportExpiry = true;
                    fieldErrorsMessage[form].passportExpiry = errorMessages/* default.checkoutAuthentication.passportExpiry.sixMonthsExpiry */.Z.checkoutAuthentication.passportExpiry.sixMonthsExpiry;
                  } else {
                    fieldErrors[form].passportExpiry = false;
                  }
                } else {
                  fieldErrors[form].passportExpiry = true;
                  fieldErrorsMessage[form].passportExpiry = errorMessages/* default.checkoutAuthentication.errors.auth.passportExpiry */.Z.checkoutAuthentication.errors.auth.passportExpiry;
                }

                fieldErrors.fail = fieldErrors[form].passportExpiry;
              } else {
                fieldErrors[form].passportExpiry = false;
              }

              return _context5.abrupt("break", 15);

            case 13:
              if (state.validationsOn[form] && state.validations[form].countryOrigin) {
                fieldErrors[form].countryOrigin = value == "" ? true : false;

                if (fieldErrors[form].countryOrigin) {
                  fieldErrorsMessage[form].countryOrigin = state.fieldErrorsMessage.auth.countryOrigin;
                }

                fieldErrors.fail = fieldErrors[form].countryOrigin;
              } else {
                fieldErrors[form].countryOrigin = false;
              }

              return _context5.abrupt("break", 15);

            case 15:
              closeSnackBar();
              setState(_objectSpread(_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fieldValidationCheck(_x9, _x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(event, val, form) {
      var name, value, idType, errForm;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;

              if (name == "idType") {
                if (value == "SAID") {
                  validations[form].idNumber = true;
                  validations[form].passportNumber = false;
                  validations[form].passportExpiry = false;
                  validations[form].countryOrigin = false;
                } else if (value == "PASSPORT") {
                  validations[form].idNumber = false;
                  validations[form].passportNumber = true;
                  validations[form].passportExpiry = true;
                  validations[form].countryOrigin = true;
                }

                fieldErrors.fail = false; //capture analytics user selects "passport" or "id"

                idType = value == "SAID" ? "id" : "passport";
                selectionAnalytics("id type", idType);
              } else if (name == "countryOrigin") {
                //capture analytics user selects "country of origin"
                selectionAnalytics("country", value);
              }

              if (name == "passportExpiry") {
                //call function to add auto slash in date field
                fieldValues[form][name] = addAutoSlash(value);
              } else {
                fieldValues[form][name] = value;
              }

              setState(_objectSpread(_objectSpread({}, state), {}, {
                validations: validations,
                fieldValues: fieldValues
              }));

              if (!(name == "idType")) {
                _context6.next = 10;
                break;
              }

              _context6.next = 8;
              return checkFormError(form);

            case 8:
              errForm = _context6.sent;

              if (errForm) {
                setSubmitDisabled(true);
              } else {
                setSubmitDisabled(false);
              }

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function updateFieldValues(_x12, _x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * Add slash to date field in dd/mm/yyyy format
   *
   * @call onChange event
   */


  var addAutoSlash = function addAutoSlash(value) {
    if (/\D\/$/.test(value)) value = value.substr(0, value.length - 3);
    var values = value.split("/").map(function (v) {
      return v.replace(/\D/g, "");
    });

    if (values[0]) {
      values[0] = checkValue(values[0], 31, values[1] ? true : false);
    }

    if (values[1]) {
      values[1] = checkValue(values[1], 12, values[2] ? true : false);
    }

    var output = values.map(function (v, i) {
      //return v.length == 2 && i < 2 ? v + " / " : v;
      if (v.length == 2 && i < 2) {
        return v + " / ";
      } else if (v.length == 1 && i < 2 && values[i + 1]) {
        return v + " / ";
      } else {
        return v;
      }
    });
    return output.join("").substr(0, 14);
  };

  function checkValue(str, max, addZero) {
    if (str.charAt(0) !== "0" || str == "00" || addZero) {
      var num = parseInt(str);

      if (addZero && str.length == 1 && num !== 0) {
        str = num.toString();
      } else if (isNaN(num) || num <= 0 || num > max) {
        num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? "0" + num : num.toString();
      }
    }

    return str;
  }
  /**
   * Check if passport expires in 6 months
   *
   * @call onChange event
   */


  function expireInSixMonths(expiryDate) {
    var _expiryDate$split = expiryDate.split(" / "),
        _expiryDate$split2 = (0,slicedToArray/* default */.Z)(_expiryDate$split, 3),
        date = _expiryDate$split2[0],
        month = _expiryDate$split2[1],
        year = _expiryDate$split2[2];

    var cd = new Date();
    var ed = new Date(year, month - 1, date); // Add 6 months

    cd.setMonth(cd.getMonth() + 6);
    var ncd = new Date(cd.getFullYear(), cd.getMonth(), cd.getDate());

    if (ncd.getTime() > ed.getTime()) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    var idType = getIdType();
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: lets get started: ".concat(customerStatus, ": form ").concat(idType),
      page_error_type: "form"
    }));
  };
  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change(country, idType)
   */


  var selectionAnalytics = function selectionAnalytics(selectionType, value) {
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "checkout: lets get started: ".concat(customerStatus, ": ").concat(selectionType),
      filter_query: value
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key] && value) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    closeSnackBar();

    if (!dealID) {
      displaySnackBar(labels/* default.checkout.lbl_no_deal_product */.Z.checkout.lbl_no_deal_product);
      window.scrollTo(0, 0);
      event.stopPropagation();
    } else if (!state.errorStatus["auth"]) {
      analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
        link_type: "o",
        link_name: "checkout: lets get started: ".concat(customerStatus, ": submit")
      }));
      submitForm();
    } else {
      displaySnackBar(labels/* default.errors.lbl_form_not_submitted_fill_required */.Z.errors.lbl_form_not_submitted_fill_required, "form_level");
      window.scrollTo(0, 0);
      event.stopPropagation();
    }
  };
  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */


  var mapFieldData = function mapFieldData() {
    return {
      docType: state.fieldValues["auth"].idType
    };
  };
  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var inputObj, reqParams, reduxInfo, _responseData$respons6, _responseData$respons7, _responseData$error, _responseData$error$d, _responseData$error2, _responseData$error3, _responseData$error3$, _responseData$error3$2, responseData, _responseData$respons8, _responseData$respons9, _responseData$respons10, _pageErrorType, _responseData$error4;

      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              inputObj = mapFieldData();
              reqParams = [inputObj.docType == "SAID" ? state.fieldValues["auth"].idNumber : state.fieldValues["auth"].passportNumber];
              reduxInfo = {
                information: null,
                idType: inputObj.docType,
                idNumber: inputObj.docType == "SAID" ? state.fieldValues["auth"].idNumber : state.fieldValues["auth"].passportNumber,
                msisdn: state.fieldValues["auth"].cellNumber,
                countryOrigin: state.fieldValues["auth"].countryOrigin,
                passportExpiry: state.fieldValues["auth"].passportExpiry
              };

              if (state.fieldValues["auth"].idNumber !== (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber)) {
                removeCreditCheckStates(null);
              }

              _context7.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              _context7.next = 8;
              return microServices/* default.get */.Z.get("api", "customerInformation", inputObj, true, reqParams);

            case 8:
              responseData = _context7.sent;
              window.scrollTo(0, 0);
              (0,helperServices/* hideSpinner */.v3)();

              if ((_responseData$respons6 = responseData.response) !== null && _responseData$respons6 !== void 0 && (_responseData$respons7 = _responseData$respons6.data) !== null && _responseData$respons7 !== void 0 && _responseData$respons7.result) {
                reduxInfo.information = responseData.response.data.result;

                if (((_responseData$respons8 = responseData.response.data.result) === null || _responseData$respons8 === void 0 ? void 0 : _responseData$respons8.customerType) == "NEW") {
                  //set newLine journey context if config is allowed
                  if (features !== null && features !== void 0 && features.newLineEnabled) {
                    setJourney(checkout_journey_context/* journeyType.newLine */.w.newLine);

                    if (state.fieldValues["auth"].idType == "SAID") {
                      //navigate to XDS authentication or pre-validation failure
                      preValidationCheck(checkout_journey_context/* journeyType.newLine */.w.newLine, "xds");
                    } else {
                      //navigate to credit check or pre-validation failure
                      preValidationCheck(checkout_journey_context/* journeyType.newLine */.w.newLine, "creditCheck");
                    }
                  } else {
                    router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/").concat(newRedirectURL, "/order-summary?salesChannel=Contract&dealSheetNumber=").concat(dealID).concat(isMiniApp ? "&miniApp=true" : ""));
                  }
                } else {
                  if (contractType == labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option) {
                    //set upgrade journey context
                    setJourney(checkout_journey_context/* journeyType.upgrade */.w.upgrade);
                    setJourneyStepTracker(checkout_journey_context/* journeyType.upgrade */.w.upgrade);

                    if (!((_responseData$respons9 = responseData.response.data.result) !== null && _responseData$respons9 !== void 0 && (_responseData$respons10 = _responseData$respons9.authorisedNumbers) !== null && _responseData$respons10 !== void 0 && _responseData$respons10.length)) {
                      fetchErrorDetails("upgradecheckout_technical_error", "checkout: authentication: ".concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                    } else {
                      navigate("otp");
                    }
                  } else {
                    //set addLine journey context if config is allowed
                    if (features !== null && features !== void 0 && features.addLineEnabled) {
                      setJourney(checkout_journey_context/* journeyType.addLine */.w.addLine);
                      setJourneyStepTracker(checkout_journey_context/* journeyType.addLine */.w.addLine); //navigate to OTP

                      navigate("otp");
                    } else {
                      router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/").concat(newRedirectURL, "/order-summary?salesChannel=Contract&dealSheetNumber=").concat(dealID).concat(isMiniApp ? "&miniApp=true" : ""));
                    }
                  }
                }
              } else if (responseData !== null && responseData !== void 0 && (_responseData$error = responseData.error) !== null && _responseData$error !== void 0 && (_responseData$error$d = _responseData$error.data) !== null && _responseData$error$d !== void 0 && _responseData$error$d.responseCode) {
                _pageErrorType = (0,helperServices/* getPreValidationErrorType */.uf)(responseData.error.data.responseCode);
                fetchErrorDetails(responseData.error.data.responseCode, "checkout: lets get started: ".concat(customerStatus), _pageErrorType, null, responseData.error.data.responseCode == "LETSGETSTARTED_LEGACY" ? labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values : []);
              } else if ((responseData === null || responseData === void 0 ? void 0 : (_responseData$error2 = responseData.error) === null || _responseData$error2 === void 0 ? void 0 : _responseData$error2.status) === 400 && responseData !== null && responseData !== void 0 && (_responseData$error3 = responseData.error) !== null && _responseData$error3 !== void 0 && (_responseData$error3$ = _responseData$error3.data) !== null && _responseData$error3$ !== void 0 && (_responseData$error3$2 = _responseData$error3$.result) !== null && _responseData$error3$2 !== void 0 && _responseData$error3$2.message) {
                displaySnackBar(responseData.error.data.result.message);
              } else {
                if (responseData !== null && responseData !== void 0 && (_responseData$error4 = responseData.error) !== null && _responseData$error4 !== void 0 && _responseData$error4.status) {
                  fetchErrorDetails("letsGetStarted_".concat(responseData.error.status), "checkout: lets get started: ".concat(customerStatus), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                } else {
                  fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "checkout: lets get started: ".concat(customerStatus), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                }
              }

              _context7.next = 17;
              break;

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](4);
              (0,helperServices/* hideSpinner */.v3)();

            case 17:
              _context7.prev = 17;
              //store the result in redux
              dispatch({
                type: actionTypes/* SET_AUTHENTICATION_DETAILS */.TY,
                payload: reduxInfo
              });
              return _context7.finish(17);

            case 20:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[4, 14, 17, 20]]);
    }));

    return function submitForm() {
      return _ref8.apply(this, arguments);
    };
  }();

  var preValidationCheck = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(journey, page) {
      var idNumber, results, newPage, _pageErrorType2, _results$errors;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              idNumber = state.fieldValues["auth"].idType == "SAID" ? state.fieldValues["auth"].idNumber : state.fieldValues["auth"].passportNumber;
              _context8.next = 4;
              return (0,checkoutService/* preValidationCheckService */.ak)(state.fieldValues["auth"].idType, idNumber, dealID, journey);

            case 4:
              results = _context8.sent;
              (0,helperServices/* hideSpinner */.v3)();

              if (results.responseCode) {
                dispatch({
                  type: actionTypes/* SET_SKIP_CREDIT_VETTING */.CI,
                  payload: results.skipCreditVetting
                });

                if (results.responseCode == "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE") {
                  dispatch({
                    type: actionTypes/* ADD_CREDIT_PROFILE */.DJ,
                    payload: results.creditFilters
                  });
                  dispatch({
                    type: actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1,
                    payload: true
                  });
                } else {
                  dispatch({
                    type: actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1,
                    payload: false
                  });
                }

                if ((0,helperServices/* preValidationEligible */.jW)(results.responseCode)) {
                  analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                    page_form_event: "success",
                    page_form_name: "checkout: lets get started: ".concat(customerStatus, ": form ").concat(state.fieldValues["auth"].idType == "SAID" ? "id" : "passport")
                  }));
                  setJourneyStepTracker(journey);
                  newPage = page == "creditCheck" && results.skipCreditVetting ? "review" : page;
                  navigate(newPage);
                } else {
                  _pageErrorType2 = (0,helperServices/* getPreValidationErrorType */.uf)(results.responseCode);
                  logger/* Logger.info */.Y.info("Prevalidation check returned code ".concat(results.responseCode), "CheckoutAuthentication", {
                    TagErrorType: _pageErrorType2 || "not returned",
                    ServiceResponseCode: results.responseCode,
                    response: JSON.stringify(results || {}),
                    data: {
                      idType: state.fieldValues["auth"].idType,
                      idNumber: idNumber,
                      dealID: dealID,
                      journey: journey
                    }
                  }, {
                    preval_result_code: results.responseCode
                  });
                  fetchErrorDetails(results.responseCode, "checkout: pre val: ".concat(customerStatus), _pageErrorType2, "authentication_id_type", results.responseCode == "Approved_Conditions_Vetting_Outcome" ? labels/* default.checkout.lbl_preference_approved_conditions_values */.Z.checkout.lbl_preference_approved_conditions_values : results.responseCode == "Declined_LeadNXT_LVL" ? labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values : []);
                }
              } else {
                fetchErrorDetails("preValidation_".concat((_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : _results$errors.status), "checkout: pre val: ".concat(customerStatus), "technical error", "authentication_id_type", labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                logger/* Logger.error */.Y.error("No pre validation response code returned", "CheckoutAuthentication", {
                  response: JSON.stringify(results || {}),
                  data: {
                    idType: state.fieldValues["auth"].idType,
                    idNumber: idNumber,
                    dealID: dealID,
                    journey: journey
                  }
                });
              }

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function preValidationCheck(_x15, _x16) {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(resultCode, pageName, pageErrorType) {
      var additionalUtagData,
          preferences,
          newResultCode,
          _result$0$primaryCTAU,
          result,
          desc,
          subDesc,
          subTitle,
          declined_lead_next_level,
          _args9 = arguments;

      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              additionalUtagData = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : null;
              preferences = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : [];
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context9.prev = 3;
              (0,helperServices/* showSpinner */.yh)();
              _context9.next = 7;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 7:
              result = _context9.sent;
              desc = result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML;
              subDesc = null, subTitle = null;
              declined_lead_next_level = "Declined_LeadNXT_LVL";

              if (resultCode == declined_lead_next_level) {
                desc = "You can still continue to purchase the other items you added to your cart";
                subTitle = result[0].resultHTML ? result[0].resultHTML : null;
                subDesc = result[0].resultText ? result[0].resultText : null;
              }

              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                subTitle: subTitle,
                desc: desc,
                subDesc: subDesc,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                  if (result[0].resultCode === "".concat(declined_lead_next_level, "_Multicart") && selectedPreference === "call-me-back") {
                    handlePrimaryNxtLvlClick();
                    return;
                  }

                  _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText, resultCode);
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                pageErrorType: pageErrorType ? pageErrorType : result[0].analyticTitle !== resultCode ? result[0].analyticTitle : "technical error",
                additionalUtagData: additionalUtagData,
                dividerLine: result[0].CTATitle != "" ? true : false,
                ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                preferences: multicartFlag ? preferences : [],
                defaultPreference: multicartFlag && (_result$0$primaryCTAU = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU !== void 0 && _result$0$primaryCTAU.includes("/checkout") ? "once-off" : null
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context9.next = 22;
              break;

            case 17:
              _context9.prev = 17;
              _context9.t0 = _context9["catch"](3);

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.checkout.lbl_invalid_attempt_title */.Z.checkout.lbl_invalid_attempt_title,
                  desc: labels/* default.checkout.lbl_invalid_attempt_desc */.Z.checkout.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)("/forms/ecommerce", "pre_validation_checks", "lead", preferenceId), "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType ? pageErrorType : "technical error",
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, "call me back");
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(null, "exit checkout");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType ? pageErrorType : "technical error",
                  additionalUtagData: additionalUtagData
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 22:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[3, 17]]);
    }));

    return function fetchErrorDetails(_x17, _x18, _x19) {
      return _ref10.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    var navigateUrl = url === "/" ? url : "".concat(helperServices/* urlPrefix */.wn).concat(url);
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      if (label.includes(labels/* default.mah_authentication.lbl_pay_my_bill */.Z.mah_authentication.lbl_pay_my_bill)) {
        router.push(url).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
        return;
      }

      router.push(navigateUrl).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var _handleSecondaryClick = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(url, label, resultCode) {
      var pageName, navigateUrl;
      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();

              if (!(resultCode === "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE")) {
                _context10.next = 4;
                break;
              }

              _context10.next = 4;
              return deleteItemsFromCart(cartId, cartProductId);

            case 4:
              pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
              navigateUrl = url === "/" ? url : "".concat(helperServices/* urlPrefix */.wn).concat(url);
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label),
                page_name: "".concat(pageName)
              });

              if (!url) {
                _context10.next = 14;
                break;
              }

              if (!label.includes(labels/* default.mah_authentication.lbl_pay_my_bill */.Z.mah_authentication.lbl_pay_my_bill)) {
                _context10.next = 11;
                break;
              }

              router.push(url).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });
              return _context10.abrupt("return");

            case 11:
              router.push(navigateUrl).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });
              _context10.next = 15;
              break;

            case 14:
              router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });

            case 15:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function _handleSecondaryClick(_x20, _x21, _x22) {
      return _ref11.apply(this, arguments);
    };
  }();

  var displaySnackBar = function displaySnackBar(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page_level";
    var idType = getIdType();
    setShowSnackBar({
      visible: true,
      message: message
    });
    var pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page"
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = "checkout: lets get started: ".concat(customerStatus, ": form ").concat(idType);
      pageAnalyticsData.page_error_type = "form";
    }

    analyticsUtag/* link */.p4(_objectSpread(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), pageAnalyticsData), {}, {
      link_type: "o",
      link_name: "checkout: lets get started: ".concat(customerStatus, ": submit")
    }));
  };

  var FormHandlerInformation = function FormHandlerInformation() {
    if (dataFail) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorInformation/* default */.Z, {
        desc: "Would you like to try again?",
        onClickHandler: fetchLoadLookUpData,
        className: (CheckoutAuthentication_module_default())["error-container"]
      });
    } else {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutAuthentication_module_default()).container),
      children: [!dataFail && dataLoaded && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutAuthentication_module_default())["form-heading"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            className: (CheckoutAuthentication_module_default()).icon,
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-auth.svg")
          }), "Please provide your details below:"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
          contents: titleContents,
          className: (CheckoutAuthentication_module_default())["standard-box"],
          descClassName: (CheckoutAuthentication_module_default())["standard-box__desc"],
          id: "checkout-authentication-standard-delivery",
          iconType: "info"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
          noValidate: true,
          className: (CheckoutAuthentication_module_default()).form,
          id: "checkout-authentication-form",
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(authenticationForm_AuthenticationForm, {
            formName: "auth",
            fieldValues: state.fieldValues["auth"],
            fieldErrors: state.fieldErrors["auth"],
            fieldErrorsMessage: state.fieldErrorsMessage["auth"],
            onChangeHandler: handleChange,
            onBlurHandler: handleBlur,
            onResetHandler: handleReset,
            idTypesOptions: idTypesOptions,
            countryTypesOptions: countryTypesOptions
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutAuthentication_module_default())["button-wrapper"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
              type: "submit",
              variant: "solid grey",
              disabled: submitDisabled,
              className: (CheckoutAuthentication_module_default()).button,
              id: "checkout-authentication-form-submit",
              children: "Continue"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormHandlerInformation, {})]
    })
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    profileLoading: state.navDetails.isProfileLoading,
    isMiniApp: state.navDetails.isMiniApp,
    authDetailsData: state.checkoutDetails.authDetails,
    cartProducts: state.cartDetails.cartProductItems,
    selectedPreference: state.checkoutPageError.selected_preference
  };
};

var mapDispatchToProps = {
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK,
  deleteItemsFromCart: cartAction/* deleteItemsFromCart */.dY
};
/* harmony default export */ var checkoutAuthentication_CheckoutAuthentication = ((0,DependencyHelper.connect)(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(CheckoutAuthentication));
// EXTERNAL MODULE: ./components/atoms/newLineForms/xdsForm/XdsForm.module.scss
var XdsForm_module = __webpack_require__(68390);
var XdsForm_module_default = /*#__PURE__*/__webpack_require__.n(XdsForm_module);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/xdsForm/XdsForm.jsx







var XdsForm = function XdsForm(_ref) {
  var formContent = _ref.formContent,
      formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      onChangeHandler = _ref.onChangeHandler;

  var handleChange = function handleChange(event, name, value) {
    onChangeHandler(event, name, value, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"], " ").concat((XdsForm_module_default())["main-container"], " "),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"], " ").concat((XdsForm_module_default())["main-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: formContent.map(function (item, index) {
          var _item$answers;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: "".concat((NewLineForms_module_default())["form-group"], " ").concat((XdsForm_module_default())["form-group"]),
            controlId: "validationFormxf".concat(index + 101),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
              className: "".concat((NewLineForms_module_default())["form-radio-main-label"]),
              id: "validationFormxf".concat(index + 101, "-label"),
              children: [index + 1, ". ", item.question]
            }), item === null || item === void 0 ? void 0 : (_item$answers = item.answers) === null || _item$answers === void 0 ? void 0 : _item$answers.answerDocument.map(function (subItem, subIndex) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Check, {
                custom: true,
                className: "".concat((NewLineForms_module_default())["form-radio-label"]),
                id: "validationFormxf".concat(index + 101, "-op-").concat(subIndex + 1),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Input, {
                  name: subItem.answerID,
                  type: "radio",
                  checked: fieldValues[item.productAuthenticationQuestionID] == subItem.answerID ? true : false,
                  onChange: function onChange(e) {
                    return handleChange(e, item.productAuthenticationQuestionID, subItem.answerID);
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Label, {
                  children: subItem.answer
                })]
              }, subIndex);
            })]
          }, index);
        })
      })
    })
  });
};

XdsForm.defaultProps = {
  fieldValues: {}
};
/* harmony default export */ var xdsForm_XdsForm = (XdsForm);
// EXTERNAL MODULE: ./components/atoms/resultInformation/ResultInformation.module.scss
var ResultInformation_module = __webpack_require__(58333);
var ResultInformation_module_default = /*#__PURE__*/__webpack_require__.n(ResultInformation_module);
;// CONCATENATED MODULE: ./components/atoms/resultInformation/ResultInformation.jsx


function ResultInformation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ResultInformation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ResultInformation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ResultInformation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ResultInformation = function ResultInformation(_ref) {
  var analyticsType = _ref.analyticsType,
      iconType = _ref.iconType,
      title = _ref.title,
      desc = _ref.desc,
      className = _ref.className,
      formName = _ref.formName,
      pageName = _ref.pageName;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var getIcon = function getIcon() {
    var icon;

    switch (iconType) {
      case "failed":
        icon = "lock.svg";
        break;

      case "success":
        icon = "success-circle.svg";
        break;

      case "loading":
        icon = "lock-loading.gif";
        break;
    }

    return "".concat(imagePrefix, "/assets/images/").concat(icon);
  };

  (0,react.useEffect)(function () {
    if (pageName && formName && analyticsType) {
      analyticsUtag/* view */.ei(ResultInformation_objectSpread({
        page_event: "view",
        page_name: "".concat(pageName, ": ").concat(formName, " ").concat(analyticsType)
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
    }
  }, [iconType]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((ResultInformation_module_default())["main-container"], " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ResultInformation_module_default()).icon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: getIcon()
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ResultInformation_module_default()).title,
      children: [" ", title, " "]
    }), desc && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ResultInformation_module_default()).desc,
      children: [" ", desc, " "]
    })]
  });
};

ResultInformation.defaultProps = {
  analyticsType: "checking loading",
  iconType: "loading",
  title: "Your application has been successfully authenticated",
  desc: null,
  formName: null,
  pageName: null
};
/* harmony default export */ var resultInformation_ResultInformation = (ResultInformation);
// EXTERNAL MODULE: ./components/organisms/checkoutXds/CheckoutXds.module.scss
var CheckoutXds_module = __webpack_require__(95183);
var CheckoutXds_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutXds_module);
;// CONCATENATED MODULE: ./components/organisms/checkoutXds/CheckoutXds.jsx




function CheckoutXds_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckoutXds_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckoutXds_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckoutXds_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var CheckoutXds = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var continueDisable = _ref.continueDisable,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      authDetails = _ref.authDetails,
      customerStatus = _ref.customerStatus,
      checkoutDetails = _ref.checkoutDetails,
      setShowSnackBar = _ref.setShowSnackBar,
      handleHeading = _ref.handleHeading,
      navigate = _ref.navigate,
      multicartFlag = _ref.multicartFlag;

  var _useState = (0,react.useState)(null),
      apiResponse = _useState[0],
      setApiResponse = _useState[1];

  var _useState2 = (0,react.useState)(null),
      formContent = _useState2[0],
      setFormContent = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      submitDisabled = _useState3[0],
      setSubmitDisabled = _useState3[1];

  var dispatch = (0,DependencyHelper.useDispatch)();

  var _useState4 = (0,react.useState)({
    visible: true,
    analyticsType: null,
    iconType: "loading",
    title: labels/* default.xds.lbl_question_fetching_title */.Z.xds.lbl_question_fetching_title,
    desc: null
  }),
      showResult = _useState4[0],
      setShowResult = _useState4[1];

  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: authentication: ".concat(customerStatus, ": xds: continue")
        });
        continueDisable(true);

        if (checkoutDetails.skipCreditVetting) {
          //navigate to review
          navigate("review");
        } else {
          //navigate to credit check
          navigate("creditCheck");
        }
      },
      back: function back() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: authentication: ".concat(customerStatus, ": xds: back to lets get started")
        });
      }
    };
  });

  var _useState5 = (0,react.useState)({
    errorStatus: {
      xds: true
    },
    fieldValues: {
      xds: {}
    }
  }),
      state = _useState5[0],
      setState = _useState5[1];

  var errorStatus = state.errorStatus,
      fieldValues = state.fieldValues;
  (0,react.useEffect)(function () {
    if (formContent && customerStatus) {
      analyticsUtag/* view */.ei(CheckoutXds_objectSpread({
        page_event: "view",
        page_name: "checkout: authentication: ".concat(customerStatus, ": xds"),
        page_channel: "checkout",
        page_master_tab: "personal",
        multicart_flag: multicartFlag ? true : false
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetails)));
    }
  }, [formContent, customerStatus]);
  /**
   * Get the question and answer of form
   */

  (0,react.useEffect)(function () {
    fetchQuestionData();
  }, []);

  var fetchQuestionData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _checkoutDetails$auth, _checkoutDetails$auth2;

      var reqParams, _res$response, _response$result, _response$result$conn, _response$result2, _response$result2$con, _response$result2$con2, _response$result2$con3, _response$result2$con4, res, response;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reqParams = [(_checkoutDetails$auth = checkoutDetails.authDetails) === null || _checkoutDetails$auth === void 0 ? void 0 : _checkoutDetails$auth.idNumber, (_checkoutDetails$auth2 = checkoutDetails.authDetails) === null || _checkoutDetails$auth2 === void 0 ? void 0 : _checkoutDetails$auth2.msisdn];
              _context.prev = 1;
              _context.next = 4;
              return microServices/* default.get */.Z.get("api", "questionsAndAnswers", null, false, reqParams);

            case 4:
              res = _context.sent;
              response = (_res$response = res.response) === null || _res$response === void 0 ? void 0 : _res$response.data;

              if (response !== null && response !== void 0 && (_response$result = response.result) !== null && _response$result !== void 0 && (_response$result$conn = _response$result.connectFraudGetQuestionsResult) !== null && _response$result$conn !== void 0 && _response$result$conn.currentObjectState) {
                setApiResponse(response.result.connectFraudGetQuestionsResult.currentObjectState);
              }

              if (response !== null && response !== void 0 && (_response$result2 = response.result) !== null && _response$result2 !== void 0 && (_response$result2$con = _response$result2.connectFraudGetQuestionsResult) !== null && _response$result2$con !== void 0 && (_response$result2$con2 = _response$result2$con.currentObjectState) !== null && _response$result2$con2 !== void 0 && (_response$result2$con3 = _response$result2$con2.authenticationDocument) !== null && _response$result2$con3 !== void 0 && (_response$result2$con4 = _response$result2$con3.questions) !== null && _response$result2$con4 !== void 0 && _response$result2$con4.questionDocument) {
                setFormContent(response.result.connectFraudGetQuestionsResult.currentObjectState.authenticationDocument.questions.questionDocument);
                handleHeading("show", "desc");
                setShowResult({
                  visible: false
                });
              } else {
                setShowResult({
                  visible: true,
                  analyticsType: "technical error",
                  iconType: "failed",
                  title: labels/* default.xds.lbl_error_title */.Z.xds.lbl_error_title,
                  desc: labels/* default.xds.lbl_error_desc */.Z.xds.lbl_error_desc
                });
                continueDisable(false);
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              setShowResult({
                visible: true,
                analyticsType: "technical error",
                iconType: "failed",
                title: labels/* default.xds.lbl_error_title */.Z.xds.lbl_error_title,
                desc: labels/* default.xds.lbl_error_desc */.Z.xds.lbl_error_desc
              });
              continueDisable(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function fetchQuestionData() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Set the initial state of form fieldvalues
   *
   * @call when formContent state value is set
   */


  (0,react.useEffect)(function () {
    if (formContent) {
      var totalQuestion = formContent.length;

      for (var i = 0; i < totalQuestion; i++) {
        var questionId = formContent[i].productAuthenticationQuestionID;
        fieldValues["xds"][questionId] = "";
      }

      setState(CheckoutXds_objectSpread(CheckoutXds_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [formContent]);
  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, name, value, form) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              _context2.next = 3;
              return fieldValidationCheck(name, value, form);

            case 3:
              _context2.next = 5;
              return checkFormError(form);

            case 5:
              errorStatus[form] = _context2.sent;
              setState(CheckoutXds_objectSpread(CheckoutXds_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus[form]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldValues
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(name, value, form) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fieldValues[form][name] = value;
              closeSnackBar();
              setState(CheckoutXds_objectSpread(CheckoutXds_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fieldValidationCheck(_x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = Object.values(state.fieldValues[form]);

    for (var _i = 0, _values = values; _i < _values.length; _i++) {
      var value = _values[_i];

      if (value == "") {
        return true;
      }
    }

    return false;
  }
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i2 = 0, _errValues = errValues; _i2 < _errValues.length; _i2++) {
      var err = _errValues[_i2];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();

    if (!state.errorStatus["xds"]) {
      analyticsUtag/* link */.p4(CheckoutXds_objectSpread(CheckoutXds_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
        link_type: "o",
        link_name: "checkout: authentication: ".concat(customerStatus, ": xds: submit answers")
      }));
      submitForm();
    } else {
      displaySnackBar(labels/* default.errors.lbl_form_not_submitted_fill_required */.Z.errors.lbl_form_not_submitted_fill_required, "form_level");
      window.scrollTo(0, 0);
      event.stopPropagation();
    }
  };
  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */


  var mapFieldData = function mapFieldData() {
    var _apiResponse$authenti, _apiResponse$authenti2, _apiResponse$authenti3, _apiResponse$authenti4, _apiResponse$authenti5, _apiResponse$authenti6, _apiResponse$authenti7, _apiResponse$authenti8, _apiResponse$authenti9, _apiResponse$authenti10, _apiResponse$authenti11;

    var questionsObj = mapQuestionsData();
    return {
      procesAction: "AUTHENTICATE",
      myAuthenticationProcess: {
        currentObjectState: {
          authenticationDocument: {
            subscriberID: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti = apiResponse.authenticationDocument) === null || _apiResponse$authenti === void 0 ? void 0 : _apiResponse$authenti.subscriberID,
            subscriberAuthenticationID: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti2 = apiResponse.authenticationDocument) === null || _apiResponse$authenti2 === void 0 ? void 0 : _apiResponse$authenti2.subscriberAuthenticationID,
            authenticationDate: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti3 = apiResponse.authenticationDocument) === null || _apiResponse$authenti3 === void 0 ? void 0 : _apiResponse$authenti3.authenticationDate,
            requiredAuthenticatedPerc: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti4 = apiResponse.authenticationDocument) === null || _apiResponse$authenti4 === void 0 ? void 0 : _apiResponse$authenti4.requiredAuthenticatedPerc,
            authenticatedPerc: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti5 = apiResponse.authenticationDocument) === null || _apiResponse$authenti5 === void 0 ? void 0 : _apiResponse$authenti5.authenticatedPerc,
            idNo: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti6 = apiResponse.authenticationDocument) === null || _apiResponse$authenti6 === void 0 ? void 0 : _apiResponse$authenti6.idNo,
            errorMessage: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti7 = apiResponse.authenticationDocument) === null || _apiResponse$authenti7 === void 0 ? void 0 : _apiResponse$authenti7.errorMessage,
            noofAttemptsRemaining: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti8 = apiResponse.authenticationDocument) === null || _apiResponse$authenti8 === void 0 ? void 0 : _apiResponse$authenti8.noofAttemptsRemaining,
            authenticationStatusReason: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti9 = apiResponse.authenticationDocument) === null || _apiResponse$authenti9 === void 0 ? void 0 : _apiResponse$authenti9.authenticationStatusReason,
            blockingReason: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti10 = apiResponse.authenticationDocument) === null || _apiResponse$authenti10 === void 0 ? void 0 : _apiResponse$authenti10.blockingReason,
            questions: {
              questionDocument: questionsObj
            },
            userBlocked: apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$authenti11 = apiResponse.authenticationDocument) === null || _apiResponse$authenti11 === void 0 ? void 0 : _apiResponse$authenti11.userBlocked
          },
          currentQuestionNum: apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.currentQuestionNum
        }
      }
    };
  };
  /**
   * Form submit request payload
   *
   * @usage map the question key-value pair request
   */


  var mapQuestionsData = function mapQuestionsData() {
    var quesArr = formContent;
    var quesLen = quesArr.length;

    for (var i = 0; i < quesLen; i++) {
      if (state.fieldValues["xds"][quesArr[i].productAuthenticationQuestionID]) {
        var ansLen = quesArr[i].answers.answerDocument.length;

        for (var j = 0; j < ansLen; j++) {
          if (quesArr[i].answers.answerDocument[j].answerID == state.fieldValues["xds"][quesArr[i].productAuthenticationQuestionID]) {
            quesArr[i].answers.answerDocument[j].enteredAnswerYN = true;
            quesArr[i].answers.answerDocument[j].isEnteredAnswerYN = true;
          } else {
            quesArr[i].answers.answerDocument[j].isEnteredAnswerYN = false;
          }
        }
      }
    }

    return quesArr;
  };
  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var inputObj, _responseData$respons, _responseData$respons2, _responseData$respons3, responseData, reduxInfo, _responseData$respons4, _responseData$respons5, _responseData$respons6, _responseData$error;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              inputObj = mapFieldData();
              _context4.prev = 1;
              handleHeading("hide", "desc");
              setShowResult({
                visible: true,
                analyticsType: null,
                iconType: "loading",
                title: labels/* default.xds.lbl_checking_answer_title */.Z.xds.lbl_checking_answer_title,
                desc: null
              });
              _context4.next = 6;
              return microServices/* default.post */.Z.post("api", "submitXdsAnswers", inputObj, null, false);

            case 6:
              responseData = _context4.sent;
              reduxInfo = {
                authenticationStatusReason: ""
              };

              if ((_responseData$respons = responseData.response) !== null && _responseData$respons !== void 0 && (_responseData$respons2 = _responseData$respons.data) !== null && _responseData$respons2 !== void 0 && (_responseData$respons3 = _responseData$respons2.result) !== null && _responseData$respons3 !== void 0 && _responseData$respons3.authenticationStatusReason) {
                if (((_responseData$respons4 = responseData.response) === null || _responseData$respons4 === void 0 ? void 0 : (_responseData$respons5 = _responseData$respons4.data) === null || _responseData$respons5 === void 0 ? void 0 : (_responseData$respons6 = _responseData$respons5.result) === null || _responseData$respons6 === void 0 ? void 0 : _responseData$respons6.authenticationStatusReason) == "Authenticated") {
                  reduxInfo.authenticationStatusReason = "success";
                  setShowResult({
                    visible: true,
                    analyticsType: "success",
                    iconType: "success",
                    title: labels/* default.xds.lbl_success_title */.Z.xds.lbl_success_title,
                    desc: labels/* default.xds.lbl_success_desc */.Z.xds.lbl_success_desc
                  });
                } else {
                  reduxInfo.authenticationStatusReason = "failed";
                  setShowResult({
                    visible: true,
                    analyticsType: "failed",
                    iconType: "failed",
                    title: labels/* default.xds.lbl_failed_title */.Z.xds.lbl_failed_title,
                    desc: labels/* default.xds.lbl_failed_desc */.Z.xds.lbl_failed_desc
                  });
                }
              } else {
                if ((responseData === null || responseData === void 0 ? void 0 : (_responseData$error = responseData.error) === null || _responseData$error === void 0 ? void 0 : _responseData$error.status) === 401) {
                  reduxInfo.authenticationStatusReason = "failed";
                  setShowResult({
                    visible: true,
                    analyticsType: "technical error",
                    iconType: "failed",
                    title: labels/* default.xds.lbl_failed_title */.Z.xds.lbl_failed_title,
                    desc: labels/* default.xds.lbl_failed_desc */.Z.xds.lbl_failed_desc
                  });
                } else {
                  reduxInfo.authenticationStatusReason = "error";
                  setShowResult({
                    visible: true,
                    analyticsType: "technical error",
                    iconType: "failed",
                    title: labels/* default.xds.lbl_error_title */.Z.xds.lbl_error_title,
                    desc: labels/* default.xds.lbl_error_desc */.Z.xds.lbl_error_desc
                  });
                }
              }

              dispatch({
                type: actionTypes/* SET_XDS_RESULT */.AH,
                payload: reduxInfo
              });
              continueDisable(false);
              _context4.next = 18;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](1);
              setShowResult({
                visible: true,
                analyticsType: "technical error",
                iconType: "failed",
                title: labels/* default.xds.lbl_error_title */.Z.xds.lbl_error_title,
                desc: labels/* default.xds.lbl_error_desc */.Z.xds.lbl_error_desc
              });
              dispatch({
                type: actionTypes/* SET_XDS_RESULT */.AH,
                payload: {
                  authenticationStatusReason: "error"
                }
              });
              continueDisable(false);

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 13]]);
    }));

    return function submitForm() {
      return _ref5.apply(this, arguments);
    };
  }();

  var displaySnackBar = function displaySnackBar(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page_level";
    setShowSnackBar({
      visible: true,
      message: message
    });
    var pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page"
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = "checkout: authentication: ".concat(customerStatus, ": xds");
      pageAnalyticsData.page_error_type = "form";
    }

    analyticsUtag/* link */.p4(CheckoutXds_objectSpread(CheckoutXds_objectSpread(CheckoutXds_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), pageAnalyticsData), {}, {
      link_type: "o",
      link_name: "checkout: authentication: ".concat(customerStatus, ": xds: submit answers")
    }));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutXds_module_default()).container),
      children: [!showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
        contents: labels/* default.xds.lbl_info */.Z.xds.lbl_info,
        className: (CheckoutXds_module_default())["standard-box"],
        id: "checkout-xds-standard-delivery",
        iconType: "info"
      }), !showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        className: "".concat((CheckoutXds_module_default()).form),
        noValidate: true,
        id: "checkout-xds-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(xdsForm_XdsForm, {
          formContent: formContent,
          formName: "xds",
          fieldValues: state.fieldValues["xds"],
          onChangeHandler: handleChange
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutXds_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutXds_module_default()).button,
            id: "checkout-xds-form-submit",
            children: "Submit answers"
          })
        })]
      }), showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(resultInformation_ResultInformation, {
        className: (CheckoutXds_module_default()).information,
        title: showResult.title,
        analyticsType: showResult.analyticsType,
        iconType: showResult.iconType,
        desc: showResult.desc,
        formName: "xds",
        pageName: "checkout: authentication: ".concat(customerStatus)
      })]
    })
  });
});
/* harmony default export */ var checkoutXds_CheckoutXds = (CheckoutXds);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/personalDetailsForm/PersonalDetailsForm.jsx






var PersonalDetailsForm = function PersonalDetailsForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      titles = _ref.titles,
      maritalStatusList = _ref.maritalStatusList,
      genders = _ref.genders,
      onResetHandler = _ref.onResetHandler,
      idType = _ref.idType,
      onBlurHandler = _ref.onBlurHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "6",
          md: "6",
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormpd101",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormpd101-label",
            children: "Title"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "title",
            label: "Title",
            data: titles,
            required: true,
            handleSelect: onChangeHandler,
            handleReset: onResetHandler,
            handleBlur: handleBlur,
            resetRequired: true,
            selectedId: fieldValues["title"],
            customId: "validationFormpd101",
            fieldError: fieldErrors["title"]
          }), fieldErrors["title"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["title"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "6",
          md: "6",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormpd102",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormpd102-label",
            children: "Initials"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "initials",
            value: fieldValues["initials"],
            placeholder: "Add initials",
            required: true,
            onBlur: handleBlur,
            onChange: handleChange,
            isInvalid: fieldErrors["initials"],
            className: fieldErrors["initials"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["initials"]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormpd103",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormpd103-label",
          children: "First name"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          name: "firstName",
          value: fieldValues["firstName"],
          placeholder: "Add your first name",
          required: true,
          onBlur: handleBlur,
          onChange: handleChange,
          isInvalid: fieldErrors["firstName"],
          className: fieldErrors["firstName"] ? (NewLineForms_module_default()).invalid : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (NewLineForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["firstName"]
        }), !fieldErrors["firstName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NewLineForms_module_default())["hint-text"],
          children: "As it appears on your ID / passport"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormpd104",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormpd104-label",
          children: "Surname"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          name: "surName",
          value: fieldValues["surName"],
          placeholder: "Add your surname",
          required: true,
          onBlur: handleBlur,
          onChange: handleChange,
          isInvalid: fieldErrors["surName"],
          className: fieldErrors["surName"] ? (NewLineForms_module_default()).invalid : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (NewLineForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["surName"]
        }), !fieldErrors["surName"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NewLineForms_module_default())["hint-text"],
          children: "As it appears on your ID / passport"
        })]
      }), idType !== "SAID" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormpd105",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormpd105-label",
          children: "Gender"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
          formName: formName,
          name: "gender",
          label: "Gender",
          data: genders,
          required: true,
          handleBlur: handleBlur,
          handleSelect: onChangeHandler,
          handleReset: onResetHandler,
          selectedId: fieldValues["gender"],
          customId: "validationFormpd105",
          resetRequired: true,
          fieldError: fieldErrors["gender"]
        }), fieldErrors["gender"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
          children: fieldErrorsMessage["gender"]
        })]
      }), idType !== "SAID" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormpd106",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormpd106-label",
          children: "Date of birth"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          name: "dob",
          value: fieldValues["dob"],
          placeholder: "DD / MM / YYYY",
          required: true,
          maxLength: "14",
          onBlur: handleBlur,
          onChange: handleChange,
          isInvalid: fieldErrors["dob"],
          className: fieldErrors["dob"] ? (NewLineForms_module_default()).invalid : ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (NewLineForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["dob"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormpd107",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormpd107-label",
          children: "Marital status"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
          formName: formName,
          name: "maritalStatus",
          label: "Marital status",
          data: maritalStatusList,
          required: true,
          handleBlur: handleBlur,
          handleSelect: onChangeHandler,
          handleReset: onResetHandler,
          selectedId: fieldValues["maritalStatus"],
          customId: "validationFormpd107",
          resetRequired: true,
          fieldError: fieldErrors["maritalStatus"]
        }), fieldErrors["maritalStatus"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
          children: fieldErrorsMessage["maritalStatus"]
        })]
      })]
    })
  });
};

PersonalDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  idType: ""
};
/* harmony default export */ var personalDetailsForm_PersonalDetailsForm = (PersonalDetailsForm);
// EXTERNAL MODULE: ./components/atoms/newLineForms/creditCheckDetails/CreditCheckDetails.module.scss
var CreditCheckDetails_module = __webpack_require__(83785);
var CreditCheckDetails_module_default = /*#__PURE__*/__webpack_require__.n(CreditCheckDetails_module);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/personalDetailsInfo/PersonalDetailsInfo.jsx





var PersonalDetailsInfo = function PersonalDetailsInfo(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Title:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Initials:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.initials
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "First name:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.firstName
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Surname:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.surName
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Marital status:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.maritalStatus
        })
      })]
    })
  });
};

PersonalDetailsInfo.defaultProps = {
  data: {}
};
/* harmony default export */ var personalDetailsInfo_PersonalDetailsInfo = (PersonalDetailsInfo);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./components/molecules/checkoutCreditCheck/CheckoutCreditCheck.module.scss
var CheckoutCreditCheck_module = __webpack_require__(21373);
var CheckoutCreditCheck_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutCreditCheck_module);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/personalDetails/PersonalDetails.jsx




function PersonalDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = PersonalDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function PersonalDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return PersonalDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PersonalDetails_arrayLikeToArray(o, minLen); }

function PersonalDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function PersonalDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PersonalDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PersonalDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PersonalDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var analyticsTags = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];
/**
 * Personal Details component holds the logic of personal detail form validation logic,
 * handling all the API calls and analytics
 */

var PersonalDetails = function PersonalDetails(_ref) {
  var customerStatus = _ref.customerStatus,
      personalDetailsData = _ref.personalDetailsData,
      loadLookupData = _ref.loadLookupData,
      authDetailsData = _ref.authDetailsData,
      onFormSubmit = _ref.onFormSubmit,
      profileData = _ref.profileData,
      doCreditCheckDisable = _ref.doCreditCheckDisable;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(true),
      submitDisabled = _useState2[0],
      setSubmitDisabled = _useState2[1];

  var _useState3 = (0,react.useState)(personalDetailsData ? false : true),
      displayEditMode = _useState3[0],
      setDisplayEditMode = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      titles = _useState4[0],
      setTitles = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      maritalStatus = _useState5[0],
      setMaritalStatus = _useState5[1];

  var _useState6 = (0,react.useState)(["Male", "Female"]),
      gender = _useState6[0],
      setGender = _useState6[1];

  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.personal */.Z.creditCheckout.errors.personal));
  var dispatch = (0,DependencyHelper.useDispatch)();
  (0,react.useEffect)(function () {
    if (personalDetailsData) {
      fieldValues.personalDetails.title = personalDetailsData.title;
      fieldValues.personalDetails.initials = personalDetailsData.initials;
      fieldValues.personalDetails.firstName = personalDetailsData.firstName;
      fieldValues.personalDetails.surName = personalDetailsData.surName;
      fieldValues.personalDetails.gender = personalDetailsData.gender;
      fieldValues.personalDetails.dob = personalDetailsData.dob;
      fieldValues.personalDetails.maritalStatus = personalDetailsData.maritalStatus;
      errorStatus.personalDetails = checkFormError("personalDetails");

      if (errorStatus.personalDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    } else if (profileData) {
      fieldValues.personalDetails.firstName = profileData !== null && profileData !== void 0 && profileData.firstname ? profileData.firstname : "";

      if (!helperServices/* charRegExpForName.test */.lW.test(profileData === null || profileData === void 0 ? void 0 : profileData.firstname)) {
        fieldErrors["personalDetails"].firstName = true;
        fieldErrorsMessage["personalDetails"].firstName = errorMessages/* default.creditCheckout.personalDetails.firstName.onlyValid */.Z.creditCheckout.personalDetails.firstName.onlyValid;
        inlineAnalytics(errorMessages/* default.creditCheckout.personalDetails.firstName.onlyValid */.Z.creditCheckout.personalDetails.firstName.onlyValid);
      } else if ((profileData === null || profileData === void 0 ? void 0 : profileData.firstname.length) < 3) {
        fieldErrors["personalDetails"].firstName = true;
        fieldErrorsMessage["personalDetails"].firstName = errorMessages/* default.creditCheckout.personalDetails.firstName.minCharacters */.Z.creditCheckout.personalDetails.firstName.minCharacters;
        inlineAnalytics(errorMessages/* default.creditCheckout.personalDetails.firstName.minCharacters */.Z.creditCheckout.personalDetails.firstName.minCharacters);
      } else {
        fieldErrors["personalDetails"].firstName = false;
      }

      setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
        fieldErrors: fieldErrors,
        fieldValues: fieldValues,
        fieldErrorsMessage: fieldErrorsMessage
      }));
    }
  }, [personalDetailsData, profileData]);

  var _useState7 = (0,react.useState)({
    validationsOn: {
      personalDetails: true
    },
    errorStatus: {
      personalDetails: true
    },
    validations: {
      personalDetails: {
        title: true,
        initials: true,
        firstName: true,
        surName: true,
        gender: true,
        dob: true,
        maritalStatus: true
      }
    },
    fieldErrors: {
      personalDetails: {
        title: false,
        initials: false,
        firstName: false,
        surName: false,
        gender: false,
        dob: false,
        maritalStatus: false
      },
      fail: false
    },
    fieldValues: {
      personalDetails: {
        title: "",
        initials: "",
        firstName: "",
        surName: "",
        gender: "",
        dob: "",
        maritalStatus: ""
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState7[0],
      setState = _useState7[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  (0,react.useEffect)(function () {
    setTitles(capitalizeTitles(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.TITLES));
    setMaritalStatus(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.MARITAL_STATUSES);
  }, []);
  /**
   * This function is used to get capitalized titles from the loadlookup api
   *
   * @call onLoad event
   */

  var capitalizeTitles = function capitalizeTitles(strValues) {
    var updatedTitles = [];

    if (strValues) {
      strValues.map(function (item) {
        if ((0,helperServices/* capitalizeFirstLetter */.fm)(item) === "Dr") {
          updatedTitles.push("Dr.");
        } else {
          updatedTitles.push((0,helperServices/* capitalizeFirstLetter */.fm)(item));
        }
      });
    }

    return updatedTitles;
  };
  /** This function is used to get birthdate and gender from the SAID number
   * @call onLoad event
   */


  (0,react.useEffect)(function () {
    if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "SAID") {
      var idNumber = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber;

      var bday = idNumber.toString().slice(0, 6),
          _gender = idNumber.toString().slice(6, 10);

      var d = new Date(),
          y = d.getFullYear();
      var lasty = parseInt(y.toString().slice(0, 2));
      var n = d.getFullYear() - 100,
          l = parseInt(n.toString().substr(-2));
      var u = parseInt(100 - l);
      var yy = bday.toString().slice(0, 2),
          mm = bday.toString().slice(2, 4),
          dd = bday.toString().slice(4, 6);
      fieldValues["personalDetails"]["gender"] = getGenderFromSAID(_gender);
      fieldValues["personalDetails"]["dob"] = getBirthYearFromSAID(yy, l, u, lasty, mm, dd);
      setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, []);
  /**
   * This function is used to get birthdate from entered SAID
   *
   * @usage Set the user's birthdate
   * @call onLoad event
   */

  var getBirthYearFromSAID = function getBirthYearFromSAID(value, l, u, lasty, mm, dd) {
    var bdate = "";
    var f_lower = Math.min(0, l),
        f_upper = Math.max(0, l),
        m_lower = Math.min(l + 1, u),
        m_upper = Math.max(l + 1, 100);

    if (value >= f_lower && value <= f_upper) {
      bdate = dd + " / " + mm + " / " + lasty.toString().concat(("0" + value).slice(-2));
    }

    if (value >= m_lower && value <= m_upper) {
      bdate = dd + " / " + mm + " / " + (lasty - 1).toString().concat(("0" + value).slice(-2));
    }

    return bdate;
  };
  /**
   * This function is used to get gender from entered SAID
   *
   * @usage Set the user's gender
   * @call onLoad event
   */


  var getGenderFromSAID = function getGenderFromSAID(value) {
    var gender = "";
    var f_lower = Math.min(0, 4999),
        f_upper = Math.max(0, 4999),
        m_lower = Math.min(5000, 9999),
        m_upper = Math.max(5000, 9999);

    if (value >= f_lower && value <= f_upper) {
      gender = "female";
    }

    if (value >= m_lower && value <= m_upper) {
      gender = "male";
    }

    return gender;
  };
  /**
   * Form input field change event handler
   *
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": personal details")
                }));
                setAnalytics(true);
              }

              _context.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, errMsg;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              _context2.next = 3;
              return fieldValidationCheck(event, val, form);

            case 3:
              _context2.next = 5;
              return checkFormError(form);

            case 5:
              errorStatus[form] = _context2.sent;
              setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                name = event.target.name;
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBlur(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(name, form) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = name;
              _context3.next = _context3.t0 === "title" ? 3 : _context3.t0 === "maritalStatus" ? 5 : _context3.t0 === "gender" ? 7 : 9;
              break;

            case 3:
              fieldValues[form].title = "";
              return _context3.abrupt("break", 9);

            case 5:
              fieldValues[form].maritalStatus = "";
              return _context3.abrupt("break", 9);

            case 7:
              if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) !== "SAID") {
                fieldValues[form].gender = "";
              }

              return _context3.abrupt("break", 9);

            case 9:
              _context3.next = 11;
              return checkFormError(form);

            case 11:
              errorStatus[form] = _context3.sent;
              setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues,
                errorStatus: errorStatus
              }));

              if (errorStatus[form]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReset(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }
  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, val, form) {
      var name, value, _fieldValues$form$gen;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context4.t0 = name;
              _context4.next = _context4.t0 === "title" ? 5 : _context4.t0 === "initials" ? 7 : _context4.t0 === "firstName" ? 9 : _context4.t0 === "surName" ? 11 : _context4.t0 === "gender" ? 13 : _context4.t0 === "maritalStatus" ? 15 : _context4.t0 === "dob" ? 17 : 19;
              break;

            case 5:
              if (state.validationsOn[form] && state.validations[form].title) {
                if ((value === null || value === void 0 ? void 0 : value.length) == 0) {
                  fieldErrors[form].title = true;
                  fieldErrorsMessage[form].title = state.fieldErrorsMessage.personalDetails.title;
                } else {
                  fieldErrors[form].title = false;
                }

                fieldErrors.fail = fieldErrors[form].title;
              } else {
                fieldErrors[form].title = false;
              }

              return _context4.abrupt("break", 19);

            case 7:
              if (state.validationsOn[form] && state.validations[form].initials) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* charRegExp.test */.D0.test(value)) {
                    fieldErrors[form].initials = true;
                    fieldErrorsMessage[form].initials = errorMessages/* default.creditCheckout.personalDetails.initials.onlyValid */.Z.creditCheckout.personalDetails.initials.onlyValid;
                  } else {
                    fieldErrors[form].initials = false;
                  }
                } else {
                  fieldErrors[form].initials = true;
                  fieldErrorsMessage[form].initials = errorMessages/* default.creditCheckout.errors.personal.personalDetails.initials */.Z.creditCheckout.errors.personal.personalDetails.initials;
                }

                fieldErrors.fail = fieldErrors[form].initials;
              } else {
                fieldErrors[form].initials = false;
              }

              return _context4.abrupt("break", 19);

            case 9:
              if (state.validationsOn[form] && state.validations[form].firstName) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* nameRegex.test */.yJ.test(value)) {
                    fieldErrors[form].firstName = true;
                    fieldErrorsMessage[form].firstName = errorMessages/* default.creditCheckout.personalDetails.firstName.onlyValid */.Z.creditCheckout.personalDetails.firstName.onlyValid;
                  } else if (value.length < 3) {
                    fieldErrors[form].firstName = true;
                    fieldErrorsMessage[form].firstName = errorMessages/* default.creditCheckout.personalDetails.firstName.minCharacters */.Z.creditCheckout.personalDetails.firstName.minCharacters;
                  } else {
                    fieldErrors[form].firstName = false;
                  }
                } else {
                  fieldErrors[form].firstName = true;
                  fieldErrorsMessage[form].firstName = errorMessages/* default.creditCheckout.errors.personal.personalDetails.firstName */.Z.creditCheckout.errors.personal.personalDetails.firstName;
                }

                fieldErrors.fail = fieldErrors[form].firstName;
              } else {
                fieldErrors[form].firstName = false;
              }

              return _context4.abrupt("break", 19);

            case 11:
              if (state.validationsOn[form] && state.validations[form].surName) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* nameRegex.test */.yJ.test(value)) {
                    fieldErrors[form].surName = true;
                    fieldErrorsMessage[form].surName = errorMessages/* default.creditCheckout.personalDetails.surName.onlyValid */.Z.creditCheckout.personalDetails.surName.onlyValid;
                  } else if (value.length <= 2) {
                    fieldErrors[form].surName = true;
                    fieldErrorsMessage[form].surName = errorMessages/* default.creditCheckout.personalDetails.surName.minCharacters */.Z.creditCheckout.personalDetails.surName.minCharacters;
                  } else {
                    fieldErrors[form].surName = false;
                  }
                } else {
                  fieldErrors[form].surName = true;
                  fieldErrorsMessage[form].surName = errorMessages/* default.creditCheckout.errors.personal.personalDetails.surName */.Z.creditCheckout.errors.personal.personalDetails.surName;
                }

                fieldErrors.fail = fieldErrors[form].surName;
              } else {
                fieldErrors[form].surName = false;
              }

              return _context4.abrupt("break", 19);

            case 13:
              if (state.validationsOn[form] && state.validations[form].gender) {
                if (((_fieldValues$form$gen = fieldValues[form].gender) === null || _fieldValues$form$gen === void 0 ? void 0 : _fieldValues$form$gen.length) > 0) {
                  if (fieldValues[form].gender === constants/* MALE */.UV) {
                    if (state.fieldValues[form].title === constants/* MRS */.tV || state.fieldValues[form].title === constants/* MISS */.QO) {
                      fieldErrors[form].gender = true;
                      fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.personalDetails.gender.matchValue */.Z.creditCheckout.personalDetails.gender.matchValue;
                    } else {
                      fieldErrors[form].gender = false;
                    }
                  } else if (fieldValues[form].gender === constants/* FEMALE */.W1) {
                    if (state.fieldValues[form].title === constants.MR) {
                      fieldErrors[form].gender = true;
                      fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.personalDetails.gender.matchValue */.Z.creditCheckout.personalDetails.gender.matchValue;
                    } else {
                      fieldErrors[form].gender = false;
                    }
                  }
                } else {
                  fieldErrors[form].gender = true;
                  fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.errors.personal.personalDetails.gender */.Z.creditCheckout.errors.personal.personalDetails.gender;
                }

                fieldErrors.fail = fieldErrors[form].gender;
              } else {
                fieldErrors[form].gender = false;
              }

              return _context4.abrupt("break", 19);

            case 15:
              if (state.validationsOn[form] && state.validations[form].maritalStatus) {
                if ((value === null || value === void 0 ? void 0 : value.length) == 0) {
                  fieldErrors[form].maritalStatus = true;
                  fieldErrorsMessage[form].maritalStatus = state.fieldErrorsMessage.personalDetails.maritalStatus;
                } else {
                  fieldErrors[form].maritalStatus = false;
                }

                fieldErrors.fail = fieldErrors[form].maritalStatus;
              } else {
                fieldErrors[form].maritalStatus = false;
              }

              return _context4.abrupt("break", 19);

            case 17:
              if (state.validationsOn[form] && state.validations[form].dob) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* dateRegex.test */.f9.test(value)) {
                    fieldErrors[form].dob = true;
                    fieldErrorsMessage[form].dob = errorMessages/* default.creditCheckout.personalDetails.dob.onlyValid */.Z.creditCheckout.personalDetails.dob.onlyValid;
                  } else {
                    if ((0,helperServices/* getAge */.Ay)(value) < 18) {
                      fieldErrors[form].dob = true;
                      fieldErrorsMessage[form].dob = errorMessages/* default.creditCheckout.personalDetails.dob.minAge */.Z.creditCheckout.personalDetails.dob.minAge;
                    } else {
                      fieldErrors[form].dob = false;
                    }
                  }
                } else {
                  fieldErrors[form].dob = true;
                  fieldErrorsMessage[form].dob = errorMessages/* default.creditCheckout.errors.personal.personalDetails.dob */.Z.creditCheckout.errors.personal.personalDetails.dob;
                }

                fieldErrors.fail = fieldErrors[form].dob;
              } else {
                fieldErrors[form].dob = false;
              }

              return _context4.abrupt("break", 19);

            case 19:
              if (displayEditMode) {
                if (name === "title" || name === "gender" || name === "maritalStatus") {
                  //capture analytics user selects "title, gender, maritalStatus"
                  selectionAnalytics(name, value);
                }
              }

              setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldValues: fieldValues,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fieldValidationCheck(_x9, _x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              fieldValues[form][name] = value;

              if (name === "title") {
                if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) !== "SAID") {
                  fieldErrors[form].gender = false;

                  if (value === constants.MR) {
                    fieldValues[form].gender = constants/* MALE */.UV;
                  } else if (value === constants/* MRS */.tV || value === constants/* MISS */.QO) {
                    fieldValues[form].gender = constants/* FEMALE */.W1;
                  } else {
                    fieldValues[form].gender = "";
                  }
                }

                fieldValues[form][name] = value;
              } else if (name == "dob") {
                //call function to add auto slash in date field
                fieldValues[form][name] = (0,helperServices/* addAutoSlash */.sG)(value);
              } else if (name == "gender") {
                if (state.validationsOn[form] && state.validations[form].gender) {
                  if (value.length > 0) {
                    if (value === constants/* MALE */.UV) {
                      if (state.fieldValues[form].title === constants/* MRS */.tV || state.fieldValues[form].title === constants/* MISS */.QO) {
                        fieldErrors[form].gender = true;
                        fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.personalDetails.gender.matchValue */.Z.creditCheckout.personalDetails.gender.matchValue;
                      } else {
                        fieldErrors[form].gender = false;
                      }
                    } else if (value === constants/* FEMALE */.W1) {
                      if (state.fieldValues[form].title === constants.MR) {
                        fieldErrors[form].gender = true;
                        fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.personalDetails.gender.matchValue */.Z.creditCheckout.personalDetails.gender.matchValue;
                      } else {
                        fieldErrors[form].gender = false;
                      }
                    }
                  } else {
                    fieldErrors[form].gender = true;
                    fieldErrorsMessage[form].gender = errorMessages/* default.creditCheckout.errors.personal.personalDetails.gender */.Z.creditCheckout.errors.personal.personalDetails.gender;
                  }

                  fieldErrors.fail = fieldErrors[form].gender;
                } else {
                  fieldErrors[form].gender = false;
                }
              } else {
                fieldValues[form][name] = value;
              }

              setState(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function updateFieldValues(_x12, _x13, _x14) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": personal details"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change(title, gender, maritalStatus)
   */


  var selectionAnalytics = function selectionAnalytics(selectionType, value) {
    analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit ").concat(selectionType, " details"),
      filter_query: value
    }));
  };
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(analyticsTags)), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": personal details: next")
    }));
  };
  /**
   * Set the on page edit
   *
   * @call on edit event
   */


  var setAnalyticsOnPageEdit = function setAnalyticsOnPageEdit() {
    analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit personal details")
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = PersonalDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["personalDetails"]) {
      submitForm();
    }
  };
  /**
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              onFormSubmit(true);
              setDisplayEditMode(false);
              doCreditCheckDisable("personalDetails", false);
              dispatch({
                type: actionTypes/* SET_CREDIT_CHECK_PERSONAL_DATA */.bP,
                payload: PersonalDetails_objectSpread({}, state.fieldValues["personalDetails"])
              });
              analyticsUtag/* link */.p4(PersonalDetails_objectSpread(PersonalDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(analyticsTags)), {}, {
                page_form_event: "success",
                page_form_name: "checkout: credit check: ".concat(customerStatus, ": personal details")
              }));

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function submitForm() {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("personalDetails", true);
    setAnalyticsOnPageEdit();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "personal-details",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-personal.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "success",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), "Personal details", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: "Section 1 of 7"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), !displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(personalDetailsInfo_PersonalDetailsInfo, {
        data: personalDetailsData
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "checkout-credit-check-personal-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(personalDetailsForm_PersonalDetailsForm, {
          formName: "personalDetails",
          fieldValues: state.fieldValues["personalDetails"],
          fieldErrors: state.fieldErrors["personalDetails"],
          fieldErrorsMessage: state.fieldErrorsMessage["personalDetails"],
          onChangeHandler: handleChange,
          onBlurHandler: handleBlur,
          onResetHandler: handleReset,
          titles: (0,helperServices/* convertInToObject */.uB)(titles),
          maritalStatusList: (0,helperServices/* convertInToObject */.uB)(maritalStatus),
          genders: (0,helperServices/* convertInToObject */.uB)(gender),
          idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
          data: personalDetailsData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-personal-form-submit",
            children: "Next"
          })
        })]
      })]
    })
  });
};

var PersonalDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    personalDetailsData: state.creditCheckDetails.personalDetails,
    loadLookupData: state.checkoutDetails.lookupDetails,
    authDetailsData: state.checkoutDetails.authDetails
  };
};

/* harmony default export */ var personalDetails_PersonalDetails = ((0,DependencyHelper.connect)(PersonalDetails_mapStateToProps)(PersonalDetails));
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/employmentDetailsForm/EmploymentDetailsForm.jsx








var EmploymentDetailsForm = function EmploymentDetailsForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      employmentTypes = _ref.employmentTypes,
      employmentCategories = _ref.employmentCategories,
      occupations = _ref.occupations,
      salaryDates = _ref.salaryDates,
      onResetHandler = _ref.onResetHandler,
      onBlurHandler = _ref.onBlurHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed102",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed102-label",
            children: "Employment Type"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "employmentType",
            label: "Employment type",
            data: employmentTypes,
            required: true,
            handleBlur: handleBlur,
            handleSelect: onChangeHandler,
            handleReset: onResetHandler,
            resetRequired: true,
            selectedId: fieldValues["employmentType"],
            customId: "validationFormed102",
            fieldError: fieldErrors["employmentType"]
          }), fieldErrors["employmentType"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["employmentType"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed103",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed103-label",
            children: "Employment category"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "employmentCategory",
            label: "Employment category",
            data: employmentCategories,
            required: true,
            handleBlur: handleBlur,
            handleSelect: onChangeHandler,
            selectedId: fieldValues["employmentCategory"],
            customId: "validationFormed103",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["employmentCategory"]
          }), fieldErrors["employmentCategory"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["employmentCategory"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed101",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed101-label",
            children: "Employer name"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "employerName",
            value: fieldValues["employerName"],
            placeholder: "Add your employer's name",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["employerName"],
            className: fieldErrors["employerName"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["employerName"]
          })]
        }), fieldValues["employmentCategory"] !== "PEN" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed1011",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed1011-label",
            children: "Employer telephone number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "employerNumber",
            value: fieldValues["employerNumber"],
            placeholder: "Add your employer's number",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["employerNumber"],
            className: fieldErrors["employerNumber"] ? (NewLineForms_module_default()).invalid : "",
            maxLength: (0,helperServices/* africaCountryCode */.xJ)(fieldValues["employerNumber"]) ? "11" : "10"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["employerNumber"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed104",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed104-label",
            children: "Occupation"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "occupation",
            label: "Occupation",
            data: occupations,
            required: true,
            handleBlur: handleBlur,
            handleSelect: onChangeHandler,
            selectedId: fieldValues["occupation"],
            customId: "validationFormed104",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["occupation"]
          }), fieldErrors["occupation"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["occupation"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "6",
          md: "6",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed105",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed105-label",
            children: "Salary Date"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "salaryDate",
            label: "Salary date",
            data: salaryDates,
            required: true,
            handleBlur: handleBlur,
            handleSelect: onChangeHandler,
            selectedId: fieldValues["salaryDate"],
            customId: "validationFormed105",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["salaryDate"]
          }), fieldErrors["salaryDate"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["salaryDate"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed106",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed106-label",
            children: "Gross monthly salary"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "grossMonthlySalary",
            value: fieldValues["grossMonthlySalary"],
            placeholder: "Add your gross monthly salary",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["grossMonthlySalary"],
            className: fieldErrors["grossMonthlySalary"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["grossMonthlySalary"]
          }), !fieldErrors["grossMonthlySalary"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((NewLineForms_module_default())["hint-text"], " ").concat((NewLineForms_module_default())["hint-text-spacing"]),
            children: "This is your total monthly salary before deduction"
          })]
        })]
      })
    })
  });
};

EmploymentDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  employmentTypes: [],
  employmentCategories: [],
  occupations: [],
  salaryDates: []
};
/* harmony default export */ var employmentDetailsForm_EmploymentDetailsForm = (EmploymentDetailsForm);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/employmentDetailsAddLineForm/EmploymentDetailsAddLineForm.jsx







var EmploymentDetailsAddLineForm = function EmploymentDetailsAddLineForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormed106",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormed106-label",
            children: "Gross monthly salary"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "grossMonthlySalary",
            value: fieldValues["grossMonthlySalary"],
            placeholder: "Add your gross monthly salary",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["grossMonthlySalary"],
            className: fieldErrors["grossMonthlySalary"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["grossMonthlySalary"]
          }), !fieldErrors["grossMonthlySalary"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NewLineForms_module_default())["hint-text"],
            children: "This is your total monthly salary before deduction"
          })]
        })
      })
    })
  });
};

EmploymentDetailsAddLineForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {}
};
/* harmony default export */ var employmentDetailsAddLineForm_EmploymentDetailsAddLineForm = (EmploymentDetailsAddLineForm);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/employmentDetailsInfo/EmploymentDetailsInfo.jsx







var EmploymentDetailsInfo = function EmploymentDetailsInfo(_ref) {
  var data = _ref.data,
      employmentTypes = _ref.employmentTypes,
      employmentCategories = _ref.employmentCategories,
      occupations = _ref.occupations;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Employer name:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.employerName
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Employment type:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.employmentType, employmentTypes)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Employment category:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.employmentCategory, employmentCategories)
        })
      }), data !== null && data !== void 0 && data.employerNumber && (data === null || data === void 0 ? void 0 : data.employerNumber.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            children: "Employee telephone number:"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: data === null || data === void 0 ? void 0 : data.employerNumber
          })
        })]
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Occupation:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.occupation, occupations)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Salary date:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* addOrdinalSuffix */.Rt)(data === null || data === void 0 ? void 0 : data.salaryDate)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Gross monthly salary:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.grossMonthlySalary
        })
      })]
    })
  });
};

EmploymentDetailsInfo.defaultProps = {
  data: {}
};
/* harmony default export */ var employmentDetailsInfo_EmploymentDetailsInfo = (EmploymentDetailsInfo);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/employmentDetailsAddLineInfo/EmploymentDetailsAddLineInfo.jsx





var EmploymentDetailsAddLineInfo = function EmploymentDetailsAddLineInfo(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Gross monthly salary:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.grossMonthlySalary
        })
      })]
    })
  });
};

EmploymentDetailsAddLineInfo.defaultProps = {
  data: {}
};
/* harmony default export */ var employmentDetailsAddLineInfo_EmploymentDetailsAddLineInfo = (EmploymentDetailsAddLineInfo);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/employmentDetails/EmploymentDetails.jsx




function EmploymentDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = EmploymentDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function EmploymentDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return EmploymentDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EmploymentDetails_arrayLikeToArray(o, minLen); }

function EmploymentDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function EmploymentDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EmploymentDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmploymentDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmploymentDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var EmploymentDetails_analyticsTags = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];

var EmploymentDetails = function EmploymentDetails(_ref) {
  var customerStatus = _ref.customerStatus,
      employmentDetailsData = _ref.employmentDetailsData,
      loadLookupData = _ref.loadLookupData,
      onFormSubmit = _ref.onFormSubmit,
      currentJourneyType = _ref.currentJourneyType,
      doCreditCheckDisable = _ref.doCreditCheckDisable;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(true),
      submitDisabled = _useState2[0],
      setSubmitDisabled = _useState2[1];

  var _useState3 = (0,react.useState)(employmentDetailsData ? false : true),
      displayEditMode = _useState3[0],
      setDisplayEditMode = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      employmentTypes = _useState4[0],
      setEmploymentTypes = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      employmentCategories = _useState5[0],
      setEmploymentCategories = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      occupations = _useState6[0],
      setOccupations = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      salaryDates = _useState7[0],
      setSalaryDate = _useState7[1];

  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.employment */.Z.creditCheckout.errors.employment));
  var dispatch = (0,DependencyHelper.useDispatch)();
  (0,react.useEffect)(function () {
    if (employmentDetailsData) {
      fieldValues.employmentDetails.employerName = employmentDetailsData.employerName;
      fieldValues.employmentDetails.employmentType = employmentDetailsData.employmentType;
      fieldValues.employmentDetails.employmentCategory = employmentDetailsData.employmentCategory;
      fieldValues.employmentDetails.occupation = employmentDetailsData.occupation;
      fieldValues.employmentDetails.salaryDate = employmentDetailsData.salaryDate;
      fieldValues.employmentDetails.grossMonthlySalary = employmentDetailsData.grossMonthlySalary;
      fieldValues.employmentDetails.employerNumber = employmentDetailsData.employerNumber ? employmentDetailsData.employerNumber : "";
      errorStatus.employmentDetails = checkFormError("employmentDetails");

      if (errorStatus.employmentDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    }
  }, [employmentDetailsData]);
  var addLineDataValidation = {
    validationsOn: {
      employmentDetails: true
    },
    errorStatus: {
      employmentDetails: true
    },
    validations: {
      employmentDetails: {
        employerName: false,
        employmentType: false,
        employmentCategory: false,
        occupation: false,
        salaryDate: false,
        grossMonthlySalary: true
      }
    },
    fieldErrors: {
      employmentDetails: {
        employerName: false,
        employmentType: false,
        employmentCategory: false,
        occupation: false,
        salaryDate: false,
        grossMonthlySalary: false
      },
      fail: false
    },
    fieldValues: {
      employmentDetails: {
        employerName: "",
        employmentType: "",
        employmentCategory: "",
        occupation: "",
        salaryDate: "",
        grossMonthlySalary: ""
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  };

  var _useState8 = (0,react.useState)(currentJourneyType !== checkout_journey_context/* journeyType.addLine */.w.addLine ? {
    validationsOn: {
      employmentDetails: true
    },
    errorStatus: {
      employmentDetails: true
    },
    validations: {
      employmentDetails: {
        employerName: true,
        employerNumber: true,
        employmentType: true,
        employmentCategory: true,
        occupation: true,
        salaryDate: true,
        grossMonthlySalary: true
      }
    },
    fieldErrors: {
      employmentDetails: {
        employerName: false,
        employerNumber: false,
        employmentType: false,
        employmentCategory: false,
        occupation: false,
        salaryDate: false,
        grossMonthlySalary: false
      },
      fail: false
    },
    fieldValues: {
      employmentDetails: {
        employerName: "",
        employerNumber: "",
        employmentType: "",
        employmentCategory: "",
        occupation: "",
        salaryDate: "",
        grossMonthlySalary: ""
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  } : addLineDataValidation),
      state = _useState8[0],
      setState = _useState8[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  (0,react.useEffect)(function () {
    setEmploymentTypes((0,helperServices/* replaceDropdownKeys */.qp)(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.EMPLOYMENT_CATEGORIES, constants/* EMP_CATEGORY_FKEY */.Tu, constants/* EMP_CATEGORY_LKEY */.Q0));
    setEmploymentCategories((0,helperServices/* replaceDropdownKeys */.qp)(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.OCCUPATION_TYPE, constants/* OCCUPATION_TYPE_FKEY */.ER, constants/* OCCUPATION_TYPE_LKEY */.aB));
    setOccupations((0,helperServices/* replaceDropdownKeys */.qp)(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.OCCUPATIONS, constants/* OCCUPATIONS_FKEY */.RR, constants/* OCCUPATIONS_LKEY */.Yw, "occupations"));
    setSalaryDate((0,helperServices/* replaceDropdownKeys */.qp)(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.SALARY_DAY, constants/* SALARY_DAY_FKEY */.mh, constants/* SALARY_DAY_LKEY */.oP));
  }, []);
  /**
   * Form input field change event handler
   *
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */

  var handleChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "visitor_login_status", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": work details")
                }));
                setAnalytics(true);
              }

              _context.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, value, errMsg;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();
              name = event.target.name;
              value = val ? val : event.target.value;
              _context2.next = 5;
              return fieldValidationCheck(event, value, form);

            case 5:
              _context2.next = 7;
              return checkFormError(form);

            case 7:
              errorStatus[form] = _context2.sent;
              setState(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus,
                validations: validations
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBlur(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;

              if (name === "grossMonthlySalary") {
                fieldValues[form][name] = formatCurrency(value, event);
              } else {
                fieldValues[form][name] = value;
              }

              if (name === "employmentCategory") {
                if (value === "PEN") {
                  validations[form].employerNumber = false;
                  fieldValues[form].employerNumber = "";
                  fieldErrors.fail = false;
                } else {
                  validations[form].employerNumber = true;
                  fieldErrors.fail = true;
                }
              }

              setState(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues,
                validations: validations,
                errorStatus: errorStatus,
                fieldErrors: fieldErrors
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function updateFieldValues(_x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(name, form) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = name;
              _context4.next = _context4.t0 === "employmentType" ? 3 : _context4.t0 === "employmentCategory" ? 5 : _context4.t0 === "occupation" ? 7 : _context4.t0 === "salaryDate" ? 9 : 11;
              break;

            case 3:
              fieldValues[form].employmentType = "";
              return _context4.abrupt("break", 11);

            case 5:
              fieldValues[form].employmentCategory = "";
              return _context4.abrupt("break", 11);

            case 7:
              fieldValues[form].occupation = "";
              return _context4.abrupt("break", 11);

            case 9:
              fieldValues[form].salaryDate = "";
              return _context4.abrupt("break", 11);

            case 11:
              _context4.next = 13;
              return checkFormError(form);

            case 13:
              errorStatus[form] = _context4.sent;
              setState(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues,
                errorStatus: errorStatus
              }));

              if (errorStatus[form]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleReset(_x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
          setSubmitDisabled(true);
          return;
        }
      }
    }

    setSubmitDisabled(false);
  }

  var reStructuredSalary = function reStructuredSalary(salary) {
    var amount = salary.replace(/\n|\R/g, "");
    return amount.replace(/,/g, "").toString();
  };
  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context5.t0 = name;
              _context5.next = _context5.t0 === "employerName" ? 5 : _context5.t0 === "employerNumber" ? 7 : _context5.t0 === "employmentType" ? 9 : _context5.t0 === "employmentCategory" ? 11 : _context5.t0 === "occupation" ? 13 : _context5.t0 === "salaryDate" ? 15 : _context5.t0 === "grossMonthlySalary" ? 17 : 19;
              break;

            case 5:
              if (state.validationsOn[form] && state.validations[form].employerName) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].employerName = true;
                  fieldErrorsMessage[form].employerName = state.fieldErrorsMessage.employmentDetails.employerName;
                } else {
                  fieldErrors[form].employerName = false;
                }

                fieldErrors.fail = fieldErrors[form].employerName;
              } else {
                fieldErrors[form].employerName = false;
              }

              return _context5.abrupt("break", 19);

            case 7:
              if (state.validationsOn[form] && state.validations[form].employerNumber) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].employerNumber = true;
                    fieldErrorsMessage[form].employerNumber = errorMessages/* default.creditCheckout.employmentDetails.employerNumber.onlyNumber */.Z.creditCheckout.employmentDetails.employerNumber.onlyNumber;
                  } else if (!helperServices/* cellPhoneRegEx.test */.RZ.test(value)) {
                    fieldErrors[form].employerNumber = true;
                    fieldErrorsMessage[form].employerNumber = errorMessages/* default.creditCheckout.employmentDetails.employerNumber.startWith */.Z.creditCheckout.employmentDetails.employerNumber.startWith;
                  } else if ((0,helperServices/* africaCountryCode */.xJ)(value) && value.length < 11) {
                    fieldErrors[form].employerNumber = true;
                    fieldErrorsMessage[form].employerNumber = state.fieldErrorsMessage.employmentDetails.employerNumber;
                  } else if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                    fieldErrors[form].employerNumber = true;
                    fieldErrorsMessage[form].employerNumber = state.fieldErrorsMessage.employmentDetails.employerNumber;
                  } else {
                    fieldErrors[form].employerNumber = false;
                  }
                } else {
                  fieldErrors[form].employerNumber = true;
                  fieldErrorsMessage[form].employerNumber = cloneOfErrorMessages.employmentDetails.employerNumber;
                }

                fieldErrors.fail = fieldErrors[form].employerNumber;
              } else {
                fieldErrors[form].employerNumber = false;
              }

              return _context5.abrupt("break", 19);

            case 9:
              if (state.validationsOn[form] && state.validations[form].employmentType) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].employmentType = true;
                  fieldErrorsMessage[form].employmentType = state.fieldErrorsMessage.employmentDetails.employmentType;
                } else {
                  fieldErrors[form].employmentType = false;
                }

                fieldErrors.fail = fieldErrors[form].employmentType;
              } else {
                fieldErrors[form].employmentType = false;
              }

              return _context5.abrupt("break", 19);

            case 11:
              if (state.validationsOn[form] && state.validations[form].employmentCategory) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].employmentCategory = true;
                  fieldErrorsMessage[form].employmentCategory = state.fieldErrorsMessage.employmentDetails.employmentCategory;
                } else {
                  fieldErrors[form].employmentCategory = false;
                }

                fieldErrors.fail = fieldErrors[form].employmentCategory;
              } else {
                fieldErrors[form].employmentCategory = false;
              }

              return _context5.abrupt("break", 19);

            case 13:
              if (state.validationsOn[form] && state.validations[form].occupation) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].occupation = true;
                  fieldErrorsMessage[form].occupation = state.fieldErrorsMessage.employmentDetails.occupation;
                } else {
                  fieldErrors[form].occupation = false;
                }

                fieldErrors.fail = fieldErrors[form].occupation;
              } else {
                fieldErrors[form].occupation = false;
              }

              return _context5.abrupt("break", 19);

            case 15:
              if (state.validationsOn[form] && state.validations[form].salaryDate) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].salaryDate = true;
                  fieldErrorsMessage[form].salaryDate = state.fieldErrorsMessage.employmentDetails.salaryDate;
                } else {
                  fieldErrors[form].salaryDate = false;
                }

                fieldErrors.fail = fieldErrors[form].salaryDate;
              } else {
                fieldErrors[form].salaryDate = false;
              }

              return _context5.abrupt("break", 19);

            case 17:
              if (state.validationsOn[form] && state.validations[form].grossMonthlySalary) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* currencyRegex.test */.DF.test(reStructuredSalary(formatCurrency(value, event)))) {
                    fieldErrors[form].grossMonthlySalary = true;
                    fieldErrorsMessage[form].grossMonthlySalary = currentJourneyType !== checkout_journey_context/* journeyType.addLine */.w.addLine ? errorMessages/* default.creditCheckout.employmentDetails.grossMonthlySalary.onlyValid */.Z.creditCheckout.employmentDetails.grossMonthlySalary.onlyValid : errorMessages/* default.creditCheckout.employmentDetails.grossMonthlySalary.onlyZero */.Z.creditCheckout.employmentDetails.grossMonthlySalary.onlyZero;
                  } else {
                    fieldErrors[form].grossMonthlySalary = false;
                  }
                } else {
                  fieldErrors[form].grossMonthlySalary = true;
                  fieldErrorsMessage[form].grossMonthlySalary = errorMessages/* default.creditCheckout.errors.employment.employmentDetails.grossMonthlySalary */.Z.creditCheckout.errors.employment.employmentDetails.grossMonthlySalary;
                }

                fieldErrors.fail = fieldErrors[form].grossMonthlySalary;
              } else {
                fieldErrors[form].grossMonthlySalary = false;
              }

              return _context5.abrupt("break", 19);

            case 19:
              setState(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldValues: fieldValues,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 20:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fieldValidationCheck(_x12, _x13, _x14) {
      return _ref6.apply(this, arguments);
    };
  }();

  function formatNumber(n) {
    // format number 1234567 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  /**
   * This function is used to format the enetered number in the south african currency
   *
   * @call onChnage event
   */


  function formatCurrency(input, event) {
    // don't validate empty input
    if (input === "") {
      return;
    }

    if (input.indexOf(".") >= 0) {
      var decimal_pos = input.indexOf(".");
      var left_side = input.substring(0, decimal_pos);
      var right_side = input.substring(decimal_pos);
      left_side = formatNumber(left_side);
      right_side = formatNumber(right_side); // Limit decimal to only 2 digits

      right_side = right_side.substring(0, 2); // appends R to value, validates decimal side

      input = "R" + left_side;
    } else {
      input = formatNumber(input);
      input = "R" + input;
    }

    return input;
  }
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(EmploymentDetails_analyticsTags)), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": work details"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the on page edit
   *
   * @call on edit event
   */


  var setAnalyticsOnPageEdit = function setAnalyticsOnPageEdit() {
    analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(EmploymentDetails_analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit work details")
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = EmploymentDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(EmploymentDetails_analyticsTags)), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": work details: next")
    }));
  };
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["employmentDetails"]) {
      submitForm();
    }
  };
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleEmploymentSubmit = function handleEmploymentSubmit(event) {
    event.preventDefault();
    event.persist();

    if (!state.errorStatus["employmentDetails"]["grossMonthlySalary"]) {
      submitForm();
      analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "visitor_login_status", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
        page_form_event: "success",
        page_form_name: "checkout: credit check: ".concat(customerStatus, ": work details")
      }));
    }
  };
  /**
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var empCategory, empIndustry;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              empCategory = (0,helperServices/* getValueLabel */.gk)(state.fieldValues["employmentDetails"]["employmentCategory"], employmentCategories);
              empIndustry = (0,helperServices/* getValueLabel */.gk)(state.fieldValues["employmentDetails"]["occupation"], occupations);
              dispatch({
                type: actionTypes/* SET_CREDIT_CHECK_EMPLOYMENT_DATA */.yP,
                payload: EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, state.fieldValues["employmentDetails"]), {}, {
                  empCategory: empCategory,
                  empIndustry: empIndustry
                })
              });
              onFormSubmit(true);
              setDisplayEditMode(false);
              doCreditCheckDisable("employmentDetails", false);
              analyticsUtag/* link */.p4(EmploymentDetails_objectSpread(EmploymentDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(EmploymentDetails_analyticsTags)), {}, {
                page_form_event: "success",
                page_form_name: "checkout: credit check: ".concat(customerStatus, ": work details")
              }));

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function submitForm() {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("employmentDetails", true);
    setAnalyticsOnPageEdit();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "work-details",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-career.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "success",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Work details" : "Salary Details", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Section 3 of 7" : "Section 2 of 5"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), currentJourneyType == checkout_journey_context/* journeyType.newLine */.w.newLine && (!displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(employmentDetailsInfo_EmploymentDetailsInfo, {
        data: employmentDetailsData,
        employmentTypes: employmentTypes,
        employmentCategories: employmentCategories,
        occupations: occupations
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "checkout-credit-check-employment-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(employmentDetailsForm_EmploymentDetailsForm, {
          formName: "employmentDetails",
          fieldValues: state.fieldValues["employmentDetails"],
          fieldErrors: state.fieldErrors["employmentDetails"],
          fieldErrorsMessage: state.fieldErrorsMessage["employmentDetails"],
          onChangeHandler: handleChange,
          onBlurHandler: handleBlur,
          onResetHandler: handleReset,
          employmentTypes: employmentTypes,
          employmentCategories: employmentCategories,
          occupations: occupations,
          salaryDates: salaryDates
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-employment-form-submit",
            children: "Next"
          })
        })]
      })), currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine && (!displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(employmentDetailsAddLineInfo_EmploymentDetailsAddLineInfo, {
        data: employmentDetailsData
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "checkout-credit-check-employment-form",
        onSubmit: handleEmploymentSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(employmentDetailsAddLineForm_EmploymentDetailsAddLineForm, {
          formName: "employmentDetails",
          fieldValues: state.fieldValues["employmentDetails"],
          fieldErrors: state.fieldErrors["employmentDetails"],
          fieldErrorsMessage: state.fieldErrorsMessage["employmentDetails"],
          onChangeHandler: handleChange,
          onBlurHandler: handleBlur
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-employment-form-submit",
            children: "Next"
          })
        })]
      }))]
    })
  });
};

var EmploymentDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    employmentDetailsData: state.creditCheckDetails.employmentDetails,
    loadLookupData: state.checkoutDetails.lookupDetails
  };
};

/* harmony default export */ var employmentDetails_EmploymentDetails = ((0,DependencyHelper.connect)(EmploymentDetails_mapStateToProps)(EmploymentDetails));
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/homeAddressForm/HomeAddressForm.jsx







var HomeAddressForm = function HomeAddressForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      stateTypesOptions = _ref.stateTypesOptions,
      onChangeHandler = _ref.onChangeHandler,
      onResetHandler = _ref.onResetHandler,
      residenceTypes = _ref.residenceTypes,
      currentJourneyType = _ref.currentJourneyType,
      onBlurHandler = _ref.onBlurHandler,
      onFocusHandler = _ref.onFocusHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var handleFocus = function handleFocus(event) {
    onFocusHandler(event, formName);
  };

  var onDropdownChange = function onDropdownChange(event) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var formName = arguments.length > 2 ? arguments[2] : undefined;
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"], " "),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha101",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha101-label",
            children: ["Unit no.", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "(Optional)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "unitNo",
            value: fieldValues["unitNo"],
            placeholder: "#",
            readOnly: readOnlyValues["unitNo"],
            onChange: handleChange,
            isInvalid: fieldErrors["unitNo"],
            className: fieldErrors["unitNo"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["unitNo"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha102",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha102-label",
            children: ["Complex name", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "(Optional)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "complexName",
            value: fieldValues["complexName"],
            placeholder: "Add complex name",
            readOnly: readOnlyValues["complexName"],
            onChange: handleChange,
            isInvalid: fieldErrors["complexName"],
            className: fieldErrors["complexName"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["complexName"]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormha103",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha103-label",
            children: ["Street no.", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "(Optional)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "streetNo",
            value: fieldValues["streetNo"],
            placeholder: "#",
            maxLength: "40",
            readOnly: readOnlyValues["streetNo"],
            onChange: handleChange,
            isInvalid: fieldErrors["streetNo"],
            className: fieldErrors["streetNo"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["streetNo"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha104",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha104-label",
            children: "Street name"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "streetName",
            value: fieldValues["streetName"],
            placeholder: "Add street name",
            readOnly: readOnlyValues["streetName"],
            onChange: handleChange,
            isInvalid: fieldErrors["streetName"],
            className: fieldErrors["streetName"] ? (NewLineForms_module_default()).invalid : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["streetName"]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha105",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha105-label",
            children: "Suburb"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "suburb",
            value: fieldValues["suburb"],
            placeholder: "Add suburb",
            readOnly: readOnlyValues["suburb"],
            onChange: handleChange,
            isInvalid: fieldErrors["suburb"],
            className: fieldErrors["suburb"] ? (NewLineForms_module_default()).invalid : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["suburb"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormha106",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormha106-label",
            children: "Postal code"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "postalCode",
            value: fieldValues["postalCode"],
            placeholder: "#",
            readOnly: readOnlyValues["postalCode"],
            maxLength: "4",
            onChange: handleChange,
            isInvalid: fieldErrors["postalCode"],
            className: fieldErrors["postalCode"] ? (NewLineForms_module_default()).invalid : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["postalCode"]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormha107",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormha107-label",
            children: "Town / City"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "town",
            value: fieldValues["town"],
            placeholder: "Add town / city",
            readOnly: readOnlyValues["town"],
            onChange: handleChange,
            isInvalid: fieldErrors["town"],
            className: fieldErrors["town"] ? (NewLineForms_module_default()).invalid : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["town"]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormha108",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormha108-label",
            children: "Province"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "province",
            label: "Province",
            data: stateTypesOptions,
            required: true,
            handleSelect: onDropdownChange,
            selectedId: fieldValues["province"],
            customId: "validationFormha108",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["province"]
          }), fieldErrors["province"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["province"]
          })]
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormha1082",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormha1082-label",
          children: "Do you own or rent this property?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
          formName: formName,
          name: "residence",
          label: "Residence",
          data: residenceTypes,
          required: true,
          handleSelect: onDropdownChange,
          selectedId: fieldValues["residence"],
          customId: "validationFormha1082",
          handleReset: onResetHandler,
          resetRequired: true,
          fieldError: fieldErrors["residence"]
        }), fieldErrors["residence"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
          children: fieldErrorsMessage["residence"]
        })]
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: "".concat((NewLineForms_module_default())["form-label"]),
          id: "validationFormha1080-label",
          children: "How long did you live at this address?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha10801",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "currentAddressYears",
            value: fieldValues["currentAddressYears"],
            placeholder: "Years",
            required: true,
            maxLength: "2",
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            isInvalid: fieldErrors["currentAddressPeriod"],
            className: fieldErrors["currentAddressPeriod"] ? (NewLineForms_module_default()).invalid : ""
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha10802",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "currentAddressMonths",
            value: fieldValues["currentAddressMonths"],
            placeholder: "Months",
            required: true,
            maxLength: "2",
            onChange: handleChange,
            onBlur: handleBlur,
            onFocus: handleFocus,
            isInvalid: fieldErrors["currentAddressPeriod"],
            className: fieldErrors["currentAddressPeriod"] ? (NewLineForms_module_default()).invalid : ""
          })
        }), fieldErrors["currentAddressPeriod"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: "".concat((NewLineForms_module_default())["form-group"], " p-0"),
          controlId: "validationFormha108021",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["currentAddressPeriod"]
          })
        })]
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
        className: (NewLineForms_module_default())["form-row"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: "".concat((NewLineForms_module_default())["form-label"]),
          id: "validationFormha1081-label",
          children: "How long did you live at your previous address?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha10811",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "previousAddressYears",
            value: fieldValues["previousAddressYears"],
            placeholder: "Years",
            required: true,
            maxLength: "2",
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            isInvalid: fieldErrors["previousAddressPeriod"],
            className: fieldErrors["previousAddressPeriod"] ? (NewLineForms_module_default()).invalid : ""
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          className: "".concat((NewLineForms_module_default())["form-group"]),
          controlId: "validationFormha10812",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "previousAddressMonths",
            value: fieldValues["previousAddressMonths"],
            placeholder: "Months",
            required: true,
            maxLength: "2",
            onChange: handleChange,
            onBlur: handleBlur,
            onFocus: handleFocus,
            isInvalid: fieldErrors["previousAddressPeriod"],
            className: fieldErrors["previousAddressPeriod"] ? (NewLineForms_module_default()).invalid : ""
          })
        }), fieldErrors["previousAddressPeriod"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormha108021",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["previousAddressPeriod"]
          })
        })]
      })]
    })
  });
};

HomeAddressForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  stateTypesOptions: []
};
/* harmony default export */ var homeAddressForm_HomeAddressForm = (HomeAddressForm);
// EXTERNAL MODULE: ./components/atoms/contentSearchBox/ContentSearchBox.jsx
var ContentSearchBox = __webpack_require__(13616);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/homeDetailsInfo/HomeDetailsInfo.jsx







var HomeDetailsInfo = function HomeDetailsInfo(_ref) {
  var data = _ref.data,
      stateTypesOptions = _ref.stateTypesOptions,
      residenceTypes = _ref.residenceTypes,
      currentJourneyType = _ref.currentJourneyType;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Unit no. & complex name:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: !(data !== null && data !== void 0 && data.unitNo) && !(data !== null && data !== void 0 && data.complexName) ? "-" : (data === null || data === void 0 ? void 0 : data.unitNo) + " " + (data === null || data === void 0 ? void 0 : data.complexName)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Street no. & street name:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [data === null || data === void 0 ? void 0 : data.streetNo, " ", data === null || data === void 0 ? void 0 : data.streetName]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Suburb & postal code:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [data === null || data === void 0 ? void 0 : data.suburb, ", ", data === null || data === void 0 ? void 0 : data.postalCode]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Town / City:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.town
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Province:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.province, stateTypesOptions)
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Property ownership type:"
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: !(data !== null && data !== void 0 && data.residence) ? "-" : (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.residence, residenceTypes)
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Period at current address:"
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (data === null || data === void 0 ? void 0 : data.currentAddressYears.toLowerCase()) + ", " + (data === null || data === void 0 ? void 0 : data.currentAddressMonths.toLowerCase())
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Period at previous address:"
        })
      }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (data === null || data === void 0 ? void 0 : data.previousAddressYears.toLowerCase()) + ", " + (data === null || data === void 0 ? void 0 : data.previousAddressMonths.toLowerCase())
        })
      })]
    })
  });
};

HomeDetailsInfo.defaultProps = {
  data: {}
};
/* harmony default export */ var homeDetailsInfo_HomeDetailsInfo = (HomeDetailsInfo);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/homeDetails/HomeDetails.jsx




function HomeDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = HomeDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function HomeDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return HomeDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HomeDetails_arrayLikeToArray(o, minLen); }

function HomeDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function HomeDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HomeDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HomeDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HomeDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var HomeDetails_analyticsTags = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];

var HomeDetails = function HomeDetails(_ref) {
  var customerStatus = _ref.customerStatus,
      homeDetailsData = _ref.homeDetailsData,
      addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      onFormSubmit = _ref.onFormSubmit,
      currentJourneyType = _ref.currentJourneyType,
      doCreditCheckDisable = _ref.doCreditCheckDisable;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(homeDetailsData ? false : true),
      displayEditMode = _useState2[0],
      setDisplayEditMode = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      submitDisabled = _useState3[0],
      setSubmitDisabled = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      finalAddress = _useState4[0],
      setFinalAddress = _useState4[1];

  var addressTypesOptions = addressTypes ? addressTypes : [];
  var stateTypesOptions = statesTypes ? statesTypes : [];

  var _useState5 = (0,react.useState)([{
    id: "W",
    name: "I’m the owner"
  }, {
    id: "R",
    name: "I rent here"
  }, {
    id: "O",
    name: "Other"
  }]),
      residenceTypes = _useState5[0],
      setResidenceTypes = _useState5[1];

  var _useState6 = (0,react.useState)("months"),
      monthString = _useState6[0],
      setMonthString = _useState6[1];

  var _useState7 = (0,react.useState)("years"),
      yearString = _useState7[0],
      setYearString = _useState7[1];

  var RESIDENTIAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? addressTypesOptions[0].id : "";
  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.home */.Z.creditCheckout.errors.home));
  var dispatch = (0,DependencyHelper.useDispatch)();
  (0,react.useEffect)(function () {
    addressSearchResultMap();
  }, [finalAddress]);
  (0,react.useEffect)(function () {
    if (addressTypesOptions.length > 0) {
      fieldValues.homeDetails.addressType = RESIDENTIAL_ADDRESS_TYPE;
      setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [addressTypesOptions]);
  (0,react.useEffect)(function () {
    if (stateTypesOptions.length > 0) {
      fieldValues.homeDetails.province = stateTypesOptions[0].id;
      setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [stateTypesOptions]);

  var getProvinceValue = function getProvinceValue(name) {
    var finalID = stateTypesOptions.filter(function (item) {
      return item.code == name;
    });

    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  (0,react.useEffect)(function () {
    if (homeDetailsData) {
      fieldValues.homeDetails.addressName = homeDetailsData.addressName;
      fieldValues.homeDetails.addressType = homeDetailsData.addressType;
      fieldValues.homeDetails.unitNo = homeDetailsData.unitNo;
      fieldValues.homeDetails.complexName = homeDetailsData.complexName;
      fieldValues.homeDetails.streetNo = homeDetailsData.streetNo;
      fieldValues.homeDetails.streetName = homeDetailsData.streetName;
      fieldValues.homeDetails.suburb = homeDetailsData.suburb;
      fieldValues.homeDetails.postalCode = homeDetailsData.postalCode;
      fieldValues.homeDetails.town = homeDetailsData.town;
      fieldValues.homeDetails.province = homeDetailsData.province;
      fieldValues.homeDetails.instructions = homeDetailsData.instructions;
      fieldValues.homeDetails.residence = homeDetailsData.residence;
      fieldValues.homeDetails.currentAddressYears = homeDetailsData.currentAddressYears;
      fieldValues.homeDetails.currentAddressMonths = homeDetailsData.currentAddressMonths;
      fieldValues.homeDetails.previousAddressYears = homeDetailsData.previousAddressYears;
      fieldValues.homeDetails.previousAddressMonths = homeDetailsData.previousAddressMonths;
      errorStatus.homeDetails = checkFormError("homeDetails");

      if (errorStatus.homeDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    }
  }, [homeDetailsData]);

  var _useState8 = (0,react.useState)({
    validationsOn: {
      homeDetails: true
    },
    errorStatus: {
      homeDetails: true
    },
    validations: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        residence: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        currentAddressYears: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        currentAddressMonths: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        previousAddressYears: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        previousAddressMonths: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        currentAddressPeriod: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false,
        previousAddressPeriod: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false
      }
    },
    fieldErrors: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        residence: false,
        currentAddressPeriod: false,
        previousAddressPeriod: false
      },
      fail: false
    },
    fieldValues: {
      homeDetails: {
        addressName: "",
        addressType: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        residence: "",
        currentAddressYears: "",
        currentAddressMonths: "",
        previousAddressYears: "",
        previousAddressMonths: ""
      }
    },
    readOnlyValues: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        residence: false,
        currentAddressYears: false,
        currentAddressMonths: false,
        previousAddressYears: false,
        previousAddressMonths: false
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState8[0],
      setState = _useState8[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      readOnlyValues = state.readOnlyValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */

  var updateFieldValues = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value; //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onChange event.

              if (name === "currentAddressYears" || name === "previousAddressYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, yearString);
              } else if (name === "previousAddressMonths" || name === "currentAddressMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, monthString);
              } else {
                fieldValues[form][name] = value;
              }

              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateFieldValues(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(HomeDetails_objectSpread(HomeDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "visitor_login_status", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": address details")
                }));
                setAnalytics(true);
              }

              _context2.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(name, form) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReset(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleFocus = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, form) {
      var name, value;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event.persist();
              name = event.target.name;
              value = event.target.value; //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onFocus event.

              if (name === "currentAddressYears" || name === "previousAddressYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, yearString);
              } else if (name === "previousAddressMonths" || name === "currentAddressMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, monthString);
              }

              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleFocus(_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value, errMsg;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              event.persist();
              name = event.target.name;
              value = val ? val : event.target.value;
              _context5.next = 5;
              return fieldValidationCheck(event, val, form);

            case 5:
              //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onBlur event.
              if (name === "currentAddressYears" || name === "previousAddressYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, true, yearString);
              } else if (name === "previousAddressMonths" || name === "currentAddressMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, true, monthString);
              }

              _context5.next = 8;
              return checkFormError(form);

            case 8:
              errorStatus[form] = _context5.sent;
              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus,
                fieldValues: fieldValues
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleBlur(_x11, _x12, _x13) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context6.t0 = name;
              _context6.next = _context6.t0 === "unitNo" ? 5 : _context6.t0 === "streetNo" ? 8 : _context6.t0 === "streetName" ? 11 : _context6.t0 === "suburb" ? 13 : _context6.t0 === "town" ? 15 : _context6.t0 === "postalCode" ? 17 : _context6.t0 === "province" ? 19 : _context6.t0 === "residence" ? 21 : _context6.t0 === "currentAddressYears" ? 23 : _context6.t0 === "currentAddressMonths" ? 23 : _context6.t0 === "previousAddressYears" ? 25 : _context6.t0 === "previousAddressMonths" ? 25 : 27;
              break;

            case 5:
              if (value.length > 0) {
                fieldErrors[form].unitNo = helperServices/* numRegEx.test */.rP.test(value) ? false : true;

                if (fieldErrors[form].unitNo) {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.homeDetails.unitNo.onlyNumber */.Z.creditCheckout.homeDetails.unitNo.onlyNumber;
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].unitNo) {
                  fieldErrors[form].unitNo = true;
                } else {
                  fieldErrors[form].unitNo = false;
                }

                fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.errors.home.homeDetails.unitNo */.Z.creditCheckout.errors.home.homeDetails.unitNo;
              }

              fieldErrors.fail = fieldErrors[form].unitNo;
              return _context6.abrupt("break", 27);

            case 8:
              if (value.length > 0) {
                fieldErrors[form].streetNo = helperServices/* numRegEx.test */.rP.test(value) ? false : true;

                if (fieldErrors[form].streetNo) {
                  fieldErrorsMessage[form].streetNo = errorMessages/* default.creditCheckout.homeDetails.streetNo.onlyValid */.Z.creditCheckout.homeDetails.streetNo.onlyValid;
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].streetNo) {
                  fieldErrors[form].streetNo = true;
                } else {
                  fieldErrors[form].streetNo = false;
                }

                fieldErrorsMessage[form].streetNo = errorMessages/* default.creditCheckout.errors.home.homeDetails.streetNo */.Z.creditCheckout.errors.home.homeDetails.streetNo;
              }

              fieldErrors.fail = fieldErrors[form].streetNo;
              return _context6.abrupt("break", 27);

            case 11:
              if (state.validationsOn[form] && state.validations[form].streetName) {
                if (value.length > 0) {
                  if (!helperServices/* streetNameRegEx.test */.VU.test(value)) {
                    fieldErrors[form].streetName = true;
                    fieldErrorsMessage[form].streetName = errorMessages/* default.creditCheckout.homeDetails.streetName.onlyValid */.Z.creditCheckout.homeDetails.streetName.onlyValid;
                  } else {
                    fieldErrors[form].streetName = false;
                  }
                } else {
                  fieldErrors[form].streetName = true;
                  fieldErrorsMessage[form].streetName = errorMessages/* default.creditCheckout.errors.home.homeDetails.streetName */.Z.creditCheckout.errors.home.homeDetails.streetName;
                }

                fieldErrors.fail = fieldErrors[form].streetName;
              } else {
                fieldErrors[form].streetName = false;
              }

              return _context6.abrupt("break", 27);

            case 13:
              if (state.validationsOn[form] && state.validations[form].suburb) {
                fieldErrors[form].suburb = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].suburb;
              } else {
                fieldErrors[form].suburb = false;
              }

              return _context6.abrupt("break", 27);

            case 15:
              if (state.validationsOn[form] && state.validations[form].town) {
                fieldErrors[form].town = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].town;
              } else {
                fieldErrors[form].town = false;
              }

              return _context6.abrupt("break", 27);

            case 17:
              if (state.validationsOn[form] && state.validations[form].postalCode) {
                if (value.length > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.homeDetails.postalCode.onlyNumber */.Z.creditCheckout.homeDetails.postalCode.onlyNumber;
                  } else if (value.length < 4) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.homeDetails.postalCode.onlyValid */.Z.creditCheckout.homeDetails.postalCode.onlyValid;
                  } else {
                    fieldErrors[form].postalCode = false;
                  }
                } else {
                  fieldErrors[form].postalCode = true;
                  fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.errors.home.homeDetails.postalCode */.Z.creditCheckout.errors.home.homeDetails.postalCode;
                }

                fieldErrors.fail = fieldErrors[form].postalCode;
              } else {
                fieldErrors[form].postalCode = false;
              }

              return _context6.abrupt("break", 27);

            case 19:
              if (state.validationsOn[form] && state.validations[form].province) {
                fieldErrors[form].province = value == "" ? true : false;

                if (fieldErrors[form].province) {
                  fieldErrorsMessage[form].province = errorMessages/* default.creditCheckout.errors.home.homeDetails.province */.Z.creditCheckout.errors.home.homeDetails.province;
                }

                fieldErrors.fail = fieldErrors[form].province;
              } else {
                fieldErrors[form].province = false;
              }

              return _context6.abrupt("break", 27);

            case 21:
              if (state.validationsOn[form] && state.validations[form].residence) {
                fieldErrors[form].residence = value == "" ? true : false;

                if (fieldErrors[form].residence) {
                  fieldErrorsMessage[form].residence = errorMessages/* default.creditCheckout.errors.home.homeDetails.residence */.Z.creditCheckout.errors.home.homeDetails.residence;
                }

                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors.fail = fieldErrors[form].residence;
                }
              } else {
                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors[form].residence = false;
                }
              }

              return _context6.abrupt("break", 27);

            case 23:
              if (state.validationsOn[form] && (state.validations[form].currentAddressYears || state.validations[form].currentAddressMonths)) {
                if (value.length > 0) {
                  if ((0,helperServices/* checkYearAndMonthFormat */.jC)(fieldValues[form].currentAddressYears, fieldValues[form].currentAddressMonths, true)) {
                    fieldErrors[form].currentAddressPeriod = true;
                    fieldErrorsMessage[form].currentAddressPeriod = errorMessages/* default.creditCheckout.homeDetails.currentAddressPeriod.onlyValid */.Z.creditCheckout.homeDetails.currentAddressPeriod.onlyValid;
                  } else {
                    fieldErrors[form].currentAddressPeriod = false;
                  }
                } else {
                  fieldErrors[form].currentAddressPeriod = true;
                  fieldErrorsMessage[form].currentAddressPeriod = errorMessages/* default.creditCheckout.errors.home.homeDetails.currentAddressPeriod */.Z.creditCheckout.errors.home.homeDetails.currentAddressPeriod;
                }

                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors.fail = fieldErrors[form].currentAddressPeriod;
                }
              } else {
                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors[form].currentAddressPeriod = false;
                }
              }

              return _context6.abrupt("break", 27);

            case 25:
              if (state.validationsOn[form] && (state.validations[form].previousAddressYears || state.validations[form].previousAddressMonths)) {
                if (value.length > 0) {
                  if ((0,helperServices/* checkYearAndMonthFormat */.jC)(fieldValues[form].previousAddressYears, fieldValues[form].previousAddressMonths, false)) {
                    fieldErrors[form].previousAddressPeriod = true;
                    fieldErrorsMessage[form].previousAddressPeriod = errorMessages/* default.creditCheckout.homeDetails.previousAddressPeriod.onlyValid */.Z.creditCheckout.homeDetails.previousAddressPeriod.onlyValid;
                  } else {
                    fieldErrors[form].previousAddressPeriod = false;
                  }
                } else {
                  fieldErrors[form].previousAddressPeriod = true;
                  fieldErrorsMessage[form].previousAddressPeriod = errorMessages/* default.creditCheckout.errors.home.homeDetails.previousAddressPeriod */.Z.creditCheckout.errors.home.homeDetails.previousAddressPeriod;
                }

                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors.fail = fieldErrors[form].previousAddressPeriod;
                }
              } else {
                if (currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  fieldErrors[form].previousAddressPeriod = false;
                }
              }

              return _context6.abrupt("break", 27);

            case 27:
              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 28:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function fieldValidationCheck(_x14, _x15, _x16) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(HomeDetails_objectSpread(HomeDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(HomeDetails_analyticsTags)), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check ".concat(customerStatus, ": address details"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the on page edit
   *
   * @call on edit event
   */


  var setAnalyticsOnPageEdit = function setAnalyticsOnPageEdit() {
    analyticsUtag/* link */.p4(HomeDetails_objectSpread(HomeDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(HomeDetails_analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit address details")
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine) {
      entries[11][1] = false;
      entries[12][1] = false;
      entries[13][1] = false;
    }

    if (state.validationsOn[form]) {
      var _iterator = HomeDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  var addressSearchResultMap = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var localityType;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              localityType = finalAddress.address_components;

              if (!(localityType && localityType.length > 0)) {
                _context7.next = 9;
                break;
              }

              _context7.next = 4;
              return mapAddressSearchData(localityType);

            case 4:
              _context7.next = 6;
              return checkFormError("homeDetails");

            case 6:
              errorStatus.homeDetails = _context7.sent;
              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus.homeDetails) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function addressSearchResultMap() {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(HomeDetails_objectSpread(HomeDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(HomeDetails_analyticsTags)), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": address details: next")
    }));
  };
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["homeDetails"]) {
      submitForm();
    }
  };
  /**
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var addressType, province;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (fieldValues.homeDetails.complexName) {
                addressType = constants/* BUILDING_ADDR */.YY;
              } else {
                addressType = constants/* STREET_ADDR */.Dz;
              }

              province = (0,helperServices/* getValueLabel */.gk)(state.fieldValues["homeDetails"]["province"], stateTypesOptions);
              dispatch({
                type: actionTypes/* SET_CREDIT_CHECK_HOME_DATA */.nd,
                payload: HomeDetails_objectSpread(HomeDetails_objectSpread({}, state.fieldValues["homeDetails"]), {}, {
                  addressType: addressType,
                  provinceName: province
                })
              });
              onFormSubmit(true);
              setDisplayEditMode(false);
              doCreditCheckDisable("homeDetails", false);
              analyticsUtag/* link */.p4(HomeDetails_objectSpread(HomeDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(HomeDetails_analyticsTags)), {}, {
                page_form_event: "success",
                page_form_name: "checkout: credit check: ".concat(customerStatus, ": address details")
              }));

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function submitForm() {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("homeDetails", true);
    setAnalyticsOnPageEdit();
  };

  var mapAddressSearchData = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(localityType) {
      var i;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              readOnlyValues.homeDetails.postalCode = false;
              fieldValues.homeDetails.unitNo = "";
              fieldValues.homeDetails.complexName = "";
              fieldValues.homeDetails.streetNo = "";
              fieldValues.homeDetails.streetName = "";
              fieldValues.homeDetails.suburb = "";
              fieldValues.homeDetails.province = "";
              fieldValues.homeDetails.town = "";
              fieldValues.homeDetails.postalCode = "";
              fieldValues.homeDetails.residence = "";
              fieldValues.homeDetails.currentAddressYears = "";
              fieldValues.homeDetails.currentAddressMonths = "";
              fieldValues.homeDetails.previousAddressYears = "";
              fieldValues.homeDetails.previousAddressMonths = "";
              fieldErrors.homeDetails.unitNo = false;
              fieldErrors.homeDetails.complexName = false;
              fieldErrors.homeDetails.streetNo = false;
              fieldErrors.homeDetails.streetName = false;
              fieldErrors.homeDetails.suburb = false;
              fieldErrors.homeDetails.province = false;
              fieldErrors.homeDetails.town = false;
              fieldErrors.homeDetails.postalCode = false;
              fieldErrors.homeDetails.residence = false;
              fieldErrors.homeDetails.currentAddressPeriod = false;
              fieldErrors.homeDetails.previousAddressPeriod = false;

              for (i = 0; i < localityType.length; i++) {
                if (localityType[i].administrative_type == constants/* UNIT */.iI) {
                  if (localityType[i].long_name) {
                    fieldValues.homeDetails.unitNo = localityType[i].long_name;
                  }
                }

                if (localityType[i].administrative_type == constants/* BUSINESS */.aL) {
                  fieldValues.homeDetails.complexName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* STREET_NO */.sr) {
                  fieldValues.homeDetails.streetNo = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* ROUTE */.ln) {
                  fieldValues.homeDetails.streetName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* SUBURB */.QP || localityType[i].administrative_type == constants/* MINOR_SUBURB */.u3) {
                  fieldValues.homeDetails.suburb = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* PROVINCE */.ew) {
                  fieldValues.homeDetails.province = getProvinceValue(localityType[i].long_name);
                }

                if (localityType[i].administrative_type == constants/* TOWN */.V8 || localityType[i].administrative_type == constants/* CITY */.Or) {
                  fieldValues.homeDetails.town = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* POST_STREET */.tb || localityType[i].administrative_type == constants/* POST_BOX */.nB) {
                  if (localityType[i].long_name.length > 0) {
                    readOnlyValues.homeDetails.postalCode = true;
                  }

                  fieldValues.homeDetails.postalCode = localityType[i].long_name;
                }
              }

              setState(HomeDetails_objectSpread(HomeDetails_objectSpread({}, state), {}, {
                readOnlyValues: readOnlyValues,
                fieldValues: fieldValues,
                fieldErrors: fieldErrors
              }));

            case 27:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function mapAddressSearchData(_x17) {
      return _ref10.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "home-details",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-home.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "succes",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), "Home address", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Section 4 of 7" : "Section 3 of 5"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), !displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(homeDetailsInfo_HomeDetailsInfo, {
        data: homeDetailsData,
        stateTypesOptions: stateTypesOptions,
        residenceTypes: residenceTypes,
        currentJourneyType: currentJourneyType
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["pt-2"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "d-none " + (CheckoutCreditCheck_module_default())["search-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
            className: (CheckoutCreditCheck_module_default())["search-wrapper__input"],
            placeholderText: "Search for your address",
            icon: "blue",
            variant: "address-search",
            setFinalAddress: setFinalAddress,
            pageName: "checkout: credit check: ".concat(customerStatus),
            analyticFormName: "address details"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
          noValidate: true,
          id: "checkout-credit-home-address-form",
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(homeAddressForm_HomeAddressForm, {
            formName: "homeDetails",
            fieldValues: state.fieldValues["homeDetails"],
            fieldErrors: state.fieldErrors["homeDetails"],
            fieldErrorsMessage: state.fieldErrorsMessage["homeDetails"],
            readOnlyValues: state.readOnlyValues["homeDetails"],
            stateTypesOptions: stateTypesOptions,
            residenceTypes: residenceTypes,
            onChangeHandler: handleChange,
            onResetHandler: handleReset,
            currentJourneyType: currentJourneyType,
            onBlurHandler: handleBlur,
            onFocusHandler: handleFocus
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutCreditCheck_module_default())["button-wrapper"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
              type: "submit",
              variant: "solid grey",
              disabled: submitDisabled,
              className: (CheckoutCreditCheck_module_default()).button,
              id: "checkout-credit-check-home-address-submit",
              children: "Next"
            })
          })]
        })]
      })]
    })
  });
};

var HomeDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    homeDetailsData: state.creditCheckDetails.homeDetails
  };
};

/* harmony default export */ var homeDetails_HomeDetails = ((0,DependencyHelper.connect)(HomeDetails_mapStateToProps)(HomeDetails));
// EXTERNAL MODULE: ./utils/featuresService.js
var featuresService = __webpack_require__(90760);
// EXTERNAL MODULE: ./components/atoms/checkBox/Checkbox.js
var Checkbox = __webpack_require__(51707);
// EXTERNAL MODULE: ./components/atoms/newLineForms/creditCheckForms/consentResultsForm/ConsentResultsForm.module.scss
var ConsentResultsForm_module = __webpack_require__(5820);
var ConsentResultsForm_module_default = /*#__PURE__*/__webpack_require__.n(ConsentResultsForm_module);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/consentResultsForm/ConsentResultsForm.jsx






var ConsentResultsForm = function ConsentResultsForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      onChangeHandler = _ref.onChangeHandler,
      onResetHandler = _ref.onResetHandler,
      formContent = _ref.formContent;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((ConsentResultsForm_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((ConsentResultsForm_module_default())["main-row"]),
      children: formContent.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: "".concat((ConsentResultsForm_module_default())["form-group"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check, {
            custom: true,
            name: "consentCheck" + index,
            label: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
            }),
            onChange: handleChange,
            className: (ConsentResultsForm_module_default())["form-checkbox-label"],
            id: item.id
          })
        }, index);
      })
    })
  });
};

ConsentResultsForm.defaultProps = {
  fieldValues: {}
};
/* harmony default export */ var consentResultsForm_ConsentResultsForm = (ConsentResultsForm);
// EXTERNAL MODULE: ./data/mockRenderComponent.js
var mockRenderComponent = __webpack_require__(29151);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/consentResultDetails/ConsentResultDetails.jsx



function ConsentResultDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ConsentResultDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ConsentResultDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ConsentResultDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























/**
 * Consent Details component holds the logic of consent and result detail form validation logic,
 * handling all the API calls and analytics
 */





var ConsentResultDetails = function ConsentResultDetails(_ref) {
  var _cartDetails$shipping, _cartDetails$prices, _cartDetails$prices$g;

  var type = _ref.type,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      onFormSubmit = _ref.onFormSubmit,
      debitDetailsData = _ref.debitDetailsData,
      personalDetailsData = _ref.personalDetailsData,
      employmentDetailsData = _ref.employmentDetailsData,
      contactDetailsData = _ref.contactDetailsData,
      homeDetailsData = _ref.homeDetailsData,
      deliveryDetailsData = _ref.deliveryDetailsData,
      authDetailsData = _ref.authDetailsData,
      setPageErr = _ref.setPageErr,
      navigate = _ref.navigate,
      setCreditOutcome = _ref.setCreditOutcome,
      continueDisable = _ref.continueDisable,
      creditFilters = _ref.creditFilters,
      cartProducts = _ref.cartProducts,
      dealCategoryId = _ref.dealCategoryId,
      setShowDocsData = _ref.setShowDocsData,
      setShowOfflineData = _ref.setShowOfflineData,
      currentJourneyType = _ref.currentJourneyType,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      isDoCreditCheckDisable = _ref.isDoCreditCheckDisable,
      deleteItemsFromCart = _ref.deleteItemsFromCart,
      cartDetails = _ref.cartDetails,
      carrierCode = _ref.carrierCode,
      methodCode = _ref.methodCode,
      multicartFlag = _ref.multicartFlag,
      setShowOnceOff = _ref.setShowOnceOff,
      selectedPreference = _ref.selectedPreference,
      selectedUpgradeResponse = _ref.selectedUpgradeResponse;

  var _useState = (0,react.useState)(true),
      submitDisabled = _useState[0],
      setSubmitDisabled = _useState[1];

  var _useState2 = (0,react.useState)(null),
      formContent = _useState2[0],
      setFormContent = _useState2[1];

  var otpAuthtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-otp-token");

  var _useState3 = (0,react.useState)(""),
      dealName = _useState3[0],
      setDealName = _useState3[1];

  var _useState4 = (0,react.useState)({
    validationsOn: {
      consentResultDetails: true
    },
    errorStatus: {
      consentResultDetails: true
    },
    validations: {
      consentResultDetails: {
        consentCheck0: true,
        consentCheck1: true
      }
    },
    fieldErrors: {
      consentResultDetails: {
        consentCheck0: false,
        consentCheck1: false
      },
      fail: false
    },
    fieldValues: {
      consentResultDetails: {
        consentCheck0: false,
        consentCheck1: false
      }
    },
    fieldErrorsMessage: {
      consentResultDetails: {}
    }
  }),
      state = _useState4[0],
      setState = _useState4[1];

  var dispatch = (0,DependencyHelper.useDispatch)();
  var router = (0,DependencyHelper.useRouter)();
  var fieldValues = state.fieldValues;
  var declined_lead_next_level_multicart = "Declined_LeadNXT_LVL_Multicart";
  /**
   *Get the consent form content from the drupal API
   *Reformatting the Year and Month data on page load
   */

  (0,react.useEffect)(function () {
    fetchFormContent();
  }, [homeDetailsData, debitDetailsData]);
  /**
   *This function is used to restructure the date format(YYYY-MM-DD)
   */

  var reStructuredDatOfBirth = function reStructuredDatOfBirth(date) {
    var updatedDate;

    if (date) {
      var year = date.slice(6, 10);
      var month = date.slice(3, 5);
      var day = date.slice(0, 2);
      updatedDate = year + "-" + month + "-" + day;
    } else {
      updatedDate = "";
    }

    return updatedDate;
  };

  var mmddyyyyDateFormat = function mmddyyyyDateFormat(date) {
    var updatedDate;

    if (date) {
      var newDate = date.replace(/\s/g, "");
      var values = newDate.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });
      updatedDate = values[1] + "/" + values[0] + "/" + values[2];
    } else {
      updatedDate = "";
    }

    return updatedDate;
  };

  var createCustDobFormat = function createCustDobFormat() {
    if (personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.dob) {
      var dob = personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.dob.replace(/\s/g, "");
      var values = dob.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });
      return values[1] + "/" + values[0] + "/" + values[2];
    }
  };
  /**
   *This function is used to remove starting digit from the string
   */


  var reStructuredTypeOfAccount = function reStructuredTypeOfAccount(accountType) {
    return accountType.substring(accountType.indexOf("-") + 1);
  };
  /**
   *This function is used to remove "R" and special characters from the number
   */


  var reStructuredSalary = function reStructuredSalary(salary) {
    var amount = salary.replace(/\n|\R/g, "");
    return Math.ceil(amount.replace(/,/g, "")).toString();
  };
  /**
   *This function is used to replace the "27" code with "0" from the phone number
   */


  var reStructuredPhoneNumber = function reStructuredPhoneNumber() {
    var phoneNumber;

    if ((contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.cellNumber.slice(0, 2)) === "27") {
      phoneNumber = contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.cellNumber.replace(/^.{2}/g, "0");
    } else {
      phoneNumber = contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.cellNumber;
    }

    return phoneNumber;
  };

  var getTitle = function getTitle(str) {
    switch (str) {
      case "Dr.":
        return "DR";

      case "Prof":
        return "Prof";

      default:
        return str.toUpperCase();
        break;
    }
  };

  var dealCartProduct = cartProducts.find(function (cartProduct) {
    var _cartProduct$product, _cartProduct$product2;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
  });
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var cartProductId = dealCartProduct === null || dealCartProduct === void 0 ? void 0 : dealCartProduct.id;
  var totalZero = parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping === void 0 ? void 0 : _cartDetails$shipping.shipping_fee) + parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices = cartDetails.prices) === null || _cartDetails$prices === void 0 ? void 0 : (_cartDetails$prices$g = _cartDetails$prices.grand_total) === null || _cartDetails$prices$g === void 0 ? void 0 : _cartDetails$prices$g.value) == parseFloat(0) ? "true" : "false";
  var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
  var vodAuthToken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
  /** Get form content from the drupal api
   * Redirect user to the generic error code page if drupal api gets failed
   */

  var fetchFormContent = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _result$sections$, result;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              _context.prev = 1;
              _context.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "creditCheckConsent");

            case 4:
              result = _context.sent;

              if (result !== null && result !== void 0 && (_result$sections$ = result.sections[0]) !== null && _result$sections$ !== void 0 && _result$sections$.items) {
                setFormContent(result.sections[0].items);
                (0,helperServices/* hideSpinner */.v3)();
              } else {
                fetchErrorDetails(labels/* default.creditVetting.lbl_form_content_not_found */.Z.creditVetting.lbl_form_content_not_found, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              }

              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              logger/* Logger.error */.Y.error(_context.t0, "ConsentResultDetails", {
                "function": "fetchFormContent"
              });
              (0,helperServices/* hideSpinner */.v3)();
              fetchErrorDetails(labels/* default.creditVetting.lbl_form_content_not_found */.Z.creditVetting.lbl_form_content_not_found, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);

            case 13:
              _context.prev = 13;
              (0,helperServices/* hideSpinner */.v3)();
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 13, 16]]);
    }));

    return function fetchFormContent() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage Enable or disable form submit button
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, form) {
      var name, value;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = event.target.name;
              value = event.target.checked;
              fieldValues[form][name] = value;
              setState(ConsentResultDetails_objectSpread(ConsentResultDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

              if (name === constants/* CONSENT_CHECK */.wR && value) {
                setAnalyticsOnconsentcheck(labels/* default.creditVetting.lbl_chk_consent */.Z.creditVetting.lbl_chk_consent);
              } else if (name === constants/* AGREE_CHECK */.y7 && value) {
                setAnalyticsOnconsentcheck(labels/* default.creditVetting.lbl_chk_agree */.Z.creditVetting.lbl_chk_agree);
              }

              if (fieldValues[form][constants/* CONSENT_CHECK */.wR] && fieldValues[form][constants/* AGREE_CHECK */.y7]) {
                setSubmitDisabled(false);
              } else {
                setSubmitDisabled(true);
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnDoCreditCheck();
    currentJourneyType === checkout_journey_context/* journeyType.newLine */.w.newLine ? submitForm() : submitAddLineForm();
  };
  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */


  var mapAddLineFieldData = function mapAddLineFieldData() {
    var _dealProduct$product;

    var dealProduct = cartProducts.find(function (cartProduct) {
      var _cartProduct$product3, _cartProduct$product4;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product3 = cartProduct.product) === null || _cartProduct$product3 === void 0 ? void 0 : _cartProduct$product3.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product4 = cartProduct.product) === null || _cartProduct$product4 === void 0 ? void 0 : _cartProduct$product4.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
    });
    var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product = dealProduct.product) === null || _dealProduct$product === void 0 ? void 0 : _dealProduct$product.sku;
    return {
      context: currentJourneyType === checkout_journey_context/* journeyType.addLine */.w.addLine ? "ADDLINE" : "UPGRADE",
      dealSheetId: dealSku,
      idNumber: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber,
      idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
      updateAddressDetails: {
        inputType: "ADDRESS",
        addressType: "Residential",
        addressDetails: {
          addressType: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.addressType,
          buildingName: "",
          city: homeDetailsData.town,
          complexName: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.complexName,
          complexNumber: "",
          complexStreet: "",
          country: "South Africa",
          deliveryAddressFlag: "true",
          lineOne: "",
          postalCode: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode,
          postalDeliveryFlag: "false",
          primaryAddressFlag: "false",
          privateBagNumber: "",
          province: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.provinceName,
          ricaFlag: "false",
          seoid: "",
          streetName: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName,
          streetNo: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.streetNo ? homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetNo : "00",
          suburb: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.suburb,
          unitNumber: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.unitNo
        }
      },
      otpToken: otpAuthtoken
    };
  };
  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */


  var submitAddLineForm = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var inputObj, _responseData$respons, responseData, _responseData$error;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              inputObj = mapAddLineFieldData();

              if (featuresService/* Features.get */.A.get("simOnlyEarlyUpgradeEnabled") && (inputObj === null || inputObj === void 0 ? void 0 : inputObj.context) === "UPGRADE") {
                inputObj.simOnlyUpgradeFlg = selectedUpgradeResponse === null || selectedUpgradeResponse === void 0 ? void 0 : selectedUpgradeResponse.simOnlyUpgradeFlg;
              }

              setCreditOutcome({
                visible: true,
                title: "",
                desc: multicartFlag ? labels/* default.creditVetting.lbl_loading_screen_msg_multicart */.Z.creditVetting.lbl_loading_screen_msg_multicart : labels/* default.creditVetting.lbl_loading_screen_msg */.Z.creditVetting.lbl_loading_screen_msg,
                screenType: "loadingScreen"
              });
              _context3.prev = 3;
              _context3.next = 6;
              return microServices/* default.put */.Z.put("api", "customerDetails", inputObj, null, true);

            case 6:
              responseData = _context3.sent;

              if (responseData !== null && responseData !== void 0 && (_responseData$respons = responseData.response) !== null && _responseData$respons !== void 0 && _responseData$respons.data) {
                getCreditVettingOutcomeResult(responseData.response.data);
              } else {
                if (responseData !== null && responseData !== void 0 && (_responseData$error = responseData.error) !== null && _responseData$error !== void 0 && _responseData$error.status) {
                  fetchErrorDetails("updateCustomerDetails_".concat(responseData.error.status), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                } else {
                  fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                }
              }

              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              logger/* Logger.error */.Y.error(_context3.t0, "ConsentResultDetails", {
                "function": "submitAddLineForm"
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 10]]);
    }));

    return function submitAddLineForm() {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var inputObj, reqParams, _responseData$respons2, _responseData$respons3, responseData, _responseData$error2;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              inputObj = mapFieldData();
              reqParams = [authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber];
              setCreditOutcome({
                visible: true,
                title: "",
                desc: multicartFlag ? labels/* default.creditVetting.lbl_loading_screen_msg_multicart */.Z.creditVetting.lbl_loading_screen_msg_multicart : labels/* default.creditVetting.lbl_loading_screen_msg */.Z.creditVetting.lbl_loading_screen_msg,
                screenType: "loadingScreen"
              });
              _context4.prev = 3;
              _context4.next = 6;
              return microServices/* default.post */.Z.post("api", "createCustomer", inputObj, null, false, reqParams);

            case 6:
              responseData = _context4.sent;

              if (responseData !== null && responseData !== void 0 && (_responseData$respons2 = responseData.response) !== null && _responseData$respons2 !== void 0 && (_responseData$respons3 = _responseData$respons2.data) !== null && _responseData$respons3 !== void 0 && _responseData$respons3.result) {
                getCreditVettingOutcomeResult(responseData.response.data.result);
              } else {
                if (responseData !== null && responseData !== void 0 && (_responseData$error2 = responseData.error) !== null && _responseData$error2 !== void 0 && _responseData$error2.status) {
                  fetchErrorDetails("createCustomer_".concat(responseData.error.status), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                } else {
                  fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                }
              }

              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              logger/* Logger.error */.Y.error(_context4.t0, "ConsentResultDetails", {
                "function": "submitForm"
              });

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 10]]);
    }));

    return function submitForm() {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Credit vetting outcome api call
   * Call credit vetting outcome api if new customer gets created
   * @usage submit the credit vetting outcome request payload
   */


  var getCreditVettingOutcomeResult = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(customerInfo) {
      var inputObj, drupalBasedResult, idType, dateOfBirth, _creditVettingRespons, _creditVettingRespons2, creditVettingResponse, creditVettingResult, _creditVettingResult$, _creditVettingResult$2, _creditVettingResult$3, _creditVettingResult$4, applicationStatus, vettingStatus, resultCode, creditFilterData, creditFiltersValue, _drupalBasedResult$, _drupalBasedResult$2, _drupalBasedResult$3, _creditVettingRespons3, _creditVettingRespons4;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              inputObj = currentJourneyType === checkout_journey_context/* journeyType.newLine */.w.newLine ? getCreditVettingOutComePayload(customerInfo) : getCreditVettingOutComeAddLinePayload(customerInfo);
              dateOfBirth = personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.dob ? (0,helperServices/* getDateOfBirth */.MV)(personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.dob) : "";
              idType = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType;
              _context5.prev = 3;
              _context5.next = 6;
              return microServices/* default.post */.Z.post("api", "creditVettingOutcome", inputObj, null, false);

            case 6:
              creditVettingResponse = _context5.sent;
              creditVettingResult = creditVettingResponse === null || creditVettingResponse === void 0 ? void 0 : (_creditVettingRespons = creditVettingResponse.response) === null || _creditVettingRespons === void 0 ? void 0 : (_creditVettingRespons2 = _creditVettingRespons.data) === null || _creditVettingRespons2 === void 0 ? void 0 : _creditVettingRespons2.result;
              dispatch({
                type: actionTypes/* SET_CREDIT_VETTING_RESULT */.GE,
                payload: creditVettingResult
              });

              if (!creditVettingResult) {
                _context5.next = 76;
                break;
              }

              applicationStatus = (_creditVettingResult$ = creditVettingResult.vettingOutcome) === null || _creditVettingResult$ === void 0 ? void 0 : (_creditVettingResult$2 = _creditVettingResult$.vettingSummary) === null || _creditVettingResult$2 === void 0 ? void 0 : _creditVettingResult$2.applicationStatus;
              vettingStatus = (_creditVettingResult$3 = creditVettingResult.vettingOutcome) === null || _creditVettingResult$3 === void 0 ? void 0 : (_creditVettingResult$4 = _creditVettingResult$3.vettingSummary) === null || _creditVettingResult$4 === void 0 ? void 0 : _creditVettingResult$4.vettingStatus;
              resultCode = creditVettingResult === null || creditVettingResult === void 0 ? void 0 : creditVettingResult.resultCode;

              if (!((vettingStatus === labels/* default.creditVetting.lbl_pended */.Z.creditVetting.lbl_pended || vettingStatus === labels/* default.creditVetting.lbl_pending */.Z.creditVetting.lbl_pending || vettingStatus === labels/* default.creditVetting.lbl_referred */.Z.creditVetting.lbl_referred || vettingStatus === labels/* default.creditVetting.lbl_declined */.Z.creditVetting.lbl_declined) && applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && (resultCode === labels/* default.creditVetting.lbl_resultcode_declined */.Z.creditVetting.lbl_resultcode_declined || resultCode === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || resultCode === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred) && idType === "SAID" && Number(dateOfBirth) > 25)) {
                _context5.next = 26;
                break;
              }

              if (!multicartFlag) {
                _context5.next = 18;
                break;
              }

              fetchErrorDetails(labels/* default.creditVetting.lbl_declined_passport */.Z.creditVetting.lbl_declined_passport, "declined passport", null);
              _context5.next = 24;
              break;

            case 18:
              _context5.next = 20;
              return placeOrder();

            case 20:
              if (!(resultCode != labels/* default.creditVetting.lbl_resultcode_declined */.Z.creditVetting.lbl_resultcode_declined)) {
                _context5.next = 23;
                break;
              }

              _context5.next = 23;
              return createSalesLead();

            case 23:
              declinedPassportDetails(resultCode);

            case 24:
              _context5.next = 74;
              break;

            case 26:
              if (!(vettingStatus === labels/* default.creditVetting.lbl_declined */.Z.creditVetting.lbl_declined && applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && resultCode === labels/* default.creditVetting.lbl_resultcode_declined_nxtlvl */.Z.creditVetting.lbl_resultcode_declined_nxtlvl && idType === "SAID" && Number(dateOfBirth) >= 18 && Number(dateOfBirth) <= 25)) {
                _context5.next = 33;
                break;
              }

              if (multicartFlag) {
                _context5.next = 30;
                break;
              }

              _context5.next = 30;
              return placeOrder();

            case 30:
              declinedSAIDDetails(labels/* default.creditVetting.lbl_declined_non_nxtlvl */.Z.creditVetting.lbl_declined_non_nxtlvl, null, null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              _context5.next = 74;
              break;

            case 33:
              if (!((vettingStatus === labels/* default.creditVetting.lbl_pended */.Z.creditVetting.lbl_pended || vettingStatus === labels/* default.creditVetting.lbl_pending */.Z.creditVetting.lbl_pending || vettingStatus === labels/* default.creditVetting.lbl_referred */.Z.creditVetting.lbl_referred || vettingStatus === labels/* default.creditVetting.lbl_declined */.Z.creditVetting.lbl_declined) && applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && (resultCode === labels/* default.creditVetting.lbl_resultcode_declined */.Z.creditVetting.lbl_resultcode_declined || resultCode === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || resultCode === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred) && idType === "PASSPORT")) {
                _context5.next = 46;
                break;
              }

              if (!multicartFlag) {
                _context5.next = 38;
                break;
              }

              fetchErrorDetails(labels/* default.creditVetting.lbl_declined_passport */.Z.creditVetting.lbl_declined_passport, "declined passport", null);
              _context5.next = 44;
              break;

            case 38:
              _context5.next = 40;
              return placeOrder();

            case 40:
              if (!(resultCode != labels/* default.creditVetting.lbl_resultcode_declined */.Z.creditVetting.lbl_resultcode_declined)) {
                _context5.next = 43;
                break;
              }

              _context5.next = 43;
              return createSalesLead();

            case 43:
              declinedPassportDetails(resultCode);

            case 44:
              _context5.next = 74;
              break;

            case 46:
              if (!(resultCode === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || resultCode === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred)) {
                _context5.next = 54;
                break;
              }

              _context5.next = 49;
              return placeOrder();

            case 49:
              _context5.next = 51;
              return createSalesLead();

            case 51:
              fetchErrorDetails(resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred ? labels/* default.creditVetting.lbl_referred_non_nxtlvl */.Z.creditVetting.lbl_referred_non_nxtlvl : labels/* default.creditVetting.lbl_pending_non_nxtlvl */.Z.creditVetting.lbl_pending_non_nxtlvl, resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred ? "referred ID / Passport" : "pending Id / Passport", null);
              _context5.next = 74;
              break;

            case 54:
              if (!(applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && vettingStatus === labels/* default.creditVetting.lbl_approved_with_condition_status */.Z.creditVetting.lbl_approved_with_condition_status && resultCode === labels/* default.creditVetting.lbl_resultcode_approved_with_condition */.Z.creditVetting.lbl_resultcode_approved_with_condition)) {
                _context5.next = 58;
                break;
              }

              if ((creditVettingResult === null || creditVettingResult === void 0 ? void 0 : creditVettingResult.vettingOutcome.vettingSummary.portfolio) === constants/* P50_CUST */.as) {
                fetchCreditVettingErrorDetails(labels/* default.creditVetting.code_p50_affordability */.Z.creditVetting.code_p50_affordability, labels/* default.creditVetting.lbl_p50_error_code */.Z.creditVetting.lbl_p50_error_code, "", null, null);
              } else {
                creditFilterData = creditVettingResult.creditFilter;
                creditFiltersValue = {
                  total_monthly_payment: creditFilterData.affordability,
                  financeIndicator: creditFilterData.creditFilters.financeIndicator,
                  deviceInstallment: creditFilterData.creditFilters.deviceInstallment
                };
                dispatch({
                  type: actionTypes/* ADD_CREDIT_PROFILE */.DJ,
                  payload: creditFiltersValue
                });
                dispatch({
                  type: actionTypes/* SET_SKIP_CREDIT_VETTING */.CI,
                  payload: true
                });
                dispatch({
                  type: actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1,
                  payload: true
                });
                fetchCreditVettingErrorDetails(labels/* default.creditVetting.code_approved_with_condition */.Z.creditVetting.code_approved_with_condition, labels/* default.creditVetting.lbl_approved_with_condition */.Z.creditVetting.lbl_approved_with_condition, creditFiltersValue, null, null, labels/* default.checkout.lbl_preference_approved_conditions_values */.Z.checkout.lbl_preference_approved_conditions_values);
              }

              _context5.next = 74;
              break;

            case 58:
              if (!(applicationStatus === labels/* default.creditVetting.lbl_processed */.Z.creditVetting.lbl_processed && vettingStatus === labels/* default.creditVetting.lbl_approved */.Z.creditVetting.lbl_approved && resultCode === labels/* default.creditVetting.lbl_resultcode_approved */.Z.creditVetting.lbl_resultcode_approved)) {
                _context5.next = 63;
                break;
              }

              continueDisable(false);
              getApprovedScreencontent(labels/* default.creditVetting.lbl_code_approved */.Z.creditVetting.lbl_code_approved);
              _context5.next = 74;
              break;

            case 63:
              if (!(resultCode === labels/* default.creditVetting.lbl_resultcode_offline */.Z.creditVetting.lbl_resultcode_offline || applicationStatus === labels/* default.creditVetting.lbl_unprocessed */.Z.creditVetting.lbl_unprocessed)) {
                _context5.next = 73;
                break;
              }

              _context5.next = 66;
              return offlineVettingContent();

            case 66:
              drupalBasedResult = _context5.sent;
              setCreditOutcome({
                visible: true,
                title: (_drupalBasedResult$ = drupalBasedResult[0]) === null || _drupalBasedResult$ === void 0 ? void 0 : _drupalBasedResult$.resultTitle,
                desc: (_drupalBasedResult$2 = drupalBasedResult[0]) === null || _drupalBasedResult$2 === void 0 ? void 0 : _drupalBasedResult$2.resultText,
                screenType: resultCode,
                iconType: (_drupalBasedResult$3 = drupalBasedResult[0]) === null || _drupalBasedResult$3 === void 0 ? void 0 : _drupalBasedResult$3.icon
              });
              dispatch({
                type: actionTypes/* SET_CREDIT_VETTING_OUTCOME */.DI,
                payload: drupalBasedResult[0]
              });
              continueDisable(false);
              setShowOfflineData(true);
              _context5.next = 74;
              break;

            case 73:
              fetchErrorDetails("".concat(creditVettingResponse !== null && creditVettingResponse !== void 0 && (_creditVettingRespons3 = creditVettingResponse.error) !== null && _creditVettingRespons3 !== void 0 && _creditVettingRespons3.status ? "creditVettingOutcome_" + creditVettingResponse.error.status : "creditVettingOutcome_424"), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);

            case 74:
              _context5.next = 77;
              break;

            case 76:
              if (creditVettingResponse !== null && creditVettingResponse !== void 0 && (_creditVettingRespons4 = creditVettingResponse.error) !== null && _creditVettingRespons4 !== void 0 && _creditVettingRespons4.status) {
                fetchErrorDetails("creditVettingOutcome_".concat(creditVettingResponse.error.status), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              } else {
                fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              }

            case 77:
              _context5.next = 83;
              break;

            case 79:
              _context5.prev = 79;
              _context5.t0 = _context5["catch"](3);
              logger/* Logger.error */.Y.error(_context5.t0, "ConsentResultDetails", {
                "function": "getCreditVettingOutcomeResult"
              });
              fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "technical error", null);

            case 83:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 79]]);
    }));

    return function getCreditVettingOutcomeResult(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  var createSalesLead = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var _cartDetails$billing_, _cartDetails$billing_2, _cartDetails$shipping2, _cartDetails$shipping3, _cartDetails$navDetai, _cartDetails$navDetai2, _cartDetails$navDetai3, _cartDetails$navDetai4, _cartDetails$billing_3, _cartDetails$billing_4, _cartDetails$shipping4, _cartDetails$shipping5, _cartDetails$navDetai5, _cartDetails$navDetai6, _cartDetails$navDetai7, _cartDetails$navDetai8, firstname, lastname, createSalesLeadFormPayload, salesLeadResponse;

      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              // When creditCheckDetails.personalDetails is null then check firstname and lastname ongit 
              // the cartDetails.billing_address and cartDetails.shipping_address
              // and cartDetails.navDetails.profileData
              // name and surname are required.
              firstname = personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.firstName : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$billing_ = cartDetails.billing_address) !== null && _cartDetails$billing_ !== void 0 && _cartDetails$billing_.firstname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$billing_2 = cartDetails.billing_address) === null || _cartDetails$billing_2 === void 0 ? void 0 : _cartDetails$billing_2.firstname : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$shipping2 = cartDetails.shipping_address) !== null && _cartDetails$shipping2 !== void 0 && _cartDetails$shipping2.firstname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping3 = cartDetails.shipping_address) === null || _cartDetails$shipping3 === void 0 ? void 0 : _cartDetails$shipping3.firstname : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$navDetai = cartDetails.navDetails) !== null && _cartDetails$navDetai !== void 0 && (_cartDetails$navDetai2 = _cartDetails$navDetai.profileData) !== null && _cartDetails$navDetai2 !== void 0 && _cartDetails$navDetai2.firstname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$navDetai3 = cartDetails.navDetails) === null || _cartDetails$navDetai3 === void 0 ? void 0 : (_cartDetails$navDetai4 = _cartDetails$navDetai3.profileData) === null || _cartDetails$navDetai4 === void 0 ? void 0 : _cartDetails$navDetai4.firstname : "";
              lastname = personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.lastname ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.lastname : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$billing_3 = cartDetails.billing_address) !== null && _cartDetails$billing_3 !== void 0 && _cartDetails$billing_3.lastname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$billing_4 = cartDetails.billing_address) === null || _cartDetails$billing_4 === void 0 ? void 0 : _cartDetails$billing_4.lastname : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$shipping4 = cartDetails.shipping_address) !== null && _cartDetails$shipping4 !== void 0 && _cartDetails$shipping4.lastname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping5 = cartDetails.shipping_address) === null || _cartDetails$shipping5 === void 0 ? void 0 : _cartDetails$shipping5.lastname : cartDetails !== null && cartDetails !== void 0 && (_cartDetails$navDetai5 = cartDetails.navDetails) !== null && _cartDetails$navDetai5 !== void 0 && (_cartDetails$navDetai6 = _cartDetails$navDetai5.profileData) !== null && _cartDetails$navDetai6 !== void 0 && _cartDetails$navDetai6.lastname ? cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$navDetai7 = cartDetails.navDetails) === null || _cartDetails$navDetai7 === void 0 ? void 0 : (_cartDetails$navDetai8 = _cartDetails$navDetai7.profileData) === null || _cartDetails$navDetai8 === void 0 ? void 0 : _cartDetails$navDetai8.lastname : "";
              createSalesLeadFormPayload = {
                channel: "ONLINE",
                requestType: "credit_vetting",
                idNumber: (0,helperServices/* africaCountryCode */.xJ)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn) ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn : (0,helperServices/* appendCountryCode */.yT)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn),
                idDocType: "MSISDN",
                name: firstname,
                surname: lastname,
                msisdn: (0,helperServices/* africaCountryCode */.xJ)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn) ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn : (0,helperServices/* appendCountryCode */.yT)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn),
                emailAddress: contactDetailsData !== null && contactDetailsData !== void 0 && contactDetailsData.emailAddress ? contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.emailAddress : ""
              };
              _context6.next = 6;
              return microServices/* default.post */.Z.post("api", "staticFormSubmit", createSalesLeadFormPayload, null, false);

            case 6:
              salesLeadResponse = _context6.sent;
              _context6.next = 12;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](0);
              // no need to set error if posible error happended -sleep in silent
              logger/* Logger.error */.Y.error(_context6.t0, "ConsentResultDetails", {
                "function": "createSalesLead"
              });

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 9]]);
    }));

    return function createSalesLead() {
      return _ref7.apply(this, arguments);
    };
  }();

  var declinedPassportDetails = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var resultCode,
          pageName,
          label,
          DrupalCodeContent,
          result,
          _args7 = arguments;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              resultCode = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";
              pageName = "checkout: credit check: ".concat(customerStatus, ": declined");
              label = "exit";
              _context7.prev = 3;
              (0,helperServices/* showSpinner */.yh)();
              DrupalCodeContent = labels/* default.creditVetting.lbl_declined_passport */.Z.creditVetting.lbl_declined_passport;

              if (resultCode === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || resultCode === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred) {
                DrupalCodeContent = resultCode === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred ? labels/* default.creditVetting.lbl_referred_non_nxtlvl */.Z.creditVetting.lbl_referred_non_nxtlvl : labels/* default.creditVetting.lbl_pending_non_nxtlvl */.Z.creditVetting.lbl_pending_non_nxtlvl;
              }

              _context7.next = 9;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [DrupalCodeContent]);

            case 9:
              result = _context7.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handleSecondaryClick(result[0].primaryCTAURL, pageName, label);
                },
                imgUrl: result[0].icon,
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context7.next = 20;
              break;

            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](3);
              setPageErr({
                type: "error",
                title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                primaryLabel: "Call me back",
                secondaryLabel: "Exit checkout",
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick();
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick();
                },
                imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                pageName: "checkout: credit check: ".concat(customerStatus, ": declined")
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 20:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[3, 15]]);
    }));

    return function declinedPassportDetails() {
      return _ref8.apply(this, arguments);
    };
  }();

  var placeOrder = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var shippingMethodData, paymentMethodData;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              (0,helperServices/* showSpinner */.yh)();
              _context8.next = 4;
              return (0,checkoutService/* setShippingMethodsOnCartService */.YD)(cartId, carrierCode, methodCode);

            case 4:
              shippingMethodData = _context8.sent;

              if (shippingMethodData.fail) {
                _context8.next = 12;
                break;
              }

              _context8.next = 8;
              return (0,checkoutService/* setPaymentMethod */.$P)(cartId, totalZero);

            case 8:
              paymentMethodData = _context8.sent;

              if (!paymentMethodData.fail) {
                orderRouter();
              } else {
                (0,helperServices/* hideSpinner */.v3)();
              }

              _context8.next = 13;
              break;

            case 12:
              (0,helperServices/* hideSpinner */.v3)();

            case 13:
              _context8.next = 19;
              break;

            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](0);
              (0,helperServices/* hideSpinner */.v3)();
              logger/* Logger.error */.Y.error(_context8.t0, "ConsentResultDetails", {
                "function": "placeOrder"
              });

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 15]]);
    }));

    return function placeOrder() {
      return _ref9.apply(this, arguments);
    };
  }();

  var orderRouter = function orderRouter() {
    var headers = {};
    var postOrder = JSON.parse(JSON.stringify(mockRenderComponent.productOrderReq).replace(/\:null/gi, ':""')); //replace null with "" for all attributes

    postOrder.productOrder[0].externalId = cartId;
    postOrder.productOrder[0].journeyType = currentJourneyType;
    postOrder.productOrder[0].contact.identificationID = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber;
    postOrder.productOrder[0].contact.identificationType = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType;

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": "Bearer ".concat(vodAuthToken),
        "x-magento-token": "Bearer ".concat(authToken)
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }

    var url = "".concat((config_default()).envConfigs[(config_default()).env].dxl.url).concat((config_default()).api.postpaidProductOrder);
    axios_default().post(url, postOrder, {
      headers: headers
    }).then(function (response) {
      if (response.data && response.data.productOrders[0]) {
        var _response$data, _response$data$produc;

        (0,helperServices/* setCookieConsentWrapper */.ol)("cookie_".concat((config_default()).order_id), [(config_default()).cookie_category.strictly_necessary], "document.cookie='".concat((config_default()).order_id, "=").concat(response.data.productOrders[0].productOrderId, ";path=/'"));
        var newCartId = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$produc = _response$data.productOrders[0]) === null || _response$data$produc === void 0 ? void 0 : _response$data$produc.newCartId;

        if (newCartId) {
          (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(newCartId, ";path=/'"));
        } else {
          DependencyHelper.Cookie.remove("cart_id");
        }

        (0,helperServices/* hideSpinner */.v3)();
      } else {
        (0,helperServices/* hideSpinner */.v3)();
      }
    })["catch"](function (err) {
      (0,helperServices/* hideSpinner */.v3)();
      checkOrderCreation(err);
      logger/* Logger.error */.Y.error(err, "ConsentResultDetails", {
        "function": "orderRouter"
      });
    });
  };

  function checkOrderCreation(result) {
    if (result.messages) {
      var len = result.messages.length;

      for (var i = 0; i < len; i++) {
        if (result.messages[i].key == "orderStatus" && (0,helperServices/* getOrderCreated */.Yn)(result.messages[i].message)) {
          DependencyHelper.Cookie.remove("cart_id");
        }
      }
    }
  }

  var offlineVettingContent = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      var result;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "UnprocessedVettingResult");

            case 2:
              result = _context9.sent;
              return _context9.abrupt("return", result);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function offlineVettingContent() {
      return _ref10.apply(this, arguments);
    };
  }();

  var leadSubmissonContent = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(resultCode) {
      var newResultCode, result;
      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context10.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 3:
              result = _context10.sent;
              return _context10.abrupt("return", result);

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function leadSubmissonContent(_x4) {
      return _ref11.apply(this, arguments);
    };
  }();

  var declinedSAIDDetails = /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11(resultCode, pageErrorType) {
      var additionalUtagData,
          preferences,
          newResultCode,
          pageName,
          result,
          _result$0$primaryCTAU,
          _args11 = arguments;

      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              additionalUtagData = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : null;
              preferences = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : [];
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              pageName = "checkout: credit check: ".concat(customerStatus, ": nxt lvl"); // let primaryLabel = "call me";
              // let secondaryLabel = "exit";

              _context11.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              _context11.next = 8;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 8:
              result = _context11.sent;

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: result[0].resultTitle,
                  desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                  subDesc: result[0].resultHTML && result[0].resultHTML !== "" ? result[0].resultHTML : null,
                  primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                  primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                  secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                  secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                  dividerLine: multicartFlag ? true : false,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return result[0].resultCode === declined_lead_next_level_multicart && preferenceId === "call-me-back" ? handlePrimaryNxtLvlClick(pageName, result[0].primaryCTAText, result[0].leadType) : _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), result[0].primaryCTAText);
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(result[0].secondaryCTAURL, pageName, result[0].secondaryCTAText);
                  },
                  imgUrl: result[0].icon,
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData,
                  ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                  disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                  preferences: multicartFlag ? preferences : [],
                  defaultPreference: multicartFlag && (_result$0$primaryCTAU = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU !== void 0 && _result$0$primaryCTAU.includes("/checkout") ? "once-off" : null
                });
              } else {
                setPageErr({
                  type: "error",
                  title: result[0].resultTitle,
                  subDesc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : null,
                  subTitle: result[0].resultHTML ? result[0].resultHTML : null,
                  primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                  primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                  secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                  secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                  dividerLine: true,
                  handlePrimaryClick: function handlePrimaryClick() {
                    return handlePrimaryNxtLvlClick(pageName, result[0].primaryCTAText, result[0].leadType);
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(result[0].secondaryCTAURL, pageName, result[0].secondaryCTAText);
                  },
                  imgUrl: result[0].icon,
                  pageName: pageName
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context11.next = 20;
              break;

            case 14:
              _context11.prev = 14;
              _context11.t0 = _context11["catch"](4);
              logger/* Logger.error */.Y.error(_context11.t0, "ConsentResultDetails", {
                "function": "declinedSAIDDetails"
              });
              setPageErr({
                type: "error",
                title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                primaryLabel: "Call me back",
                secondaryLabel: "Exit checkout",
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick(null, null, pageName, primaryLabel);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick(null, pageName, secondaryLabel);
                },
                imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/info-s-copy.svg"),
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 20:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[4, 14]]);
    }));

    return function declinedSAIDDetails(_x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }();
  /**
   * Credit vetting outcome request payload
   *
   * @usage map the key-value pair request
   */


  var getCreditVettingOutComePayload = function getCreditVettingOutComePayload(customerInfo) {
    var _dealProduct$product2, _dealProduct$product3, _dealProduct$product4, _dealProduct$product5, _deliveryDetailsData$, _deliveryDetailsData$2, _deliveryDetailsData$3, _deliveryDetailsData$4, _authDetailsData$pass, _deliveryDetailsData$5, _deliveryDetailsData$6, _deliveryDetailsData$7, _deliveryDetailsData$8, _deliveryDetailsData$9, _deliveryDetailsData$10, _deliveryDetailsData$11, _deliveryDetailsData$12;

    var dealProduct = cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.find(function (cartProduct) {
      var _cartProduct$product5, _cartProduct$product6;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product5 = cartProduct.product) === null || _cartProduct$product5 === void 0 ? void 0 : _cartProduct$product5.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product6 = cartProduct.product) === null || _cartProduct$product6 === void 0 ? void 0 : _cartProduct$product6.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
    });
    var dealPrice = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product2 = dealProduct.product) === null || _dealProduct$product2 === void 0 ? void 0 : _dealProduct$product2.monthly_recurring.toString();
    var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product3 = dealProduct.product) === null || _dealProduct$product3 === void 0 ? void 0 : _dealProduct$product3.sku;
    var eppixproductcode = dealProduct !== null && dealProduct !== void 0 && (_dealProduct$product4 = dealProduct.product) !== null && _dealProduct$product4 !== void 0 && _dealProduct$product4.eppixproductcode ? dealProduct.product.eppixproductcode : "0";
    setDealName(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product5 = dealProduct.product) === null || _dealProduct$product5 === void 0 ? void 0 : _dealProduct$product5.name);
    return {
      journeyType: "Newline",
      creditVettingPayload: {
        bankingDetails: {
          bankAccountType: reStructuredTypeOfAccount(debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.accountType),
          salaryDay: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.salaryDate,
          accountHolder: (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.firstName) + " " + (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.surName),
          accountNumber: debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.accountNumber,
          branchName: debitDetailsData !== null && debitDetailsData !== void 0 && debitDetailsData.branchName ? debitDetailsData.branchName : "Universal",
          bankName: debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.bank,
          branchCode: debitDetailsData !== null && debitDetailsData !== void 0 && debitDetailsData.branchCode ? debitDetailsData.branchCode : "",
          debiCheckFlag: debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.debiCheckFlag,
          ageOfAccount: {
            years: debitDetailsData.ageOfAccountYears ? Number(debitDetailsData.ageOfAccountYears.replace(/\D/g, "")) : 0,
            months: debitDetailsData.ageOfAccountMonths ? Number(debitDetailsData.ageOfAccountMonths.replace(/\D/g, "")) : 0
          }
        },
        contactDetails: {
          residentialAddressDetails: {
            residence: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.residence,
            streetNumberName: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName,
            suburb: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.suburb,
            townCity: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.town,
            postalCode: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode,
            periodAtCurrentAddress: {
              years: Number(homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.currentAddressYears ? homeDetailsData.currentAddressYears.replace(/\D/g, "") : "00"),
              months: Number(homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.currentAddressMonths ? homeDetailsData.currentAddressMonths.replace(/\D/g, "") : "00")
            },
            periodAtPreviousAddress: {
              years: Number(homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.previousAddressYears ? homeDetailsData.previousAddressYears.replace(/\D/g, "") : "00"),
              months: Number(homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.previousAddressMonths ? homeDetailsData.previousAddressMonths.replace(/\D/g, "") : "00")
            }
          },
          postalAddressDetails: {
            addressLine1: deliveryDetailsData !== null && deliveryDetailsData !== void 0 && (_deliveryDetailsData$ = deliveryDetailsData.address) !== null && _deliveryDetailsData$ !== void 0 && _deliveryDetailsData$.addressLine1 ? deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$2 = deliveryDetailsData.address) === null || _deliveryDetailsData$2 === void 0 ? void 0 : _deliveryDetailsData$2.addressLine1 : "",
            suburb: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$3 = deliveryDetailsData.address) === null || _deliveryDetailsData$3 === void 0 ? void 0 : _deliveryDetailsData$3.suburb,
            townCity: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$4 = deliveryDetailsData.address) === null || _deliveryDetailsData$4 === void 0 ? void 0 : _deliveryDetailsData$4.town
          },
          postalCode: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode,
          contactNumbers: {
            mobileNumber: reStructuredPhoneNumber()
          },
          emailAddress: contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.emailAddress
        },
        customerDetails: {
          title: getTitle(personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.title),
          initials: personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.initials,
          firstName: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData.firstName : "",
          surname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData.surName : "",
          idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
          idPassportNumber: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.idNumber ? authDetailsData.idNumber.toString() : "",
          passportExpiryDate: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.passportExpiry ? reStructuredDatOfBirth(authDetailsData === null || authDetailsData === void 0 ? void 0 : (_authDetailsData$pass = authDetailsData.passportExpiry) === null || _authDetailsData$pass === void 0 ? void 0 : _authDetailsData$pass.replace(/\s/g, "")) : "",
          countryOfOrigin: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.countryOrigin ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.countryOrigin.split("-").pop() : "",
          dateOfBirth: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.dob ? reStructuredDatOfBirth(personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.dob.replace(/\s/g, "")) : "",
          gender: (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.gender) === "male" ? "M" : "F",
          maritalStatus: personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.maritalStatus,
          accountNumber: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.accountNumber
        },
        deliveryDetails: {
          building: deliveryDetailsData !== null && deliveryDetailsData !== void 0 && (_deliveryDetailsData$5 = deliveryDetailsData.address) !== null && _deliveryDetailsData$5 !== void 0 && _deliveryDetailsData$5.complexName ? deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$6 = deliveryDetailsData.address) === null || _deliveryDetailsData$6 === void 0 ? void 0 : _deliveryDetailsData$6.complexName : "",
          physicalAddress: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$7 = deliveryDetailsData.address) === null || _deliveryDetailsData$7 === void 0 ? void 0 : _deliveryDetailsData$7.addressLine1,
          physicalCode: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$8 = deliveryDetailsData.address) === null || _deliveryDetailsData$8 === void 0 ? void 0 : _deliveryDetailsData$8.postalCode,
          province: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.provinceName,
          shoppingCenter: "",
          streetName: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$9 = deliveryDetailsData.address) === null || _deliveryDetailsData$9 === void 0 ? void 0 : _deliveryDetailsData$9.streetName,
          streetNumber: deliveryDetailsData !== null && deliveryDetailsData !== void 0 && (_deliveryDetailsData$10 = deliveryDetailsData.address) !== null && _deliveryDetailsData$10 !== void 0 && _deliveryDetailsData$10.streetNo ? deliveryDetailsData.address.streetNo : "00",
          suburb: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$11 = deliveryDetailsData.address) === null || _deliveryDetailsData$11 === void 0 ? void 0 : _deliveryDetailsData$11.suburb,
          unitSuitFloor: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$12 = deliveryDetailsData.address) === null || _deliveryDetailsData$12 === void 0 ? void 0 : _deliveryDetailsData$12.unitNo
        },
        employmentDetails: {
          occupationCode: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employmentCategory,
          employerName: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employerName,
          monthlyIncome: employmentDetailsData !== null && employmentDetailsData !== void 0 && employmentDetailsData.grossMonthlySalary ? reStructuredSalary(employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.grossMonthlySalary) : "",
          occupation: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.empIndustry,
          employmentCategoryCode: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employmentType,
          salaryFrequency: "Monthly"
        },
        otherDetails: {
          userId: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.accountId,
          accountID: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.accountNumber,
          dealID: dealSku,
          dealCost: dealPrice,
          dealSheetId: dealSku,
          dealSheetNumber: dealSku,
          portInReason: "",
          addressID: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.primaryAddressID,
          vasCode: " ",
          vasList: [{
            reasonCodeList: {
              reasonCode: [{
                code: "",
                description: ""
              }]
            }
          }],
          billingProfileID: customerInfo.billingProfileId,
          contractCoverFlag: "",
          tarrifCode: eppixproductcode
        }
      }
    };
  };
  /**
   * Credit vetting outcome request payload
   *
   * @usage map the key-value pair request
   */


  var getCreditVettingOutComeAddLinePayload = function getCreditVettingOutComeAddLinePayload(customerInfo) {
    var _dealProduct$product6, _dealProduct$product7, _dealProduct$product8, _deliveryDetailsData$13, _deliveryDetailsData$14, _deliveryDetailsData$15;

    var dealProduct = cartProducts.find(function (cartProduct) {
      var _cartProduct$product7, _cartProduct$product8;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product7 = cartProduct.product) === null || _cartProduct$product7 === void 0 ? void 0 : _cartProduct$product7.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product8 = cartProduct.product) === null || _cartProduct$product8 === void 0 ? void 0 : _cartProduct$product8.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
    });
    var dealPrice = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product6 = dealProduct.product) === null || _dealProduct$product6 === void 0 ? void 0 : _dealProduct$product6.monthly_recurring.toString();
    var dealSku = dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product7 = dealProduct.product) === null || _dealProduct$product7 === void 0 ? void 0 : _dealProduct$product7.sku;
    var eppixproductcode = dealProduct !== null && dealProduct !== void 0 && (_dealProduct$product8 = dealProduct.product) !== null && _dealProduct$product8 !== void 0 && _dealProduct$product8.eppixproductcode ? dealProduct.product.eppixproductcode : "0";
    return {
      journeyType: "Addline",
      creditVettingPayload: {
        applicationDetails: {
          applicantContactNumber: reStructuredPhoneNumber()
        },
        customerDetails: {
          idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
          idPassportNumber: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.idNumber ? authDetailsData.idNumber.toString() : "",
          monthlyIncome: employmentDetailsData !== null && employmentDetailsData !== void 0 && employmentDetailsData.grossMonthlySalary ? reStructuredSalary(employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.grossMonthlySalary) : "",
          mobileNumber: reStructuredPhoneNumber()
        },
        deliveryDetails: {
          streetName: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$13 = deliveryDetailsData.address) === null || _deliveryDetailsData$13 === void 0 ? void 0 : _deliveryDetailsData$13.streetName,
          streetNumber: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$14 = deliveryDetailsData.address) === null || _deliveryDetailsData$14 === void 0 ? void 0 : _deliveryDetailsData$14.streetNo,
          suburb: deliveryDetailsData === null || deliveryDetailsData === void 0 ? void 0 : (_deliveryDetailsData$15 = deliveryDetailsData.address) === null || _deliveryDetailsData$15 === void 0 ? void 0 : _deliveryDetailsData$15.suburb
        },
        otherDetails: {
          userId: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.accountId,
          accountID: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.accountNumber,
          dealID: dealSku,
          dealCost: dealPrice,
          dealSheetId: dealSku,
          dealSheetNumber: dealSku,
          portInReason: "",
          addressID: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.addressId,
          vasCode: "ROH",
          vasList: [{
            reasonCodeList: {
              reasonCode: [{
                code: "",
                description: ""
              }]
            }
          }],
          billingProfileID: customerInfo.billingProfileId,
          contractCoverFlag: "",
          tarrifCode: eppixproductcode,
          debiCheckFlag: "N"
        }
      },
      otpToken: otpAuthtoken
    };
  };

  var getApprovedScreencontent = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(resultCode) {
      var newResultCode, _result$, _result$2, _result$3, result;

      return regenerator_default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context12.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context12.next = 5;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 5:
              result = _context12.sent;
              setCreditOutcome({
                visible: true,
                title: (_result$ = result[0]) === null || _result$ === void 0 ? void 0 : _result$.resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                screenType: (_result$2 = result[0]) === null || _result$2 === void 0 ? void 0 : _result$2.resultCode,
                iconType: (_result$3 = result[0]) === null || _result$3 === void 0 ? void 0 : _result$3.icon
              });
              dispatch({
                type: actionTypes/* SET_CREDIT_VETTING_OUTCOME */.DI,
                payload: result[0]
              });
              _context12.next = 15;
              break;

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12["catch"](1);
              logger/* Logger.error */.Y.error(_context12.t0, "ConsentResultDetails", {
                "function": "getApprovedScreencontent"
              });
              (0,helperServices/* hideSpinner */.v3)();
              fetchErrorDetails("contentNotFound", "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);

            case 15:
              _context12.prev = 15;
              (0,helperServices/* hideSpinner */.v3)();
              return _context12.finish(15);

            case 18:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 10, 15, 18]]);
    }));

    return function getApprovedScreencontent(_x7) {
      return _ref13.apply(this, arguments);
    };
  }();
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee13(resultCode, pageErrorType) {
      var additionalUtagData,
          preferences,
          pageName,
          label,
          newResultCode,
          _result$0$primaryCTAU2,
          result,
          _args13 = arguments;

      return regenerator_default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              additionalUtagData = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : null;
              preferences = _args13.length > 3 && _args13[3] !== undefined ? _args13[3] : [];
              pageName = "checkout: credit check: ".concat(customerStatus);
              label = "";
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context13.prev = 5;
              (0,helperServices/* showSpinner */.yh)();
              _context13.next = 9;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 9:
              result = _context13.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                  return result[0].resultCode === declined_lead_next_level_multicart && selectedPreference === "call-me-back" ? handlePrimaryNxtLvlClick(pageName, primaryLabel, result[0].leadType) : _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), pageName, result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), pageName, result[0].secondaryCTAText, resultCode);
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                pageErrorType: pageErrorType,
                additionalUtagData: additionalUtagData,
                dividerLine: multicartFlag ? true : false,
                ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                preferences: multicartFlag ? preferences : [],
                defaultPreference: multicartFlag && (_result$0$primaryCTAU2 = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU2 !== void 0 && _result$0$primaryCTAU2.includes("/checkout") ? "once-off" : null
              });
              logger/* Logger.error */.Y.error(result[0].resultTitle || "fetchErrorDetails - ConsentResultDetails - error", "ConsentResultDetails", {
                response: JSON.stringify(result),
                "function": "fetchErrorDetails",
                functionParams: {
                  resultCode: resultCode,
                  pageErrorType: pageErrorType,
                  additionalUtagData: JSON.stringify(additionalUtagData || {}),
                  preferences: JSON.stringify(preferences || {})
                }
              });
              setAnalyticsOnErrorPage(pageName, label);
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context13.next = 23;
              break;

            case 17:
              _context13.prev = 17;
              _context13.t0 = _context13["catch"](5);
              logger/* Logger.error */.Y.error(_context13.t0, "ConsentResultDetails", {
                "function": "fetchErrorDetails",
                multicartFlag: multicartFlag
              });

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.checkout.lbl_invalid_attempt_title */.Z.checkout.lbl_invalid_attempt_title,
                  desc: labels/* default.checkout.lbl_invalid_attempt_desc */.Z.checkout.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)("/forms/ecommerce", "credit_vetting", "lead", preferenceId), "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, pageName, "Call me back", label);
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(null, pageName, "Exit checkout", label);
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 23:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[5, 17]]);
    }));

    return function fetchErrorDetails(_x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }();

  var fetchCreditVettingErrorDetails = /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee14(resultCode, errorCode, creditFiltersValue, pageErrorType) {
      var additionalUtagData,
          preferences,
          pageName,
          label,
          newResultCode,
          _result$0$primaryCTAU3,
          result,
          _args14 = arguments;

      return regenerator_default().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              additionalUtagData = _args14.length > 4 && _args14[4] !== undefined ? _args14[4] : null;
              preferences = _args14.length > 5 && _args14[5] !== undefined ? _args14[5] : [];
              pageName = "checkout: credit check: ".concat(customerStatus, ": approved with conditions");

              if (errorCode === labels/* default.creditVetting.lbl_approved_with_condition */.Z.creditVetting.lbl_approved_with_condition) {
                label = "deal";
              }

              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context14.prev = 5;
              (0,helperServices/* showSpinner */.yh)();
              _context14.next = 9;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 9:
              result = _context14.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  var preferenceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), errorCode, pageName, label, creditFiltersValue);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType));
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                pageErrorType: pageErrorType,
                additionalUtagData: additionalUtagData,
                dividerLine: multicartFlag ? true : false,
                ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                preferences: multicartFlag ? preferences : [],
                defaultPreference: multicartFlag && (_result$0$primaryCTAU3 = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU3 !== void 0 && _result$0$primaryCTAU3.includes("/checkout") ? "once-off" : null
              });
              setAnalyticsOnErrorPage(pageName, label);
              (0,helperServices/* hideSpinner */.v3)();
              navigate("pageError");
              _context14.next = 20;
              break;

            case 16:
              _context14.prev = 16;
              _context14.t0 = _context14["catch"](5);
              logger/* Logger.error */.Y.error(_context14.t0, "ConsentResultDetails", {
                "function": "fetchCreditVettingErrorDetails",
                multicartFlag: multicartFlag
              });

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.creditVetting.lbl_invalid_attempt_title */.Z.creditVetting.lbl_invalid_attempt_title,
                  desc: labels/* default.creditVetting.lbl_invalid_attempt_desc */.Z.creditVetting.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)("/forms/ecommerce", "credit_vetting", "lead", preferenceId), "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick();
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick();
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: "checkout: credit check: ".concat(customerStatus)
                });
                (0,helperServices/* hideSpinner */.v3)();
                navigate("pageError");
              }

            case 20:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[5, 16]]);
    }));

    return function fetchCreditVettingErrorDetails(_x10, _x11, _x12, _x13) {
      return _ref15.apply(this, arguments);
    };
  }();
  /**
   * Get the next pre-populated next level form and submit it on behalf of the customer
   * @usage Redirect to Next level form
   */


  var handlePrimaryNxtLvlClick = /*#__PURE__*/function () {
    var _ref16 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee15(pageName, label, leadType) {
      var nexLvlFormPayload, _formResponse$respons, _formResponse$respons2, formResponse, formResult, result, _formResponse$error, _formResponse$error2;

      return regenerator_default().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              nexLvlFormPayload = {
                channel: "ONLINE",
                requestType: "next_level_cust",
                idNumber: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.idNumber ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber : "",
                idDocType: "SAID",
                name: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.firstName : "",
                surname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.surName : "",
                msisdn: (0,helperServices/* africaCountryCode */.xJ)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn) ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn : (0,helperServices/* appendCountryCode */.yT)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn),
                emailAddress: contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.emailAddress
              };
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label)
              });
              _context15.prev = 3;
              _context15.next = 6;
              return microServices/* default.post */.Z.post("api", "staticFormSubmit", nexLvlFormPayload, null, false);

            case 6:
              formResponse = _context15.sent;
              formResult = (_formResponse$respons = formResponse.response) === null || _formResponse$respons === void 0 ? void 0 : (_formResponse$respons2 = _formResponse$respons.data) === null || _formResponse$respons2 === void 0 ? void 0 : _formResponse$respons2.result;

              if (!(formResult !== null && formResult !== void 0 && formResult.successful)) {
                _context15.next = 17;
                break;
              }

              _context15.next = 11;
              return leadSubmissonContent(labels/* default.creditVetting.lbl_lead_submitted */.Z.creditVetting.lbl_lead_submitted);

            case 11:
              result = _context15.sent;
              setPageErr({
                type: "success",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handleSecondaryClick(result[0].primaryCTAURL, pageName, "exit");
                },
                imgUrl: result[0].icon,
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)();
              navigate("pageError");
              _context15.next = 18;
              break;

            case 17:
              if (formResponse !== null && formResponse !== void 0 && (_formResponse$error = formResponse.error) !== null && _formResponse$error !== void 0 && _formResponse$error.status) {
                fetchErrorDetails("creditVettingOutcome_".concat(formResponse === null || formResponse === void 0 ? void 0 : (_formResponse$error2 = formResponse.error) === null || _formResponse$error2 === void 0 ? void 0 : _formResponse$error2.status), "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              } else {
                fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              }

            case 18:
              _context15.next = 24;
              break;

            case 20:
              _context15.prev = 20;
              _context15.t0 = _context15["catch"](3);
              logger/* Logger.error */.Y.error(_context15.t0, "ConsentResultDetails", {
                "function": "handlePrimaryNxtLvlClick"
              });
              (0,helperServices/* hideSpinner */.v3)();

            case 24:
              _context15.prev = 24;
              removeCreditCheckStates(null);
              return _context15.finish(24);

            case 27:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[3, 20, 24, 27]]);
    }));

    return function handlePrimaryNxtLvlClick(_x14, _x15, _x16) {
      return _ref16.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick = /*#__PURE__*/function () {
    var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee16(url, errorCode, pageName, label, creditFiltersValue) {
      var maxPrice, navigateUrl;
      return regenerator_default().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (errorCode === labels/* default.creditVetting.lbl_approved_with_condition */.Z.creditVetting.lbl_approved_with_condition) {
                if (creditFilters !== null && creditFilters !== void 0 && creditFilters.total_monthly_payment) {
                  maxPrice = creditFilters === null || creditFilters === void 0 ? void 0 : creditFilters.total_monthly_payment;
                } else {
                  maxPrice = creditFiltersValue === null || creditFiltersValue === void 0 ? void 0 : creditFiltersValue.total_monthly_payment;
                }
              }

              (0,helperServices/* showSpinner */.yh)();
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label)
              });
              navigateUrl = url === "/" ? url : "".concat(helperServices/* urlPrefix */.wn).concat(url);

              if (!url) {
                _context16.next = 17;
                break;
              }

              _context16.t0 = errorCode;
              _context16.next = _context16.t0 === labels/* default.creditVetting.lbl_approved_with_condition */.Z.creditVetting.lbl_approved_with_condition ? 8 : 10;
              break;

            case 8:
              if (multicartFlag) {
                if (url === "/deals") {
                  router.push("".concat(helperServices/* urlPrefix */.wn).concat(url, "?monthly_recurring=minValue:0,maxValue:").concat(maxPrice, "&isShowQualifying=true")).then(function () {
                    (0,helperServices/* hideSpinner */.v3)();
                  });
                } else {
                  router.push(navigateUrl).then(function () {
                    (0,helperServices/* hideSpinner */.v3)();
                  });
                }
              } else {
                router.push("".concat(helperServices/* urlPrefix */.wn).concat(url, "?category=").concat(dealCategoryId, "&monthly_recurring=minValue:0,maxValue:").concat(maxPrice, "&isShowQualifying=true")).then(function () {
                  (0,helperServices/* hideSpinner */.v3)();
                });
              }

              return _context16.abrupt("break", 15);

            case 10:
              if (!(navigateUrl === "/")) {
                _context16.next = 13;
                break;
              }

              _context16.next = 13;
              return deleteItemsFromCart(cartId, cartProductId);

            case 13:
              router.push(navigateUrl).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });
              return _context16.abrupt("break", 15);

            case 15:
              _context16.next = 18;
              break;

            case 17:
              router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
                (0,helperServices/* hideSpinner */.v3)();
              });

            case 18:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function _handlePrimaryClick(_x17, _x18, _x19, _x20, _x21) {
      return _ref17.apply(this, arguments);
    };
  }();
  /**
   * This function is triggered when the user clicks on the error page screen secondary button.
   *
   * @call clicks on "Exit/Exit checkout" button
   */


  var _handleSecondaryClick = /*#__PURE__*/function () {
    var _ref18 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee17(url, pageName, label) {
      return regenerator_default().wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();

              if (!dealCartProduct) {
                _context17.next = 4;
                break;
              }

              _context17.next = 4;
              return deleteItemsFromCart(cartId, cartProductId);

            case 4:
              if (url) {
                router.push("".concat(url)).then(function () {
                  (0,helperServices/* hideSpinner */.v3)();
                });
              } else {
                router.push("/").then(function () {
                  (0,helperServices/* hideSpinner */.v3)();
                });
              }

              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label)
              });
              removeCreditCheckStates(null);
              dispatch({
                type: actionTypes/* SET_CREDIT_VETTING_RESULT */.GE,
                payload: null
              });

            case 8:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function _handleSecondaryClick(_x22, _x23, _x24) {
      return _ref18.apply(this, arguments);
    };
  }();
  /**
   * Set the on Error page
   *
   * @call on error page load
   */


  var setAnalyticsOnErrorPage = function setAnalyticsOnErrorPage(pageName, label) {
    analyticsUtag/* view */.ei(ConsentResultDetails_objectSpread({
      page_event: "view",
      page_name: pageName
    }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type", "multicart_flag"])));
  };
  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */


  var mapFieldData = function mapFieldData() {
    var _bankAccountDetails;

    var isIdTypeSaid = (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "SAID";
    var isIdTypePassport = (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "PASSPORT";
    return {
      individualDetails: ConsentResultDetails_objectSpread(ConsentResultDetails_objectSpread({
        title: getTitle(personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.title),
        firstName: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData.firstName : "",
        lastName: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData.surName : "",
        gender: (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.gender) === "male" ? "M" : "F",
        maritalStatus: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.maritalStatus ? personalDetailsData.maritalStatus : "",
        idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
        emailAddress: contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.emailAddress,
        birthDate: mmddyyyyDateFormat(personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.dob ? personalDetailsData.dob : ""),
        cellphoneNumber: reStructuredPhoneNumber(),
        homephoneNumber: reStructuredPhoneNumber()
      }, isIdTypePassport && {
        passportNumber: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "PASSPORT" ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber.toString() : "",
        passportCountryofIssue: (0,helperServices/* titleCaseFirstLetterOfString */.FZ)(authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.countryOrigin ? authDetailsData.countryOrigin.split("-")[0] : ""),
        passportExpirationDate: mmddyyyyDateFormat(authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.passportExpiry ? authDetailsData.passportExpiry : "")
      }), isIdTypeSaid && {
        saIdNumber: (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "SAID" ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber.toString() : "",
        passportNumber: "",
        passportCountryofIssue: "",
        passportExpirationDate: ""
      }),
      ricaAddress: {
        c3DSiebelAddressType: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.addressType,
        streetNumber: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.streetNo ? homeDetailsData.streetNo : "00",
        streetName: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName,
        suburb: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.suburb,
        postalCode: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode,
        deliveryAddressFlag: "N",
        cityTown: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.town,
        province: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.provinceName,
        periodAtCurrentAddressYears: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.currentAddressYears ? homeDetailsData.currentAddressYears.replace(/\D/g, "") : "00",
        periodAtCurrentAddressMonths: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.currentAddressMonths ? homeDetailsData.currentAddressMonths.replace(/\D/g, "") : "00",
        postalDeliveryFlag: "N",
        residence: homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.residence
      },
      payment: {
        bankAccountDetails: (_bankAccountDetails = {
          bankAccountName: ""
        }, (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankAccountName", (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.firstName) + " " + (personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.surName)), (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankAccountType", debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.accountType), (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankAccountNumber", debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.accountNumber), (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankBranch", debitDetailsData !== null && debitDetailsData !== void 0 && debitDetailsData.branchName ? debitDetailsData.branchName : "Universal"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankName", debitDetailsData === null || debitDetailsData === void 0 ? void 0 : debitDetailsData.bank), (0,defineProperty/* default */.Z)(_bankAccountDetails, "billFrequency", "Monthly"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "billType", "Detailed Invoice"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "mediaType", "email PDF"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "paymentMethod", "Direct Debit"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "paymentType", "Postpaid"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "bankBranchCode", debitDetailsData !== null && debitDetailsData !== void 0 && debitDetailsData.branchCode ? debitDetailsData.branchCode : ""), (0,defineProperty/* default */.Z)(_bankAccountDetails, "billFormat", "email PDF"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "ageOfAccountYears", debitDetailsData.ageOfAccountYears ? debitDetailsData.ageOfAccountYears.replace(/\D/g, "") : "00"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "ageOfAccountMonths", debitDetailsData.ageOfAccountMonths ? debitDetailsData.ageOfAccountMonths.replace(/\D/g, "") : "00"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "c3DBankValidationFlag", "Y"), (0,defineProperty/* default */.Z)(_bankAccountDetails, "debitOrderCycle", "DIRECT DEBIT 1ST OF THE MONTH"), _bankAccountDetails),
        creditVettingDetails: {
          employerIndustry: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.empIndustry.toUpperCase(),
          employerName: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employerName,
          employerNumber: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employerNumber,
          frequencyOfSalary: "MONTHLY",
          grossMonthlyIncome: employmentDetailsData !== null && employmentDetailsData !== void 0 && employmentDetailsData.grossMonthlySalary ? reStructuredSalary(employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.grossMonthlySalary) : "",
          occupationType: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.empCategory,
          periodatPreviousAddressYears: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.previousAddressYears ? homeDetailsData.previousAddressYears.replace(/\D/g, "") : "00",
          periodatPreviousAddressMonths: homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.previousAddressMonths ? homeDetailsData.previousAddressMonths.replace(/\D/g, "") : "00",
          salaryDay: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.salaryDate,
          c3DEmploymentCategoryCode: employmentDetailsData === null || employmentDetailsData === void 0 ? void 0 : employmentDetailsData.employmentType
        }
      }
    };
  };
  /**
   * Set the analytics(link)
   *
   * @call clicks on checkboxes
   */


  var setAnalyticsOnconsentcheck = function setAnalyticsOnconsentcheck(message) {
    analyticsUtag/* link */.p4(ConsentResultDetails_objectSpread(ConsentResultDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": ") + message
    }));
  };
  /**
   * Set the analytics(link)
   *
   * @call clicks on "do credit check" button
   */


  var setAnalyticsOnDoCreditCheck = function setAnalyticsOnDoCreditCheck() {
    analyticsUtag/* link */.p4(ConsentResultDetails_objectSpread(ConsentResultDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": credit check")
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["form-heading"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/like_section.svg"),
            alt: "tick"
          }), "Credit check consent", /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutCreditCheck_module_default())["section-numbers"],
            children: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Section 7 of 7" : "Section 5 of 5"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), formContent && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
          noValidate: true,
          id: "checkout-credit-check-consent-form",
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(consentResultsForm_ConsentResultsForm, {
            formName: type,
            fieldValues: state.fieldValues[type],
            fieldErrors: state.fieldErrors[type],
            fieldErrorsMessage: state.fieldErrorsMessage[type],
            formContent: formContent ? formContent : "",
            onChangeHandler: handleChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutCreditCheck_module_default())["button-wrapper"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
              type: "submit",
              variant: "solid grey",
              disabled: submitDisabled || !isDoCreditCheckDisable,
              className: (CheckoutCreditCheck_module_default()).button,
              id: "checkout-credit-check-consent-form-submit",
              onClick: function onClick() {
                return handleSubmit;
              },
              children: "Do credit check"
            })
          })]
        })]
      })
    })
  });
};

var ConsentResultDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    debitDetailsData: state.creditCheckDetails.debitDetails,
    personalDetailsData: state.creditCheckDetails.personalDetails,
    employmentDetailsData: state.creditCheckDetails.employmentDetails,
    contactDetailsData: state.creditCheckDetails.contactDetails,
    homeDetailsData: state.creditCheckDetails.homeDetails,
    deliveryDetailsData: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    creditFilters: state.upgrade.creditFilters,
    selectedUpgradeResponse: state.upgrade.selectedUpgradeResponse,
    cartProducts: state.cartDetails.cartProductItems,
    cartDetails: state.cartDetails,
    selectedPreference: state.checkoutPageError.selected_preference
  };
};

var ConsentResultDetails_mapDispatchToProps = {
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK,
  deleteItemsFromCart: cartAction/* deleteItemsFromCart */.dY
};
ConsentResultDetails.defaultProps = {
  type: "consentResultDetails"
};
/* harmony default export */ var consentResultDetails_ConsentResultDetails = ((0,DependencyHelper.connect)(ConsentResultDetails_mapStateToProps, ConsentResultDetails_mapDispatchToProps)(ConsentResultDetails));
// EXTERNAL MODULE: ./components/organisms/debicheckMandate/DebicheckMandate.module.scss
var DebicheckMandate_module = __webpack_require__(77264);
var DebicheckMandate_module_default = /*#__PURE__*/__webpack_require__.n(DebicheckMandate_module);
// EXTERNAL MODULE: ./components/atoms/staticForms/StaticForms.module.scss
var StaticForms_module = __webpack_require__(88192);
var StaticForms_module_default = /*#__PURE__*/__webpack_require__.n(StaticForms_module);
;// CONCATENATED MODULE: ./components/organisms/debicheckMandate/DebicheckMandate.jsx







var DebicheckMandate = function DebicheckMandate(_ref) {
  var onChangeHandler = _ref.onChangeHandler,
      isCheckedState = _ref.isCheckedState,
      multicartFlag = _ref.multicartFlag;

  var handleChange = function handleChange(event) {
    onChangeHandler(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((StaticForms_module_default())["main-container"], " ").concat((DebicheckMandate_module_default()).debi_mandate_container),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((StaticForms_module_default())["main-row"], " ").concat((StaticForms_module_default())["checkbox-row"], " ").concat((StaticForms_module_default())["full-row"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "".concat((DebicheckMandate_module_default()).debi_mandate_head),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "27",
          height: "28",
          viewBox: "0 0 27 28",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.94565 4.21714L13.3832 2.33136C13.4607 2.31403 13.5412 2.31403 13.6187 2.33136L22.0562 4.21714C22.303 4.27229 22.4784 4.49129 22.4784 4.74414V15.6173C22.4784 16.6193 21.9753 17.5631 20.849 19.0451C20.0773 20.0657 18.9964 21.0946 17.6371 22.1057C15.927 23.3789 14.5834 24.2829 13.7484 24.7133C13.593 24.7934 13.4085 24.7934 13.2532 24.7132C12.4228 24.2844 11.0822 23.3841 9.36289 22.11C7.99952 21.086 6.92138 20.0612 6.15225 19.0518C5.03121 17.5767 4.52344 16.6204 4.52344 15.6173V4.74414C4.52344 4.49129 4.69889 4.27229 4.94565 4.21714ZM16.4371 9.02482C16.0617 7.71473 14.8637 6.81186 13.5009 6.81186C12.1381 6.81186 10.9402 7.71473 10.5647 9.02482C10.2252 10.2096 10.6327 11.4682 11.5688 12.232L10.458 17.543C10.4529 17.5671 10.4496 17.5916 10.4478 17.6162C10.4194 18.0268 10.5687 18.4299 10.8578 18.7228C11.1429 19.0118 11.537 19.1663 11.9421 19.1484H15.0593C15.463 19.165 15.8554 19.011 16.1401 18.7237C16.4286 18.4327 16.5792 18.0325 16.5543 17.6235C16.5524 17.5926 16.5479 17.5619 16.5408 17.5318L15.929 14.95L15.4261 12.2377C16.3671 11.4745 16.7775 10.2126 16.4371 9.02482ZM15.373 17.9634C15.3011 18.036 15.2017 18.0744 15.0997 18.0691L15.0717 18.0684H11.9287L11.8986 18.0692C11.797 18.0749 11.6979 18.0367 11.6265 17.9643C11.5618 17.8987 11.5255 17.8109 11.5244 17.7195L12.6978 12.1095C12.7441 11.8879 12.6473 11.6609 12.4552 11.5409C11.708 11.0744 11.3602 10.1692 11.6029 9.32234C11.8456 8.47548 12.62 7.89186 13.5009 7.89186C14.3819 7.89186 15.1562 8.47548 15.3989 9.32234C15.6416 10.1692 15.2939 11.0744 14.5466 11.5409C14.3583 11.6585 14.2612 11.8793 14.3017 12.0975L14.8726 15.173L15.4767 17.7252C15.4731 17.8143 15.4364 17.8995 15.373 17.9634Z",
            fill: "#333333"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
            id: "Debi_mandate_mask",
            "mask-type": "alpha",
            maskUnits: "userSpaceOnUse",
            x: "4",
            y: "2",
            width: "19",
            height: "23",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.94565 4.21714L13.3832 2.33136C13.4607 2.31403 13.5412 2.31403 13.6187 2.33136L22.0562 4.21714C22.303 4.27229 22.4784 4.49129 22.4784 4.74414V15.6173C22.4784 16.6193 21.9753 17.5631 20.849 19.0451C20.0773 20.0657 18.9964 21.0946 17.6371 22.1057C15.927 23.3789 14.5834 24.2829 13.7484 24.7133C13.593 24.7934 13.4085 24.7934 13.2532 24.7132C12.4228 24.2844 11.0822 23.3841 9.36289 22.11C7.99952 21.086 6.92138 20.0612 6.15225 19.0518C5.03121 17.5767 4.52344 16.6204 4.52344 15.6173V4.74414C4.52344 4.49129 4.69889 4.27229 4.94565 4.21714ZM16.4371 9.02482C16.0617 7.71473 14.8637 6.81186 13.5009 6.81186C12.1381 6.81186 10.9402 7.71473 10.5647 9.02482C10.2252 10.2096 10.6327 11.4682 11.5688 12.232L10.458 17.543C10.4529 17.5671 10.4496 17.5916 10.4478 17.6162C10.4194 18.0268 10.5687 18.4299 10.8578 18.7228C11.1429 19.0118 11.537 19.1663 11.9421 19.1484H15.0593C15.463 19.165 15.8554 19.011 16.1401 18.7237C16.4286 18.4327 16.5792 18.0325 16.5543 17.6235C16.5524 17.5926 16.5479 17.5619 16.5408 17.5318L15.929 14.95L15.4261 12.2377C16.3671 11.4745 16.7775 10.2126 16.4371 9.02482ZM15.373 17.9634C15.3011 18.036 15.2017 18.0744 15.0997 18.0691L15.0717 18.0684H11.9287L11.8986 18.0692C11.797 18.0749 11.6979 18.0367 11.6265 17.9643C11.5618 17.8987 11.5255 17.8109 11.5244 17.7195L12.6978 12.1095C12.7441 11.8879 12.6473 11.6609 12.4552 11.5409C11.708 11.0744 11.3602 10.1692 11.6029 9.32234C11.8456 8.47548 12.62 7.89186 13.5009 7.89186C14.3819 7.89186 15.1562 8.47548 15.3989 9.32234C15.6416 10.1692 15.2939 11.0744 14.5466 11.5409C14.3583 11.6585 14.2612 11.8793 14.3017 12.0975L14.8726 15.173L15.4767 17.7252C15.4731 17.8143 15.4364 17.8995 15.373 17.9634Z",
              fill: "white"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            mask: "url(#Debi_mandate_mask)",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              y: "0.0449219",
              width: "27",
              height: "27",
              fill: "#282828"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((DebicheckMandate_module_default()).debi_mandate_head_main),
          children: "DebiCheck"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((DebicheckMandate_module_default()).debi_mandate_head_minor),
          children: "(Optional)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((DebicheckMandate_module_default()).debi_mandate_info),
        children: multicartFlag ? labels/* default.creditCheckout.lbl_debicheck_mandate_multicart */.Z.creditCheckout.lbl_debicheck_mandate_multicart : labels/* default.creditCheckout.lbl_debicheck_mandate */.Z.creditCheckout.lbl_debicheck_mandate
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
        className: "".concat((DebicheckMandate_module_default()).debi_mandate_check_container),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Check, {
          custom: true,
          className: "".concat((StaticForms_module_default())["form-checkbox-label"]),
          id: "debicheck_mandate_check",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Input, {
            name: "debiCheckFlag",
            type: "checkbox",
            onChange: handleChange,
            checked: isCheckedState
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Label, {
            id: "debicheck_mandate_check-label",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "I would like Vodacom to perform a DebiCheck."
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var debicheckMandate_DebicheckMandate = (DebicheckMandate);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/debitDetailsForm/DebitDetailsForm.jsx








var DebitDetailsForm = function DebitDetailsForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      bankList = _ref.bankList,
      accountTypeList = _ref.accountTypeList,
      debitOrderDateList = _ref.debitOrderDateList,
      onResetHandler = _ref.onResetHandler,
      isDisplayBranchInfo = _ref.isDisplayBranchInfo,
      onBlurHandler = _ref.onBlurHandler,
      onFocusHandler = _ref.onFocusHandler,
      multicartFlag = _ref.multicartFlag;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var handleFocus = function handleFocus(event) {
    onFocusHandler(event, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd101",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd101-label",
            children: "Bank"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "bank",
            label: "Bank",
            data: bankList,
            required: true,
            handleSelect: onChangeHandler,
            handleBlur: handleBlur,
            selectedId: fieldValues["bank"],
            customId: "validationFormdd101",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["bank"]
          }), fieldErrors["bank"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["bank"]
          })]
        }), isDisplayBranchInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd102",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd102-label",
            children: "Branch name"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "branchName",
            value: fieldValues["branchName"],
            placeholder: "Add branch name",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["branchName"],
            className: fieldErrors["branchName"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["branchName"]
          })]
        }), isDisplayBranchInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd103",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd103-label",
            children: "Branch code"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "branchCode",
            value: fieldValues["branchCode"],
            placeholder: "Add branch code",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["branchCode"],
            className: fieldErrors["branchCode"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["branchCode"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd104",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd104-label",
            children: "Account Type"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "accountType",
            label: "Account type",
            data: accountTypeList,
            required: true,
            handleSelect: onChangeHandler,
            handleBlur: handleBlur,
            selectedId: fieldValues["accountType"],
            customId: "validationFormdd104",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["accountType"]
          }), fieldErrors["accountType"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["accountType"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd105",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd105-label",
            children: "Account number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
            type: "text",
            name: "accountNumber",
            value: fieldValues["accountNumber"],
            placeholder: "Add account number",
            required: true,
            onChange: handleChange,
            onBlur: handleBlur,
            isInvalid: fieldErrors["accountNumber"],
            className: fieldErrors["accountNumber"] ? (NewLineForms_module_default()).invalid : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: (NewLineForms_module_default())["invalid-feedback"],
            children: fieldErrorsMessage["accountNumber"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
          className: (NewLineForms_module_default())["form-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"], " d-none d-md-block d-lg-block"),
            id: "validationFormdd106-label",
            children: "Account holder initials & surname"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "5",
            md: "5",
            className: "".concat((NewLineForms_module_default())["form-group"]),
            controlId: "validationFormdd107",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: "d-block d-sm-none ".concat((NewLineForms_module_default())["form-label"], " "),
              id: "validationFormdd107-label",
              children: "Account holder initials"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "initials",
              value: fieldValues["initials"],
              placeholder: "Add initials",
              required: true,
              onBlur: handleBlur,
              onChange: handleChange,
              isInvalid: fieldErrors["initials"],
              className: fieldErrors["initials"] ? (NewLineForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (NewLineForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["initials"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "7",
            md: "7",
            className: "".concat((NewLineForms_module_default())["form-group"]),
            controlId: "validationFormdd108",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: "d-block d-sm-none ".concat((NewLineForms_module_default())["form-label"]),
              id: "validationFormdd108-label",
              children: "Account holder surname"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "surname",
              value: fieldValues["surname"],
              placeholder: "Add your surname",
              required: true,
              onChange: handleChange,
              onBlur: handleBlur,
              isInvalid: fieldErrors["surname"],
              className: fieldErrors["surname"] ? (NewLineForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (NewLineForms_module_default())["invalid-feedback"],
              children: fieldErrorsMessage["surname"]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
          className: (NewLineForms_module_default())["form-row"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: "".concat((NewLineForms_module_default())["form-label"]),
            id: "validationFormdd110-label",
            children: "How long have you had this account?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            className: "".concat((NewLineForms_module_default())["form-group"]),
            controlId: "validationFormdd1101",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "ageOfAccountYears",
              value: fieldValues["ageOfAccountYears"],
              placeholder: "Years",
              required: true,
              maxLength: "2",
              onBlur: handleBlur,
              onChange: handleChange,
              onFocus: handleFocus,
              isInvalid: fieldErrors["duration"],
              className: fieldErrors["duration"] ? (NewLineForms_module_default()).invalid : ""
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            className: "".concat((NewLineForms_module_default())["form-group"]),
            controlId: "validationFormdd1102",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              name: "ageOfAccountMonths",
              value: fieldValues["ageOfAccountMonths"],
              placeholder: "Months",
              required: true,
              maxLength: "2",
              onChange: handleChange,
              onBlur: handleBlur,
              onFocus: handleFocus,
              isInvalid: fieldErrors["duration"],
              className: fieldErrors["duration"] ? (NewLineForms_module_default()).invalid : ""
            })
          }), fieldErrors["duration"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: "".concat((NewLineForms_module_default())["form-group"], " p-0"),
            controlId: "validationFormha108021",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
              children: fieldErrorsMessage["duration"]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
          as: DependencyHelper.Col,
          sm: "12",
          md: "12",
          className: (NewLineForms_module_default())["form-group"],
          controlId: "validationFormdd111",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
            className: (NewLineForms_module_default())["form-label"],
            id: "validationFormdd111-label",
            children: "Preferred debit order date"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
            formName: formName,
            name: "debitOrderDate",
            label: "Debit order date",
            data: debitOrderDateList,
            required: true,
            handleSelect: onChangeHandler,
            handleBlur: handleBlur,
            selectedId: fieldValues["debitOrderDate"],
            customId: "validationFormdd111",
            handleReset: onResetHandler,
            resetRequired: true,
            fieldError: fieldErrors["debitOrderDate"]
          }), fieldErrors["debitOrderDate"] && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
            type: "invalid",
            className: "".concat((NewLineForms_module_default())["invalid-feedback"], " ").concat((NewLineForms_module_default()).error),
            children: fieldErrorsMessage["debitOrderDate"]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(debicheckMandate_DebicheckMandate, {
      isCheckedState: fieldValues["debiCheckFlag"] === "N" ? false : true,
      onChangeHandler: handleChange,
      multicartFlag: multicartFlag
    })]
  });
};

DebitDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {}
};
/* harmony default export */ var debitDetailsForm_DebitDetailsForm = (DebitDetailsForm);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/debitDetailsInfo/DebitDetailsInfo.jsx






var DebitDetailsInfo = function DebitDetailsInfo(_ref) {
  var data = _ref.data,
      accountTypes = _ref.accountTypes;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Bank:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.bank
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Account type:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helperServices/* getValueLabel */.gk)(data === null || data === void 0 ? void 0 : data.accountType, accountTypes)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Account number:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.accountNumber
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Account holder name:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (data === null || data === void 0 ? void 0 : data.initials) + " " + (data === null || data === void 0 ? void 0 : data.surname)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "How long have you had this account?"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (data === null || data === void 0 ? void 0 : data.ageOfAccountYears.toLowerCase()) + ", " + (data === null || data === void 0 ? void 0 : data.ageOfAccountMonths.toLowerCase())
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Preferred debit order date:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.debitOrderDate
        })
      })]
    })
  });
};

DebitDetailsInfo.defaultProps = {
  data: {},
  accountTypes: []
};
/* harmony default export */ var debitDetailsInfo_DebitDetailsInfo = (DebitDetailsInfo);
// EXTERNAL MODULE: ./components/atoms/warningTitle/WarningTitle.module.scss
var WarningTitle_module = __webpack_require__(55452);
var WarningTitle_module_default = /*#__PURE__*/__webpack_require__.n(WarningTitle_module);
;// CONCATENATED MODULE: ./components/atoms/warningTitle/WarningTitle.jsx







var WarningTitle = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var title = _ref.title,
      contents = _ref.contents,
      className = _ref.className,
      id = _ref.id;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var iconTypeSvg = "warning-black.svg";
  var iconTypePath = "".concat(imagePrefix, "/assets/images/").concat(iconTypeSvg);

  var ListItem = function ListItem(_ref2) {
    var index = _ref2.index,
        desc = _ref2.desc;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        id: "".concat(id, "-item-").concat(index),
        className: (WarningTitle_module_default()).desc,
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(desc)
      })
    });
  };

  var listItems = contents.map(function (item, index) {
    return item ? /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
        index: index,
        desc: item.description ? item.description : item
      })
    }, index) : "";
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((WarningTitle_module_default()).warningTitle, " ").concat(className),
    id: id,
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (WarningTitle_module_default()).warningTitle__heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (WarningTitle_module_default()).icon,
        src: iconTypePath
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (WarningTitle_module_default()).title,
        children: title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "".concat((WarningTitle_module_default()).warningTitle__content),
      children: listItems
    })]
  });
});
WarningTitle.defaultProps = {
  title: null,
  contents: []
};
/* harmony default export */ var warningTitle_WarningTitle = (WarningTitle);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/debitDetails/DebitDetails.jsx




function DebitDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = DebitDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function DebitDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return DebitDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DebitDetails_arrayLikeToArray(o, minLen); }

function DebitDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function DebitDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DebitDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DebitDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DebitDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var DebitDetails_analyticsTags = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];

var DebitDetails = function DebitDetails(_ref) {
  var customerStatus = _ref.customerStatus,
      debitDetailsData = _ref.debitDetailsData,
      personalDetailsData = _ref.personalDetailsData,
      loadLookupData = _ref.loadLookupData,
      authDetailsData = _ref.authDetailsData,
      setShowSnackBar = _ref.setShowSnackBar,
      setPageErr = _ref.setPageErr,
      navigate = _ref.navigate,
      onFormSubmit = _ref.onFormSubmit,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      doCreditCheckDisable = _ref.doCreditCheckDisable,
      multicartFlag = _ref.multicartFlag;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(true),
      submitDisabled = _useState2[0],
      setSubmitDisabled = _useState2[1];

  var _useState3 = (0,react.useState)(debitDetailsData ? false : true),
      displayEditMode = _useState3[0],
      setDisplayEditMode = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      bankDetailsAttempt = _useState4[0],
      setBankDetailsAttempt = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      displayBranchDetailsAttempt = _useState5[0],
      setDisplayBranchDetailsAttempt = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showWarningMsg = _useState6[0],
      setShowWarningMsg = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      bankList = _useState7[0],
      setBankList = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      accountType = _useState8[0],
      setAccountType = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      debitOrderDate = _useState9[0],
      setDebitOrderDate = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      isDisplayBranchInfo = _useState10[0],
      setDisplayBranchInfo = _useState10[1];

  var _useState11 = (0,react.useState)("months"),
      monthString = _useState11[0],
      setMonthString = _useState11[1];

  var _useState12 = (0,react.useState)("years"),
      yearString = _useState12[0],
      setYearString = _useState12[1];

  var titleContents = labels/* default.creditCheckout.lbl_warning_contents */.Z.creditCheckout.lbl_warning_contents;
  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.debit */.Z.creditCheckout.errors.debit));
  var sectionReference = (0,react.useRef)(null);
  var dispatch = (0,DependencyHelper.useDispatch)();
  var router = (0,DependencyHelper.useRouter)();
  (0,react.useEffect)(function () {
    if (debitDetailsData) {
      fieldValues.debitDetails.bank = debitDetailsData.bank;
      fieldValues.debitDetails.accountType = debitDetailsData.accountType;
      fieldValues.debitDetails.accountNumber = debitDetailsData.accountNumber;
      fieldValues.debitDetails.initials = debitDetailsData.initials;
      fieldValues.debitDetails.surname = debitDetailsData.surname;
      fieldValues.debitDetails.duration = debitDetailsData.duration;
      fieldValues.debitDetails.ageOfAccountYears = debitDetailsData.ageOfAccountYears;
      fieldValues.debitDetails.ageOfAccountMonths = debitDetailsData.ageOfAccountMonths;
      fieldValues.debitDetails.debitOrderDate = debitDetailsData.debitOrderDate;
      fieldValues.debitDetails.debiCheckFlag = debitDetailsData.debiCheckFlag;
      errorStatus.debitDetails = checkFormError("debitDetails");

      if (errorStatus.debitDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    }
  }, [debitDetailsData]);

  var _useState13 = (0,react.useState)({
    validationsOn: {
      debitDetails: true
    },
    errorStatus: {
      debitDetails: true
    },
    validations: {
      debitDetails: {
        bank: true,
        accountType: true,
        accountNumber: true,
        initials: true,
        surname: true,
        duration: true,
        ageOfAccountYears: true,
        ageOfAccountMonths: true,
        debitOrderDate: true,
        branchName: false,
        branchCode: false,
        debiCheckFlag: false
      }
    },
    fieldErrors: {
      debitDetails: {
        bank: false,
        accountType: false,
        accountNumber: false,
        initials: false,
        surname: false,
        duration: false,
        debitOrderDate: false,
        branchName: false,
        branchCode: false,
        debiCheckFlag: false
      },
      fail: false
    },
    fieldValues: {
      debitDetails: {
        bank: "",
        accountType: "",
        accountNumber: "",
        initials: personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.initials,
        surname: personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.surName,
        ageOfAccountYears: "",
        ageOfAccountMonths: "",
        debitOrderDate: "",
        branchName: "",
        branchCode: "",
        debiCheckFlag: "N"
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState13[0],
      setState = _useState13[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  (0,react.useEffect)(function () {
    setBankList((0,helperServices/* convertInToObject */.uB)(toGetBankList(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.BANK_LIST, constants/* BANK_NAME */.NO)[constants/* BANK_NAME */.NO]));
    setAccountType((0,helperServices/* replaceDropdownKeys */.qp)(sortAccountType(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.BANK_ACCOUNT_TYPE), constants/* ACCOUNT_TYPE_FKEY */.rm, constants/* ACCOUNT_TYPE_LKEY */.Kz, constants/* ACCOUNT_TYPE */.Q5));
    setDebitOrderDate((0,helperServices/* convertInToObject */.uB)(toGetBankList(loadLookupData === null || loadLookupData === void 0 ? void 0 : loadLookupData.DEBIT_ORDER_DATE, constants/* DEBIT_DATE_FKEY */.Sw)[constants/* DEBIT_DATE_FKEY */.Sw]));
  }, []);
  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */

  var handleChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "visitor_login_status", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": bank details")
                }));
                setAnalytics(true);
              }

              _context.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              fieldValues[form][name] = value; //call function to add auto slash in date field

              if (name === "ageOfAccountYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, yearString);
              } else if (name === "ageOfAccountMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, monthString);
              } else if (name === "debiCheckFlag") {
                fieldValues[form][name] = event.target.checked ? "Y" : "N";
                updateDebiCheckAnalytics(event.target.checked);
              } else {
                fieldValues[form][name] = value;
              }

              setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateFieldValues(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */


  var handleReset = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(name, form) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = name;
              _context3.next = _context3.t0 === "bank" ? 3 : _context3.t0 === "accountType" ? 5 : _context3.t0 === "debitOrderDate" ? 7 : 9;
              break;

            case 3:
              fieldValues[form].bank = "";
              return _context3.abrupt("break", 9);

            case 5:
              fieldValues[form].accountType = "";
              return _context3.abrupt("break", 9);

            case 7:
              fieldValues[form].debitOrderDate = "";
              return _context3.abrupt("break", 9);

            case 9:
              _context3.next = 11;
              return checkFormError(form);

            case 11:
              errorStatus[form] = _context3.sent;
              setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues,
                errorStatus: errorStatus
              }));

              if (errorStatus[form]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleReset(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleFocus = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, form) {
      var name, value;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event.persist();
              name = event.target.name;
              value = event.target.value;

              if (name === "ageOfAccountYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, yearString);
              } else if (name === "ageOfAccountMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, false, monthString);
              }

              setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleFocus(_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(event, val, form) {
      var name, value, errMsg;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              event.persist();
              name = event.target.name;
              value = val ? val : event.target.value;
              _context5.next = 5;
              return fieldValidationCheck(event, val, form);

            case 5:
              //call function to reformat MM valu on OnBlur event
              if (name === "ageOfAccountYears") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, true, yearString);
              } else if (name === "ageOfAccountMonths") {
                fieldValues[form][name] = (0,helperServices/* addAutoSlashToPeriod */.I)(value, true, monthString);
              }

              _context5.next = 8;
              return checkFormError(form);

            case 8:
              errorStatus[form] = _context5.sent;
              setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleBlur(_x11, _x12, _x13) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }
  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context6.t0 = name;
              _context6.next = _context6.t0 === "bank" ? 5 : _context6.t0 === "accountType" ? 7 : _context6.t0 === "accountNumber" ? 9 : _context6.t0 === "initials" ? 11 : _context6.t0 === "surname" ? 13 : _context6.t0 === "ageOfAccountYears" ? 15 : _context6.t0 === "ageOfAccountMonths" ? 15 : _context6.t0 === "debitOrderDate" ? 17 : _context6.t0 === "branchName" ? 19 : _context6.t0 === "branchCode" ? 21 : 23;
              break;

            case 5:
              if (state.validationsOn[form] && state.validations[form].bank) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].bank = true;
                  fieldErrorsMessage[form].bank = state.fieldErrorsMessage.debitDetails.bank;
                } else {
                  fieldErrors[form].bank = false;
                }

                fieldErrors.fail = fieldErrors[form].bank;
              } else {
                fieldErrors[form].bank = false;
              }

              return _context6.abrupt("break", 23);

            case 7:
              if (state.validationsOn[form] && state.validations[form].accountType) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].accountType = true;
                  fieldErrorsMessage[form].accountType = state.fieldErrorsMessage.debitDetails.accountType;
                } else {
                  fieldErrors[form].accountType = false;
                }

                fieldErrors.fail = fieldErrors[form].accountType;
              } else {
                fieldErrors[form].accountType = false;
              }

              return _context6.abrupt("break", 23);

            case 9:
              if (state.validationsOn[form] && state.validations[form].accountNumber) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].accountNumber = true;
                    fieldErrorsMessage[form].accountNumber = errorMessages/* default.creditCheckout.debitDetails.accountNumber.onlyValid */.Z.creditCheckout.debitDetails.accountNumber.onlyValid;
                  } else {
                    fieldErrors[form].accountNumber = false;
                  }
                } else {
                  fieldErrors[form].accountNumber = true;
                  fieldErrorsMessage[form].accountNumber = errorMessages/* default.creditCheckout.errors.debit.debitDetails.accountNumber */.Z.creditCheckout.errors.debit.debitDetails.accountNumber;
                }

                fieldErrors.fail = fieldErrors[form].accountNumber;
              } else {
                fieldErrors[form].accountNumber = false;
              }

              return _context6.abrupt("break", 23);

            case 11:
              if (state.validationsOn[form] && state.validations[form].initials) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* charRegExp.test */.D0.test(value)) {
                    fieldErrors[form].initials = true;
                    fieldErrorsMessage[form].initials = state.fieldErrorsMessage.debitDetails.initials;
                  } else {
                    fieldErrors[form].initials = false;
                  }
                } else {
                  fieldErrors[form].initials = true;
                  fieldErrorsMessage[form].initials = state.fieldErrorsMessage.debitDetails.initials;
                }

                fieldErrors.fail = fieldErrors[form].initials;
              } else {
                fieldErrors[form].initials = false;
              }

              return _context6.abrupt("break", 23);

            case 13:
              if (state.validationsOn[form] && state.validations[form].surname) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* nameRegex.test */.yJ.test(value)) {
                    fieldErrors[form].surname = true;
                    fieldErrorsMessage[form].initials = state.fieldErrorsMessage.debitDetails.initials;
                  } else if (value.length <= 2) {
                    fieldErrors[form].surname = true;
                    fieldErrorsMessage[form].initials = state.fieldErrorsMessage.debitDetails.initials;
                  } else {
                    fieldErrors[form].surname = false;
                  }
                } else {
                  fieldErrors[form].surname = true;
                  fieldErrorsMessage[form].initials = state.fieldErrorsMessage.debitDetails.initials;
                }

                fieldErrors.fail = fieldErrors[form].surname;
              } else {
                fieldErrors[form].surname = false;
              }

              return _context6.abrupt("break", 23);

            case 15:
              if (state.validationsOn[form] && (state.validations[form].ageOfAccountYears || state.validations[form].ageOfAccountMonths)) {
                if (value.length > 0) {
                  if ((0,helperServices/* checkYearAndMonthFormat */.jC)(fieldValues[form].ageOfAccountYears, fieldValues[form].ageOfAccountMonths, true)) {
                    fieldErrors[form].duration = true;
                    fieldErrorsMessage[form].duration = errorMessages/* default.creditCheckout.debitDetails.duration.onlyValid */.Z.creditCheckout.debitDetails.duration.onlyValid;
                  } else {
                    fieldErrors[form].duration = false;
                  }
                } else {
                  fieldErrors[form].duration = true;
                  fieldErrorsMessage[form].duration = errorMessages/* default.creditCheckout.errors.debit.debitDetails.duration */.Z.creditCheckout.errors.debit.debitDetails.duration;
                }

                fieldErrors.fail = fieldErrors[form].duration;
              } else {
                fieldErrors[form].duration = false;
              }

              return _context6.abrupt("break", 23);

            case 17:
              if (state.validationsOn[form] && state.validations[form].debitOrderDate) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].debitOrderDate = true;
                  fieldErrorsMessage[form].debitOrderDate = state.fieldErrorsMessage.debitDetails.debitOrderDate;
                } else {
                  fieldErrors[form].debitOrderDate = false;
                }

                fieldErrors.fail = fieldErrors[form].debitOrderDate;
              } else {
                fieldErrors[form].debitOrderDate = false;
              }

              return _context6.abrupt("break", 23);

            case 19:
              if (state.validationsOn[form] && state.validations[form].branchName) {
                if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                  fieldErrors[form].branchName = true;
                  fieldErrorsMessage[form].branchName = state.fieldErrorsMessage.debitDetails.branchName;
                } else {
                  fieldErrors[form].branchName = false;
                }

                fieldErrors.fail = fieldErrors[form].branchName;
              } else {
                fieldErrors[form].branchName = false;
              }

              return _context6.abrupt("break", 23);

            case 21:
              if (state.validationsOn[form] && state.validations[form].branchCode) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].branchCode = true;
                    fieldErrorsMessage[form].branchCode = errorMessages/* default.creditCheckout.debitDetails.branchCode.onlyValid */.Z.creditCheckout.debitDetails.branchCode.onlyValid;
                  } else {
                    fieldErrors[form].branchCode = false;
                  }
                } else {
                  fieldErrors[form].branchCode = true;
                  fieldErrorsMessage[form].branchCode = errorMessages/* default.creditCheckout.errors.debit.debitDetails.branchCode */.Z.creditCheckout.errors.debit.debitDetails.branchCode;
                }

                fieldErrors.fail = fieldErrors[form].branchCode;
              } else {
                fieldErrors[form].branchCode = false;
              }

              return _context6.abrupt("break", 23);

            case 23:
              if (isDisplayBranchInfo) {
                validations[form].branchName = true;
                validations[form].branchCode = true;
              }

              closeSnackBar();
              setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                validations: validations,
                fieldErrors: fieldErrors,
                fieldValues: fieldValues,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 26:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function fieldValidationCheck(_x14, _x15, _x16) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   *
   * @param {} message
   */


  var updateDebiCheckAnalytics = function updateDebiCheckAnalytics(isChecked) {
    if (isChecked) {
      analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
        page_tool_event: "use",
        page_tool_name: "checkout: credit check: consent for debicheck"
      }));
    } else {
      analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
        page_tool_event: "use",
        page_tool_name: "checkout: credit check: remove debicheck"
      }));
    }
  };
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": bank details"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the on page edit
   *
   * @call on edit event
   */


  var setAnalyticsOnPageEdit = function setAnalyticsOnPageEdit() {
    analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit bank details")
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = DebitDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["debitDetails"]) {
      submitForm();
    } else {
      displaySnackBar(labels/* default.errors.lbl_form_not_submitted_fill_required */.Z.errors.lbl_form_not_submitted_fill_required, "form_level");
      event.stopPropagation();
    }
  };
  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var newIdType, bankName, inputObj, reqParams, _res$response, _res$response$data, _res$error, _res$error$data, _res$error2, res;

      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              newIdType = "";

              if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "SAID") {
                newIdType = constants/* SID */.x5;
              } else if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) === "PASSPORT") {
                if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.countryOrigin) === constants/* SA_COUNTRY */.cl) {
                  newIdType = constants/* SPP */.Zy;
                } else {
                  newIdType = constants/* FPP */._d;
                }
              }

              bankName = state.fieldValues["debitDetails"].bank;
              inputObj = {
                accountNumber: state.fieldValues["debitDetails"].accountNumber,
                accountType: state.fieldValues["debitDetails"].accountType,
                branchCode: state.fieldValues["debitDetails"].branchCode ? state.fieldValues["debitDetails"].branchCode : "",
                idCompRegNo: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.idNumber ? authDetailsData.idNumber : "",
                idType: newIdType,
                surnameCompName: state.fieldValues["debitDetails"].surname
              };
              reqParams = [bankName];
              _context7.prev = 5;
              (0,helperServices/* showSpinner */.yh)();
              _context7.next = 9;
              return microServices/* default.get */.Z.get("api", "validateBankDetails", inputObj, false, reqParams);

            case 9:
              res = _context7.sent;

              if ((_res$response = res.response) !== null && _res$response !== void 0 && (_res$response$data = _res$response.data) !== null && _res$response$data !== void 0 && _res$response$data.result) {
                if (res.response.data.result === "F") {
                  setShowWarningMsg(true);
                  setBankDetailsAttempt(bankDetailsAttempt + 1);

                  if (bankDetailsAttempt === 0) {
                    if (sectionReference.current) {
                      sectionReference.current.scrollIntoView({
                        behavior: "smooth"
                      });
                    }

                    if (multicartFlag) displaySnackBar(labels/* default.creditCheckout.lbl_invalid_attempt_1_multicart */.Z.creditCheckout.lbl_invalid_attempt_1_multicart);else displaySnackBar(labels/* default.creditCheckout.lbl_invalid_attempt_1 */.Z.creditCheckout.lbl_invalid_attempt_1);
                  } else if (bankDetailsAttempt === 1) {
                    if (sectionReference.current) {
                      sectionReference.current.scrollIntoView({
                        behavior: "smooth"
                      });
                    }

                    displaySnackBar(labels/* default.creditCheckout.lbl_invalid_attempt_2 */.Z.creditCheckout.lbl_invalid_attempt_2);
                  } else if (bankDetailsAttempt === 2) {
                    fetchErrorDetails("captureDebitDetails_invalid", "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                    closeSnackBar();
                    dispatch({
                      type: actionTypes/* SET_CREDIT_CHECK_DEBIT_DATA */.cq,
                      payload: null
                    });
                  }
                } else if (res.response.data.result === "Y") {
                  setShowWarningMsg(false);
                  setDisplayEditMode(false);
                  doCreditCheckDisable("debitDetails", false);
                  fieldValues["debitDetails"]["branchName"] = res.response.data.branchName;
                  fieldValues["debitDetails"]["branchCode"] = res.response.data.branchCode;
                  dispatch({
                    type: actionTypes/* SET_CREDIT_CHECK_DEBIT_DATA */.cq,
                    payload: DebitDetails_objectSpread({}, state.fieldValues["debitDetails"])
                  });
                  setDisplayBranchInfo(false);
                  onFormSubmit(true);
                  analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
                    page_form_event: "success",
                    page_form_name: "checkout: credit check: ".concat(customerStatus, ": bank details")
                  }));
                }
              } else if (((_res$error = res.error) === null || _res$error === void 0 ? void 0 : (_res$error$data = _res$error.data) === null || _res$error$data === void 0 ? void 0 : _res$error$data.result) === "U" && ((_res$error2 = res.error) === null || _res$error2 === void 0 ? void 0 : _res$error2.status) === 500) {
                setDisplayBranchDetailsAttempt(displayBranchDetailsAttempt + 1);

                if (displayBranchDetailsAttempt === 0) {
                  setDisplayBranchInfo(true);
                  validations[type].branchName = true;
                  validations[type].branchCode = true;
                  setState(DebitDetails_objectSpread(DebitDetails_objectSpread({}, state), {}, {
                    validations: validations
                  }));
                } else if (displayBranchDetailsAttempt === 1) {
                  fetchErrorDetails("captureDebitDetails_" + res.error.status, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                }
              } else {
                fetchErrorDetails("captureDebitDetails_" + res.error.status, "technical error", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              }

              (0,helperServices/* hideSpinner */.v3)();
              _context7.next = 17;
              break;

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](5);
              (0,helperServices/* hideSpinner */.v3)();

            case 17:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 14]]);
    }));

    return function submitForm() {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("debitDetails", true);
    setAnalyticsOnPageEdit();
  };
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(resultCode, pageErrorType) {
      var additionalUtagData,
          preferences,
          pageName,
          newResultCode,
          _result$0$primaryCTAU,
          result,
          _args8 = arguments;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              additionalUtagData = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : null;
              preferences = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : [];
              pageName = "checkout: credit check: ".concat(customerStatus, ": bank details");
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              _context8.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              _context8.next = 8;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 8:
              result = _context8.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText);
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                pageErrorType: pageErrorType,
                additionalUtagData: additionalUtagData,
                dividerLine: multicartFlag ? true : false,
                ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                preferences: multicartFlag ? preferences : [],
                defaultPreference: (_result$0$primaryCTAU = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU !== void 0 && _result$0$primaryCTAU.includes("/checkout") ? "once-off" : null
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context8.next = 19;
              break;

            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](4);

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.creditvetting.lbl_invalid_attempt_title */.Z.creditvetting.lbl_invalid_attempt_title,
                  desc: labels/* default.creditvetting.lbl_invalid_attempt_desc */.Z.creditvetting.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)("/forms/ecommerce", "banking_verification_check", "lead", preferenceId), "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, "call me back");
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(null, "exit checkout");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType,
                  additionalUtagData: additionalUtagData
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[4, 14]]);
    }));

    return function fetchErrorDetails(_x17, _x18) {
      return _ref9.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var _handleSecondaryClick = function _handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }

    removeCreditCheckStates(null);
  };
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": bank details: next")
    }));
  };

  var displaySnackBar = function displaySnackBar(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page_level";
    setShowSnackBar({
      visible: true,
      message: message
    });
    var pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page"
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = "checkout: credit check: ".concat(customerStatus, ": bank details");
      pageAnalyticsData.page_error_type = "form";
    }

    analyticsUtag/* link */.p4(DebitDetails_objectSpread(DebitDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(DebitDetails_analyticsTags)), pageAnalyticsData));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };
  /**
     * This function is used to saperate out bank name and create another list of array
     *
     * @usage call toGetBankList function
     
     */


  var toGetBankList = function toGetBankList(arr, key) {
    if (!arr.length) {
      return [];
    }

    var updatedList = {};
    arr.forEach(function (el) {
      if (updatedList.hasOwnProperty(key)) {
        updatedList[key].push(el[key]);
      } else {
        updatedList[key] = [el[key]];
      }
    });
    return updatedList;
  };
  /**
   * This function is used to sort the value in asc order
   * @usage call sortAccountType function
   */


  var sortAccountType = function sortAccountType(arr) {
    return arr.sort(function (a, b) {
      return a.name.normalize().localeCompare(b.name.normalize());
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "bank-details",
      ref: sectionReference,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-bank.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "success",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), "Bank account details", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: "Section 5 of 7"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), displayEditMode && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-description"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/info_teal.svg"),
            alt: "tick"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: labels/* default.creditCheckout.lbl_bank_page_warning */.Z.creditCheckout.lbl_bank_page_warning
          })]
        }), showWarningMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(warningTitle_WarningTitle, {
          title: "Please ensure that:",
          contents: titleContents,
          className: (CheckoutCreditCheck_module_default())["warning-box"],
          id: "checkout-credit-check-warning-bank-details"
        })]
      }), !displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(debitDetailsInfo_DebitDetailsInfo, {
        data: debitDetailsData,
        accountTypes: accountType
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "checkout-credit-check-debit-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(debitDetailsForm_DebitDetailsForm, {
          formName: "debitDetails",
          fieldValues: state.fieldValues["debitDetails"],
          fieldErrors: state.fieldErrors["debitDetails"],
          fieldErrorsMessage: state.fieldErrorsMessage["debitDetails"],
          onChangeHandler: handleChange,
          onBlurHandler: handleBlur,
          onResetHandler: handleReset,
          onFocusHandler: handleFocus,
          bankList: bankList,
          accountTypeList: accountType,
          debitOrderDateList: debitOrderDate,
          isDisplayBranchInfo: isDisplayBranchInfo,
          multicartFlag: multicartFlag
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-debit-form-submit",
            children: "Next"
          })
        })]
      })]
    })
  });
};

var DebitDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    debitDetailsData: state.creditCheckDetails.debitDetails,
    loadLookupData: state.checkoutDetails.lookupDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    personalDetailsData: state.creditCheckDetails.personalDetails
  };
};

var DebitDetails_mapDispatchToProps = {
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK
};
/* harmony default export */ var debitDetails_DebitDetails = ((0,DependencyHelper.connect)(DebitDetails_mapStateToProps, DebitDetails_mapDispatchToProps)(DebitDetails));
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/atoms/newLineForms/creditCheckForms/deliveryDetailsForm/DeliveryDetailsForm.jsx
var DeliveryDetailsForm = __webpack_require__(62765);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/deliveryDetailsInfo/DeliveryDetailsInfo.jsx






var DeliveryDetailsInfo = function DeliveryDetailsInfo(_ref) {
  var data = _ref.data,
      stateTypesOptions = _ref.stateTypesOptions;

  var displayAddress = function displayAddress() {
    var finalAdd = "";

    if (data) {
      var _data$address, _data$address2, _data$address3, _data$address4, _data$address5, _data$address6, _data$address7, _data$address8, _data$address9, _data$address10, _data$address11, _data$address12;

      var neUnit = ((_data$address = data.address) === null || _data$address === void 0 ? void 0 : _data$address.unitNo) !== "" && ((_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : _data$address2.complexName) !== "" ? data.address.unitNo + " " + data.address.complexName + ", " : ((_data$address3 = data.address) === null || _data$address3 === void 0 ? void 0 : _data$address3.unitNo) !== "" ? data.address.unitNo + ", " : ((_data$address4 = data.address) === null || _data$address4 === void 0 ? void 0 : _data$address4.complexName) !== "" ? data.address.complexName + ", " : "";
      var neStreet = ((_data$address5 = data.address) === null || _data$address5 === void 0 ? void 0 : _data$address5.streetNo) !== "" && ((_data$address6 = data.address) === null || _data$address6 === void 0 ? void 0 : _data$address6.streetName) !== "" ? data.address.streetNo + " " + data.address.streetName + ", " : ((_data$address7 = data.address) === null || _data$address7 === void 0 ? void 0 : _data$address7.streetNo) !== "" ? data.address.streetNo + ", " : ((_data$address8 = data.address) === null || _data$address8 === void 0 ? void 0 : _data$address8.streetName) !== "" ? data.address.streetName + ", " : "";
      var neSuburb = ((_data$address9 = data.address) === null || _data$address9 === void 0 ? void 0 : _data$address9.suburb) !== "" ? data.address.suburb + ", " : "";
      var neTown = ((_data$address10 = data.address) === null || _data$address10 === void 0 ? void 0 : _data$address10.town) !== "" ? data.address.town + ", " : "";
      var neProvince = ((_data$address11 = data.address) === null || _data$address11 === void 0 ? void 0 : _data$address11.province) !== "" ? (0,helperServices/* getValueLabel */.gk)(data.address.province, stateTypesOptions) + ", " : "";
      var nePostal = ((_data$address12 = data.address) === null || _data$address12 === void 0 ? void 0 : _data$address12.postalCode) !== "" ? data.address.postalCode : "";
      finalAdd = neUnit + neStreet + neSuburb + neTown + neProvince + nePostal;
    }

    return finalAdd;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-lg-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Delivery type:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-lg-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: ["Delivery via ", data === null || data === void 0 ? void 0 : data.receiveType]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-lg-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Delivery address:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-lg-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: displayAddress()
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-lg-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Contact number:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-lg-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.cellNumber
        })
      })]
    })
  });
};

DeliveryDetailsInfo.defaultProps = {
  stateTypesOptions: []
};
/* harmony default export */ var deliveryDetailsInfo_DeliveryDetailsInfo = (DeliveryDetailsInfo);
// EXTERNAL MODULE: ./components/molecules/receiveType/ReceiveType.jsx
var ReceiveType = __webpack_require__(70021);
// EXTERNAL MODULE: ./components/atoms/addressTile/AddressTile.jsx
var AddressTile = __webpack_require__(24761);
// EXTERNAL MODULE: ./components/molecules/modals/checkoutFormsModal/CheckoutFormsModal.jsx + 1 modules
var CheckoutFormsModal = __webpack_require__(23060);
// EXTERNAL MODULE: ./components/molecules/checkoutCreditCheck/deliveryDetails/DeliveryDetails.module.scss
var DeliveryDetails_module = __webpack_require__(46365);
var DeliveryDetails_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryDetails_module);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/deliveryDetails/DeliveryDetails.jsx




function DeliveryDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = DeliveryDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function DeliveryDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return DeliveryDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DeliveryDetails_arrayLikeToArray(o, minLen); }

function DeliveryDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function DeliveryDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DeliveryDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeliveryDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeliveryDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





























var receiveTypesOptions = [{
  id: "courier",
  label: "Deliver via courier",
  hide: false
}, {
  id: "store",
  label: "Collect in store",
  hide: true
}];
var types1 = [{
  id: "home",
  label: "My home address"
}, {
  id: "another",
  label: "Another delivery address"
}];
var types2 = [{
  id: "home",
  label: "My home address"
}, {
  id: "previous",
  label: "One of my previous delivery addresses"
}, {
  id: "another",
  label: "Another delivery address"
}];

var DeliveryDetails = function DeliveryDetails(_ref) {
  var userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      personalDetailsData = _ref.personalDetailsData,
      homeDetailsData = _ref.homeDetailsData,
      contactDetailsData = _ref.contactDetailsData,
      deliveryDetailsData = _ref.deliveryDetailsData,
      addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      shippingAddress = _ref.shippingAddress,
      countryCode = _ref.countryCode,
      countryName = _ref.countryName,
      setShowSnackBar = _ref.setShowSnackBar,
      setPageErr = _ref.setPageErr,
      navigate = _ref.navigate,
      onFormSubmit = _ref.onFormSubmit,
      profileLoading = _ref.profileLoading,
      setReLogin = _ref.setReLogin,
      carrierCode = _ref.carrierCode,
      methodCode = _ref.methodCode,
      currentJourneyType = _ref.currentJourneyType,
      doCreditCheckDisable = _ref.doCreditCheckDisable;
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(deliveryDetailsData ? false : true),
      displayEditMode = _useState2[0],
      setDisplayEditMode = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      submitDisabled = _useState3[0],
      setSubmitDisabled = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      finalAddress = _useState4[0],
      setFinalAddress = _useState4[1];

  var _useState5 = (0,react.useState)("courier"),
      selectedReceiveType = _useState5[0],
      setSelectedReceiveType = _useState5[1];

  var _useState6 = (0,react.useState)("home"),
      selectedDeliveryType = _useState6[0],
      setSelectedDeliveryType = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      selectedDeliveryAddress = _useState7[0],
      setSelectedDeliveryAddress = _useState7[1];

  var _useState8 = (0,react.useState)("delivery"),
      modalType = _useState8[0],
      setModalType = _useState8[1];

  var _useState9 = (0,react.useState)("edit"),
      modalVariant = _useState9[0],
      setModalVariant = _useState9[1];

  var _useState10 = (0,react.useState)({}),
      modalValues = _useState10[0],
      setModalValues = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      modalShow = _useState11[0],
      setModalShow = _useState11[1];

  var _useState12 = (0,react.useState)(0),
      submitAttempt = _useState12[0],
      setSubmitAttempt = _useState12[1];

  var _useState13 = (0,react.useState)(types1),
      deliveryTypeOptions = _useState13[0],
      setDeliveryTypeOptions = _useState13[1];

  var addressTypesOptions = addressTypes ? addressTypes : [];
  var stateTypesOptions = statesTypes ? statesTypes : [];
  var RESIDENTIAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? addressTypesOptions[0].id : "";
  var BUSINESS_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 ? addressTypesOptions[1].id : "";

  var _useState14 = (0,react.useState)([]),
      deliveryAddresslists = _useState14[0],
      setDeliveryAddresslists = _useState14[1];

  var _useState15 = (0,react.useState)(0),
      totalDeliveryAddress = _useState15[0],
      setTotalDeliveryAddress = _useState15[1];

  var titleContents = labels/* default.creditCheckout.deliveryDetails.lbl_store_contents */.Z.creditCheckout.deliveryDetails.lbl_store_contents;
  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.delivery */.Z.creditCheckout.errors.delivery));
  var router = (0,DependencyHelper.useRouter)();
  var dispatch = (0,DependencyHelper.useDispatch)();

  var createStreetString = function createStreetString(arr) {
    var res = arr;

    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }

    return res;
  };

  (0,react.useEffect)(function () {
    if (displayEditMode && !profileLoading) {
      closeSnackBar();
      fetchData();
      setFormDetailInformation();
    }
  }, [displayEditMode, profileLoading]);
  (0,react.useEffect)(function () {
    addressSearchResultMap();
  }, [finalAddress]);
  (0,react.useEffect)(function () {
    if (addressTypesOptions.length > 0) {
      fieldValues.deliveryDetails.addressType = RESIDENTIAL_ADDRESS_TYPE;

      if (addressTypesOptions[2]) {
        //Remove postal adddress type
        addressTypesOptions.splice(2, 1);
      }

      setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [addressTypesOptions]);
  (0,react.useEffect)(function () {
    if (stateTypesOptions.length > 0) {
      fieldValues.deliveryDetails.province = stateTypesOptions[0].id;
      setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues
      }));
    }
  }, [stateTypesOptions]);
  (0,react.useEffect)(function () {
    if (selectedReceiveType == "courier") {
      if (selectedDeliveryType == "home" && homeDetailsData) {
        setSubmitDisabled(false);
      } else if (selectedDeliveryType == "previous" && totalDeliveryAddress !== 0 && selectedDeliveryAddress) {
        setSubmitDisabled(false);
      } else if (selectedDeliveryType == "another" && !checkFormError("deliveryDetails")) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    } else if (selectedReceiveType == "store") {
      setSubmitDisabled(true);
    }
  }, [selectedDeliveryType, selectedReceiveType, selectedDeliveryAddress, homeDetailsData]);
  (0,react.useEffect)(function () {
    if (totalDeliveryAddress > 0) {
      setDeliveryTypeOptions(types2);
    }
  }, [totalDeliveryAddress]);

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var results, _results$errors, _results$errors$;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0,helperServices/* showSpinner */.yh)();
              _context.next = 4;
              return (0,checkoutService/* getAllCustomerAddressListsService */.ey)();

            case 4:
              results = _context.sent;

              if (results.fail) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return filterAddressLists(results.addressList);

            case 8:
              (0,helperServices/* hideSpinner */.v3)();
              _context.next = 13;
              break;

            case 11:
              (0,helperServices/* hideSpinner */.v3)();

              if (results && results.errors) {
                technicalFailure((_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : (_results$errors$ = _results$errors[0]) === null || _results$errors$ === void 0 ? void 0 : _results$errors$.message);
              } else {
                technicalFailure();
              }

            case 13:
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getProvinceValue = function getProvinceValue(name) {
    var finalID = stateTypesOptions.filter(function (item) {
      return item.code == name;
    });

    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  var filterAddressLists = function filterAddressLists(addressLists) {
    if (addressLists && addressLists.length > 0) {
      var deliveryLists = [];
      addressLists.map(function (address) {
        if (address.is_shipping_address) {
          deliveryLists.push(address);

          if (shippingAddress && shippingAddress.customer_address_id && shippingAddress.customer_address_id == address.id) {
            setSelectedDeliveryAddress(shippingAddress.customer_address_id);
          } else if (address.default_shipping && address.default_shipping == true && !selectedDeliveryAddress) {
            setSelectedDeliveryAddress(address.id);
          }
        }
      });
      setTotalDeliveryAddress(deliveryLists.length);
      setDeliveryAddresslists(deliveryLists);
    } else {
      setTotalDeliveryAddress(0);
      setDeliveryAddresslists([]);
    }
  };

  var displayHomeAddress = function displayHomeAddress() {
    var finalAdd = "";

    if (homeDetailsData) {
      var neUnit = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.unitNo) !== "" && (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.complexName) !== "" ? homeDetailsData.unitNo + " " + homeDetailsData.complexName + ", " : (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.unitNo) !== "" ? homeDetailsData.unitNo + ", " : (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.complexName) !== "" ? homeDetailsData.complexName + ", " : "";
      var neStreet = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetNo) !== "" && (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName) !== "" ? homeDetailsData.streetNo + " " + homeDetailsData.streetName + ", " : (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetNo) !== "" ? homeDetailsData.streetNo + ", " : (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName) !== "" ? homeDetailsData.streetName + ", " : "";
      var neSuburb = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.suburb) !== "" ? homeDetailsData.suburb + ", " : "";
      var neTown = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.town) !== "" ? homeDetailsData.town + ", " : "";
      var neProvince = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.province) !== "" ? (0,helperServices/* getValueLabel */.gk)(homeDetailsData.province, stateTypesOptions) + ", " : "";
      var nePostal = (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode) !== "" ? homeDetailsData.postalCode : "";
      finalAdd = neUnit + neStreet + neSuburb + neTown + neProvince + nePostal;
    }

    return finalAdd;
  };

  var seperateStreetString = function seperateStreetString(str) {
    if (str && str !== "") {
      return str.split(", ");
    } else {
      return null;
    }
  };

  var getRegionValue = function getRegionValue(id) {
    return id && id !== "" ? statesTypes.find(function (item) {
      return item.id == id;
    }) : null;
  };

  function setFormDetailInformation() {
    if (deliveryDetailsData) {
      fieldValues.deliveryDetails.addressName = deliveryDetailsData.address.addressName;
      fieldValues.deliveryDetails.addressType = deliveryDetailsData.address.addressType;
      fieldValues.deliveryDetails.companyName = deliveryDetailsData.address.companyName;
      fieldValues.deliveryDetails.unitNo = deliveryDetailsData.address.unitNo;
      fieldValues.deliveryDetails.complexName = deliveryDetailsData.address.complexName;
      fieldValues.deliveryDetails.streetNo = deliveryDetailsData.address.streetNo;
      fieldValues.deliveryDetails.streetName = deliveryDetailsData.address.streetName;
      fieldValues.deliveryDetails.suburb = deliveryDetailsData.address.suburb;
      fieldValues.deliveryDetails.postalCode = deliveryDetailsData.address.postalCode;
      fieldValues.deliveryDetails.town = deliveryDetailsData.address.town;
      fieldValues.deliveryDetails.province = deliveryDetailsData.address.province;
      fieldValues.deliveryDetails.instructions = deliveryDetailsData.address.instructions;
      fieldValues.deliveryDetails.futureCheck = deliveryDetailsData.address.futureCheck;
      errorStatus.deliveryDetails = checkFormError("deliveryDetails");

      if (errorStatus.deliveryDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      if (deliveryDetailsData.receiveType !== selectedReceiveType) {
        setSelectedReceiveType(deliveryDetailsData.receiveType);
      }

      if (deliveryDetailsData.address.futureCheck && deliveryDetailsData.deliveryType == "another" && deliveryTypeOptions === types2) {
        setSelectedDeliveryType("previous");
      } else if (deliveryDetailsData.deliveryType !== selectedDeliveryType) {
        setSelectedDeliveryType(deliveryDetailsData.deliveryType);
      }

      setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    }
  }

  var _useState16 = (0,react.useState)({
    validationsOn: {
      deliveryDetails: true
    },
    errorStatus: {
      deliveryDetails: true
    },
    validations: {
      deliveryDetails: {
        addressName: true,
        addressType: true,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        futureCheck: false
      }
    },
    fieldErrors: {
      deliveryDetails: {
        addressName: false,
        addressType: false,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        futureCheck: false
      },
      fail: false
    },
    fieldValues: {
      deliveryDetails: {
        addressName: "",
        addressType: "",
        companyName: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        futureCheck: false
      }
    },
    readOnlyValues: {
      deliveryDetails: {
        addressName: false,
        addressType: false,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState16[0],
      setState = _useState16[1];

  var errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      readOnlyValues = state.readOnlyValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  (0,react.useEffect)(function () {
    if (customerStatus) {
      analyticsUtag/* link */.p4(DeliveryDetails_objectSpread({
        page_event: "view",
        page_name: "checkout: credit check: ".concat(customerStatus),
        page_channel: "checkout",
        page_master_tab: "personal",
        delivery_type: "deliver"
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData)));
    }
  }, [customerStatus]);

  function mapFormData(values) {
    var formData = {
      addressName: "",
      addressType: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      unitNo: "",
      complexName: "",
      streetNo: "",
      streetName: "",
      suburb: "",
      postalCode: "",
      town: "",
      province: "",
      instructions: ""
    };

    if (values) {
      formData.addressName = values.address_name ? values.address_name : "";
      formData.addressType = values.address_type_name ? values.address_type_name : addressTypesOptions && addressTypesOptions.length > 0 ? addressTypesOptions[0].id : "";
      formData.companyName = values.company ? values.company : "";
      formData.addressLine1 = values.street && values.street[0] ? values.street[0] : "";
      formData.addressLine2 = values.street && values.street[1] ? values.street[1] : "";
      formData.unitNo = values.unit_number ? values.unit_number : "";
      formData.complexName = values.complex_name ? values.complex_name : "";
      formData.streetNo = values.street_number ? values.street_number : "";
      formData.streetName = values.street ? createStreetString(values.street) : "";
      formData.suburb = values.suburb ? values.suburb : "";
      formData.postalCode = values.postcode ? values.postcode : "";
      formData.town = values.city ? values.city : "";
      formData.province = values.region ? values.region.region_id : stateTypesOptions && stateTypesOptions.length > 0 ? stateTypesOptions[0].id : "";
      formData.instructions = values.instructions ? values.instructions : "";
    }

    return formData;
  }
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      var name, errMsg;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = event.target.name;
              event.persist();
              _context2.next = 4;
              return fieldValidationCheck(name, val, form, event);

            case 4:
              if (name == "addressType") {
                // Check form validation because field validation updated
                multipleFieldsValidationCheck(["companyName", "unitNo", "complexName", "streetNo", "streetName"], form, event);
              }

              _context2.next = 7;
              return checkFormError(form);

            case 7:
              errorStatus[form] = _context2.sent;
              setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBlur(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details")
                }));
                setAnalytics(true);
              }

              _context3.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleChange(_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;

              if (name == "addressType") {
                validations[form].companyName = false;
                validations[form].unitNo = false;
                validations[form].complexName = false;
                validations[form].streetNo = false;
                validations[form].streetName = true;

                if (value == BUSINESS_ADDRESS_TYPE) {
                  validations[form].companyName = true;
                  validations[form].unitNo = true;
                  validations[form].complexName = true;
                  validations[form].streetNo = true;

                  if (fieldValues[form].companyName == "" || fieldValues[form].unitNo == "" || fieldValues[form].complexName == "" || fieldValues[form].streetNo == "" || fieldValues[form].streetName == "") {
                    fieldErrors[form].fail = true;
                  } else {
                    fieldErrors[form].fail = false;
                  }
                }

                if (value == RESIDENTIAL_ADDRESS_TYPE) {
                  validations[form].unitNo = true;
                  validations[form].complexName = true;
                  validations[form].streetNo = true;

                  if (fieldValues[form].unitNo == "" || fieldValues[form].complexName == "" || fieldValues[form].streetNo == "" || fieldValues[form].streetName == "") {
                    fieldErrors[form].fail = true;
                  } else {
                    fieldErrors[form].fail = false;
                  }
                }
              }

              if (name == "futureCheck") {
                fieldValues[form][name] = event.target.checked;
              } else {
                fieldValues[form][name] = value;
              }

              if (name == "addressType") {
                //capture analytics user selects "address type"
                selectionAnalytics("address type", (0,helperServices/* getValueLabel */.gk)(value, addressTypesOptions));
              } else if (name == "province") {
                //capture analytics user selects "province"
                selectionAnalytics("province", (0,helperServices/* getValueLabel */.gk)(value, stateTypesOptions));
              }

              setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
                validations: validations,
                fieldValues: fieldValues
              }));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function updateFieldValues(_x7, _x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();

  var multipleFieldsValidationCheck = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(fieldsArray, form, event) {
      var values, errors, entries, i;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              values = state.fieldValues[form];
              errors = state.fieldErrors[form];
              entries = fieldsArray.length;

              if (state.validationsOn[form]) {
                for (i = 0; i < entries; i++) {
                  if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
                    fieldValidationCheck(fieldsArray[i], values[fieldsArray[i]], form, event);
                  }
                }
              }

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function multipleFieldsValidationCheck(_x10, _x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(name, val, form, event) {
      var value;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              value = val ? val : event.target.value;
              _context6.t0 = name;
              _context6.next = _context6.t0 === "addressName" ? 4 : _context6.t0 === "addressType" ? 6 : _context6.t0 === "companyName" ? 8 : _context6.t0 === "unitNo" ? 10 : _context6.t0 === "complexName" ? 14 : _context6.t0 === "streetNo" ? 18 : _context6.t0 === "streetName" ? 21 : _context6.t0 === "suburb" ? 23 : _context6.t0 === "town" ? 25 : _context6.t0 === "postalCode" ? 27 : _context6.t0 === "province" ? 29 : 31;
              break;

            case 4:
              if (state.validationsOn[form] && state.validations[form].addressName) {
                fieldErrors[form].addressName = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors[form].addressName;
              } else {
                fieldErrors[form].addressName = false;
              }

              return _context6.abrupt("break", 31);

            case 6:
              if (state.validationsOn[form] && state.validations[form].addressType) {
                fieldErrors[form].addressType = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors[form].addressType;
              } else {
                fieldErrors[form].addressType = false;
              }

              return _context6.abrupt("break", 31);

            case 8:
              if (state.validationsOn[form] && state.validations[form].companyName) {
                fieldErrors[form].companyName = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors.companyName;
              } else {
                fieldErrors[form].companyName = false;
              }

              return _context6.abrupt("break", 31);

            case 10:
              if (value.length > 0) {
                fieldErrors[form].unitNo = helperServices/* numRegEx.test */.rP.test(value) ? false : true;

                if (fieldErrors[form].unitNo) {
                  if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.deliveryDetails.floorNo.onlyNumber */.Z.creditCheckout.deliveryDetails.floorNo.onlyNumber;
                  } else {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.deliveryDetails.unitNo.onlyNumber */.Z.creditCheckout.deliveryDetails.unitNo.onlyNumber;
                  }
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].unitNo) {
                  fieldErrors[form].unitNo = true;
                } else {
                  fieldErrors[form].unitNo = false;
                }

                if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.errors.delivery.deliveryDetails.floorNo */.Z.creditCheckout.errors.delivery.deliveryDetails.floorNo;
                } else {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.creditCheckout.errors.delivery.deliveryDetails.unitNo */.Z.creditCheckout.errors.delivery.deliveryDetails.unitNo;
                }
              }

              if (state.fieldValues[form].unitNo !== "") {
                state.validations.delivery.complexName = true;
              }

              fieldErrors[form].fail = fieldErrors[form].unitNo;
              return _context6.abrupt("break", 31);

            case 14:
              if (state.validationsOn[form] && state.validations[form].complexName) {
                fieldErrors[form].complexName = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors.complexName;

                if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage.deliveryDetails.officeComplexName;
                } else {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage.deliveryDetails.complexName;
                }
              } else {
                fieldErrors[form].complexName = false;
              }

              if (state.fieldValues[form].complexName !== "") {
                state.validations.delivery.unitNo = true;
              }

              if (state.fieldValues[form].complexName == "") {
                state.validations.delivery.unitNo = false;
              }

              return _context6.abrupt("break", 31);

            case 18:
              if (value.length > 0) {
                fieldErrors[form].streetNo = helperServices/* numRegEx.test */.rP.test(value) ? false : true;

                if (fieldErrors[form].streetNo) {
                  fieldErrorsMessage[form].streetNo = errorMessages/* default.creditCheckout.deliveryDetails.streetNo.onlyValid */.Z.creditCheckout.deliveryDetails.streetNo.onlyValid;
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].streetNo) {
                  fieldErrors[form].streetNo = true;
                } else {
                  fieldErrors[form].streetNo = false;
                }

                fieldErrorsMessage[form].streetNo = errorMessages/* default.creditCheckout.errors.delivery.deliveryDetails.streetNo */.Z.creditCheckout.errors.delivery.deliveryDetails.streetNo;
              }

              fieldErrors[form].fail = fieldErrors[form].streetNo;
              return _context6.abrupt("break", 31);

            case 21:
              if (state.validationsOn[form] && state.validations[form].streetName) {
                if (value.length > 0) {
                  if (!helperServices/* streetNameRegEx.test */.VU.test(value)) {
                    fieldErrors[form].streetName = true;
                    fieldErrorsMessage[form].streetName = errorMessages/* default.creditCheckout.deliveryDetails.streetName.onlyValid */.Z.creditCheckout.deliveryDetails.streetName.onlyValid;
                  } else {
                    fieldErrors[form].streetName = false;
                  }
                } else {
                  fieldErrors[form].streetName = true;
                  fieldErrorsMessage[form].streetName = errorMessages/* default.creditCheckout.errors.delivery.deliveryDetails.streetName */.Z.creditCheckout.errors.delivery.deliveryDetails.streetName;
                }

                fieldErrors[form].fail = fieldErrors[form].streetName;
              } else {
                fieldErrors[form].streetName = false;
              }

              return _context6.abrupt("break", 31);

            case 23:
              if (state.validationsOn[form] && state.validations[form].suburb) {
                fieldErrors[form].suburb = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors[form].suburb;
              } else {
                fieldErrors[form].suburb = false;
              }

              return _context6.abrupt("break", 31);

            case 25:
              if (state.validationsOn[form] && state.validations[form].town) {
                fieldErrors[form].town = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors[form].town;
              } else {
                fieldErrors[form].town = false;
              }

              return _context6.abrupt("break", 31);

            case 27:
              if (state.validationsOn[form] && state.validations[form].postalCode) {
                if (value.length > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.deliveryDetails.postalCode.onlyNumber */.Z.creditCheckout.deliveryDetails.postalCode.onlyNumber;
                  } else if (value.length < 4) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.deliveryDetails.postalCode.onlyValid */.Z.creditCheckout.deliveryDetails.postalCode.onlyValid;
                  } else {
                    fieldErrors[form].postalCode = false;
                  }
                } else {
                  fieldErrors[form].postalCode = true;
                  fieldErrorsMessage[form].postalCode = errorMessages/* default.creditCheckout.errors.delivery.deliveryDetails.postalCode */.Z.creditCheckout.errors.delivery.deliveryDetails.postalCode;
                }

                fieldErrors.fail = fieldErrors[form].postalCode;
              } else {
                fieldErrors[form].postalCode = false;
              }

              return _context6.abrupt("break", 31);

            case 29:
              if (state.validationsOn[form] && state.validations[form].province) {
                fieldErrors[form].province = value.length == 0 ? true : false;
                fieldErrors[form].fail = fieldErrors[form].province;
              } else {
                fieldErrors[form].province = false;
              }

              return _context6.abrupt("break", 31);

            case 31:
              closeSnackBar();
              setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 33:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function fieldValidationCheck(_x13, _x14, _x15, _x16) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details"),
      page_error_type: "form"
    }));
  };
  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change(address type, province)
   */


  var selectionAnalytics = function selectionAnalytics(selectionType, value) {
    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: ").concat(selectionType),
      filter_query: value
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = DeliveryDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  var addressSearchResultMap = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var localityType;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              localityType = finalAddress.address_components;

              if (!(localityType && localityType.length > 0)) {
                _context7.next = 9;
                break;
              }

              _context7.next = 4;
              return mapAddressSearchData(localityType);

            case 4:
              _context7.next = 6;
              return checkFormError("deliveryDetails");

            case 6:
              errorStatus.deliveryDetails = _context7.sent;
              setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus.deliveryDetails) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function addressSearchResultMap() {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: next")
    }));
  };
  /**
   * Form submit handler
   *
   * @usage call addDeliveryBillingAddress funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    closeSnackBar();

    if (selectedReceiveType == "courier") {
      addDeliveryBillingAddress();
    }
  };

  var showFormDetails = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(result) {
      var newResult;
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              newResult = {
                address: mapFormData(result),
                receiveType: selectedReceiveType,
                deliveryType: selectedDeliveryType,
                cellNumber: contactDetailsData !== null && contactDetailsData !== void 0 && contactDetailsData.cellNumber ? contactDetailsData.cellNumber : ""
              };
              dispatch({
                type: actionTypes/* SET_CREDIT_CHECK_DELIVERY_DATA */.pM,
                payload: newResult
              });

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function showFormDetails(_x17) {
      return _ref9.apply(this, arguments);
    };
  }();

  var mapAddressSearchData = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(localityType) {
      var i;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              readOnlyValues.deliveryDetails.postalCode = false;
              fieldValues.deliveryDetails.unitNo = "";
              fieldValues.deliveryDetails.complexName = "";
              fieldValues.deliveryDetails.streetNo = "";
              fieldValues.deliveryDetails.streetName = "";
              fieldValues.deliveryDetails.suburb = "";
              fieldValues.deliveryDetails.province = "";
              fieldValues.deliveryDetails.town = "";
              fieldValues.deliveryDetails.postalCode = "";
              fieldErrors.deliveryDetails.unitNo = false;
              fieldErrors.deliveryDetails.complexName = false;
              fieldErrors.deliveryDetails.streetNo = false;
              fieldErrors.deliveryDetails.streetName = false;
              fieldErrors.deliveryDetails.suburb = false;
              fieldErrors.deliveryDetails.province = false;
              fieldErrors.deliveryDetails.town = false;
              fieldErrors.deliveryDetails.postalCode = false;

              for (i = 0; i < localityType.length; i++) {
                if (localityType[i].administrative_type == constants/* UNIT */.iI) {
                  if (localityType[i].long_name) {
                    fieldValues.deliveryDetails.unitNo = localityType[i].long_name;
                  }
                }

                if (localityType[i].administrative_type == constants/* BUSINESS */.aL) {
                  fieldValues.deliveryDetails.complexName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* STREET_NO */.sr) {
                  fieldValues.deliveryDetails.streetNo = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* ROUTE */.ln) {
                  fieldValues.deliveryDetails.streetName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* SUBURB */.QP) {
                  fieldValues.deliveryDetails.suburb = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* PROVINCE */.ew) {
                  fieldValues.deliveryDetails.province = getProvinceValue(localityType[i].long_name);
                }

                if (localityType[i].administrative_type == constants/* TOWN */.V8 || localityType[i].administrative_type == constants/* CITY */.Or) {
                  fieldValues.deliveryDetails.town = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == constants/* POST_STREET */.tb) {
                  if (localityType[i].long_name.length > 0) {
                    readOnlyValues.deliveryDetails.postalCode = true;
                  }

                  fieldValues.deliveryDetails.postalCode = localityType[i].long_name;
                }
              }

              setState(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, state), {}, {
                readOnlyValues: readOnlyValues,
                fieldValues: fieldValues,
                fieldErrors: fieldErrors
              }));

            case 19:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function mapAddressSearchData(_x18) {
      return _ref10.apply(this, arguments);
    };
  }();

  var mapHomeFieldData = function mapHomeFieldData() {
    var regionValue = homeDetailsData !== null && homeDetailsData !== void 0 && homeDetailsData.province ? getRegionValue(homeDetailsData.province) : null;
    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.instructions) !== "" ? homeDetailsData.instructions : null,
      street: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetName) !== "" ? seperateStreetString(homeDetailsData.streetName) : null,
      postcode: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.postalCode) !== "" ? homeDetailsData.postalCode : null,
      city: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.town) !== "" ? homeDetailsData.town : null,
      address_type_name: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.addressType) !== "" ? homeDetailsData.addressType : "",
      address_name: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.addressName) !== "" ? homeDetailsData.addressName : "Home",
      company: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.companyName) !== "" ? homeDetailsData.companyName : null,
      unit_number: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.unitNo) !== "" ? homeDetailsData.unitNo : null,
      complex_name: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.complexName) !== "" ? homeDetailsData.complexName : null,
      street_number: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.streetNo) !== "" ? homeDetailsData.streetNo : null,
      suburb: (homeDetailsData === null || homeDetailsData === void 0 ? void 0 : homeDetailsData.suburb) !== "" ? homeDetailsData.suburb : null,
      firstname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData.firstName : "",
      lastname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData.surName : "",
      telephone: contactDetailsData !== null && contactDetailsData !== void 0 && contactDetailsData.cellNumber ? contactDetailsData.cellNumber : "",
      save_in_address_book: true,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 1,
      is_billing_address: 1,
      same_as_shipping: true
    };
  };

  var mapFieldData = function mapFieldData() {
    var regionValue = getRegionValue(state.fieldValues["deliveryDetails"].province);
    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions: state.fieldValues["deliveryDetails"].instructions !== "" ? state.fieldValues["deliveryDetails"].instructions : null,
      street: state.fieldValues["deliveryDetails"].streetName !== "" && state.validations["deliveryDetails"].streetName ? seperateStreetString(state.fieldValues["deliveryDetails"].streetName) : state.fieldValues["deliveryDetails"].addressLine1 !== "" && state.fieldValues["deliveryDetails"].addressLine2 !== "" && state.validations["deliveryDetails"].addressLine1 && state.validations["deliveryDetails"].addressLine2 ? createStreetFromAddressLines(state.fieldValues["deliveryDetails"].addressLine1, state.fieldValues["deliveryDetails"].addressLine2) : null,
      postcode: state.fieldValues["deliveryDetails"].postalCode !== "" ? state.fieldValues["deliveryDetails"].postalCode : null,
      city: state.fieldValues["deliveryDetails"].town !== "" ? state.fieldValues["deliveryDetails"].town : null,
      address_type_name: state.fieldValues["deliveryDetails"].addressType !== "" ? state.fieldValues["deliveryDetails"].addressType : null,
      address_name: state.fieldValues["deliveryDetails"].addressName !== "" ? state.fieldValues["deliveryDetails"].addressName : null,
      company: state.fieldValues["deliveryDetails"].companyName !== "" ? state.fieldValues["deliveryDetails"].companyName : null,
      unit_number: state.fieldValues["deliveryDetails"].unitNo !== "" ? state.fieldValues["deliveryDetails"].unitNo : null,
      complex_name: state.fieldValues["deliveryDetails"].complexName !== "" ? state.fieldValues["deliveryDetails"].complexName : null,
      street_number: state.fieldValues["deliveryDetails"].streetNo !== "" ? state.fieldValues["deliveryDetails"].streetNo : null,
      suburb: state.fieldValues["deliveryDetails"].suburb !== "" ? state.fieldValues["deliveryDetails"].suburb : null,
      firstname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData.firstName : "",
      lastname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData.surName : "",
      telephone: contactDetailsData !== null && contactDetailsData !== void 0 && contactDetailsData.cellNumber ? contactDetailsData.cellNumber : "",
      save_in_address_book: state.fieldValues["deliveryDetails"].futureCheck,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 1,
      is_billing_address: 1,
      same_as_shipping: true
    };
  };

  var addDeliveryBillingAddress = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var inputAddressObj, results, _results$errors2, _results$errors2$, _results, _results$errors3, _results$errors3$;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!(selectedDeliveryType !== "previous")) {
                _context10.next = 17;
                break;
              }

              inputAddressObj = selectedDeliveryType == "home" ? mapHomeFieldData() : mapFieldData();

              if (currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine && inputAddressObj.firstname == "") {
                inputAddressObj.firstname = profileData === null || profileData === void 0 ? void 0 : profileData.firstname;
                inputAddressObj.lastname = profileData === null || profileData === void 0 ? void 0 : profileData.lastname;
              }

              _context10.prev = 3;
              (0,helperServices/* showSpinner */.yh)();
              _context10.next = 7;
              return (0,checkoutService/* setNewBillingAddressService */.xz)(inputAddressObj);

            case 7:
              results = _context10.sent;

              if (!results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING */.sm,
                  payload: results
                });
                dispatch({
                  type: actionTypes/* SET_BILLING */.BP,
                  payload: results
                });
                showFormDetails(results.setAddress);
                addShippingMethod();
                analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "success",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details")
                }));
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (results && results.errors) {
                  technicalFailure((_results$errors2 = results.errors) === null || _results$errors2 === void 0 ? void 0 : (_results$errors2$ = _results$errors2[0]) === null || _results$errors2$ === void 0 ? void 0 : _results$errors2$.message);
                } else {
                  technicalFailure();
                }
              }

              _context10.next = 15;
              break;

            case 11:
              _context10.prev = 11;
              _context10.t0 = _context10["catch"](3);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 15:
              _context10.next = 29;
              break;

            case 17:
              _context10.prev = 17;
              (0,helperServices/* showSpinner */.yh)();
              _context10.next = 21;
              return (0,checkoutService/* setExistingBillAddressService */.gR)(cartId, selectedDeliveryAddress, true);

            case 21:
              _results = _context10.sent;

              if (!_results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING */.sm,
                  payload: _results
                });
                dispatch({
                  type: actionTypes/* SET_BILLING */.BP,
                  payload: _results
                });
                showFormDetails(_results.setAddress);
                addShippingMethod();
                analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "success",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details")
                }));
              } else {
                (0,helperServices/* hideSpinner */.v3)();

                if (_results && _results.errors) {
                  technicalFailure((_results$errors3 = _results.errors) === null || _results$errors3 === void 0 ? void 0 : (_results$errors3$ = _results$errors3[0]) === null || _results$errors3$ === void 0 ? void 0 : _results$errors3$.message);
                } else {
                  technicalFailure();
                }
              }

              _context10.next = 29;
              break;

            case 25:
              _context10.prev = 25;
              _context10.t1 = _context10["catch"](17);
              (0,helperServices/* hideSpinner */.v3)();
              technicalFailure();

            case 29:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[3, 11], [17, 25]]);
    }));

    return function addDeliveryBillingAddress() {
      return _ref11.apply(this, arguments);
    };
  }();

  var addShippingMethod = /*#__PURE__*/function () {
    var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
      var cart_id, results;
      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              cart_id = cartId !== "" ? cartId : null;
              _context11.next = 3;
              return (0,checkoutService/* setShippingMethodsOnCartService */.YD)(cart_id, carrierCode, methodCode);

            case 3:
              results = _context11.sent;

              if (!results.fail) {
                dispatch({
                  type: actionTypes/* SET_SHIPPING_METHOD */.SQ,
                  payload: results
                });
              }

              onFormSubmit(true);
              setDisplayEditMode(false);
              doCreditCheckDisable("deliveryDetails", false);
              (0,helperServices/* hideSpinner */.v3)();

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function addShippingMethod() {
      return _ref12.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("deliveryDetails", true);
  };

  var technicalFailure = function technicalFailure(errorMsg) {
    window.scrollTo(0, 0);

    if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "authorized")) {
      displaySnackBar(labels/* default.checkout.lbl_session_invalid */.Z.checkout.lbl_session_invalid);
      setReLogin(true);
    } else if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "cart")) {
      displaySnackBar(labels/* default.checkout.lbl_cart_invalid */.Z.checkout.lbl_cart_invalid);
      setReLogin(true);
    } else if ((0,helperServices/* matchWordInString */.Rn)(errorMsg, "server")) {
      if (submitAttempt == 0) {
        displaySnackBar(labels/* default.checkout.lbl_something_went_wrong_try_again */.Z.checkout.lbl_something_went_wrong_try_again);
      } else {
        setAnalyticsOnNextButton();
        fetchErrorDetails("captureDeliveryDetails_invalid");
        closeSnackBar();
      }

      setSubmitAttempt(submitAttempt + 1);
    } else {
      displaySnackBar(labels/* default.checkout.lbl_something_went_wrong_try_again */.Z.checkout.lbl_something_went_wrong_try_again);
    }
  };
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(resultCode) {
      var pageName, result;
      return regenerator_default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              pageName = "checkout: credit check: ".concat(customerStatus, ": delivery details");
              _context12.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context12.next = 5;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [resultCode]);

            case 5:
              result = _context12.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText);
                },
                imgUrl: result[0].icon,
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context12.next = 16;
              break;

            case 11:
              _context12.prev = 11;
              _context12.t0 = _context12["catch"](1);
              setPageErr({
                type: "error",
                title: labels/* default.creditCheckout.deliveryDetails.lbl_invalid_attempt_title */.Z.creditCheckout.deliveryDetails.lbl_invalid_attempt_title,
                desc: labels/* default.creditCheckout.deliveryDetails.lbl_invalid_attempt_desc */.Z.creditCheckout.deliveryDetails.lbl_invalid_attempt_desc,
                primaryLabel: "Call me back",
                secondaryLabel: "Exit checkout",
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handlePrimaryClick(null, "call me back");
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick(null, "exit checkout");
                },
                imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 16:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 11]]);
    }));

    return function fetchErrorDetails(_x19) {
      return _ref13.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var _handleSecondaryClick = function _handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var displaySnackBar = function displaySnackBar(message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page_level";
    setShowSnackBar({
      visible: true,
      message: message
    });
    var pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page"
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = "checkout: credit check: ".concat(customerStatus, ": delivery details");
      pageAnalyticsData.page_error_type = "form";
    }

    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), pageAnalyticsData), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: next")
    }));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar({
      visible: false,
      message: ""
    });
  };

  var showModal = function showModal(type, variant, addressData) {
    setModalType(type);
    setModalVariant(variant);
    setModalValues(addressData);
    setModalShow(true);
    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_form_event: "start",
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: ").concat(variant, " ").concat(type, " address")
    }));
  };

  var hideModal = function hideModal(refresh) {
    setModalShow(false);

    if (refresh == true) {
      fetchData();
    }
  };

  var addressTileClickHandler = function addressTileClickHandler(data) {
    setSelectedDeliveryAddress(data.id);
    analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: select delivery address"),
      filter_query: data.address_name
    }));
  };
  /**
   * Radio change event handler
   *
   * @usage Set the id of selected receive type
   * @usage Show the content of selected receive type
   * @call onChange event
   */


  var handleReceiveType = /*#__PURE__*/function () {
    var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee13(val, index) {
      var _receiveTypesOptions$;

      return regenerator_default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              setSelectedReceiveType(val);
              analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                page_tool_event: "use",
                page_tool_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: delivery type"),
                filter_query: ((_receiveTypesOptions$ = receiveTypesOptions[index]) === null || _receiveTypesOptions$ === void 0 ? void 0 : _receiveTypesOptions$.id) == "courier" ? "deliver" : "collect"
              }));

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function handleReceiveType(_x20, _x21) {
      return _ref14.apply(this, arguments);
    };
  }();
  /**
   * Dropdown change event handler
   *
   * @usage Set the id of selected delivery type
   * @usage Show the content of selected delivery type
   * @call onChange event
   */


  var handleDeliveryType = /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee14(event, val, index) {
      var _deliveryTypeOptions$;

      return regenerator_default().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              event.persist();
              setSelectedDeliveryType(val);

              if (!analytics) {
                analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": delivery details")
                }));
                setAnalytics(true);
              }

              analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                page_tool_event: "use",
                page_tool_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: address process"),
                filter_query: (_deliveryTypeOptions$ = deliveryTypeOptions[index]) === null || _deliveryTypeOptions$ === void 0 ? void 0 : _deliveryTypeOptions$.label
              }));

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function handleDeliveryType(_x22, _x23, _x24) {
      return _ref15.apply(this, arguments);
    };
  }();
  /**
   * Dropdown field reset handler
   *
   * @usage Set the default selected
   */


  var handleDeliveryTypeReset = /*#__PURE__*/function () {
    var _ref16 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee15() {
      var _deliveryTypeOptions$2;

      return regenerator_default().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              setSelectedDeliveryType("home");
              analyticsUtag/* link */.p4(DeliveryDetails_objectSpread(DeliveryDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
                page_tool_event: "use",
                page_tool_name: "checkout: credit check: ".concat(customerStatus, ": delivery details: address process"),
                filter_query: (_deliveryTypeOptions$2 = deliveryTypeOptions[0]) === null || _deliveryTypeOptions$2 === void 0 ? void 0 : _deliveryTypeOptions$2.label
              }));

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function handleDeliveryTypeReset() {
      return _ref16.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "delivery-details",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-delivery.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "succes",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), "Delivery details", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Section 6 of 7" : "Section 4 of 5"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton(true);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), !displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(deliveryDetailsInfo_DeliveryDetailsInfo, {
        data: deliveryDetailsData,
        stateTypesOptions: stateTypesOptions
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["pt-2"],
        children: [selectedReceiveType == "courier" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (DeliveryDetails_module_default()).courier,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (DeliveryDetails_module_default())["delivery-selection"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
              text: labels/* default.creditCheckout.deliveryDetails.lbl_delivery_type_title */.Z.creditCheckout.deliveryDetails.lbl_delivery_type_title,
              level: 3,
              className: "".concat((DeliveryDetails_module_default())["delivery-selection__heading"], " ").concat((DeliveryDetails_module_default())["mt-m"])
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((DeliveryDetails_module_default())["select-row"], " ").concat((DeliveryDetails_module_default())["mt-m"]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "".concat((DeliveryDetails_module_default())["select-group"]),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown/* default */.Z, {
                  label: "Delivery type",
                  name: "deliveyType",
                  data: deliveryTypeOptions,
                  handleSelect: handleDeliveryType,
                  handleReset: handleDeliveryTypeReset,
                  resetRequired: true,
                  selectedId: selectedDeliveryType,
                  customId: "checkout-credit-check-delivey-type-select"
                })
              })
            })]
          }), selectedDeliveryType == "home" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((DeliveryDetails_module_default())["home-address"], " ").concat((DeliveryDetails_module_default())["mtb-m"]),
            children: displayHomeAddress()
          }), selectedDeliveryType == "previous" && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((DeliveryDetails_module_default())["tiles-section"], " ").concat((DeliveryDetails_module_default())["mtb-m"]),
            children: deliveryAddresslists.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(AddressTile/* default */.Z, {
                type: "delivery",
                variant: "edit",
                data: item,
                handleOnEdit: showModal,
                handleOnClick: addressTileClickHandler,
                selectedAddress: selectedDeliveryAddress,
                deleteOption: false,
                id: "checkout-credit-check-delivery-address-tile-".concat(index)
              }, index);
            })
          }), selectedDeliveryType == "another" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((DeliveryDetails_module_default())["another-address"], " ").concat((DeliveryDetails_module_default())["mt-m"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
              text: labels/* default.creditCheckout.deliveryDetails.lbl_another_address_title */.Z.creditCheckout.deliveryDetails.lbl_another_address_title,
              level: 3,
              className: (DeliveryDetails_module_default())["another-address__heading"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat("d-none " + (CheckoutCreditCheck_module_default())["search-wrapper"], " ").concat((DeliveryDetails_module_default())["mt-m"]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
                className: (CheckoutCreditCheck_module_default())["search-wrapper__input"],
                placeholderText: "Search for your address",
                icon: "blue",
                variant: "address-search",
                setFinalAddress: setFinalAddress,
                pageName: "checkout: credit check: ".concat(customerStatus),
                analyticFormName: "delivery details"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form, {
              noValidate: true,
              id: "checkout-credit-check-delivery-address-form",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryDetailsForm/* default */.Z, {
                formName: "deliveryDetails",
                validations: state.validations["deliveryDetails"],
                fieldValues: state.fieldValues["deliveryDetails"],
                fieldErrors: state.fieldErrors["deliveryDetails"],
                fieldErrorsMessage: state.fieldErrorsMessage["deliveryDetails"],
                readOnlyValues: state.readOnlyValues["deliveryDetails"],
                addressTypesOptions: addressTypesOptions,
                stateTypesOptions: stateTypesOptions,
                onChangeHandler: handleChange,
                onBlurHandler: handleBlur
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (DeliveryDetails_module_default()).contact,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
              text: labels/* default.creditCheckout.deliveryDetails.lbl_courier_title */.Z.creditCheckout.deliveryDetails.lbl_courier_title,
              level: 3,
              className: "".concat((DeliveryDetails_module_default()).contact__heading, " ").concat((DeliveryDetails_module_default())["mt-m"])
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (DeliveryDetails_module_default()).contact__value,
              children: contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.cellNumber
            })]
          })]
        }), selectedReceiveType == "store" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (DeliveryDetails_module_default()).store,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
            title: labels/* default.creditCheckout.deliveryDetails.lbl_store_title */.Z.creditCheckout.deliveryDetails.lbl_store_title,
            contents: titleContents,
            className: (DeliveryDetails_module_default())["mt-m"],
            id: "checkout-credit-check-store-standard-delivery",
            iconType: "dot"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
            text: labels/* default.creditCheckout.deliveryDetails.lbl_collect_type_title */.Z.creditCheckout.deliveryDetails.lbl_collect_type_title,
            level: 3,
            className: "".concat((DeliveryDetails_module_default())["seacrh-heading"], " ").concat((DeliveryDetails_module_default())["mt-m"])
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat("d-none " + (CheckoutCreditCheck_module_default())["search-wrapper"], " ").concat((DeliveryDetails_module_default())["mtb-m"]),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
              className: (CheckoutCreditCheck_module_default())["search-wrapper__input"],
              placeholderText: labels/* default.creditCheckout.deliveryDetails.lbl_store_search_title */.Z.creditCheckout.deliveryDetails.lbl_store_search_title,
              icon: "blue",
              variant: "address-search",
              setFinalAddress: setFinalAddress,
              pageName: "checkout: credit check: ".concat(customerStatus),
              analyticFormName: "delivery details"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "button",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-delivery-address-submit",
            handleClick: function handleClick(event) {
              return handleSubmit(event);
            },
            children: "Next"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutFormsModal/* default */.Z, {
      show: modalShow,
      hide: hideModal,
      formType: modalType,
      variant: modalVariant,
      values: modalValues,
      addressTypes: addressTypesOptions,
      statesTypes: stateTypesOptions,
      countryCode: countryCode,
      countryName: countryName,
      cartId: cartId,
      step: "creditCheck",
      deleteOption: false,
      pageName: "checkout: credit check: ".concat(customerStatus, ": delivery details"),
      isGuestUser: userLoggedIn ? false : true
    })]
  });
};

var DeliveryDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    personalDetailsData: state.creditCheckDetails.personalDetails,
    homeDetailsData: state.creditCheckDetails.homeDetails,
    contactDetailsData: state.creditCheckDetails.contactDetails,
    deliveryDetailsData: state.creditCheckDetails.deliveryDetails,
    profileLoading: state.navDetails.isProfileLoading
  };
};

var DeliveryDetails_mapDispatchToProps = {
  setReLogin: navAction/* setReLogin */.Lf
};
/* harmony default export */ var deliveryDetails_DeliveryDetails = ((0,DependencyHelper.connect)(DeliveryDetails_mapStateToProps, DeliveryDetails_mapDispatchToProps)(DeliveryDetails));
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckForms/contactDetailsForm/ContactDetailsForm.jsx







var ContactDetailsForm = function ContactDetailsForm(_ref) {
  var formName = _ref.formName,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((NewLineForms_module_default())["main-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Row, {
      className: "".concat((NewLineForms_module_default())["main-row"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormcd101",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormcd101-label",
          children: "Cellphone number"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          type: "text",
          maxLength: (0,helperServices/* africaCountryCode */.xJ)(fieldValues["cellNumber"]) ? "11" : "10",
          name: "cellNumber",
          value: fieldValues["cellNumber"],
          placeholder: "Add your cellphone number",
          onChange: handleChange,
          isInvalid: fieldErrors["cellNumber"],
          className: fieldErrors["cellNumber"] ? (NewLineForms_module_default()).invalid : "",
          onBlur: handleBlur
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (NewLineForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["cellNumber"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (NewLineForms_module_default())["form-group"],
        controlId: "validationFormcd102",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
          className: (NewLineForms_module_default())["form-label"],
          id: "validationFormcd102-label",
          children: "Email address"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          disabled: true,
          type: "text",
          name: "emailAddress",
          value: fieldValues["emailAddress"],
          placeholder: "Add your email address",
          onChange: handleChange,
          isInvalid: fieldErrors["emailAddress"],
          className: (NewLineForms_module_default())["disable-input"],
          onBlur: handleBlur
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NewLineForms_module_default())["hint-text"],
          children: labels/* default.auth.lbl_email_readOnly */.Z.auth.lbl_email_readOnly
        })]
      })]
    })
  });
};

ContactDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {}
};
/* harmony default export */ var contactDetailsForm_ContactDetailsForm = (ContactDetailsForm);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/creditCheckDetails/contactDetailsInfo/ContactDetailsInfo.jsx





var ContactDetailsInfo = function ContactDetailsInfo(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CreditCheckDetails_module_default())["form-details-container"]),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " ").concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Cellphone number:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-1"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.cellNumber
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((CreditCheckDetails_module_default())["pb-6"], " col-md-6 col-sm-12"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          children: "Email address:"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "col-md-6 col-sm-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.emailAddress
        })
      })]
    })
  });
};

ContactDetailsInfo.defaultProps = {
  data: {}
};
/* harmony default export */ var contactDetailsInfo_ContactDetailsInfo = (ContactDetailsInfo);
;// CONCATENATED MODULE: ./components/molecules/checkoutCreditCheck/contactDetails/ContactDetails.jsx




function ContactDetails_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = ContactDetails_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function ContactDetails_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return ContactDetails_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContactDetails_arrayLikeToArray(o, minLen); }

function ContactDetails_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ContactDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContactDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContactDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContactDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var ContactDetails_analyticsTags = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];
/**
 * Contact Details component holds the logic of contact detail form validation logic,
 * handling all the API calls and analytics
 */

var ContactDetails = function ContactDetails(_ref) {
  var customerStatus = _ref.customerStatus,
      profileData = _ref.profileData,
      onFormSubmit = _ref.onFormSubmit,
      contactDetailsData = _ref.contactDetailsData,
      authDetailsData = _ref.authDetailsData,
      currentJourneyType = _ref.currentJourneyType,
      doCreditCheckDisable = _ref.doCreditCheckDisable;

  var _useState = (0,react.useState)(false),
      analytics = _useState[0],
      setAnalytics = _useState[1];

  var _useState2 = (0,react.useState)(true),
      submitDisabled = _useState2[0],
      setSubmitDisabled = _useState2[1];

  var _useState3 = (0,react.useState)(contactDetailsData ? false : true),
      displayEditMode = _useState3[0],
      setDisplayEditMode = _useState3[1];

  var cloneOfErrorMessages = JSON.parse(JSON.stringify(errorMessages/* default.creditCheckout.errors.contact */.Z.creditCheckout.errors.contact));
  var dispatch = (0,DependencyHelper.useDispatch)();
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */

  var handleBlur = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      var name, errMsg;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.persist();
              _context.next = 3;
              return fieldValidationCheck(event, val, form);

            case 3:
              _context.next = 5;
              return checkFormError(form);

            case 5:
              errorStatus[form] = _context.sent;
              setState(ContactDetails_objectSpread(ContactDetails_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (fieldErrors.fail) {
                setSubmitDisabled(true);
                name = event.target.name;
                errMsg = fieldErrorsMessage[form][name];
                inlineAnalytics(errMsg);
              } else {
                checkErrorStatus();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleBlur(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (contactDetailsData) {
      fieldValues.contactDetails.cellNumber = contactDetailsData.cellNumber;
      fieldValues.contactDetails.emailAddress = contactDetailsData.emailAddress;
    } else if (authDetailsData) {
      fieldValues.contactDetails.cellNumber = authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.msisdn ? authDetailsData.msisdn : "";
      fieldValues.contactDetails.emailAddress = profileData !== null && profileData !== void 0 && profileData.email ? profileData.email : "";
    }

    if (contactDetailsData || profileData) {
      errorStatus.contactDetails = checkFormError("contactDetails");

      if (errorStatus.contactDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState(ContactDetails_objectSpread(ContactDetails_objectSpread({}, state), {}, {
        fieldValues: fieldValues,
        errorStatus: errorStatus
      }));
    }
  }, [contactDetailsData, profileData]);

  var _useState4 = (0,react.useState)({
    validationsOn: {
      contactDetails: true
    },
    errorStatus: {
      contactDetails: true
    },
    validations: {
      contactDetails: {
        cellNumber: true,
        emailAddress: true
      }
    },
    fieldErrors: {
      contactDetails: {
        cellNumber: false,
        emailAddress: false
      },
      fail: false
    },
    fieldValues: {
      contactDetails: {
        cellNumber: "",
        emailAddress: ""
      }
    },
    fieldErrorsMessage: cloneOfErrorMessages
  }),
      state = _useState4[0],
      setState = _useState4[1];

  var errorStatus = state.errorStatus,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      fieldErrorsMessage = state.fieldErrorsMessage;
  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.persist();

              if (!analytics) {
                analyticsUtag/* link */.p4(ContactDetails_objectSpread(ContactDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(ContactDetails_analyticsTags)), {}, {
                  page_form_event: "start",
                  page_form_name: "checkout: credit check: ".concat(customerStatus, ": contact details")
                }));
                setAnalytics(true);
              }

              _context2.next = 4;
              return updateFieldValues(event, val, form);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */


  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }
  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              fieldValues[form][name] = value;
              setState(ContactDetails_objectSpread(ContactDetails_objectSpread({}, state), {}, {
                fieldValues: fieldValues
              }));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function updateFieldValues(_x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */


  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(event, val, form) {
      var name, value;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;
              _context4.t0 = name;
              _context4.next = _context4.t0 === "cellNumber" ? 5 : _context4.t0 === "emailAddress" ? 7 : 9;
              break;

            case 5:
              if (state.validationsOn[form] && state.validations[form].cellNumber) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* numRegEx.test */.rP.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.creditCheckout.contactDetails.cellNumber.onlyNumber */.Z.creditCheckout.contactDetails.cellNumber.onlyNumber;
                  } else if (!helperServices/* cellPhoneRegEx.test */.RZ.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.creditCheckout.contactDetails.cellNumber.startWith */.Z.creditCheckout.contactDetails.cellNumber.startWith;
                  } else if ((0,helperServices/* africaCountryCode */.xJ)(value) && value.length < 11) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.creditCheckout.errors.contact.contactDetails.cellNumber */.Z.creditCheckout.errors.contact.contactDetails.cellNumber;
                  } else if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.creditCheckout.errors.contact.contactDetails.cellNumber */.Z.creditCheckout.errors.contact.contactDetails.cellNumber;
                  } else {
                    fieldErrors[form].cellNumber = false;
                  }
                } else {
                  fieldErrors[form].cellNumber = true;
                  fieldErrorsMessage[form].cellNumber = errorMessages/* default.creditCheckout.errors.contact.contactDetails.cellNumber */.Z.creditCheckout.errors.contact.contactDetails.cellNumber;
                }

                fieldErrors.fail = fieldErrors[form].cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }

              return _context4.abrupt("break", 9);

            case 7:
              if (state.validationsOn[form] && state.validations[form].emailAddress) {
                if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
                  if (!helperServices/* emailRegEx.test */.TH.test(value)) {
                    fieldErrors[form].emailAddress = true;
                    fieldErrorsMessage[form].emailAddress = errorMessages/* default.creditCheckout.contactDetails.emailAddress.onlyValid */.Z.creditCheckout.contactDetails.emailAddress.onlyValid;
                  } else {
                    fieldErrors[form].emailAddress = false;
                  }
                } else {
                  fieldErrors[form].emailAddress = true;
                  fieldErrorsMessage[form].emailAddress = errorMessages/* default.creditCheckout.errors.contact.contactDetails.emailAddress */.Z.creditCheckout.errors.contact.contactDetails.emailAddress;
                }

                fieldErrors.fail = fieldErrors[form].emailAddress;
              } else {
                fieldErrors.emailaddress = false;
              }

              return _context4.abrupt("break", 9);

            case 9:
              setState(ContactDetails_objectSpread(ContactDetails_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fieldValidationCheck(_x10, _x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */


  var inlineAnalytics = function inlineAnalytics(message) {
    analyticsUtag/* link */.p4(ContactDetails_objectSpread(ContactDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(ContactDetails_analyticsTags)), {}, {
      page_form_event: "error",
      page_errors: message,
      page_form_name: "checkout: credit check: ".concat(customerStatus, ": contact details"),
      page_error_type: "form"
    }));
  };
  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */


  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = ContactDetails_createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }
  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */


  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["contactDetails"]) {
      submitForm();
    }
  };
  /**
   * Set the on page submit
   *
   * @call on next button click
   */


  var setAnalyticsOnNextButton = function setAnalyticsOnNextButton() {
    analyticsUtag/* link */.p4(ContactDetails_objectSpread(ContactDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(ContactDetails_analyticsTags)), {}, {
      link_type: "o",
      link_name: "checkout: credit check: ".concat(customerStatus, ": contact details: next")
    }));
  };
  /**
   * Set the on page edit
   *
   * @call on edit event
   */


  var setAnalyticsOnPageEdit = function setAnalyticsOnPageEdit() {
    analyticsUtag/* link */.p4(ContactDetails_objectSpread(ContactDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(ContactDetails_analyticsTags)), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout: credit check: ".concat(customerStatus, ": edit contact details")
    }));
  };
  /**
   *
   * @usage submit the form with request payload
   */


  var submitForm = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch({
                type: actionTypes/* SET_CREDIT_CHECK_CONTACT_DATA */.HM,
                payload: ContactDetails_objectSpread({}, state.fieldValues["contactDetails"])
              });
              onFormSubmit(true);
              setDisplayEditMode(false);
              doCreditCheckDisable("contactDetails", false);
              analyticsUtag/* link */.p4(ContactDetails_objectSpread(ContactDetails_objectSpread({}, analyticsUtag/* getUtagData */.GS(ContactDetails_analyticsTags)), {}, {
                page_form_event: "success",
                page_form_name: "checkout: credit check: ".concat(customerStatus, ": contact details")
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function submitForm() {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */


  var clickOnEditButton = function clickOnEditButton() {
    setDisplayEditMode(true);
    doCreditCheckDisable("contactDetails", true);
    setAnalyticsOnPageEdit();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((CheckoutCreditCheck_module_default()).container),
      id: "contact-details",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CheckoutCreditCheck_module_default())["form-heading"],
        children: [displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-call.svg"),
          img_alt: "section",
          className: (CheckoutCreditCheck_module_default())["section-icon"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/success-circle_small.svg"),
          img_alt: "success",
          className: (CheckoutCreditCheck_module_default())["section-success-icon"]
        }), "Contact details", displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Section 2 of 7" : "Section 1 of 5"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["section-numbers"],
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              return clickOnEditButton();
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/blog.svg"),
              img_alt: "edit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Edit details"
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), !displayEditMode ? /*#__PURE__*/(0,jsx_runtime.jsx)(contactDetailsInfo_ContactDetailsInfo, {
        data: contactDetailsData
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        id: "checkout-credit-check-contact-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(contactDetailsForm_ContactDetailsForm, {
          formName: "contactDetails",
          fieldValues: state.fieldValues["contactDetails"],
          fieldErrors: state.fieldErrors["contactDetails"],
          fieldErrorsMessage: state.fieldErrorsMessage["contactDetails"],
          onChangeHandler: handleChange,
          onBlurHandler: handleBlur
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (CheckoutCreditCheck_module_default())["button-wrapper"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            variant: "solid grey",
            disabled: submitDisabled,
            className: (CheckoutCreditCheck_module_default()).button,
            id: "checkout-credit-check-contact-form-submit",
            children: "Next"
          })
        })]
      })]
    })
  });
};

var ContactDetails_mapStateToProps = function mapStateToProps(state) {
  return {
    contactDetailsData: state.creditCheckDetails.contactDetails,
    authDetailsData: state.checkoutDetails.authDetails
  };
};

/* harmony default export */ var contactDetails_ContactDetails = ((0,DependencyHelper.connect)(ContactDetails_mapStateToProps)(ContactDetails));
// EXTERNAL MODULE: ./components/atoms/newLineForms/outcomeInformation/OutcomeInformation.module.scss
var OutcomeInformation_module = __webpack_require__(38957);
var OutcomeInformation_module_default = /*#__PURE__*/__webpack_require__.n(OutcomeInformation_module);
;// CONCATENATED MODULE: ./components/atoms/newLineForms/outcomeInformation/OutcomeInformation.jsx


function OutcomeInformation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OutcomeInformation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OutcomeInformation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OutcomeInformation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var OutcomeInformation = function OutcomeInformation(_ref) {
  var className = _ref.className,
      title = _ref.title,
      screenType = _ref.screenType,
      iconType = _ref.iconType,
      description = _ref.description,
      customerStatus = _ref.customerStatus,
      setDisableBackButton = _ref.setDisableBackButton,
      handleHeading = _ref.handleHeading;
  (0,react.useEffect)(function () {
    handleHeading("hide", "desc");
    setDisableBackButton(true);
    window.scrollTo(0, 0);

    switch (screenType) {
      case labels/* default.creditVetting.approved.lbl_screentype */.Z.creditVetting.approved.lbl_screentype:
        analyticsUtag/* view */.ei(OutcomeInformation_objectSpread({
          page_event: "view",
          page_name: "checkout: credit check: ".concat(customerStatus, ": success")
        }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
        break;
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((OutcomeInformation_module_default())["main-container"], " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OutcomeInformation_module_default()).icon,
      children: screenType === labels/* default.creditVetting.lbl_screentype_loading */.Z.creditVetting.lbl_screentype_loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/lock-loading.gif")
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: iconType
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OutcomeInformation_module_default()).title,
      children: [" ", title, " "]
    }), description && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OutcomeInformation_module_default()).desc,
      children: [" ", description, " "]
    })]
  });
};

/* harmony default export */ var outcomeInformation_OutcomeInformation = (OutcomeInformation);
// EXTERNAL MODULE: ./components/organisms/checkoutCreditCheck/CheckoutCreditCheck.module.scss
var checkoutCreditCheck_CheckoutCreditCheck_module = __webpack_require__(7254);
var checkoutCreditCheck_CheckoutCreditCheck_module_default = /*#__PURE__*/__webpack_require__.n(checkoutCreditCheck_CheckoutCreditCheck_module);
;// CONCATENATED MODULE: ./components/organisms/checkoutCreditCheck/CheckoutCreditCheck.jsx



function CheckoutCreditCheck_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckoutCreditCheck_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckoutCreditCheck_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckoutCreditCheck_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




























var CheckoutCreditCheck = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _cartDetails$shipping, _cartDetails$prices, _cartDetails$prices$g;

  var userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      countryCode = _ref.countryCode,
      countryName = _ref.countryName,
      setShowSnackBar = _ref.setShowSnackBar,
      setPageErr = _ref.setPageErr,
      navigate = _ref.navigate,
      continueDisable = _ref.continueDisable,
      creditCheckDetails = _ref.creditCheckDetails,
      authDetailsData = _ref.authDetailsData,
      setDisableBackButton = _ref.setDisableBackButton,
      handleHeading = _ref.handleHeading,
      carrierCode = _ref.carrierCode,
      methodCode = _ref.methodCode,
      dealCategoryId = _ref.dealCategoryId,
      cartDetails = _ref.cartDetails,
      currentJourneyType = _ref.currentJourneyType,
      creditVettingDetails = _ref.creditVettingDetails,
      paymentMethodCode = _ref.paymentMethodCode,
      multicartFlag = _ref.multicartFlag,
      numberTransferEnabled = _ref.numberTransferEnabled,
      setShowOnceOff = _ref.setShowOnceOff,
      setPostCheckoutCurrentStep = _ref.setPostCheckoutCurrentStep;
  var showPersonalDetails = creditVettingDetails ? false : true;

  var _useState = (0,react.useState)(creditVettingDetails ? false : creditCheckDetails.personalDetails || creditCheckDetails.contactDetails ? true : currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine ? true : false),
      showContactDetails = _useState[0],
      setShowContactDetails = _useState[1];

  var _useState2 = (0,react.useState)(creditVettingDetails ? false : creditCheckDetails.contactDetails || creditCheckDetails.employmentDetails ? true : false),
      showEmploymentDetails = _useState2[0],
      setShowEmploymentDetails = _useState2[1];

  var _useState3 = (0,react.useState)(creditVettingDetails ? false : creditCheckDetails.employmentDetails || creditCheckDetails.homeDetails ? true : false),
      showHomeDetails = _useState3[0],
      setShowHomeDetails = _useState3[1];

  var _useState4 = (0,react.useState)(creditVettingDetails ? false : creditCheckDetails.homeDetails || creditCheckDetails.debitDetails ? true : false),
      showDebitDetails = _useState4[0],
      setShowDebitDetails = _useState4[1];

  var _useState5 = (0,react.useState)(creditVettingDetails ? false : creditCheckDetails.debitDetails || creditCheckDetails.deliveryDetails ? true : false),
      showDeliveryDetails = _useState5[0],
      setShowDeliveryDetails = _useState5[1];

  var _useState6 = (0,react.useState)(creditCheckDetails.deliveryDetails ? true : false),
      showConsentDetails = _useState6[0],
      setConsentDetails = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      showDocsData = _useState7[0],
      setShowDocsData = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      showOfflineData = _useState8[0],
      setShowOfflineData = _useState8[1];

  var _useState9 = (0,react.useState)({
    visible: false,
    title: "Your credit status has been approved!",
    desc: "You can now continue with your application.",
    screenType: "approved",
    isdisableBackButton: false,
    isHidePageDesription: false
  }),
      getCreditOutcome = _useState9[0],
      setCreditOutcome = _useState9[1];

  var _useState10 = (0,react.useState)({
    personalDetails: false,
    contactDetails: false,
    employmentDetails: false,
    debitDetails: false,
    homeDetails: false,
    deliveryDetails: false
  }),
      formEditState = _useState10[0],
      setEditFormState = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      doCreditCheckDisable = _useState11[0],
      setDoCreditCheckDisable = _useState11[1];

  var _useState12 = (0,react.useState)(""),
      orderSplitMessage = _useState12[0],
      setOrderSplitMessage = _useState12[1];

  var _useState13 = (0,react.useState)(""),
      submitDocMessage = _useState13[0],
      setSubmitDocMessage = _useState13[1];

  var multiCartText = multicartFlag ? "_multicart" : "";
  (0,react.useEffect)(function () {
    setDoCreditCheckDisable(Object.keys(formEditState).every(function (k) {
      return !formEditState[k];
    }));
  }, [formEditState]);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function () {
        var _submit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  analyticsUtag/* link */.p4({
                    link_type: "o",
                    link_name: "checkout: credit check: ".concat(customerStatus, ": continue")
                  });
                  continueDisable(true);
                  navigate(numberTransferEnabled ? "numberTransfer" : "delivery");

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function submit() {
          return _submit.apply(this, arguments);
        }

        return submit;
      }(),
      back: function back() {
        if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "PASSPORT") {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: credit check: ".concat(customerStatus, ": back to lets get started")
          });
        }
      }
    };
  });
  (0,react.useEffect)(function () {
    var _getCreditOutcome$scr;

    if (getCreditOutcome.screenType === "".concat(labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended + multiCartText) || getCreditOutcome.screenType === "".concat(labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending + multiCartText) || getCreditOutcome.screenType === "".concat(labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred + multiCartText) || getCreditOutcome.screenType === "".concat(labels/* default.creditVetting.lbl_resultcode_offline */.Z.creditVetting.lbl_resultcode_offline + multiCartText) || (_getCreditOutcome$scr = getCreditOutcome.screenType) !== null && _getCreditOutcome$scr !== void 0 && _getCreditOutcome$scr.toUpperCase().includes(labels/* default.creditVetting.lbl_unprocessed */.Z.creditVetting.lbl_unprocessed)) {
      //If browser back button is clicked, go back to multi cart page
      window.onpopstate = function () {
        (0,helperServices/* showSpinner */.yh)();
        router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
          setPostCheckoutCurrentStep(null);
          (0,helperServices/* hideSpinner */.v3)();
        });
      };
    }
  });
  (0,react.useEffect)(function () {
    if (customerStatus) {
      analyticsUtag/* view */.ei(CheckoutCreditCheck_objectSpread({
        page_event: "view",
        page_name: "checkout: credit check: ".concat(customerStatus),
        page_channel: "checkout",
        page_master_tab: "personal",
        multicart_flag: multicartFlag ? true : false
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
    }
  }, [customerStatus]);

  var updateShowDebitDetails = function updateShowDebitDetails(arg) {
    if (currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine) {
      setShowDebitDetails(true);
      setShowDeliveryDetails(true);
    } else {
      var obj = creditCheckDetails.homeDetails || creditCheckDetails.debitDetails ? true : false;
      setShowDebitDetails(obj);
    }
  }; // changes for pended, referred, pending


  var router = (0,DependencyHelper.useRouter)();
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var authToken = (0,helperServices/* getCookieValue */.Do)("auth_token");
  var vodAuthToken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
  var totalZero = parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping === void 0 ? void 0 : _cartDetails$shipping.shipping_fee) + parseFloat(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices = cartDetails.prices) === null || _cartDetails$prices === void 0 ? void 0 : (_cartDetails$prices$g = _cartDetails$prices.grand_total) === null || _cartDetails$prices$g === void 0 ? void 0 : _cartDetails$prices$g.value) == parseFloat(0) ? "true" : "false";

  var orderRouter = function orderRouter() {
    var headers = {};
    var postOrder = JSON.parse(JSON.stringify(mockRenderComponent.productOrderReq).replace(/\:null/gi, ':""')); //replace null with "" for all attributes

    postOrder.productOrder[0].externalId = cartId;
    postOrder.productOrder[0].journeyType = currentJourneyType;
    postOrder.productOrder[0].contact.identificationID = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber;
    postOrder.productOrder[0].contact.identificationType = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType;
    postOrder.productOrder[0]["removeStandalone"] = false;

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": "Bearer ".concat(vodAuthToken),
        "x-magento-token": "Bearer ".concat(authToken)
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    }

    var url = "".concat((config_default()).envConfigs[(config_default()).env].dxl.url).concat((config_default()).api.postpaidProductOrder);
    axios_default().post(url, postOrder, {
      headers: headers
    }).then(function (response) {
      if (response.data && response.data.productOrders[0]) {
        (0,helperServices/* setCookieConsentWrapper */.ol)("cookie_".concat((config_default()).order_id), [(config_default()).cookie_category.strictly_necessary], "document.cookie='".concat((config_default()).order_id, "=").concat(response.data.productOrders[0].productOrderId, ";path=/'"));
        DependencyHelper.Cookie.remove("cart_id");
        (0,helperServices/* hideSpinner */.v3)();
        navigate("orderConfirmation");
      } else {
        (0,helperServices/* hideSpinner */.v3)();
        handleApiFailure();
      }
    })["catch"](function (err) {
      (0,helperServices/* hideSpinner */.v3)();
      checkOrderCreation(err);
      handleApiFailure();
    });
  };

  function checkOrderCreation(result) {
    if (result.messages) {
      var len = result.messages.length;

      for (var i = 0; i < len; i++) {
        if (result.messages[i].key == "orderStatus" && (0,helperServices/* getOrderCreated */.Yn)(result.messages[i].message)) {
          DependencyHelper.Cookie.remove("cart_id");
        }
      }
    }
  }

  function handleApiFailure() {
    var pageName = "checkout: credit check: ".concat(customerStatus);
    setPageErr({
      type: "error",
      title: labels/* default.checkout.lbl_technical_error_title */.Z.checkout.lbl_technical_error_title,
      desc: labels/* default.checkout.lbl_technical_error_desc */.Z.checkout.lbl_technical_error_desc,
      primaryLabel: null,
      secondaryLabel: "Exit checkout",
      handlePrimaryClick: function handlePrimaryClick() {
        return _handlePrimaryClick(null, "exit checkout");
      },
      imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
      pageName: pageName,
      pageErrorType: "technical error"
    });
    navigate("pageError");
  }

  var _handlePrimaryClick = function _handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var placeOrder = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var shippingMethodData, paymentMethodData;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0,helperServices/* showSpinner */.yh)();
              _context2.next = 4;
              return (0,checkoutService/* setShippingMethodsOnCartService */.YD)(cartId, carrierCode, methodCode);

            case 4:
              shippingMethodData = _context2.sent;

              if (shippingMethodData.fail) {
                _context2.next = 12;
                break;
              }

              _context2.next = 8;
              return (0,checkoutService/* setPaymentMethod */.$P)(cartId, totalZero, paymentMethodCode);

            case 8:
              paymentMethodData = _context2.sent;

              if (!paymentMethodData.fail) {
                orderRouter();
              } else {
                (0,helperServices/* hideSpinner */.v3)();
                handleApiFailure();
              }

              _context2.next = 14;
              break;

            case 12:
              (0,helperServices/* hideSpinner */.v3)();
              handleApiFailure();

            case 14:
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);
              (0,helperServices/* hideSpinner */.v3)();
              handleApiFailure();

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 16]]);
    }));

    return function placeOrder() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    //display credit vetting outcome page if user clicks on back button on review page
    if (creditVettingDetails) {
      setCreditOutcome({
        visible: true,
        title: creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultTitle,
        desc: creditVettingDetails.resultText && creditVettingDetails.resultText !== "" ? creditVettingDetails.resultText : creditVettingDetails.resultHTML,
        screenType: creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode,
        iconType: creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.icon
      });
      continueDisable(false);

      if (multicartFlag && creditVettingDetails !== null && creditVettingDetails !== void 0 && creditVettingDetails.resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_offline.toUpperCase */.Z.creditVetting.lbl_resultcode_offline.toUpperCase()) || creditVettingDetails !== null && creditVettingDetails !== void 0 && creditVettingDetails.resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase */.Z.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase())) {
        getOrderSplitMessage(creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode);
        setShowOfflineData(true);
      }

      if (multicartFlag && creditVettingDetails !== null && creditVettingDetails !== void 0 && creditVettingDetails.resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_pended.toUpperCase */.Z.creditVetting.lbl_resultcode_pended.toUpperCase()) || creditVettingDetails !== null && creditVettingDetails !== void 0 && creditVettingDetails.resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_referred.toUpperCase */.Z.creditVetting.lbl_resultcode_referred.toUpperCase())) {
        getOrderSplitMessage(creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode);
        setShowDocsData(true);
      }

      if (multicartFlag && creditVettingDetails !== null && creditVettingDetails !== void 0 && creditVettingDetails.resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_pending.toUpperCase */.Z.creditVetting.lbl_resultcode_pending.toUpperCase())) {
        setShowDocsData(true);
      }

      setShowOnceOff(true); //redisplay once-off prices in Checkout Order Summary
    }
  }, [creditVettingDetails]);

  var setDoCreditButtonState = function setDoCreditButtonState(label, value) {
    setEditFormState(function (prevState) {
      return CheckoutCreditCheck_objectSpread(CheckoutCreditCheck_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, label, value));
    });
  };

  var scrollToTargetAdjusted = function scrollToTargetAdjusted(elementID) {
    var element = document.getElementById(elementID);
    var offset = 96;
    var bodyRect = document.body.getBoundingClientRect().top;
    var elementRect = element.getBoundingClientRect().top;
    var elementPosition = elementRect - bodyRect;
    var offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  };

  var enableEditContactDetails = function enableEditContactDetails(val) {
    setShowContactDetails(val);
    setTimeout(function () {
      scrollToTargetAdjusted("contact-detail-section");
    }, 50);
  };

  var enableEditEmploymentDetails = function enableEditEmploymentDetails(val) {
    setShowEmploymentDetails(val);
    setTimeout(function () {
      scrollToTargetAdjusted("employee-detail-section");
    }, 50);
  };

  var enableEditHomeDetails = function enableEditHomeDetails(val) {
    setShowHomeDetails(val);
    setTimeout(function () {
      scrollToTargetAdjusted("address-detail-section");
    }, 50);
  };

  var enableDebitDetails = function enableDebitDetails(value) {
    setShowDebitDetails(value);
    setTimeout(function () {
      scrollToTargetAdjusted("debit-detail-section");
    }, 100);
  };

  var enableEditDeliveryDetails = function enableEditDeliveryDetails(val) {
    setShowDeliveryDetails(val);
    setTimeout(function () {
      scrollToTargetAdjusted("delivery-detail-section");
    }, 100);
  };

  var enableConsentDetails = function enableConsentDetails(val) {
    setConsentDetails(val);
    setTimeout(function () {
      scrollToTargetAdjusted("consent-detail-section");
    }, 100);
  };

  var getOrderSplitMessage = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(resultCode) {
      var cbuApi, isPendedReferred, isOffline, _result$sections$, result, _result$sections$7, _result$sections$2, _result$sections$2$it, _result$sections$3, _result$sections$4, _result$sections$4$it, _result$sections$5, _result$sections$6, _result$sections$8, _result$sections$8$it, _result$sections$9, _result$sections$10;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cbuApi = "";
              isPendedReferred = false;
              isOffline = false;
              _context3.prev = 3;

              if (resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_pended.toUpperCase */.Z.creditVetting.lbl_resultcode_pended.toUpperCase()) || resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_referred.toUpperCase */.Z.creditVetting.lbl_resultcode_referred.toUpperCase())) {
                cbuApi = "pendedReferredSplitMessage";
                isPendedReferred = true;
              } else if (resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_offline.toUpperCase */.Z.creditVetting.lbl_resultcode_offline.toUpperCase()) || resultCode.toUpperCase().includes(labels/* default.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase */.Z.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase())) {
                cbuApi = "offlineSplitMessage";
                isOffline = true;
              }

              if (!cbuApi) {
                _context3.next = 10;
                break;
              }

              _context3.next = 8;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", cbuApi);

            case 8:
              result = _context3.sent;

              if (result !== null && result !== void 0 && (_result$sections$ = result.sections[0]) !== null && _result$sections$ !== void 0 && _result$sections$.items) {
                if (isPendedReferred) {
                  setSubmitDocMessage(result !== null && result !== void 0 && (_result$sections$2 = result.sections[0]) !== null && _result$sections$2 !== void 0 && (_result$sections$2$it = _result$sections$2.items[1]) !== null && _result$sections$2$it !== void 0 && _result$sections$2$it.description ? result === null || result === void 0 ? void 0 : (_result$sections$3 = result.sections[0]) === null || _result$sections$3 === void 0 ? void 0 : _result$sections$3.items[1].description : "");
                  setOrderSplitMessage("".concat(result !== null && result !== void 0 && (_result$sections$4 = result.sections[0]) !== null && _result$sections$4 !== void 0 && (_result$sections$4$it = _result$sections$4.items[0]) !== null && _result$sections$4$it !== void 0 && _result$sections$4$it.title ? "<strong>" + (result === null || result === void 0 ? void 0 : (_result$sections$5 = result.sections[0]) === null || _result$sections$5 === void 0 ? void 0 : _result$sections$5.items[0].title) + "</strong><br/>" : "") + (result === null || result === void 0 ? void 0 : (_result$sections$6 = result.sections[0]) === null || _result$sections$6 === void 0 ? void 0 : _result$sections$6.items[0].description));
                } else if (isOffline && result !== null && result !== void 0 && (_result$sections$7 = result.sections[1]) !== null && _result$sections$7 !== void 0 && _result$sections$7.items) {
                  setOrderSplitMessage("".concat(result !== null && result !== void 0 && (_result$sections$8 = result.sections[1]) !== null && _result$sections$8 !== void 0 && (_result$sections$8$it = _result$sections$8.items[0]) !== null && _result$sections$8$it !== void 0 && _result$sections$8$it.title ? "<strong>" + (result === null || result === void 0 ? void 0 : (_result$sections$9 = result.sections[1]) === null || _result$sections$9 === void 0 ? void 0 : _result$sections$9.items[0].title) + "</strong><br/>" : "") + (result === null || result === void 0 ? void 0 : (_result$sections$10 = result.sections[1]) === null || _result$sections$10 === void 0 ? void 0 : _result$sections$10.items[0].description));
                }
              }

            case 10:
              _context3.next = 14;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));

    return function getOrderSplitMessage(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["checkout-container"]),
      children: [!getCreditOutcome.visible && /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-wrapper"]),
        children: [showPersonalDetails && currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(personalDetails_PersonalDetails, {
            customerStatus: customerStatus,
            onFormSubmit: enableEditContactDetails,
            profileData: profileData ? profileData : null,
            doCreditCheckDisable: setDoCreditButtonState
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "contact-detail-section"
        }), !showContactDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-call-disable.svg"),
            img_alt: "section"
          }), "Contact details"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(contactDetails_ContactDetails, {
            customerStatus: customerStatus,
            onFormSubmit: enableEditEmploymentDetails,
            profileData: profileData ? profileData : null,
            currentJourneyType: currentJourneyType,
            doCreditCheckDisable: setDoCreditButtonState
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "employee-detail-section"
        }), !showEmploymentDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-career-disable.svg"),
            img_alt: "section",
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["section-icon"]
          }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine ? "Work details" : "Salary Details"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(employmentDetails_EmploymentDetails, {
            customerStatus: customerStatus,
            currentJourneyType: currentJourneyType,
            onFormSubmit: enableEditHomeDetails,
            doCreditCheckDisable: setDoCreditButtonState
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "address-detail-section"
        }), !showHomeDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-home-disable.svg"),
            img_alt: "section",
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["section-icon"]
          }), "Home address"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          id: "address-detail",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(homeDetails_HomeDetails, {
            customerStatus: customerStatus,
            addressTypes: addressTypes,
            statesTypes: statesTypes,
            onFormSubmit: currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine ? updateShowDebitDetails : enableDebitDetails,
            currentJourneyType: currentJourneyType,
            doCreditCheckDisable: setDoCreditButtonState
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "debit-detail-section"
        }), currentJourneyType != checkout_journey_context/* journeyType.addLine */.w.addLine && (!showDebitDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-bank-disable.svg"),
            img_alt: "section",
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["section-icon"]
          }), "Bank account details"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(debitDetails_DebitDetails, {
            customerStatus: customerStatus,
            setShowSnackBar: setShowSnackBar,
            setPageErr: setPageErr,
            navigate: navigate,
            onFormSubmit: enableEditDeliveryDetails,
            doCreditCheckDisable: setDoCreditButtonState,
            multicartFlag: multicartFlag
          })
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "delivery-detail-section"
        }), !showDeliveryDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/icon-delivery-disable.svg"),
            img_alt: "section",
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["section-icon"]
          }), "Delivery details"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(deliveryDetails_DeliveryDetails, {
            userLoggedIn: userLoggedIn,
            profileData: profileData,
            customerStatus: customerStatus,
            addressTypes: addressTypes,
            statesTypes: statesTypes,
            countryCode: countryCode,
            countryName: countryName,
            setShowSnackBar: setShowSnackBar,
            setPageErr: setPageErr,
            navigate: navigate,
            onFormSubmit: enableConsentDetails,
            carrierCode: carrierCode,
            methodCode: methodCode,
            currentJourneyType: currentJourneyType,
            doCreditCheckDisable: setDoCreditButtonState
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          id: "consent-detail-section"
        }), !showConsentDetails ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-heading"], " ").concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/consent-disable.svg"),
            img_alt: "section"
          }), "Credit check consent"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "".concat((checkoutCreditCheck_CheckoutCreditCheck_module_default())["form-body"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(consentResultDetails_ConsentResultDetails, {
            customerStatus: customerStatus,
            setShowSnackBar: setShowSnackBar,
            setPageErr: setPageErr,
            navigate: navigate,
            setCreditOutcome: setCreditOutcome,
            continueDisable: continueDisable,
            dealCategoryId: dealCategoryId,
            setShowDocsData: setShowDocsData,
            setShowOfflineData: setShowOfflineData,
            currentJourneyType: currentJourneyType,
            isDoCreditCheckDisable: doCreditCheckDisable,
            carrierCode: carrierCode,
            methodCode: methodCode,
            multicartFlag: multicartFlag,
            setShowOnceOff: setShowOnceOff
          })
        })]
      }), getCreditOutcome.visible && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(outcomeInformation_OutcomeInformation, {
          className: (checkoutCreditCheck_CheckoutCreditCheck_module_default()).information,
          title: getCreditOutcome.title,
          iconType: getCreditOutcome.iconType,
          description: getCreditOutcome.desc,
          formName: "credit-vetting-outcome",
          screenType: getCreditOutcome.screenType,
          customerStatus: customerStatus,
          setDisableBackButton: setDisableBackButton,
          handleHeading: handleHeading
        }), showDocsData && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
            contents: [submitDocMessage ? submitDocMessage : labels/* default.creditVetting.lbl_submit_docs_info */.Z.creditVetting.lbl_submit_docs_info],
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["standard-box"],
            id: "checkout-credit-check-status",
            iconType: "info-white"
          }), labels/* default.lbl_split_cart_notification_message */.Z.lbl_split_cart_notification_message, multicartFlag && !submitDocMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
            contents: [labels/* default.creditVetting.lbl_split_cart_notification_message */.Z.creditVetting.lbl_split_cart_notification_message],
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["standard-box"],
            id: "checkout-credit-check-status",
            iconType: "info-white"
          }), multicartFlag && orderSplitMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
            contents: [orderSplitMessage],
            className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["standard-box"],
            id: "checkout-cart-split-notification",
            iconType: "info-white"
          })]
        }), showOfflineData && multicartFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
          contents: [orderSplitMessage ? orderSplitMessage : labels/* default.creditVetting.lbl_split_cart_notification_message */.Z.creditVetting.lbl_split_cart_notification_message],
          className: (checkoutCreditCheck_CheckoutCreditCheck_module_default())["standard-box"],
          id: "checkout-cart-split-notification",
          iconType: "info-white"
        })]
      })]
    })
  });
});

var CheckoutCreditCheck_mapStateToProps = function mapStateToProps(state) {
  return {
    creditCheckDetails: state.creditCheckDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    cartDetails: state.cartDetails,
    creditVettingDetails: state.creditCheckDetails.creditVettingDetails,
    paymentMethodCode: state.checkoutDetails.paymentMethodCode
  };
};

var CheckoutCreditCheck_mapDispatchToProps = {
  setPostCheckoutCurrentStep: checkoutAction/* setPostCheckoutCurrentStep */.Gr
};
/* harmony default export */ var checkoutCreditCheck_CheckoutCreditCheck = ((0,DependencyHelper.connect)(CheckoutCreditCheck_mapStateToProps, CheckoutCreditCheck_mapDispatchToProps, null, {
  forwardRef: true
})(CheckoutCreditCheck));
// EXTERNAL MODULE: ./components/organisms/checkoutDelivery/CheckoutDelivery.jsx + 4 modules
var CheckoutDelivery = __webpack_require__(39986);
// EXTERNAL MODULE: ./components/organisms/checkoutReview/CheckoutReview.jsx + 5 modules
var CheckoutReview = __webpack_require__(38983);
// EXTERNAL MODULE: ./components/organisms/checkoutPayment/CheckoutPayment.jsx + 1 modules
var CheckoutPayment = __webpack_require__(88573);
// EXTERNAL MODULE: ./components/molecules/checkoutOrderSummary/CheckoutOrderSummary.jsx + 1 modules
var CheckoutOrderSummary = __webpack_require__(15681);
// EXTERNAL MODULE: ./components/organisms/checkoutOrderConfirmation/CheckoutOrderConfirmation.jsx + 3 modules
var CheckoutOrderConfirmation = __webpack_require__(34161);
// EXTERNAL MODULE: ./components/organisms/checkoutPaymentError/CheckoutPaymentError.jsx
var CheckoutPaymentError = __webpack_require__(58651);
// EXTERNAL MODULE: ./components/atoms/pageDescription/PageDescription.jsx
var PageDescription = __webpack_require__(5241);
// EXTERNAL MODULE: ./components/atoms/formRightSidebar/FormRightSidebar.module.scss
var FormRightSidebar_module = __webpack_require__(43092);
var FormRightSidebar_module_default = /*#__PURE__*/__webpack_require__.n(FormRightSidebar_module);
;// CONCATENATED MODULE: ./components/atoms/formRightSidebar/FormRightSidebar.jsx


function FormRightSidebar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FormRightSidebar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FormRightSidebar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FormRightSidebar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var FormRightSidebar = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var content = _ref.content,
      heading = _ref.heading,
      formName = _ref.formName,
      pageName = _ref.pageName,
      pageChannel = _ref.pageChannel,
      linkId = _ref.linkId,
      linkPrevent = _ref.linkPrevent;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var mainHeading = content ? content.title : heading;
  var items = content ? content.items : [];
  var linkButton = content ? {
    title: content.callToActionLabel,
    href: content.callToActionUri
  } : {};

  var handleClick = function handleClick(event) {
    if (linkPrevent) {
      event.preventDefault();
    }

    if (pageName && formName && pageChannel) {
      analyticsUtag/* link */.p4(FormRightSidebar_objectSpread(FormRightSidebar_objectSpread({
        page_name: "".concat(pageName),
        page_channel: "".concat(pageChannel),
        page_master_tab: "personal"
      }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
        link_type: "o",
        link_name: "".concat(pageName, ": ").concat(formName)
      }));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((FormRightSidebar_module_default()).container),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FormRightSidebar_module_default()).heading,
        children: mainHeading
      }), items.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FormRightSidebar_module_default()).content,
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (FormRightSidebar_module_default()).item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: item.icon
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
            })]
          }, index);
        })
      }), (linkButton === null || linkButton === void 0 ? void 0 : linkButton.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FormRightSidebar_module_default())["link-button"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CTAButton["default"], {
          variant: "outline grey",
          id: linkId,
          url: linkButton.href ? (0,helperServices/* internalUrl */.az)(linkButton.href).url : "#",
          handleClick: handleClick,
          children: [linkButton.title, /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(imagePrefix, "/assets/images/caret-right-blue.svg")
          })]
        })
      })]
    })
  });
});
FormRightSidebar.defaultProps = {
  heading: "Wondering what to expect?",
  content: {},
  formName: null,
  pageName: null,
  pageChannel: null,
  linkId: "link-cta-btn",
  linkPrevent: false
};
/* harmony default export */ var formRightSidebar_FormRightSidebar = (FormRightSidebar);
// EXTERNAL MODULE: ./components/atoms/loginModal/LoginModal.jsx
var LoginModal = __webpack_require__(24671);
// EXTERNAL MODULE: ./components/molecules/syncError/SyncError.jsx
var SyncError = __webpack_require__(54047);
// EXTERNAL MODULE: ./components/organisms/paymentRedirect/PaymentRedirect.jsx
var PaymentRedirect = __webpack_require__(11972);
// EXTERNAL MODULE: ./components/atoms/checkoutPageError/CheckoutPageError.jsx + 1 modules
var CheckoutPageError = __webpack_require__(76284);
// EXTERNAL MODULE: ./components/organisms/checkoutPage/CheckoutPage.module.scss
var CheckoutPage_module = __webpack_require__(52923);
var CheckoutPage_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutPage_module);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./services/pageService.js
var pageService = __webpack_require__(76173);
// EXTERNAL MODULE: ./components/atoms/Seo/Seo.js
var Seo = __webpack_require__(22505);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/molecules/infoWithButton/InfoWithButton.module.scss
var InfoWithButton_module = __webpack_require__(1421);
var InfoWithButton_module_default = /*#__PURE__*/__webpack_require__.n(InfoWithButton_module);
;// CONCATENATED MODULE: ./components/molecules/infoWithButton/InfoWithButton.jsx






var InfoWithButton = function InfoWithButton(_ref) {
  var title = _ref.title,
      description = _ref.description,
      buttonText = _ref.buttonText,
      buttonHandler = _ref.buttonHandler,
      containerClass = _ref.containerClass;

  var _handleClick = function handleClick(e) {
    e.preventDefault();
    buttonHandler(buttonText);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((InfoWithButton_module_default()).container, " ").concat(containerClass),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (InfoWithButton_module_default()).title,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (InfoWithButton_module_default()).description,
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
      variant: "link black",
      className: (InfoWithButton_module_default()).button,
      handleClick: function handleClick(e) {
        return _handleClick(e);
      },
      children: buttonText
    })]
  });
};

/* harmony default export */ var infoWithButton_InfoWithButton = (InfoWithButton);
// EXTERNAL MODULE: ./components/molecules/otpInput/OtpInput.jsx + 1 modules
var OtpInput = __webpack_require__(19899);
// EXTERNAL MODULE: ./components/molecules/otpComponent/OtpComponent.module.scss
var OtpComponent_module = __webpack_require__(69739);
var OtpComponent_module_default = /*#__PURE__*/__webpack_require__.n(OtpComponent_module);
;// CONCATENATED MODULE: ./components/molecules/otpComponent/OtpComponent.jsx










var OtpComponent = function OtpComponent(_ref) {
  var title = _ref.title,
      otpValue = _ref.otpValue,
      otpHandler = _ref.otpHandler,
      primaryButtonText = _ref.primaryButtonText,
      primaryButtonStyle = _ref.primaryButtonStyle,
      primaryButtonHandler = _ref.primaryButtonHandler,
      secondaryButtonText = _ref.secondaryButtonText,
      secondaryButtonHandler = _ref.secondaryButtonHandler,
      primaryButtonDisabled = _ref.primaryButtonDisabled,
      secondaryButtonDisabled = _ref.secondaryButtonDisabled,
      secondaryButtonStyle = _ref.secondaryButtonStyle,
      showBackButton = _ref.showBackButton,
      backButtonText = _ref.backButtonText,
      handleBackButton = _ref.handleBackButton,
      containerClass = _ref.containerClass;

  var _useState = (0,react.useState)("password"),
      otpFieldType = _useState[0],
      setOtpFieldType = _useState[1];

  var imagePrefix = (config_default()).envConfigs[(config_default()).env].imagePrefix;

  var otpShowHideToggle = function otpShowHideToggle() {
    setOtpFieldType(otpFieldType === "text" ? "password" : "text");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((OtpComponent_module_default()).container, " ").concat(containerClass),
    children: [showBackButton && /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
      className: "".concat((OtpComponent_module_default())["back-button"]),
      labelText: backButtonText,
      img_url_inactive: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
      img_url_active: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
      img_url_disable: "".concat(imagePrefix, "/assets/images/disable-caret-back.svg"),
      clickHandler: handleBackButton,
      id: "checkout-upgrade-back"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (OtpComponent_module_default()).title,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtpInput/* default */.Z, {
      autoFocus: true,
      isNumberInput: true,
      length: 6,
      className: (OtpComponent_module_default()).otpContainer,
      inputClassName: (OtpComponent_module_default()).otpInput,
      otpValues: otpValue,
      setOTPValues: otpHandler,
      otpFieldType: otpFieldType,
      setOtpFieldType: setOtpFieldType
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (OtpComponent_module_default())["show-otp-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: otpFieldType === "text" ? "".concat(imagePrefix, "/assets/images/hide.svg") : "".concat(imagePrefix, "/assets/images/show.svg"),
          alt: "",
          width: 20,
          height: 20
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
        handleClick: otpShowHideToggle,
        variant: "flat teal51",
        className: (OtpComponent_module_default())["show-otp"],
        children: otpFieldType === "text" ? "Hide OTP" : "Show OTP"
      })]
    }), primaryButtonText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OtpComponent_module_default()).buttonContainer,
      children: [primaryButtonText && /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
        variant: primaryButtonStyle,
        className: "".concat((OtpComponent_module_default()).continueBtn),
        handleClick: primaryButtonHandler,
        disabled: primaryButtonDisabled,
        children: primaryButtonText
      }), secondaryButtonText && /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
        variant: secondaryButtonStyle,
        className: "".concat((OtpComponent_module_default()).continueBtn, " py-0"),
        handleClick: function handleClick() {
          return secondaryButtonHandler(secondaryButtonText);
        },
        disabled: secondaryButtonDisabled,
        children: secondaryButtonText
      })]
    })]
  });
};

/* harmony default export */ var otpComponent_OtpComponent = (OtpComponent);
// EXTERNAL MODULE: ./components/organisms/checkoutMahAuthentication/CheckoutMahAuthentication.module.scss
var CheckoutMahAuthentication_module = __webpack_require__(6564);
var CheckoutMahAuthentication_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutMahAuthentication_module);
// EXTERNAL MODULE: ./components/atoms/upgradeDropdown/UpgradeDropdown.jsx + 1 modules
var UpgradeDropdown = __webpack_require__(51969);
// EXTERNAL MODULE: ./components/molecules/numberCheckComponent/NumberCheckComponent.module.scss
var NumberCheckComponent_module = __webpack_require__(99335);
var NumberCheckComponent_module_default = /*#__PURE__*/__webpack_require__.n(NumberCheckComponent_module);
;// CONCATENATED MODULE: ./components/molecules/numberCheckComponent/NumberCheckComponent.jsx
var _require = __webpack_require__(79549),
    NumberCheckComponent_CTAButton = _require["default"];

var _require2 = __webpack_require__(28658),
    CustomContainer = _require2.CustomContainer;







var NumberCheckComponent = function NumberCheckComponent(_ref) {
  var selectedNumber = _ref.selectedNumber,
      numberList = _ref.numberList,
      handleNumberSelect = _ref.handleNumberSelect,
      buttonDisabled = _ref.buttonDisabled,
      buttonHandler = _ref.buttonHandler,
      buttonStyle = _ref.buttonStyle,
      buttonText = _ref.buttonText,
      checkValue = _ref.checkValue,
      checkBoxText = _ref.checkBoxText,
      checkBoxHandler = _ref.checkBoxHandler,
      showCheckBox = _ref.showCheckBox;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CustomContainer, {
    className: (NumberCheckComponent_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeDropdown/* default */.Z, {
      containerclass: (NumberCheckComponent_module_default())["dropdown-container"],
      selectedValue: selectedNumber,
      optionsList: numberList,
      handleSelect: handleNumberSelect,
      selectClass: "mt-0"
    }), showCheckBox && /*#__PURE__*/(0,jsx_runtime.jsxs)(CustomContainer, {
      className: (NumberCheckComponent_module_default()).checkboxContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
        isChecked: !!checkValue,
        id: "checkbox1",
        click: checkBoxHandler
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (NumberCheckComponent_module_default()).checkboxText,
        children: checkBoxText
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CustomContainer, {
      className: (NumberCheckComponent_module_default()).buttonContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NumberCheckComponent_CTAButton, {
        variant: buttonStyle,
        className: "".concat((NumberCheckComponent_module_default()).continueBtn),
        handleClick: function handleClick() {
          buttonHandler(buttonText);
        },
        disabled: buttonDisabled,
        children: buttonText
      })
    })]
  });
};

/* harmony default export */ var numberCheckComponent_NumberCheckComponent = (NumberCheckComponent);
;// CONCATENATED MODULE: ./components/organisms/checkoutMahAuthentication/CheckoutMahAuthentication.jsx




function CheckoutMahAuthentication_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CheckoutMahAuthentication_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CheckoutMahAuthentication_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CheckoutMahAuthentication_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var CheckoutMahAuthentication = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var authDetailsData = _ref.authDetailsData,
      setShowTooltip = _ref.setShowTooltip,
      continueDisable = _ref.continueDisable,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      customerStatus = _ref.customerStatus,
      setPageErr = _ref.setPageErr,
      navigate = _ref.navigate,
      upgradeResponse = _ref.upgradeResponse,
      handleHeading = _ref.handleHeading,
      currentJourney = _ref.currentJourney,
      dealID = _ref.dealID,
      multicartFlag = _ref.multicartFlag,
      numberTransferEnabled = _ref.numberTransferEnabled;

  var _useState = (0,react.useState)(Array(6).fill("")),
      otp = _useState[0],
      setOtp = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showSnackBar = _useState2[0],
      setShowSnackBar = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      invalidAttempts = _useState3[0],
      setInvalidAttempts = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      otpCheckBox = _useState4[0],
      setOtpCheckBox = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      otpSent = _useState5[0],
      setOtpSent = _useState5[1];

  var _useState6 = (0,react.useState)(),
      newOtp = _useState6[0],
      setNewOtp = _useState6[1];

  var _useState7 = (0,react.useState)(),
      selectedNumber = _useState7[0],
      setSelectedNumber = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      selectedmaskedNumber = _useState8[0],
      setSelectedmaskedNumber = _useState8[1];

  var _useState9 = (0,react.useState)({
    visible: false
  }),
      showResult = _useState9[0],
      setShowResult = _useState9[1];

  var _useState10 = (0,react.useState)([]),
      allPreviligedNumbers = _useState10[0],
      setAllPreviligedNumbers = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      selectAnotherOtpNumber = _useState11[0],
      setSelectAnotherOtpNumber = _useState11[1];

  var analyticsPageName = "lets get started";
  var dispatch = (0,DependencyHelper.useDispatch)();
  var router = (0,DependencyHelper.useRouter)();
  var addOnlineLeadType = "verification_of_existing_customer_addon_line_otp";
  var leadFormUrl = "".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce");
  (0,react.useEffect)(function () {
    if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine) {
      upgradeResponse.mah = true;
      handleHeading("update", "title", "".concat(labels/* default.post_checkout.otp_authentication.lbl_main_heading */.Z.post_checkout.otp_authentication.lbl_main_heading));
    }
  }, []);
  (0,react.useEffect)(function () {
    var _authDetailsData$info, _authDetailsData$info2;

    if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : (_authDetailsData$info = authDetailsData.information) === null || _authDetailsData$info === void 0 ? void 0 : (_authDetailsData$info2 = _authDetailsData$info.authorisedNumbers) === null || _authDetailsData$info2 === void 0 ? void 0 : _authDetailsData$info2.length) > 0) {
      var _authDetailsData$info3, _authDetailsData$info4;

      if ((authDetailsData === null || authDetailsData === void 0 ? void 0 : (_authDetailsData$info3 = authDetailsData.information) === null || _authDetailsData$info3 === void 0 ? void 0 : (_authDetailsData$info4 = _authDetailsData$info3.authorisedNumbers) === null || _authDetailsData$info4 === void 0 ? void 0 : _authDetailsData$info4.length) === 1) {
        var _authDetailsData$info5, _authDetailsData$info6;

        var numberSelected = authDetailsData === null || authDetailsData === void 0 ? void 0 : (_authDetailsData$info5 = authDetailsData.information) === null || _authDetailsData$info5 === void 0 ? void 0 : (_authDetailsData$info6 = _authDetailsData$info5.authorisedNumbers[0]) === null || _authDetailsData$info6 === void 0 ? void 0 : _authDetailsData$info6.standardFormat;
        resendOTP(numberSelected);
        setSelectedNumber(numberSelected);
        setSelectedmaskedNumber((0,upgradeService/* maskMsisdn */.Ly)(numberSelected));
      } else {
        var _authDetailsData$info7;

        if (upgradeResponse.mah) {
          if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine) {
            handleHeading("hide", "desc");
          } else {
            handleHeading("update", "desc", labels/* default.mah_authentication.lbl_will_send_otp */.Z.mah_authentication.lbl_will_send_otp);
          }
        } else {
          handleHeading("update", "title", labels/* default.mah_authentication.lbl_mah_auth */.Z.mah_authentication.lbl_mah_auth);
          handleHeading("update", "desc", labels/* default.mah_authentication.lbl_mah_auth_desc */.Z.mah_authentication.lbl_mah_auth_desc);
        }

        var numbersList = authDetailsData === null || authDetailsData === void 0 ? void 0 : (_authDetailsData$info7 = authDetailsData.information) === null || _authDetailsData$info7 === void 0 ? void 0 : _authDetailsData$info7.authorisedNumbers.map(function (item, key) {
          return {
            id: item === null || item === void 0 ? void 0 : item.standardFormat,
            label: (0,upgradeService/* maskMsisdn */.Ly)(item === null || item === void 0 ? void 0 : item.standardFormat)
          };
        });
        setAllPreviligedNumbers(numbersList);
        setSelectedNumber(numbersList[0].id);
        setSelectedmaskedNumber((0,upgradeService/* maskMsisdn */.Ly)(numbersList[0].label));
      }

      analyticsUtag/* view */.ei(CheckoutMahAuthentication_objectSpread({
        page_event: "view",
        page_name: "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus, " ").concat(currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine ? "send otp" : "enter otp"),
        page_channel: "checkout",
        page_master_tab: "personal",
        multicart_flag: multicartFlag ? true : false
      }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
    }
  }, [authDetailsData]);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus, ": continue")
        });
        continueDisable(true);

        if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine) {
          //check prevalidation and navigate to credit check
          preValidationCheck(checkout_journey_context/* journeyType.addLine */.w.addLine, "creditCheck");
        } else {
          //check prevalidation and navigate to (Number transfer if it is enabled or delivery details)
          preValidationCheck(checkout_journey_context/* journeyType.upgrade */.w.upgrade, "delivery");
        }
      },
      back: function back() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus, ": back to lets get started")
        });
      }
    };
  });

  var _handlePrimaryClick = function handlePrimaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    ctaAnalytics(label);
    var navigateUrl = url === "/" ? url : "".concat(helperServices/* urlPrefix */.wn).concat(url);

    if (url) {
      if (label.includes(labels/* default.mah_authentication.lbl_pay_my_bill */.Z.mah_authentication.lbl_pay_my_bill)) {
        router.push(url).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
        return;
      }

      router.push(navigateUrl).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/forms/ecommerce")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var _handleSecondaryClick = function handleSecondaryClick(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    ctaAnalytics(label);
    var navigateUrl = url === "/" ? url : "".concat(helperServices/* urlPrefix */.wn).concat(url);

    if (url) {
      if (label.includes(labels/* default.mah_authentication.lbl_pay_my_bill */.Z.mah_authentication.lbl_pay_my_bill)) {
        router.push(url).then(function () {
          (0,helperServices/* hideSpinner */.v3)();
        });
        return;
      }

      router.push(navigateUrl).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(resultCode, pageName, pageErrorType) {
      var additionalUtagData,
          preferences,
          newResultCode,
          _result$0$primaryCTAU,
          result,
          _args = arguments;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              additionalUtagData = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
              preferences = _args.length > 4 && _args[4] !== undefined ? _args[4] : [];
              newResultCode = multicartFlag ? resultCode + "_multicart" : resultCode;
              setShowTooltip({
                visible: false,
                message: ""
              });
              _context.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              _context.next = 8;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [newResultCode]);

            case 8:
              result = _context.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                primaryUrl: result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                secondaryLabel: result[0].secondaryEnabled === "Yes" ? result[0].secondaryCTAText : null,
                secondaryUrl: result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                  return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].primaryCTAURL, result[0].leadType, result[0].primaryCTAType, preferenceId), result[0].primaryCTAText);
                },
                handleSecondaryClick: function handleSecondaryClick() {
                  return _handleSecondaryClick((0,helperServices/* generateFormURL */.Pj)(result[0].secondaryCTAURL, result[0].leadType, result[0].secondaryCTAType), result[0].secondaryCTAText);
                },
                imgUrl: result[0].icon,
                pageName: pageName,
                pageErrorType: pageErrorType ? pageErrorType : result[0].analyticTitle !== resultCode ? result[0].analyticTitle : "technical error",
                additionalUtagData: additionalUtagData,
                dividerLine: result[0].CTATitle != "" ? true : false,
                ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
                disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
                preferences: multicartFlag ? preferences : [],
                defaultPreference: multicartFlag && (_result$0$primaryCTAU = result[0].primaryCTAURL) !== null && _result$0$primaryCTAU !== void 0 && _result$0$primaryCTAU.includes("/checkout") ? "once-off" : null
              });
              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");
              _context.next = 19;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              if (multicartFlag) {
                setPageErr({
                  type: "error",
                  title: labels/* default.checkout.lbl_invalid_attempt_title */.Z.checkout.lbl_invalid_attempt_title,
                  desc: labels/* default.checkout.lbl_invalid_attempt_desc */.Z.checkout.lbl_invalid_attempt_desc,
                  primaryLabel: "Continue",
                  secondaryLabel: null,
                  handlePrimaryClick: function handlePrimaryClick(preferenceId) {
                    return _handlePrimaryClick((0,helperServices/* generateFormURL */.Pj)("/forms/ecommerce", "pre_validation_checks", "lead", preferenceId), "continue");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType ? pageErrorType : "technical error",
                  additionalUtagData: additionalUtagData,
                  dividerLine: true,
                  ctaTitle: labels/* default.checkout.lbl_select_preference */.Z.checkout.lbl_select_preference,
                  disablePrimary: true,
                  preferences: labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values
                });
              } else {
                setPageErr({
                  type: "error",
                  title: labels/* default.auth.lbl_technical_error_title */.Z.auth.lbl_technical_error_title,
                  desc: labels/* default.auth.lbl_technical_error_desc */.Z.auth.lbl_technical_error_desc,
                  primaryLabel: "Call me back",
                  secondaryLabel: "Exit checkout",
                  handlePrimaryClick: function handlePrimaryClick() {
                    return _handlePrimaryClick(null, "call me back");
                  },
                  handleSecondaryClick: function handleSecondaryClick() {
                    return _handleSecondaryClick(null, "exit checkout");
                  },
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: pageName,
                  pageErrorType: pageErrorType ? pageErrorType : "technical error",
                  additionalUtagData: additionalUtagData
                });
              }

              (0,helperServices/* hideSpinner */.v3)(); //navigate to checkout page error

              navigate("pageError");

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }));

    return function fetchErrorDetails(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var preValidationCheck = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(journey, page) {
      var idNumber, results, newPage, pageErrorType, _pageErrorType, _results$errors;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              idNumber = authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber;
              _context2.next = 4;
              return (0,checkoutService/* preValidationCheckService */.ak)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType, idNumber, dealID, journey);

            case 4:
              results = _context2.sent;
              (0,helperServices/* hideSpinner */.v3)();

              if (results !== null && results !== void 0 && results.responseCode) {
                if (journey == checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  dispatch({
                    type: actionTypes/* SET_SKIP_CREDIT_VETTING */.CI,
                    payload: results.skipCreditVetting
                  });

                  if (results.responseCode == "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE") {
                    dispatch({
                      type: actionTypes/* ADD_CREDIT_PROFILE */.DJ,
                      payload: results.creditFilters
                    });
                    dispatch({
                      type: actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1,
                      payload: true
                    });
                  } else {
                    dispatch({
                      type: actionTypes/* SET_CREDIT_CHECK_AFFORD_DEAL */.n1,
                      payload: false
                    });
                  }

                  if ((0,helperServices/* preValidationEligible */.jW)(results.responseCode)) {
                    newPage = page == "creditCheck" && results.skipCreditVetting ? "review" : page;
                    navigate(newPage);
                  } else {
                    pageErrorType = (0,helperServices/* getPreValidationErrorType */.uf)(results.responseCode);
                    logger/* Logger.info */.Y.info("Prevalidation check returned code ".concat(results.responseCode), "CheckoutMahAuthentication", {
                      TagErrorType: pageErrorType || "not returned",
                      ServiceResponseCode: results.responseCode,
                      response: JSON.stringify(results || {}),
                      data: {
                        idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
                        idNumber: idNumber,
                        dealID: dealID,
                        journey: journey
                      }
                    }, {
                      preval_result_code: results.responseCode
                    });
                    fetchErrorDetails(results.responseCode, "checkout: pre val: ".concat(customerStatus), pageErrorType, "authentication_id_type");
                  }
                } else {
                  //upgrade checkout
                  if ((0,helperServices/* preValidationUpgradeEligible */.qH)(results.responseCode)) {
                    navigate(page);
                  } else {
                    _pageErrorType = (0,helperServices/* getPreValidationErrorType */.uf)(results.responseCode);
                    logger/* Logger.info */.Y.info("Prevalidation check returned code ".concat(results.responseCode), "CheckoutMahAuthentication", {
                      TagErrorType: _pageErrorType || "not returned",
                      ServiceResponseCode: results.responseCode,
                      response: JSON.stringify(results || {}),
                      data: {
                        idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
                        idNumber: idNumber,
                        dealID: dealID,
                        journey: journey
                      }
                    }, {
                      preval_result_code: results.responseCode
                    });
                    fetchErrorDetails(results.responseCode, "checkout: pre val: ".concat(customerStatus), _pageErrorType, "authentication_id_type");
                  }
                }
              } else {
                fetchErrorDetails("preValidation_".concat((_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : _results$errors.status), "checkout: pre val: ".concat(customerStatus), "technical error", "authentication_id_type", labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                logger/* Logger.error */.Y.error("No pre validation response code returned", "CheckoutMahAuthentication", {
                  response: JSON.stringify(results || {}),
                  data: {
                    idType: authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType,
                    idNumber: idNumber,
                    dealID: dealID,
                    journey: journey
                  }
                });
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function preValidationCheck(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var cantReciveOtpButtonHandler = function cantReciveOtpButtonHandler(label) {
    ctaAnalytics(label);

    if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine && (label.toLowerCase() == "call me back" || label.toLowerCase() == labels/* default.mah_authentication.lbl_cant_receive_otp.toLowerCase */.Z.mah_authentication.lbl_cant_receive_otp.toLowerCase())) {
      (0,helperServices/* showSpinner */.yh)();
      router.push((0,helperServices/* generateFormURL */.Pj)(leadFormUrl, addOnlineLeadType, "lead")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      fetchErrorDetails("upgradecheckout_cant_generate_otp", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "can't otp", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
    }
  };

  var getUtagViewData = function getUtagViewData() {
    return analyticsUtag/* getUtagData */.GS(["visitor_customer_id", "visitor_id_hash", "visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "multicart_flag"]);
  };

  var ctaAnalytics = function ctaAnalytics(label) {
    if (label) {
      var pageName = currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine ? "checkout: ".concat(analyticsPageName, ": ec") : analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;

      if (label.toLowerCase() == "resend otp") {
        analyticsUtag/* link */.p4(CheckoutMahAuthentication_objectSpread({
          page_tool_event: "use",
          page_tool_name: "".concat(pageName, ": ").concat(label.toLowerCase())
        }, getUtagViewData()));
      } else {
        analyticsUtag/* link */.p4(CheckoutMahAuthentication_objectSpread({
          link_type: "o",
          link_name: "".concat(pageName, ": ").concat(label)
        }, getUtagViewData()));
      }
    }
  };

  var validateOTP = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var otpValue, urlParams, responseData, occurance, _responseData$respons, _responseData$respons2;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              otpValue = otp.join("");
              _context3.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              ctaAnalytics(" Validate OTP");
              setShowTooltip({
                visible: false,
                message: ""
              });
              urlParams = "?idNumber=".concat(authDetailsData.idNumber, "&docType=").concat(authDetailsData.idType, "&maskedMsisdn=").concat((0,upgradeService/* newMaskMsisdn */.Ls)(selectedNumber), "&otp=").concat(otpValue);
              _context3.next = 8;
              return microServices/* default.post */.Z.post("api", "authenticateAlternativeNumber", {}, null, false, null, urlParams);

            case 8:
              responseData = _context3.sent;

              if (responseData.fail) {
                if (responseData.error.status === 401) {
                  occurance = invalidAttempts + 1;
                  setInvalidAttempts(occurance);

                  if (invalidAttempts === 0) {
                    displayTooltip(labels/* default.upgrade.lbl_invalid_otp_try_1 */.Z.upgrade.lbl_invalid_otp_try_1, occurance);
                  } else {
                    displayTooltip(labels/* default.upgrade.lbl_invalid_otp_try_2 */.Z.upgrade.lbl_invalid_otp_try_2, occurance);
                  }

                  setOtp(Array(6).fill(""));
                } else if (responseData.error.status === 400) {
                  fetchErrorDetails("upgradecheckout_max_invalid_otps", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "otp failed third time");
                } else if (responseData.error.status === 404) {
                  fetchErrorDetails("upgradecheckout_technical_error", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                } else {
                  fetchErrorDetails("upgradecheckout_technical_error", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
                }
              } else {
                handleHeading("hide", "desc");
                setShowResult({
                  visible: true,
                  analyticsType: "success",
                  iconType: "success",
                  title: currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine ? labels/* default.post_checkout.otp_authentication.lbl_otp_success */.Z.post_checkout.otp_authentication.lbl_otp_success : labels/* default.mah_authentication.lbl_success_title */.Z.mah_authentication.lbl_success_title
                });
                continueDisable(false); //Create cookie with JWT token here

                (0,helperServices/* setCookieConsentWrapper */.ol)("vod-web-auth-otp-token", [(config_default()).cookie_category.strictly_necessary], "document.cookie='vod-web-auth-otp-token=".concat((_responseData$respons = responseData.response) === null || _responseData$respons === void 0 ? void 0 : (_responseData$respons2 = _responseData$respons.data) === null || _responseData$respons2 === void 0 ? void 0 : _responseData$respons2.result, ";path=/'"));
              }

              _context3.next = 16;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](1);
              (0,helperServices/* hideSpinner */.v3)();
              fetchErrorDetails("upgradecheckout_technical_error", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);

            case 16:
              _context3.prev = 16;
              (0,helperServices/* hideSpinner */.v3)();
              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 12, 16, 19]]);
    }));

    return function validateOTP() {
      return _ref4.apply(this, arguments);
    };
  }();

  var resendOTP = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(maskedMsisdn) {
      var label,
          urlParams,
          responseData,
          _args4 = arguments;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              label = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : "";

              if (label) {
                ctaAnalytics(label);
              }

              setShowTooltip({
                visible: false,
                message: ""
              });
              setOtp(Array(6).fill(""));
              _context4.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              urlParams = "?idNumber=".concat(authDetailsData.idNumber, "&docType=").concat(authDetailsData.idType, "&maskedMsisdn=").concat((0,upgradeService/* newMaskMsisdn */.Ls)(maskedMsisdn));
              _context4.next = 9;
              return microServices/* default.post */.Z.post("api", "generateOtp", {}, null, false, null, urlParams);

            case 9:
              responseData = _context4.sent;

              if (responseData.fail) {
                fetchErrorDetails("upgradecheckout_technical_error", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);
              } else {
                if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine) {
                  handleHeading("show", "desc");
                  handleHeading("update", "desc", "".concat(labels/* default.post_checkout.otp_authentication.lbl_sub_heading */.Z.post_checkout.otp_authentication.lbl_sub_heading, " ").concat((0,upgradeService/* maskMsisdn */.Ly)(maskedMsisdn)).concat(labels/* default.post_checkout.otp_authentication.lbl_sub_heading_2 */.Z.post_checkout.otp_authentication.lbl_sub_heading_2));
                  analyticsUtag/* view */.ei(CheckoutMahAuthentication_objectSpread({
                    page_event: "view",
                    page_name: "checkout: ".concat(analyticsPageName, ": ec enter otp"),
                    page_channel: "checkout",
                    page_master_tab: "personal",
                    multicart_flag: multicartFlag ? true : false
                  }, analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData, authDetailsData)));
                } else {
                  handleHeading("update", "desc", "".concat(labels/* default.mah_authentication.lbl_otp_sent_desc_1 */.Z.mah_authentication.lbl_otp_sent_desc_1, " ").concat((0,upgradeService/* maskMsisdn */.Ly)(maskedMsisdn)).concat(labels/* default.mah_authentication.lbl_otp_sent_desc_2 */.Z.mah_authentication.lbl_otp_sent_desc_2));
                }

                if (!otpSent) {
                  setOtpSent(true);
                }

                if (otpSent) {
                  setShowSnackBar(true);
                }
              }

              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](4);
              (0,helperServices/* hideSpinner */.v3)();
              fetchErrorDetails("upgradecheckout_technical_error", "checkout: ".concat(analyticsPageName, ": ").concat(customerStatus), "siebel", null, labels/* default.checkout.lbl_preference_values */.Z.checkout.lbl_preference_values);

            case 17:
              _context4.prev = 17;
              (0,helperServices/* hideSpinner */.v3)();
              return _context4.finish(17);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 13, 17, 20]]);
    }));

    return function resendOTP(_x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine && !otpSent) {
      handleHeading("hide", "desc");
    }
  }, [otpSent]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return closeSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  var displayTooltip = function displayTooltip(message, occurance) {
    setShowTooltip({
      visible: true,
      message: message
    });
    var occurance_word = "";

    if (occurance == 1) {
      occurance_word = "once";
    } else if (occurance == 2) {
      occurance_word = "twice";
    } else if (occurance >= 3) {
      occurance_word = "thrice";
    }

    analyticsUtag/* view */.ei(CheckoutMahAuthentication_objectSpread(CheckoutMahAuthentication_objectSpread({}, getUtagViewData()), {}, {
      page_name: "checkout: ".concat(analyticsPageName, ":  ").concat(customerStatus, ": otp failed ").concat(occurance_word)
    }));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar(false);
  };

  (0,react.useEffect)(function () {
    var numArray = [];

    for (var i = 0; i < otp.length; i++) {
      if (otp[i] != "") {
        numArray.push(otp[i]);
      }
    }

    setNewOtp(numArray);
  }, [otp]);

  var handleNumberSelect = function handleNumberSelect(value) {
    if (value !== selectedmaskedNumber && selectAnotherOtpNumber) {
      setSelectAnotherOtpNumber(false);
      setInvalidAttempts(0); //reset since the user chose another number
    }

    setSelectedmaskedNumber(value);
    var foundval = allPreviligedNumbers.find(function (item) {
      return item.label === value;
    });
    setSelectedNumber(foundval.id);
  };

  var updateCheckBox = function updateCheckBox() {
    setOtpCheckBox(!otpCheckBox);
    var pageName = currentJourney == checkout_journey_context/* journeyType.addLine */.w.addLine ? "checkout: ".concat(analyticsPageName, ": ec") : analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4(CheckoutMahAuthentication_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": ").concat(otpCheckBox ? "I can't use sms" : "I can use sms")
    }, getUtagViewData()));
  };

  var numberButtonHandler = function numberButtonHandler(label) {
    if (otpCheckBox) {
      resendOTP(selectedNumber, label);
    } else {
      cantReciveOtpButtonHandler(label);
    }
  };

  var handleSendOtpToAnotherNumber = function handleSendOtpToAnotherNumber() {
    setOtpSent(false);
    ctaAnalytics("Send OTP to another number");
    setSelectAnotherOtpNumber(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (CheckoutMahAuthentication_module_default()).container,
    children: [showSnackBar && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: labels/* default.upgrade.lbl_otp_resent_info */.Z.upgrade.lbl_otp_resent_info,
      className: "defaultSnackBarStyling",
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar
    }), !(upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.mah) && !showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryTitle/* default */.Z, {
      contents: [labels/* default.mah_authentication.lbl_mah_info */.Z.mah_authentication.lbl_mah_info],
      className: (CheckoutMahAuthentication_module_default())["standard-box"],
      id: "checkout-xds-standard-delivery",
      iconType: "info"
    }), !showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CheckoutMahAuthentication_module_default()).titleSection,
        children: otpSent ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (CheckoutMahAuthentication_module_default()).title,
          children: upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.mah ? labels/* default.mah_authentication.lbl_enter_otp_title */.Z.mah_authentication.lbl_enter_otp_title : labels/* default.mah_authentication.lbl_enter_mah_otp_title */.Z.mah_authentication.lbl_enter_mah_otp_title
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (CheckoutMahAuthentication_module_default()).title,
            children: labels/* default.mah_authentication.lbl_where_to_sent_otp */.Z.mah_authentication.lbl_where_to_sent_otp
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (CheckoutMahAuthentication_module_default()).description,
            children: labels/* default.mah_authentication.lbl_select_number */.Z.mah_authentication.lbl_select_number
          })]
        })
      }), otpSent ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(otpComponent_OtpComponent, {
          title: labels/* default.mah_authentication.lbl_one_time_pin */.Z.mah_authentication.lbl_one_time_pin,
          primaryButtonText: labels/* default.mah_authentication.lbl_validate_otp */.Z.mah_authentication.lbl_validate_otp,
          primaryButtonStyle: newOtp && newOtp.length == 6 ? "solid black" : "solid light gray",
          primaryButtonDisabled: !(newOtp && newOtp.length == 6),
          primaryButtonHandler: validateOTP,
          secondaryButtonText: labels/* default.mah_authentication.lbl_resend_otp */.Z.mah_authentication.lbl_resend_otp,
          secondaryButtonStyle: "flat black",
          secondaryButtonDisabled: false,
          secondaryButtonHandler: function secondaryButtonHandler(label) {
            return resendOTP(selectedNumber, label);
          },
          otpValue: otp,
          otpHandler: setOtp,
          showBackButton: allPreviligedNumbers.length > 1,
          backButtonText: labels/* default.mah_authentication.lbl_send_otp_other */.Z.mah_authentication.lbl_send_otp_other,
          handleBackButton: function handleBackButton() {
            return handleSendOtpToAnotherNumber();
          },
          containerClass: (CheckoutMahAuthentication_module_default()).otpComponentClass
        }), (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.mah) && !allPreviligedNumbers.length && /*#__PURE__*/(0,jsx_runtime.jsx)(infoWithButton_InfoWithButton, {
          title: labels/* default.mah_authentication.lbl_havent_received_otp */.Z.mah_authentication.lbl_havent_received_otp,
          description: "".concat(labels/* default.mah_authentication.lbl_otp_sent_desc_1 */.Z.mah_authentication.lbl_otp_sent_desc_1, " ").concat((0,upgradeService/* newMaskMsisdn */.Ls)(selectedNumber)).concat(labels/* default.mah_authentication.lbl_otp_sent_desc_2 */.Z.mah_authentication.lbl_otp_sent_desc_2),
          buttonText: labels/* default.mah_authentication.lbl_cant_receive_otp */.Z.mah_authentication.lbl_cant_receive_otp,
          buttonHandler: cantReciveOtpButtonHandler,
          containerClass: (CheckoutMahAuthentication_module_default()).cantReceiveClass
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(numberCheckComponent_NumberCheckComponent, {
          buttonStyle: "solid black",
          buttonHandler: numberButtonHandler,
          buttonDisabled: false,
          buttonText: otpCheckBox ? labels/* default.mah_authentication.lbl_send_otp */.Z.mah_authentication.lbl_send_otp : labels/* default.mah_authentication.lbl_call_me_back */.Z.mah_authentication.lbl_call_me_back,
          showCheckBox: upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.mah,
          checkValue: otpCheckBox,
          checkBoxText: labels/* default.upgrade.lbl_enter_msisdn_checkbox_text */.Z.upgrade.lbl_enter_msisdn_checkbox_text,
          checkBoxHandler: updateCheckBox,
          selectedNumber: selectedmaskedNumber,
          numberList: allPreviligedNumbers,
          handleNumberSelect: handleNumberSelect
        })
      })]
    }), showResult.visible && /*#__PURE__*/(0,jsx_runtime.jsx)(resultInformation_ResultInformation, {
      className: (CheckoutMahAuthentication_module_default()).information,
      title: showResult.title,
      analyticsType: showResult.analyticsType,
      iconType: showResult.iconType,
      formName: "otp",
      pageName: "checkout: authentication: ".concat(customerStatus)
    })]
  });
});

var CheckoutMahAuthentication_mapStateToProps = function mapStateToProps(state) {
  return {
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse
  };
};

/* harmony default export */ var checkoutMahAuthentication_CheckoutMahAuthentication = ((0,DependencyHelper.connect)(CheckoutMahAuthentication_mapStateToProps, {}, null, {
  forwardRef: true
})(CheckoutMahAuthentication));
// EXTERNAL MODULE: ./components/molecules/NotificationBox/NotificationBox.jsx
var NotificationBox = __webpack_require__(90685);
// EXTERNAL MODULE: ./components/molecules/NumberTransfer/numberTransferTypes.module.scss
var numberTransferTypes_module = __webpack_require__(90356);
var numberTransferTypes_module_default = /*#__PURE__*/__webpack_require__.n(numberTransferTypes_module);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/NumberTransferOption.jsx






var NumberTransferOption = function NumberTransferOption(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      onClick = _ref.onClick,
      selected = _ref.selected;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    className: "".concat((numberTransferTypes_module_default())["number-transfer-types__option"], " ").concat(selected && (numberTransferTypes_module_default())["number-transfer-types__option__selected"]),
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "".concat(imagePrefix, "/assets/images/").concat(icon, ".svg")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (numberTransferTypes_module_default())["number-transfer-types__option__title"],
      children: title
    })]
  });
};

/* harmony default export */ var NumberTransfer_NumberTransferOption = (NumberTransferOption);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/NumberTransferTypes.jsx


function NumberTransferTypes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NumberTransferTypes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NumberTransferTypes_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NumberTransferTypes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var NumberTransferTypes = function NumberTransferTypes(_ref) {
  var customerStatus = _ref.customerStatus;
  var dispatch = (0,es/* useDispatch */.I0)();

  var selectTransferType = function selectTransferType(type) {
    dispatch((0,checkoutAction/* setNumberTranferType */.ks)(type));
    dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({}));
    sendAnalitycs(type);
  };

  var sendAnalitycs = function sendAnalitycs(type) {
    analyticsUtag/* link */.p4(NumberTransferTypes_objectSpread(NumberTransferTypes_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "checkout number transfer: ".concat(customerStatus, ": ").concat(type)
    }));
  };

  var active = (0,es/* useSelector */.v9)(function (_ref2) {
    var checkoutDetails = _ref2.checkoutDetails;
    return checkoutDetails.numberTransferType;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransferCBU.Consumer, {
    children: function children(content) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(FlagsContext.Consumer, {
        children: function children(_ref3) {
          var _, _2, _3, _4, _5, _6, _7;

          var vodacomPrepaidTransfer = _ref3.vodacomPrepaidTransfer,
              otherPrepaidTransfer = _ref3.otherPrepaidTransfer;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (numberTransferTypes_module_default())["number-transfer-step__subtitle"],
              children: (_ = (content.sections || 0)[0]) === null || _ === void 0 ? void 0 : _.headingTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (numberTransferTypes_module_default())["number-transfer-types__wrapper"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferOption, {
                icon: "new-number",
                title: (_2 = (((_3 = (content.sections || 0)[0]) === null || _3 === void 0 ? void 0 : _3.items) || [])[0]) === null || _2 === void 0 ? void 0 : _2.title,
                selected: active === constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER,
                onClick: function onClick() {
                  return selectTransferType(constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER);
                }
              }), vodacomPrepaidTransfer && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferOption, {
                icon: "vod-gray",
                title: (_4 = (((_5 = (content.sections || 0)[0]) === null || _5 === void 0 ? void 0 : _5.items) || [])[1]) === null || _4 === void 0 ? void 0 : _4.title,
                selected: active === constants/* NumberTransferTypes.VOD_NUMBER */.Wh.VOD_NUMBER,
                onClick: function onClick() {
                  return selectTransferType(constants/* NumberTransferTypes.VOD_NUMBER */.Wh.VOD_NUMBER);
                }
              }), otherPrepaidTransfer && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferOption, {
                icon: "external-number",
                title: (_6 = (((_7 = (content.sections || 0)[0]) === null || _7 === void 0 ? void 0 : _7.items) || [])[2]) === null || _6 === void 0 ? void 0 : _6.title,
                selected: active === constants/* NumberTransferTypes.EXTERNAL */.Wh.EXTERNAL,
                onClick: function onClick() {
                  return selectTransferType(constants/* NumberTransferTypes.EXTERNAL */.Wh.EXTERNAL);
                }
              })]
            })]
          });
        }
      });
    }
  });
};

/* harmony default export */ var NumberTransfer_NumberTransferTypes = (NumberTransferTypes);
// EXTERNAL MODULE: ./components/organisms/NumberTransfer/numberTransfer.module.scss
var numberTransfer_module = __webpack_require__(47932);
var numberTransfer_module_default = /*#__PURE__*/__webpack_require__.n(numberTransfer_module);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/NumberTransferInfoBox.jsx








var NumberTransferInfoBox = function NumberTransferInfoBox() {
  var _, _2, _3;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      showInfo = _React$useState2[0],
      setShowInfo = _React$useState2[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var context = react.useContext(NumberTransferCBU);
  var content = (_ = (((_2 = ((context === null || context === void 0 ? void 0 : context.sections) || [])[1]) === null || _2 === void 0 ? void 0 : _2.items) || [])[0]) === null || _ === void 0 ? void 0 : _.description;
  var title = (_3 = ((context === null || context === void 0 ? void 0 : context.sections) || [])[1]) === null || _3 === void 0 ? void 0 : _3.title;

  if (!content || !title) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (numberTransfer_module_default())["number-transfer-step__infobox-wraper"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (numberTransfer_module_default())["number-transfer-step__subtitle"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        onClick: function onClick() {
          return setShowInfo(function (show) {
            return !show;
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Important info"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(imagePrefix, "/assets/images/collapsible.svg"),
          className: "".concat(showInfo && (numberTransfer_module_default())["number-transfer-step__icon-hide"])
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "".concat((numberTransfer_module_default())["number-transfer-step__infobox"], " ").concat(!showInfo && (numberTransfer_module_default())["number-transfer-step__infobox-hide"]),
      dangerouslySetInnerHTML: {
        __html: content
      }
    })]
  });
};

/* harmony default export */ var NumberTransfer_NumberTransferInfoBox = (NumberTransferInfoBox);
// EXTERNAL MODULE: ./components/molecules/upgradeModal/UpgradeModal.jsx
var UpgradeModal = __webpack_require__(27575);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/GeneralError.jsx


function GeneralError_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GeneralError_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GeneralError_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GeneralError_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var GeneralError = function GeneralError(_ref) {
  var navigate = _ref.navigate,
      showGeneralError = _ref.showGeneralError;

  var sendAnalitycsLink = function sendAnalitycsLink(additionalInfo) {
    analyticsUtag/* link */.p4(GeneralError_objectSpread(GeneralError_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_event", "page_name", "page_channel", "page_master_tab", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o"
    }, additionalInfo));
  };

  var _useState = (0,react.useState)({
    title: "",
    analyticTitle: "",
    description: ""
  }),
      errorDetails = _useState[0],
      setErrorDetails = _useState[1];

  var dispatch = (0,DependencyHelper.useDispatch)();

  var next = function next() {
    sendAnalitycsLink({
      link_name: "checkout: number transfer: new number",
      link_type: "o"
    });
    dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({}));
    dispatch((0,checkoutAction/* setNumberTranferType */.ks)(constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER));
    navigate("review");
  };

  var router = (0,DependencyHelper.useRouter)();
  (0,react.useEffect)(function () {
    (0,helperServices/* showSpinner */.yh)();
    ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", ["number_transfer_error"]).then(function (response) {
      setErrorDetails(GeneralError_objectSpread({
        title: response[0].resultTitle,
        analyticTitle: response[0].analyticTitle,
        description: response[0].resultHTML,
        primaryButtonText: response[0].primaryCTAText,
        secondaryButtonText: response[0].secondaryCTAText
      }, response[0] || {}));
    })["catch"](function () {
      setErrorDetails({
        title: "We’ve encountered a technical issue",
        analyticTitle: "shopping: upgrade: eligibility: enter otp",
        description: "Unfortunately, we cannot validate your prepaid number right now.<br /><br />If you would like to continue checking out now, you can choose to have a new number assigned to your contract. Otherwise you can exit checkout and let one of our consultants contact you to transfer your number and complete your application telephonically.",
        primaryButtonText: "Continue & Get a new number"
      });
    })["finally"](function () {
      return (0,helperServices/* hideSpinner */.v3)();
    });
  }, []);

  if (!errorDetails.title) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeModal/* default */.Z, {
    showModal: true,
    toggleModal: function toggleModal() {
      showGeneralError(function (currentValue) {
        return !currentValue;
      });
      sendAnalitycsLink({
        link_name: "checkout: number transfer: dismiss",
        link_type: "o"
      });
    },
    displayData: {
      iconUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
      title: errorDetails.title,
      analyticTitle: errorDetails.analyticTitle,
      description: errorDetails.description,
      primaryButtonText: errorDetails.primaryButtonText,
      secondaryButtonStyle: "flat black",
      onClickHandlerPrimary: next,
      secondaryButtonText: errorDetails.secondaryCTAText,
      onClickHandlerSecondary: function onClickHandlerSecondary() {
        sendAnalitycsLink({
          link_name: "checkout: number transfer: call me back",
          link_type: "o"
        });
        router.push("".concat(helperServices/* urlPrefix */.wn, "/").concat(errorDetails.secondaryCTAURL, "?bucket=").concat(errorDetails.leadType));
      }
    }
  });
};

/* harmony default export */ var NumberTransfer_GeneralError = (GeneralError);
// EXTERNAL MODULE: ./components/atoms/checkBox/Checkbox.module.scss
var Checkbox_module = __webpack_require__(97565);
var Checkbox_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_module);
;// CONCATENATED MODULE: ./components/atoms/checkBox/CheckBoxGroup.jsx






var CheckBoxGroup = function CheckBoxGroup(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      checked = _ref.checked,
      id = _ref.id,
      name = _ref.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
    className: (Checkbox_module_default())["checkbox-group"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Check, {
      custom: true,
      className: "".concat((Checkbox_module_default())["form-checkbox-label"]),
      id: id,
      onChange: onChange,
      checked: checked,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Input, {
        name: name,
        type: "checkbox",
        checked: checked,
        onChange: onChange
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Label, {
        id: id,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        })
      })]
    })
  });
};

/* harmony default export */ var checkBox_CheckBoxGroup = (CheckBoxGroup);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/NumberTransferCheckboxes.jsx


function NumberTransferCheckboxes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NumberTransferCheckboxes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NumberTransferCheckboxes_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NumberTransferCheckboxes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var NumberTransferCheckboxes = function NumberTransferCheckboxes(_ref) {
  var _, _2, _3, _4, _5, _6;

  var checkboxes = _ref.checkboxes,
      setCheckBoxes = _ref.setCheckBoxes;
  var context = react.useContext(NumberTransferCBU);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(checkBox_CheckBoxGroup, {
      checked: checkboxes.prepaid,
      label: ((_ = (((_2 = ((context === null || context === void 0 ? void 0 : context.sections) || [])[2]) === null || _2 === void 0 ? void 0 : _2.items) || [])[0]) === null || _ === void 0 ? void 0 : _.description) || labels/* default.lbl_transfer_number.lbl_agree_1 */.Z.lbl_transfer_number.lbl_agree_1,
      onChange: function onChange(event) {
        event.persist();
        setCheckBoxes(function (state) {
          var _event$target;

          return NumberTransferCheckboxes_objectSpread(NumberTransferCheckboxes_objectSpread({}, state), {}, {
            prepaid: event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.checked
          });
        });
      },
      id: "checkbox-prepaid",
      name: "checkbox-prepaid"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(checkBox_CheckBoxGroup, {
      checked: checkboxes["new"],
      label: ((_3 = (((_4 = ((context === null || context === void 0 ? void 0 : context.sections) || [])[2]) === null || _4 === void 0 ? void 0 : _4.items) || [])[1]) === null || _3 === void 0 ? void 0 : _3.description) || labels/* default.lbl_transfer_number.lbl_agree_2 */.Z.lbl_transfer_number.lbl_agree_2,
      onChange: function onChange(event) {
        event.persist();
        setCheckBoxes(function (state) {
          var _event$target2;

          return NumberTransferCheckboxes_objectSpread(NumberTransferCheckboxes_objectSpread({}, state), {}, {
            "new": event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.checked
          });
        });
      },
      id: "checkbox-new",
      name: "checkbox-new"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(checkBox_CheckBoxGroup, {
      checked: checkboxes.forfeit,
      label: ((_5 = (((_6 = ((context === null || context === void 0 ? void 0 : context.sections) || [])[2]) === null || _6 === void 0 ? void 0 : _6.items) || [])[2]) === null || _5 === void 0 ? void 0 : _5.description) || labels/* default.lbl_transfer_number.lbl_agree_3 */.Z.lbl_transfer_number.lbl_agree_3,
      onChange: function onChange(event) {
        event.persist();
        setCheckBoxes(function (state) {
          var _event$target3;

          return NumberTransferCheckboxes_objectSpread(NumberTransferCheckboxes_objectSpread({}, state), {}, {
            forfeit: event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.checked
          });
        });
      },
      id: "checkbox-forfeit",
      name: "checkbox-forfeit"
    })]
  });
};

/* harmony default export */ var NumberTransfer_NumberTransferCheckboxes = (NumberTransferCheckboxes);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/NumberTransferNumber.jsx




function NumberTransferNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NumberTransferNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NumberTransferNumber_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NumberTransferNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var NumberTransferNumber = function NumberTransferNumber(_ref) {
  var setShowSnackBar = _ref.setShowSnackBar,
      navigate = _ref.navigate,
      currentJourneyType = _ref.currentJourneyType,
      customerStatus = _ref.customerStatus;

  var _useState = (0,react.useState)(""),
      error = _useState[0],
      setError = _useState[1];

  var _useContext = (0,react.useContext)(NumberTransferCBU),
      multicartFlag = _useContext.multicartFlag;

  var _useState2 = (0,react.useState)(false),
      otpResent = _useState2[0],
      setOtpResent = _useState2[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState3 = (0,react.useState)(1),
      attempts = _useState3[0],
      setAttempts = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      generalError = _useState4[0],
      showGeneralError = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      otp = _useState5[0],
      setOtp = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showModal = _useState6[0],
      setShowModal = _useState6[1];

  var _useState7 = (0,react.useState)({
    prepaid: false,
    "new": false,
    forfeit: false
  }),
      checkboxes = _useState7[0],
      setCheckBoxes = _useState7[1];

  var prevCheckboxRef = (0,react.useRef)();
  var keepNumberErrorScenario = Object.freeze({
    "Legacy_number": "Legacy_number",
    "Existing_port_in_request": "Existing_port_in_request",
    "Port_in_request_in_past_60_days": "Port_in_request_in_past_60_days",
    "Vodacom_contract_number": "Vodacom_contract_number",
    "Number_not_validated": "Number_not_validated"
  });

  var sendAnalitycsLink = function sendAnalitycsLink(additionalInfo) {
    analyticsUtag/* link */.p4(NumberTransferNumber_objectSpread(NumberTransferNumber_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o"
    }, additionalInfo));
  };

  var validateNumber = function validateNumber(number) {
    var minlenght = (0,helperServices/* africaCountryCode */.xJ)(number) ? 11 : 10;

    if (!/^[0-9]*$/.test(number)) {
      return errorMessages/* default.checkoutAuthentication.cellNumber.onlyNumber */.Z.checkoutAuthentication.cellNumber.onlyNumber;
    }

    if (!/^0|27[0-9]*$/.test(number)) {
      return errorMessages/* default.checkoutAuthentication.cellNumber.startWith */.Z.checkoutAuthentication.cellNumber.startWith;
    }

    if (number.length < minlenght) {
      return errorMessages/* default.checkoutAuthentication.errors.auth.cellNumber */.Z.checkoutAuthentication.errors.auth.cellNumber;
    }

    return "";
  };

  var authDetails = (0,es/* useSelector */.v9)(function (_ref2) {
    var checkoutDetails = _ref2.checkoutDetails;
    return checkoutDetails.authDetails;
  });

  var _onChange = function onChange(event) {
    dispatch((0,checkoutAction/* setNumberToTranfer */.j2)(event.target.value));
    var valError = validateNumber(event.target.value);

    if (!valError) {
      sendAnalitycsLink({
        page_form_event: "start",
        page_form_name: "checkout: number transfer: ".concat(customerStatus, ": vodacom terms and conditions")
      });
    }

    setError(valError);
    setAttempts(1);
  };

  var buttonDisabled = function buttonDisabled() {
    var numberValid = !validateNumber(value);
    var termsAccepted = Object.values(checkboxes).every(function (term) {
      return term;
    });
    return !numberValid || !termsAccepted;
  };

  var sendOtp = function sendOtp(number) {
    (0,helperServices/* showSpinner */.yh)();
    setShowModal(false);
    microServices/* default.post */.Z.post("api", "oneTimePinv2", {
      destinations: [{
        address: number,
        message: "otp-default-sms-message",
        type: "SMS"
      }]
    }, null, false, [number]).then(function (responseData) {
      if (responseData.fail) {
        setShowSnackBar({
          visible: false
        });
        showGeneralError(true);
        setShowModal(false);
        return;
      }

      analyticsUtag/* view */.ei(NumberTransferNumber_objectSpread({
        page_event: "view",
        multicart_flag: multicartFlag ? true : false,
        page_name: "checkout: number transfer: ".concat(customerStatus, ": enter otp")
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
      setShowModal(true);
    })["catch"](function () {
      setShowSnackBar({
        visible: false
      });
      showGeneralError(true);
      setShowModal(false);
    })["finally"](function () {
      return (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var onSubmit = function onSubmit() {
    if (!buttonDisabled()) {
      sendAnalitycsLink({
        link_name: "checkout: number transfer: ".concat(customerStatus, ": next"),
        page_form_event: "success",
        page_form_name: "checkout: number transfer: ".concat(customerStatus, ": ").concat(active, " terms and conditions")
      });

      if (currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine && value !== authDetails.msisdn) {
        handleKeepNumberError(keepNumberErrorScenario.Number_not_validated);
        return;
      }

      sendOtp(value);
      return;
    }

    sendAnalitycsLink({
      link_name: "checkout: number transfer: ".concat(customerStatus, ": next"),
      page_form_event: "error",
      page_form_name: "checkout: number transfer: ".concat(customerStatus, ": ").concat(active, " terms and conditions"),
      page_errors: !Object.values(checkboxes).every(function (term) {
        return term;
      }) ? "Terms are not accepted" : validateNumber(value)
    });
  };

  var validateOtp = function validateOtp(otpNum, phone) {
    sendAnalitycsLink({
      link_name: "checkout: number transfer: ".concat(customerStatus, ": submit otp"),
      link_type: "o"
    });
    setShowSnackBar({
      visible: false
    });
    microServices/* default.get */.Z.get("api", "oneTimePinEligible", null, false, [phone, otpNum.join("")]).then(function (response) {
      var currentAttempts = attempts + 1;
      setOtp(["", "", "", ""]);
      setAttempts(currentAttempts);
      setShowSnackBar({
        visible: false
      });

      if (currentAttempts > 3) {
        showGeneralError(true);
        setShowModal(false);
        analyticsUtag/* view */.ei(NumberTransferNumber_objectSpread({
          page_event: "view",
          multicart_flag: multicartFlag ? true : false,
          page_name: "checkout: number transfer: ".concat(customerStatus, ": otp failed a third time")
        }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
        return;
      }

      if (response.fail) {
        analyticsUtag/* view */.ei(NumberTransferNumber_objectSpread({
          page_event: "view",
          multicart_flag: multicartFlag ? true : false,
          page_name: "checkout: number transfer: ".concat(customerStatus, ": otp failed ").concat(attempts === 1 ? "once" : "twice")
        }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
        setShowSnackBar({
          visible: true,
          message: labels/* default.upgrade */.Z.upgrade["lbl_invalid_otp_try_".concat(attempts)],
          className: (numberTransferTypes_module_default())["number-transfer-snack-bar"]
        });
        return;
      }

      setShowModal(false);
      (0,helperServices/* showSpinner */.yh)();
      microServices/* default.get */.Z.get("api", "validatePhoneForPrepaidNumber", null, false, [phone]).then( /*#__PURE__*/function () {
        var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
          var _data$response, _data$response$data, _data$response$data$r, _data$response$data$r2;

          var error, portInData, _portInData$result, _portInData$result2, _portInData$result3, _portInData$result4, _portInData$result5, _data$response2, _data$response2$data, _data$response2$data$, _data$response3, _data$response3$data, _data$response3$data$, _data$response$data$r3, SUBSCRIBERTYPE, C3D, VSP, _data$response4, _data$response4$data, _data$response4$data$;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  error = (data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$r = _data$response$data.result) === null || _data$response$data$r === void 0 ? void 0 : (_data$response$data$r2 = _data$response$data$r.errors) === null || _data$response$data$r2 === void 0 ? void 0 : _data$response$data$r2.find(function (error) {
                    return (error === null || error === void 0 ? void 0 : error.errorCode) === "SRV-404";
                  })) || data.error.status === 404;

                  if (!error) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 4;
                  return getPortInRequest(phone, authDetails);

                case 4:
                  portInData = _context.sent;
                  (0,helperServices/* hideSpinner */.v3)();

                  if (!portInData) {
                    // Number not validated
                    handleKeepNumberError(keepNumberErrorScenario.Number_not_validated);
                  } else {
                    if (portInData !== null && portInData !== void 0 && (_portInData$result = portInData.result) !== null && _portInData$result !== void 0 && _portInData$result.eligible) {
                      // success
                      dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
                        success: true,
                        details: portInData
                      }));
                    } else if (["PORT-IN ACTIVATED"].includes(portInData === null || portInData === void 0 ? void 0 : (_portInData$result2 = portInData.result) === null || _portInData$result2 === void 0 ? void 0 : _portInData$result2.status) && !(portInData !== null && portInData !== void 0 && (_portInData$result3 = portInData.result) !== null && _portInData$result3 !== void 0 && _portInData$result3.eligible)) {
                      // Vodacom Contract Number
                      handleKeepNumberError(keepNumberErrorScenario.Vodacom_contract_number);
                    } else if (["PORT-IN PENDING", "PORT-IN APPROVED"].includes(portInData === null || portInData === void 0 ? void 0 : (_portInData$result4 = portInData.result) === null || _portInData$result4 === void 0 ? void 0 : _portInData$result4.status) && !(portInData !== null && portInData !== void 0 && (_portInData$result5 = portInData.result) !== null && _portInData$result5 !== void 0 && _portInData$result5.eligible)) {
                      // Request in past 60 days
                      handleKeepNumberError(keepNumberErrorScenario.Port_in_request_in_past_60_days);
                    }
                  }

                  _context.next = 10;
                  break;

                case 9:
                  if ((_data$response2 = data.response) !== null && _data$response2 !== void 0 && (_data$response2$data = _data$response2.data) !== null && _data$response2$data !== void 0 && (_data$response2$data$ = _data$response2$data.result) !== null && _data$response2$data$ !== void 0 && _data$response2$data$.msisdnDetails) {
                    (0,helperServices/* hideSpinner */.v3)();
                    _data$response$data$r3 = (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : (_data$response3$data$ = _data$response3$data.result) === null || _data$response3$data$ === void 0 ? void 0 : _data$response3$data$.msisdnDetails, SUBSCRIBERTYPE = _data$response$data$r3.SUBSCRIBERTYPE, C3D = _data$response$data$r3.C3D, VSP = _data$response$data$r3.VSP;

                    if (SUBSCRIBERTYPE === "PREPAID" && VSP === "true" && C3D === "false") {
                      // Legacy Number
                      handleKeepNumberError(keepNumberErrorScenario.Legacy_number);
                    } else if (SUBSCRIBERTYPE === "CONTRACT" || SUBSCRIBERTYPE === "HYBRID") {
                      // Vodacom Contract Number
                      handleKeepNumberError(keepNumberErrorScenario.Vodacom_contract_number);
                    } else if (SUBSCRIBERTYPE === "PREPAID" && C3D === "true" && VSP === "true") {
                      dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
                        success: true,
                        details: (_data$response4 = data.response) === null || _data$response4 === void 0 ? void 0 : (_data$response4$data = _data$response4.data) === null || _data$response4$data === void 0 ? void 0 : (_data$response4$data$ = _data$response4$data.result) === null || _data$response4$data$ === void 0 ? void 0 : _data$response4$data$.msisdnDetails
                      }));
                    }
                  }

                case 10:
                  if (!(data.response.status !== 200 && !error)) {
                    _context.next = 14;
                    break;
                  }

                  (0,helperServices/* hideSpinner */.v3)();
                  showGeneralError(true);
                  return _context.abrupt("return");

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }())["catch"](function () {
        (0,helperServices/* hideSpinner */.v3)();
        setOtp(["", "", "", ""]);
        showGeneralError(true);
      });
    })["catch"](function () {
      return showGeneralError(true);
    });
  };

  var handleKeepNumberError = function handleKeepNumberError(type) {
    dispatch((0,checkoutAction/* setNumberTranferType */.ks)(constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER));

    switch (type) {
      case "Legacy_number":
        dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
          success: false,
          errorType: keepNumberErrorScenario.Legacy_number
        }));
        updateAnalyticsForError("legacy");
        break;

      case "Vodacom_contract_number":
        dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
          success: false,
          errorType: keepNumberErrorScenario.Vodacom_contract_number
        }));
        updateAnalyticsForError("postpaid number");
        break;

      case "Existing_port_in_request":
        dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
          success: false,
          errorType: keepNumberErrorScenario.Existing_port_in_request
        }));
        updateAnalyticsForError("port in request");
        break;

      case "Port_in_request_in_past_60_days":
        dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
          success: false,
          errorType: keepNumberErrorScenario.Port_in_request_in_past_60_days
        }));
        updateAnalyticsForError("60 days");
        break;

      case "Number_not_validated":
        dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({
          success: false,
          errorType: keepNumberErrorScenario.Number_not_validated
        }));
        updateAnalyticsForError("Number not validated");
        break;

      default:
        break;
    }

    return;
  };

  var updateAnalyticsForError = function updateAnalyticsForError(errorType) {
    analyticsUtag/* view */.ei(NumberTransferNumber_objectSpread({
      page_event: "view",
      multicart_flag: multicartFlag ? true : false,
      page_name: "checkout: number transfer: ".concat(errorType)
    }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
  };

  var getPortInRequest = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(phone, authDetails) {
      var _res$response;

      var res, response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return microServices/* default.get */.Z.get("api", "portInValidation", null, true, [phone, "".concat(authDetails.idNumber, "?activationType=Port-In")]);

            case 2:
              res = _context2.sent;
              response = (_res$response = res.response) === null || _res$response === void 0 ? void 0 : _res$response.data;
              return _context2.abrupt("return", response);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getPortInRequest(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    prevCheckboxRef.current = checkboxes;
  });
  var prevCheckbox = prevCheckboxRef.current;
  (0,react.useEffect)(function () {
    var isPreviousSelected;

    if (prevCheckbox) {
      isPreviousSelected = Object.values(prevCheckbox).filter(function (item) {
        return item;
      });
    }

    var count = 0;

    for (var key in checkboxes) {
      if (Object.hasOwnProperty.call(checkboxes, key)) {
        var _isPreviousSelected;

        if (checkboxes[key] && ((_isPreviousSelected = isPreviousSelected) === null || _isPreviousSelected === void 0 ? void 0 : _isPreviousSelected.length) === 0) {
          count += 1;
        }
      }
    }

    if (count === 1) {
      sendAnalitycsLink({
        page_form_event: "start",
        page_form_name: "checkout: number transfer: ".concat(customerStatus, ": ").concat(active, " terms and conditions")
      });
    }
  }, [checkboxes]);
  var value = (0,es/* useSelector */.v9)(function (_ref5) {
    var checkoutDetails = _ref5.checkoutDetails;
    return checkoutDetails.numberToTransfer;
  });

  var maskNumber = function maskNumber() {
    return [value.slice(0, 3), "****", value.slice(-3)].join("");
  };

  var active = (0,es/* useSelector */.v9)(function (_ref6) {
    var checkoutDetails = _ref6.checkoutDetails;
    return checkoutDetails.numberTransferType;
  });

  if (active === constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [otpResent && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (numberTransferTypes_module_default())["number-transfer-step__snackbar"],
      onClick: function onClick() {
        return setOtpResent(false);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (numberTransferTypes_module_default())["number-transfer-step__snackbar-text"],
        children: labels/* default.upgrade.lbl_otp_resent_info */.Z.upgrade.lbl_otp_resent_info
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (numberTransferTypes_module_default())["number-transfer-step__snackbar-close"],
        children: "+"
      })]
    }), generalError && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_GeneralError, {
      navigate: navigate,
      showGeneralError: showGeneralError
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (numberTransferTypes_module_default())["number-transfer-step__subtitle"],
      children: "Please enter your prepaid number below:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat((numberTransferTypes_module_default())["number-transfer-number-main-container"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((NewLineForms_module_default())["main-container"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
          className: "".concat((NewLineForms_module_default())["main-row"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
            as: DependencyHelper.Col,
            sm: "12",
            md: "12",
            className: (NewLineForms_module_default())["form-group"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Label, {
              className: (NewLineForms_module_default())["form-label"],
              children: "Cellphone number"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
              type: "text",
              maxLength: !(0,helperServices/* africaCountryCode */.xJ)(value) ? "10" : "11",
              name: "cellNumber",
              value: value,
              placeholder: "Enter your cellphone number",
              onChange: function onChange(event) {
                event.persist();

                _onChange(event);
              },
              isInvalid: error,
              className: error ? (NewLineForms_module_default()).invalid : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
              type: "invalid",
              className: (NewLineForms_module_default())["invalid-feedback"],
              children: error
            }), !error && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (NewLineForms_module_default())["hint-text"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (NewLineForms_module_default())["text-spacing"],
                children: " This must be a prepaid number "
              })
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferCheckboxes, {
        checkboxes: checkboxes,
        setCheckBoxes: setCheckBoxes
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (numberTransferTypes_module_default())["number-transfer-button-wrapper"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "".concat((numberTransferTypes_module_default())["number-transfer-button"], " ").concat(buttonDisabled() ? (numberTransferTypes_module_default())["number-transfer-button__disabled"] : ""),
          onClick: onSubmit,
          children: "Next"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeModal/* default */.Z, {
      showModal: showModal,
      toggleModal: function toggleModal() {
        setOtp(["", "", "", ""]);
        setShowSnackBar({
          visible: false
        });
        sendAnalitycsLink({
          link_name: "checkout: number transfer: ".concat(customerStatus, ": dismiss"),
          link_type: "o"
        });
        setOtpResent(false);
        setShowModal(false);
      },
      displayData: {
        title: labels/* default.upgrade.lbl_enter_otp_title */.Z.upgrade.lbl_enter_otp_title,
        analyticTitle: "checkout: number transfer: ".concat(customerStatus, ": enter otp"),
        description: "".concat(labels/* default.upgrade.lbl_enter_otp_desc_prefix */.Z.upgrade.lbl_enter_otp_desc_prefix, " ").concat(maskNumber(), ".<br/>").concat(labels/* default.upgrade.lbl_enter_otp_desc_suffix_v2 */.Z.upgrade.lbl_enter_otp_desc_suffix_v2),
        otpInput: true,
        invalidOTPTries: 0,
        otpValue: otp,
        // otp,
        otpHandler: setOtp,
        // setOtp,
        textButton: labels/* default.upgrade.lbl_btn_resend_otp */.Z.upgrade.lbl_btn_resend_otp,
        textButtonHandler: function textButtonHandler() {
          setOtp(["", "", "", ""]);
          setOtpResent(true);
          sendAnalitycsLink({
            link_name: "checkout: number transfer: ".concat(customerStatus, ": resend otp"),
            link_type: "o"
          });
          sendOtp(value);
        },
        // resendOTP,
        primaryButtonText: labels/* default.upgrade.lbl_btn_submit_otp */.Z.upgrade.lbl_btn_submit_otp,
        primaryButtonStyle: otp.filter(function (pin) {
          return pin;
        }).length == 4 && attempts < 4 ? "solid red" : "solid light gray",
        primaryButtonDisabled: otp.filter(function (pin) {
          return pin;
        }).length !== 4 || attempts >= 4,
        onClickHandlerPrimary: function onClickHandlerPrimary() {
          return validateOtp(otp, value);
        } // validateOTP,

      }
    })]
  });
};

/* harmony default export */ var NumberTransfer_NumberTransferNumber = (NumberTransferNumber);
;// CONCATENATED MODULE: ./components/molecules/NumberTransfer/GeneralInfoBox.jsx



function GeneralInfoBox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GeneralInfoBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GeneralInfoBox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GeneralInfoBox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var GeneralInfoBox = function GeneralInfoBox(_ref) {
  var onChangeHandler = _ref.onChangeHandler;

  var _useContext = (0,react.useContext)(NumberTransferCBU),
      multicartFlag = _useContext.multicartFlag;

  var sendAnalitycsLink = function sendAnalitycsLink(additionalInfo) {
    analyticsUtag/* link */.p4(GeneralInfoBox_objectSpread(GeneralInfoBox_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      link_type: "o"
    }, additionalInfo));
  };

  var _useState = (0,react.useState)({
    icon: "",
    title: "",
    description: ""
  }),
      message = _useState[0],
      setMessage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var details = (0,es/* useSelector */.v9)(function (_ref2) {
    var checkoutDetails = _ref2.checkoutDetails;
    return checkoutDetails.numberTransferDetails;
  });
  var number = (0,es/* useSelector */.v9)(function (_ref3) {
    var checkoutDetails = _ref3.checkoutDetails;
    return checkoutDetails.numberToTransfer;
  });
  var dispatch = (0,es/* useDispatch */.I0)();

  var tryAnother = function tryAnother() {
    setMessage({
      icon: "",
      title: "",
      description: ""
    });
    dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({}));
    sendAnalitycsLink({
      link_name: "checkout: number transfer: use another number",
      link_type: "o"
    });
  };

  (0,react.useEffect)(function () {
    if (details !== null && details !== void 0 && details.success) {
      analyticsUtag/* view */.ei(GeneralInfoBox_objectSpread({
        page_event: "view",
        multicart_flag: multicartFlag ? true : false,
        page_name: "checkout: number transfer: success"
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
      ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", ["OTP Successful"]).then(function (_ref4) {
        var _response$resultTitle;

        var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 1),
            response = _ref5[0];

        setMessage({
          icon: "icon-sucess",
          title: response === null || response === void 0 ? void 0 : (_response$resultTitle = response.resultTitle) === null || _response$resultTitle === void 0 ? void 0 : _response$resultTitle.replace("{customer number}", [number.slice(0, 3), "****", number.slice(-3)].join("")),
          description: response.resultText
        });
      })["catch"](function () {
        setMessage({
          icon: "icon-sucess",
          title: "Great! We’ll transfer {customer number} to this contract".replace("{customer number}", [number.slice(0, 3), "****", number.slice(-3)].join("")),
          description: "We’ll begin the number transfer process once this application has been successfully submitted."
        });
      });
    } else {
      if (details.errorType) {
        ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [details.errorType]).then(function (_ref6) {
          var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 1),
              response = _ref7[0];

          setMessage({
            icon: "lock",
            title: response === null || response === void 0 ? void 0 : response.resultTitle,
            description: response === null || response === void 0 ? void 0 : response.resultHTML
          });
        })["catch"](function () {
          setMessage({
            icon: "lock",
            title: "This number cannot be used for your new contract",
            description: "We see that the number you've entered is already being used on a Vodacom contract. We can only transfer a prepaid number to your new contract. You can continue completing your application and get a new number, or you can try transferring another prepaid number."
          });
        });
      } else {
        setMessage({
          icon: "lock",
          title: "Your prepaid number cannot be transferred right now",
          description: "We see there is currently an existing request to transfer this number to another contract. Until this request has been resolved and 30 days have passed, we cannot use this number.<br /><br />You can continue completing your application and get a new number, or you can try transferring another prepaid number."
        });
      }
    }
  }, [details]);

  if (!details || !message.icon) {
    return null;
  }

  window.scrollTo(0, 0);

  var handleChange = function handleChange(event) {
    setIsChecked(!isChecked);
    onChangeHandler(!isChecked);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (numberTransferTypes_module_default())["number-transfer-general-info__box"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Image, {
      src: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/").concat(message.icon, ".svg"),
      className: (numberTransferTypes_module_default())["number-transfer-general-info__icon"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (numberTransferTypes_module_default())["number-transfer-general-info__title"],
      children: message.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (numberTransferTypes_module_default())["number-transfer-general-info__description"],
      dangerouslySetInnerHTML: {
        __html: message.description
      }
    }), (details === null || details === void 0 ? void 0 : details.errorType) === "Number_not_validated" && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((StaticForms_module_default())["main-container"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
          className: "".concat((StaticForms_module_default())["main-row"], " ").concat((StaticForms_module_default())["full-row"], " p-0"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Group, {
            className: "".concat((numberTransferTypes_module_default()).contact_container),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Check, {
              custom: true,
              className: "".concat((StaticForms_module_default())["form-checkbox-label"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Input, {
                name: "contactMe",
                type: "checkbox",
                onChange: handleChange,
                checked: isChecked
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Check.Label, {
                id: "contact_container-label",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Yes, I\u2019d like a consultant to contact me to finalise my number transfer"
                })
              })]
            })
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      className: (numberTransferTypes_module_default())["number-transfer-general-info__button"],
      onClick: function onClick() {
        return tryAnother();
      },
      children: [details !== null && details !== void 0 && details.success ? labels/* default.lbl_transfer_number.lbl_retry_button2 */.Z.lbl_transfer_number.lbl_retry_button2 : labels/* default.lbl_transfer_number.lbl_retry_button */.Z.lbl_transfer_number.lbl_retry_button, /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: (numberTransferTypes_module_default())["number-transfer-general-info__arrow"]
      })]
    })]
  });
};

/* harmony default export */ var NumberTransfer_GeneralInfoBox = (GeneralInfoBox);
;// CONCATENATED MODULE: ./components/organisms/NumberTransfer/numberTransferCbu.js
/* harmony default export */ var numberTransferCbu = ({
  id: "df11f267-0d8f-420d-a7ca-337f96debc24",
  analyticTitle: "Transfer a prepaid number Landing page",
  sections: [{
    type: "paragraph_list",
    id: "18afbbf4-78a0-4b57-a74e-dde52e4c82c5",
    analyticTitle: "Transfer a prepaid number page",
    title: "Transfer a prepaid number",
    siteType: "CBU",
    description: "<p>If you have an existing prepaid cellphone number (from any SA network) that you would like to use on this contract, you can apply to have it transferred now. If not, you can skip this step.</p>",
    headingTitle: "Which number would you like to use?",
    items: [{
      id: "c8466536-2877-4e47-943d-d643aef39828",
      icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/plus_icon.svg",
      title: "I’d like a new number"
    }, {
      id: "12452fe2-8c99-46f9-b1a7-8fa10ee72589",
      icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/logo_icon.svg",
      title: "I have a Vodacom  prepaid number"
    }, {
      id: "9daf401d-ea58-483a-bc98-ae511078a54f",
      icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/transfer_icon.svg",
      title: "I have a prepaid number from another network"
    }]
  }, {
    type: "paragraph_list",
    id: "b37336a5-d6c3-4d9a-9063-fc122db7d713",
    analyticTitle: "I have a prepaid number from another network page",
    title: "Important things to know:",
    siteType: "CBU",
    items: [{
      id: "7c6e4f0a-2f32-40dd-8ed6-3f541a869f75",
      description: "<ul>\t<li>We can transfer a number from any network, as long as it’s a prepaid number.</li>\t<li>If your number could not be transferred successfully, you will automatically be assigned a new number.</li>\t<li>Any airtime and/or bundles loaded on your number will be forfeited when you start using your new SIM card.</li>\t<li>We can’t transfer a number that has been transferred (ported) to another network in the last 60 days.</li></ul>"
    }]
  }, {
    type: "paragraph_list",
    id: "6ddeb11d-3574-4bc4-857d-fa4fab223f12",
    analyticTitle: "Transfer number checkout",
    siteType: "CBU",
    items: [{
      id: "8652d5c6-2726-4145-b5f5-8536b8621594",
      description: "<p>I agree that the number above is a prepaid number and it belongs to me</p>"
    }, {
      id: "9c0fd2dc-115b-44f6-ae58-fcf59d10a8ca",
      description: "<p>I agree to receive a new number if this number cannot be transferred successfully</p>"
    }, {
      id: "e5b77895-255e-4b59-972c-f5dbb77c30a8",
      description: "<p>I agree to forfeit any airtime or bundles on this number when it is transferred</p>"
    }]
  }],
  status: "success"
});
;// CONCATENATED MODULE: ./components/organisms/NumberTransfer/NumberTransfer.jsx




function NumberTransfer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NumberTransfer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NumberTransfer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NumberTransfer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var NumberTransferCBU = /*#__PURE__*/(0,react.createContext)({}); // eslint-disable-next-line react/display-name

var NumberTransfer = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var continueDisable = _ref.continueDisable,
      setShowSnackBar = _ref.setShowSnackBar,
      navigate = _ref.navigate,
      handleHeading = _ref.handleHeading,
      customerStatus = _ref.customerStatus,
      currentJourneyType = _ref.currentJourneyType,
      multicartFlag = _ref.multicartFlag;
  var dispatch = (0,es/* useDispatch */.I0)();
  var active = (0,es/* useSelector */.v9)(function (_ref2) {
    var checkoutDetails = _ref2.checkoutDetails;
    return checkoutDetails.numberTransferType;
  });
  var details = (0,es/* useSelector */.v9)(function (_ref3) {
    var checkoutDetails = _ref3.checkoutDetails;
    return checkoutDetails.numberTransferDetails;
  });

  var _useState = (0,react.useState)(""),
      content = _useState[0],
      setContent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isContactMeChecked = _useState2[0],
      setIsContactMeChecked = _useState2[1];

  (0,react.useEffect)(function () {
    dispatch((0,checkoutAction/* setNumberTransferDetails */.L7)({}));
    analyticsUtag/* view */.ei(NumberTransfer_objectSpread({
      page_event: "view",
      multicart_flag: multicartFlag ? true : false,
      page_name: "checkout: number transfer: ".concat(customerStatus)
    }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
    var texts = {};
    ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "numberTransferPage").then(function (numberTransferResponse) {
      texts = numberTransferResponse;
    })["catch"](function () {
      texts = numberTransferCbu;
    })["finally"](function () {
      var _texts, _texts$sections$, _texts2, _texts2$sections$;

      setContent(texts);
      handleHeading("update", "desc", (_texts = texts) === null || _texts === void 0 ? void 0 : (_texts$sections$ = _texts.sections[0]) === null || _texts$sections$ === void 0 ? void 0 : _texts$sections$.description);
      handleHeading("update", "title", (_texts2 = texts) === null || _texts2 === void 0 ? void 0 : (_texts2$sections$ = _texts2.sections[0]) === null || _texts2$sections$ === void 0 ? void 0 : _texts2$sections$.title);
    });
  }, []);
  (0,react.useEffect)(function () {
    continueDisable(details.success === undefined && active !== constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER);
    handleHeading(details.success === undefined ? "show" : "hide", "desc");
  }, [details, active]);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      submit: function submit() {
        analyticsUtag/* link */.p4({
          link_type: "o",
          link_name: "checkout: number transfer: ".concat(customerStatus, ": continue")
        });

        if (isContactMeChecked) {
          // create a number transfer lead
          submitLeadFormInSilent();
        }

        navigate("delivery");
      },
      back: function back() {
        if (currentJourneyType == checkout_journey_context/* journeyType.newLine */.w.newLine || currentJourneyType == checkout_journey_context/* journeyType.addLine */.w.addLine) {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: number transfer: ".concat(customerStatus, ": back to credit check")
          });
        } else {
          analyticsUtag/* link */.p4({
            link_type: "o",
            link_name: "checkout: number transfer: ".concat(customerStatus, ": back to lets get started")
          });
        }
      }
    };
  });

  var handleChange = function handleChange(isChecked) {
    setIsContactMeChecked(isChecked);
  };

  var userProfileData = (0,es/* useSelector */.v9)(function (_ref4) {
    var navDetails = _ref4.navDetails;
    return navDetails.profileData;
  });
  var msisdnValue = (0,es/* useSelector */.v9)(function (_ref5) {
    var checkoutDetails = _ref5.checkoutDetails;
    return checkoutDetails.numberToTransfer;
  });

  var submitLeadFormInSilent = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var inputObj;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputObj = {
                channel: "ONLINE",
                emailAddress: userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.email,
                idDocType: "MSISDN",
                idNumber: msisdnValue,
                msisdn: msisdnValue,
                name: userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.firstname,
                requestType: "number_transfer",
                surname: userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.lastname
              };
              _context.next = 3;
              return microServices/* default.post */.Z.post("api", "staticFormSubmit", inputObj, null, false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitLeadFormInSilent() {
      return _ref6.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (numberTransfer_module_default())["number-transfer-wrapper"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(NumberTransferCBU.Provider, {
      value: NumberTransfer_objectSpread(NumberTransfer_objectSpread({}, content), {}, {
        multicartFlag: multicartFlag
      }),
      children: [details.success !== undefined && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_GeneralInfoBox, {
        onChangeHandler: handleChange
      }), details.success === undefined && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferTypes, {
        customerStatus: customerStatus
      }), active !== constants/* NumberTransferTypes.NEW_NUMBER */.Wh.NEW_NUMBER && details.success !== false && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferInfoBox, {}), details.success === undefined && /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransferNumber, {
        setShowSnackBar: setShowSnackBar,
        currentJourneyType: currentJourneyType,
        navigate: navigate,
        customerStatus: customerStatus
      })]
    })
  });
});
/* harmony default export */ var NumberTransfer_NumberTransfer = ((0,DependencyHelper.connect)(null, null, null, {
  forwardRef: true
})(NumberTransfer));
// EXTERNAL MODULE: ./Redux/actions/getHelpAction.js
var getHelpAction = __webpack_require__(87524);
;// CONCATENATED MODULE: ./pages/shopping/post-checkout.js





function post_checkout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function post_checkout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? post_checkout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : post_checkout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function post_checkout_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = post_checkout_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function post_checkout_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return post_checkout_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return post_checkout_arrayLikeToArray(o, minLen); }

function post_checkout_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












































var __N_SSP = true;
var FlagsContext = /*#__PURE__*/(0,react.createContext)({
  vodacomPrepaidTransfer: false,
  otherPrepaidTransfer: false
});

var PostCheckout = function PostCheckout(_ref) {
  var _allPrices$subtotal_i, _dealCartProducts$, _dealCartProducts$$pr, _dealCartProducts$2, _dealCartProducts$2$p, _dealCartProducts$3, _dealCartProducts$3$c, _dealCartProducts$3$c2, _dealCartProducts$4, _dealCartProducts$4$c, _dealCartProducts$4$c2, _cartDetails$shipping, _cartDetails$shipping2, _checkoutDetails$auth, _checkoutDetails$auth2, _dealCartProducts$5, _dealCartProducts$5$p, _router$query;

  var cartDetails = _ref.cartDetails,
      checkoutDetails = _ref.checkoutDetails,
      setPostCheckoutCurrentStep = _ref.setPostCheckoutCurrentStep,
      removeCreditCheckStates = _ref.removeCreditCheckStates,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      authDetails = _ref.authDetails,
      paymentConfiguration = _ref.paymentConfiguration,
      cartProductItems = _ref.cartProductItems,
      personalDetailsData = _ref.personalDetailsData,
      contactDetailsData = _ref.contactDetailsData,
      dealCategoryId = _ref.dealCategoryId,
      addGuestCartProducts = _ref.addGuestCartProducts,
      addBundleProductToGuestCart = _ref.addBundleProductToGuestCart,
      authDetailsData = _ref.authDetailsData,
      vodacomPrepaidTransfer = _ref.vodacomPrepaidTransfer,
      otherPrepaidTransfer = _ref.otherPrepaidTransfer,
      numberTransferEnabled = _ref.numberTransferEnabled,
      addCouponToCart = _ref.addCouponToCart,
      addSimpleProductToGuestCart = _ref.addSimpleProductToGuestCart,
      addConfigurableToGuestCart = _ref.addConfigurableToGuestCart,
      setCartMulti = _ref.setCartMulti,
      showGuestCart = _ref.showGuestCart,
      creditVettingDetails = _ref.creditVettingDetails,
      setHelpLeadBucket = _ref.setHelpLeadBucket,
      setPaymentMethodUrl = _ref.setPaymentMethodUrl,
      setPostOrderResponse = _ref.setPostOrderResponse,
      paymentOptionsEnabled = _ref.paymentOptionsEnabled,
      clickAndCollectEnabled = _ref.clickAndCollectEnabled;
  var postCheckoutPageRef = (0,react.useRef)();
  var orderId = (0,helperServices/* getCookieValue */.Do)((config_default()).order_id);
  var env = (config_default()).env;
  var cartIdCookie = (0,helperServices/* getCookieValue */.Do)("cart_id");
  var profileSyncFail = (0,helperServices/* getCookieValue */.Do)("profileSyncFail");

  var _useState = (0,react.useState)({}),
      metadata = _useState[0],
      setMetaData = _useState[1];

  var _useState2 = (0,react.useState)(cartIdCookie),
      cartId = _useState2[0],
      setCartId = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      redirectURL = _useState3[0],
      setRedirectURL = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      features = _useState4[0],
      setFeatures = _useState4[1];

  var cartItems = cartDetails && cartDetails !== null && cartDetails !== void 0 && cartDetails.cartProductItems ? cartDetails.cartProductItems : [];
  var allPrices = cartDetails && cartDetails !== null && cartDetails !== void 0 && cartDetails.prices ? cartDetails.prices : null;

  var _splitCartItems = (0,helperServices/* splitCartItems */.zp)(cartProductItems),
      dealCartProducts = _splitCartItems.dealCartProducts,
      onceOffCartProducts = _splitCartItems.onceOffCartProducts;

  var onceOffSubTotal = allPrices && allPrices !== null && allPrices !== void 0 && (_allPrices$subtotal_i = allPrices.subtotal_including_tax) !== null && _allPrices$subtotal_i !== void 0 && _allPrices$subtotal_i.value ? "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round(allPrices.subtotal_including_tax.value * 100) / 100)) : "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0));
  var dealID = (_dealCartProducts$ = dealCartProducts[0]) === null || _dealCartProducts$ === void 0 ? void 0 : (_dealCartProducts$$pr = _dealCartProducts$.product) === null || _dealCartProducts$$pr === void 0 ? void 0 : _dealCartProducts$$pr.sku;
  var primaryProductSku = (_dealCartProducts$2 = dealCartProducts[0]) === null || _dealCartProducts$2 === void 0 ? void 0 : (_dealCartProducts$2$p = _dealCartProducts$2.product) === null || _dealCartProducts$2$p === void 0 ? void 0 : _dealCartProducts$2$p.primary_product_sku;
  var contractType;

  if (((_dealCartProducts$3 = dealCartProducts[0]) === null || _dealCartProducts$3 === void 0 ? void 0 : (_dealCartProducts$3$c = _dealCartProducts$3.customizable_options[0]) === null || _dealCartProducts$3$c === void 0 ? void 0 : (_dealCartProducts$3$c2 = _dealCartProducts$3$c.values[0]) === null || _dealCartProducts$3$c2 === void 0 ? void 0 : _dealCartProducts$3$c2.label) === labels/* default.deal_details.lbl_new_contract_deal_option */.Z.deal_details.lbl_new_contract_deal_option) {
    contractType = labels/* default.deal_details.lbl_new_contract_deal */.Z.deal_details.lbl_new_contract_deal;
  } else if (((_dealCartProducts$4 = dealCartProducts[0]) === null || _dealCartProducts$4 === void 0 ? void 0 : (_dealCartProducts$4$c = _dealCartProducts$4.customizable_options[0]) === null || _dealCartProducts$4$c === void 0 ? void 0 : (_dealCartProducts$4$c2 = _dealCartProducts$4$c.values[0]) === null || _dealCartProducts$4$c2 === void 0 ? void 0 : _dealCartProducts$4$c2.label) === labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option) {
    contractType = labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option;
  }

  var monthlyCartProducts = [];

  var _iterator = post_checkout_createForOfIteratorHelper(dealCartProducts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      for (var index = 0; index < item.quantity; index++) {
        monthlyCartProducts.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var dealSku, monthlyCartVasProducts;

  if (Array.isArray(monthlyCartProducts)) {
    monthlyCartProducts.forEach(function (item) {
      var _item$product;

      dealSku = item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.sku;
      monthlyCartVasProducts = cartProductItems.filter(function (cartProduct) {
        return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring) && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku;
      });
    });
  } else {
    var _monthlyCartProducts$;

    dealSku = monthlyCartProducts === null || monthlyCartProducts === void 0 ? void 0 : (_monthlyCartProducts$ = monthlyCartProducts.product) === null || _monthlyCartProducts$ === void 0 ? void 0 : _monthlyCartProducts$.sku;
    monthlyCartVasProducts = cartProductItems.filter(function (cartProduct) {
      return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring) && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku;
    });
  }

  if (Array.isArray(monthlyCartVasProducts)) {
    var _iterator2 = post_checkout_createForOfIteratorHelper(monthlyCartVasProducts),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;

        for (var index = 0; index < item.quantity; index++) {
          monthlyCartProducts.push(item);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  var shippingAddress = cartDetails.shipping_address ? Array.isArray(cartDetails.shipping_address) && cartDetails.shipping_address.length > 0 ? cartDetails.shipping_address[0] : cartDetails.shipping_address : null;
  var billingAddress = cartDetails.billing_address ? Array.isArray(cartDetails.billing_address) && cartDetails.billing_address.length > 0 ? cartDetails.billing_address[0] : cartDetails.billing_address : null;
  var shippingMessageText = cartDetails && cartDetails.shippingMessageText ? cartDetails.shippingMessageText : null;
  var shippingFeeCalculateAmount = cartDetails && cartDetails.shippingFeeCalculate && cartDetails.shippingFeeCalculate.grand_total_amount ? cartDetails.shippingFeeCalculate.grand_total_amount : null;
  var carrierCode = cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping === void 0 ? void 0 : _cartDetails$shipping.carrier_code;
  var methodCode = cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$shipping2 = cartDetails.shippingFeeCalculate) === null || _cartDetails$shipping2 === void 0 ? void 0 : _cartDetails$shipping2.method_code;

  var _useState5 = (0,react.useState)(((_checkoutDetails$auth = checkoutDetails.authDetails) === null || _checkoutDetails$auth === void 0 ? void 0 : (_checkoutDetails$auth2 = _checkoutDetails$auth.information) === null || _checkoutDetails$auth2 === void 0 ? void 0 : _checkoutDetails$auth2.customerType) == "EXISTING" ? contractType == labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option ? checkout_journey_context/* journeyType.upgrade */.w.upgrade : checkout_journey_context/* journeyType.addLine */.w.addLine : contractType == labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option ? checkout_journey_context/* journeyType.upgrade */.w.upgrade : checkout_journey_context/* journeyType.newLine */.w.newLine),
      journey = _useState5[0],
      setJourney = _useState5[1];

  var journeyProviderValue = {
    journey: journey,
    setJourney: setJourney
  };

  var _useState6 = (0,react.useState)([]),
      addressTypes = _useState6[0],
      setAddressTypes = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      countryCode = _useState7[0],
      setCountryCode = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      countryName = _useState8[0],
      setCountryName = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      regions = _useState9[0],
      setRegions = _useState9[1];

  var _useState10 = (0,react.useState)(null),
      formContent = _useState10[0],
      setFormContent = _useState10[1];

  var _useState11 = (0,react.useState)(null),
      sidebarContent = _useState11[0],
      setSidebarContent = _useState11[1];

  var _useState12 = (0,react.useState)(null),
      faq = _useState12[0],
      setFaq = _useState12[1];

  var _useState13 = (0,react.useState)(null),
      notificationContent = _useState13[0],
      setNotificationContent = _useState13[1];

  var _useState14 = (0,react.useState)(true),
      allowPlaceOrder = _useState14[0],
      setAllowPlaceOrder = _useState14[1];

  var _useState15 = (0,react.useState)(true),
      continueDisabled = _useState15[0],
      setContinueDisabled = _useState15[1];

  var _useState16 = (0,react.useState)(true),
      showLoginModal = _useState16[0],
      setShowLoginModal = _useState16[1];

  var _useState17 = (0,react.useState)(null),
      activeStep = _useState17[0],
      setActiveStep = _useState17[1];

  var _useState18 = (0,react.useState)(0),
      activeStepNo = _useState18[0],
      setActiveStepNo = _useState18[1];

  var _useState19 = (0,react.useState)(null),
      customerStatus = _useState19[0],
      setCustomerStatus = _useState19[1];

  var _useState20 = (0,react.useState)(true),
      showOnceOff = _useState20[0],
      setShowOnceOff = _useState20[1];

  var clickAndCollectDelivery = dealCartProducts && (_dealCartProducts$5 = dealCartProducts[0]) !== null && _dealCartProducts$5 !== void 0 && (_dealCartProducts$5$p = _dealCartProducts$5.product) !== null && _dealCartProducts$5$p !== void 0 && _dealCartProducts$5$p.enable_click_and_collect && clickAndCollectEnabled && !(cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) ? true : false;
  var activeStepRef = (0,react.useRef)(activeStep);
  var router = (0,DependencyHelper.useRouter)();
  var paymentStatus = router.query;
  var previewMode = ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.previewMode) === "on";

  var _useState21 = (0,react.useState)({
    visible: false,
    message: "",
    type: "default",
    className: "",
    dismissClass: "",
    textClass: ""
  }),
      showSnackBar = _useState21[0],
      setShowSnackBar = _useState21[1];

  var _useState22 = (0,react.useState)({
    type: "success",
    title: "We’ll be in contact soon!",
    desc: null,
    primaryLabel: null,
    primaryUrl: null,
    secondaryLabel: null,
    secondaryUrl: null,
    handlePrimaryClick: function handlePrimaryClick() {},
    handleSecondaryClick: function handleSecondaryClick() {},
    imgUrl: null,
    pageName: null,
    pageErrorType: null,
    additionalUtagData: null,
    dividerLine: false,
    subTitle: null,
    subDesc: null,
    ctaTitle: null,
    disablePrimary: false,
    preferences: [],
    defaultPreference: null,
    analyticsPageErrorCode: null,
    analyticsPageErrorMessage: null
  }),
      pageErr = _useState22[0],
      setPageErr = _useState22[1];

  var _useState23 = (0,react.useState)({
    heading: {
      title: "",
      desc: "",
      titleClass: "",
      descClass: "",
      id: "",
      "class": ""
    },
    button: {
      secure: false,
      payment: false,
      lable: "Continue",
      backLable: "Back to cart",
      backButtonId: "back-cart",
      backButtonClass: "d-none",
      btnType: "submit",
      disable: false
    },
    orderSummery: {
      variant: "plain"
    },
    steps: {
      all: journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.upgradeStepsTrackerWithPayment */.e9.upgradeStepsTrackerWithPayment : constants/* CHECKOUT_CONFIG.upgradeStepsTracker */.e9.upgradeStepsTracker : numberTransferEnabled && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransferPayment */.e9.newLineStepsTrackerWithNumberTransferPayment : numberTransferEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransfer */.e9.newLineStepsTrackerWithNumberTransfer : cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithPayment */.e9.newLineStepsTrackerWithPayment : constants/* CHECKOUT_CONFIG.newLineStepsTracker */.e9.newLineStepsTracker,
      show: false,
      width: journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? "step-width-65" : numberTransferEnabled || cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? "step-width-75" : "step-width-65"
    }
  }),
      state = _useState23[0],
      setState = _useState23[1];

  var heading = state.heading,
      button = state.button,
      orderSummery = state.orderSummery,
      steps = state.steps;

  function featuresCheck() {
    return _featuresCheck.apply(this, arguments);
  }

  function _featuresCheck() {
    _featuresCheck = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
      var featuresResult;
      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet( // TODO: Replace with redux features.
              "featureBaseUrl", "", "api", "features");

            case 3:
              featuresResult = _context11.sent;
              setFeatures(featuresResult);

              if (featuresResult !== null && featuresResult !== void 0 && featuresResult.multiCartEnabled && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) {
                setCartMulti(true);
              } else {
                setCartMulti(false);
              }

              _context11.next = 11;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](0);
              console.log("error", _context11.t0);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 8]]);
    }));
    return _featuresCheck.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    if (true) {
      setRedirectURL(window.location.href);
    }

    featuresCheck();
  }, []);
  (0,react.useEffect)(function () {
    if ((0,helperServices/* isArrayNotEmpty */.wh)(cartDetails.guestCartItems) && cartDetails.totalQuantity > cartDetails.guestCartQty && userLoggedIn && customerStatus) {
      fetchErrorDetails();
    }
  }, [cartDetails.totalQuantity, userLoggedIn, customerStatus]);
  (0,react.useEffect)(function () {
    if (userLoggedIn) {
      //Set the customer status(nc,ec,upgrade) value as per journey
      getCustomerStatus(journey);
      fetchAddressStateTypes();
      fetchFaqData();

      if (checkoutDetails.postCheckoutCurrentStep) {
        setLabels(checkoutDetails.postCheckoutCurrentStep);
        setActiveStep(checkoutDetails.postCheckoutCurrentStep);

        if (checkoutDetails.postCheckoutCurrentStep !== "login" && checkoutDetails.postCheckoutCurrentStep !== "authentication") {
          history.pushState({
            name: checkoutDetails.postCheckoutCurrentStep
          }, null, window.location.pathname);
        }
      } else {
        setLabels("authentication");
        setActiveStep("authentication");
      }
    } else {
      setLabels("login");
      setActiveStep("login");
    }
  }, [userLoggedIn]);
  (0,react.useEffect)(function () {
    if (activeStep) {
      window.scrollTo(0, 0);
      var activeStepObjNo;
      var newActiveStep = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled && (activeStep == "paymentRedirect" || activeStep == "paymentError") ? "payment" : activeStep == "paymentRedirect" || activeStep == "paymentError" ? "review" : activeStep;

      if (journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
        var _CHECKOUT_CONFIG$upgr, _CHECKOUT_CONFIG$upgr2;

        activeStepObjNo = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$upgr = constants/* CHECKOUT_CONFIG.upgradeJourneyWithPayment */.e9.upgradeJourneyWithPayment[newActiveStep]) === null || _CHECKOUT_CONFIG$upgr === void 0 ? void 0 : _CHECKOUT_CONFIG$upgr.activeStepNo : (_CHECKOUT_CONFIG$upgr2 = constants/* CHECKOUT_CONFIG.upgradeJourney */.e9.upgradeJourney[newActiveStep]) === null || _CHECKOUT_CONFIG$upgr2 === void 0 ? void 0 : _CHECKOUT_CONFIG$upgr2.activeStepNo;
      } else {
        var _CHECKOUT_CONFIG$newL, _CHECKOUT_CONFIG$newL2, _CHECKOUT_CONFIG$newL3, _CHECKOUT_CONFIG$newL4;

        activeStepObjNo = numberTransferEnabled && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$newL = constants/* CHECKOUT_CONFIG.newLineJourneyWithNumberTransferPayment */.e9.newLineJourneyWithNumberTransferPayment[newActiveStep]) === null || _CHECKOUT_CONFIG$newL === void 0 ? void 0 : _CHECKOUT_CONFIG$newL.activeStepNo : numberTransferEnabled ? (_CHECKOUT_CONFIG$newL2 = constants/* CHECKOUT_CONFIG.newLineJourneyWithNumberTransfer */.e9.newLineJourneyWithNumberTransfer[newActiveStep]) === null || _CHECKOUT_CONFIG$newL2 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL2.activeStepNo : cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$newL3 = constants/* CHECKOUT_CONFIG.newLineJourneyWithPayment */.e9.newLineJourneyWithPayment[newActiveStep]) === null || _CHECKOUT_CONFIG$newL3 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL3.activeStepNo : (_CHECKOUT_CONFIG$newL4 = constants/* CHECKOUT_CONFIG.newLineJourney */.e9.newLineJourney[newActiveStep]) === null || _CHECKOUT_CONFIG$newL4 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL4.activeStepNo;
      }

      setActiveStepNo(activeStepObjNo ? activeStepObjNo : 0);

      if (checkoutDetails.postCheckoutCurrentStep !== activeStep) {
        setCurrentStep(activeStep);
      }
    }

    var bucket = (0,checkoutService/* getLeadBucket */.p6)(activeStep, journey);
    setHelpLeadBucket(bucket);
  }, [activeStep]);

  function setCurrentStep(step) {
    if (step == "login" || step == "payment" || step == "paymentRedirect" || step == "paymentError" || step == "orderConfirmation" || step == "pageError") {
      if (checkoutDetails.skipCreditVetting && checkoutDetails.postCheckoutCurrentStep && authDetailsData && step == "pageError") {
        if (journey == checkout_journey_context/* journeyType.newLine */.w.newLine) {
          //Redirect user to the XDS/review page if the selected deal is affordable
          var newStep = (authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idType) == "SAID" ? "xds" : "review";
          setPostCheckoutCurrentStep(newStep);
          activeStepRef.current = newStep;
        }
      } else {
        //Reset step
        setPostCheckoutCurrentStep(null); //Browser back button redirects to cart on error if step is authentication- in handleBackStep function

        activeStepRef.current = "authentication";
      }
    } else {
      setPostCheckoutCurrentStep(step);
      activeStepRef.current = step;
    }
  }

  var browserBackButton = function browserBackButton(e) {
    if (activeStepRef.current) {
      e.preventDefault();
      e.stopPropagation();
      handleBackStep();
    }
  };

  (0,react.useEffect)(function () {
    window.addEventListener("popstate", browserBackButton);
    return function () {
      window.removeEventListener("popstate", browserBackButton);
    };
  }, []);
  /**
   * Set the step tracker as per journey context
   */

  var setJourneyStepTracker = function setJourneyStepTracker(type) {
    //Set the customer status(nc,ec,upgrade) value as per journey
    getCustomerStatus(type);

    if (type == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
      steps.all = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.upgradeStepsTrackerWithPayment */.e9.upgradeStepsTrackerWithPayment : constants/* CHECKOUT_CONFIG.upgradeStepsTracker */.e9.upgradeStepsTracker;
      steps.width = "step-width-65"; //upgradeStepsTracker
    } else {
      steps.all = numberTransferEnabled && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransferPayment */.e9.newLineStepsTrackerWithNumberTransferPayment : numberTransferEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithNumberTransfer */.e9.newLineStepsTrackerWithNumberTransfer : cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? constants/* CHECKOUT_CONFIG.newLineStepsTrackerWithPayment */.e9.newLineStepsTrackerWithPayment : constants/* CHECKOUT_CONFIG.newLineStepsTracker */.e9.newLineStepsTracker;
      steps.width = numberTransferEnabled || cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? "step-width-75" : "step-width-65";
    }

    setState(post_checkout_objectSpread(post_checkout_objectSpread({}, state), {}, {
      steps: steps
    }));
  };
  /**
   * Disable back button
   */


  var setDisableBackButton = function setDisableBackButton(status) {
    button.disable = status;
    setState(post_checkout_objectSpread(post_checkout_objectSpread({}, state), {}, {
      button: button
    }));
  };
  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */


  var fetchErrorDetails = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // const pageName = `checkout: pre val: ${customerStatus}: merge cart`;
              try {
                (0,helperServices/* showSpinner */.yh)(); // const result = await ajaxService.httpGet(
                //   "drupalBaseUrl",
                //   "",
                //   "api",
                //   "mergeCartError"
                // );

                handleClearCartAndCheckout(null, "checkout: cart read issue", "Clear cart", "pageError");
                setPageErr({
                  type: "error",
                  title: labels/* default.errors.lbl_something_went_wrong */.Z.errors.lbl_something_went_wrong,
                  desc: "There seems to be issue with cart. Please try again",
                  primaryLabel: "Browse deals",
                  handlePrimaryClick: function () {
                    var _handlePrimaryClick = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                      return regenerator_default().wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return router.push("".concat(helperServices/* urlPrefix */.wn, "/deals"));

                            case 2:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    function handlePrimaryClick() {
                      return _handlePrimaryClick.apply(this, arguments);
                    }

                    return handlePrimaryClick;
                  }(),
                  handleSecondaryClick: function handleSecondaryClick() {},
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: "checkout: cart read issue"
                });
                (0,helperServices/* hideSpinner */.v3)(); //Navigate to checkout page error

                handleNextStep("pageError"); // setPageErr({
                //   type: "error",
                //   title: result[0].resultTitle,
                //   desc:
                //     result[0].resultText && result[0].resultText !== ""
                //       ? result[0].resultText
                //       : result[0].resultHTML,
                //   primaryLabel:
                //     result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
                //   primaryUrl:
                //     result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
                //   secondaryLabel:
                //     result[0].secondaryEnabled === "Yes"
                //       ? result[0].secondaryCTAText
                //       : null,
                //   secondaryUrl:
                //     result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
                //   handlePrimaryClick: () =>
                //     handleClearCartAndCheckout(
                //       result[0].primaryCTAURL,
                //       pageName,
                //       result[0].primaryCTAText
                //     ),
                //   handleSecondaryClick: () =>
                //     handleSecondaryClick(
                //       generateFormURL(
                //         result[0].secondaryCTAURL,
                //         result[0].leadType,
                //         result[0].secondaryCTAType
                //       ),
                //       pageName,
                //       result[0].secondaryCTAText
                //     ),
                //   imgUrl: result[0].icon,
                //   pageName: pageName,
                // });
                // hideSpinner();
                // //Navigate to checkout page error
                // handleNextStep("pageError");
              } catch (_unused) {
                // setPageErr({
                //   type: "error",
                //   title: labels.checkout.lbl_merge_cart_error_title,
                //   desc: labels.checkout.lbl_merge_cart_error_desc,
                //   primaryLabel: "Clear cart & continue with checkout",
                //   secondaryLabel: "View my cart",
                //   handlePrimaryClick: () =>
                //     handleClearCartAndCheckout(
                //       null,
                //       pageName,
                //       "Clear cart & continue with checkout"
                //     ),
                //   handleSecondaryClick: () =>
                //     handleSecondaryClick(null, pageName, "View my cart"),
                //   imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
                //   pageName: pageName,
                // });
                handleClearCartAndCheckout(null, "checkout: cart read issue", "Clear cart", "pageError");
                setPageErr({
                  type: "error",
                  title: labels/* default.errors.lbl_something_went_wrong */.Z.errors.lbl_something_went_wrong,
                  desc: "There seems to be issue with cart. Please try again",
                  primaryLabel: "Browse deals",
                  handlePrimaryClick: function () {
                    var _handlePrimaryClick2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
                      return regenerator_default().wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return router.push("".concat(helperServices/* urlPrefix */.wn, "/deals"));

                            case 2:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    function handlePrimaryClick() {
                      return _handlePrimaryClick2.apply(this, arguments);
                    }

                    return handlePrimaryClick;
                  }(),
                  handleSecondaryClick: function handleSecondaryClick() {},
                  imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
                  pageName: "checkout: cart read issue"
                });
                (0,helperServices/* hideSpinner */.v3)(); //Navigate to checkout page error

                handleNextStep("pageError");
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchErrorDetails() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleClearCartAndCheckout = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(url, pageName, label, action) {
      var nonVasProducts, cartItemsIds, query, dealGuestProducts, simpleProducts, configurableProducts, bundledProduct, vasProduct, valueString, optionId, cartItemsArr, vasArray, _cartDetails$guestCou, code;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label)
              });
              (0,helperServices/* showSpinner */.yh)();
              nonVasProducts = cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.cartProductItems.filter(function (item) {
                return !(item !== null && item !== void 0 && item.parent_product_sku);
              });
              cartItemsIds = nonVasProducts.map(function (item) {
                return item === null || item === void 0 ? void 0 : item.id;
              });
              query = (0,helperServices/* getClearCartQuery */.Bn)(cartItemsIds);
              _context4.next = 7;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(query);

            case 7:
              _context4.next = 9;
              return showGuestCart(cartId);

            case 9:
              dealGuestProducts = cartDetails.guestCartItems.filter(function (item) {
                var _item$product2;

                return (item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.is_deal_product) === 1;
              });
              simpleProducts = cartDetails.guestCartItems.filter(function (item) {
                var _item$product3;

                return !(item !== null && item !== void 0 && item.monthly_recurring) && (item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.__typename) === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple && !(0,helperServices/* checkIsOutOfStock */.zy)(item);
              });
              configurableProducts = cartDetails.guestCartItems.filter(function (item) {
                var _item$product4;

                return (item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && !(0,helperServices/* checkIsOutOfStock */.zy)(item);
              });
              bundledProduct = cartDetails.guestCartItems.filter(function (item) {
                var _item$product5, _item$product6;

                return (item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.is_deal_product) === 0 && !(item !== null && item !== void 0 && item.monthly_recurring) && (item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle && !(0,helperServices/* checkIsOutOfStock */.zy)(item);
              });
              vasProduct = cartDetails.guestCartItems.filter(function (item) {
                var _dealGuestProducts$, _dealGuestProducts$$p;

                return (item === null || item === void 0 ? void 0 : item.parent_product_sku) === (dealGuestProducts === null || dealGuestProducts === void 0 ? void 0 : (_dealGuestProducts$ = dealGuestProducts[0]) === null || _dealGuestProducts$ === void 0 ? void 0 : (_dealGuestProducts$$p = _dealGuestProducts$.product) === null || _dealGuestProducts$$p === void 0 ? void 0 : _dealGuestProducts$$p.sku);
              });

              if (!(0,helperServices/* isArrayNotEmpty */.wh)(dealGuestProducts)) {
                _context4.next = 20;
                break;
              }

              cartItemsArr = dealGuestProducts.map(function (item) {
                var _item$bundle_custom_o, _item$bundle_custom_o2, _item$product7, _item$product7$option, _item$product8, _item$product9;

                valueString = item === null || item === void 0 ? void 0 : (_item$bundle_custom_o = item.bundle_custom_options[0]) === null || _item$bundle_custom_o === void 0 ? void 0 : (_item$bundle_custom_o2 = _item$bundle_custom_o.values[0]) === null || _item$bundle_custom_o2 === void 0 ? void 0 : _item$bundle_custom_o2.value;
                optionId = item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : (_item$product7$option = _item$product7.options[0]) === null || _item$product7$option === void 0 ? void 0 : _item$product7$option.option_id;
                var bundleOptions = item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.items.map(function (bundle) {
                  var values = bundle === null || bundle === void 0 ? void 0 : bundle.options.map(function (option) {
                    return option.id;
                  });
                  var obj = {
                    id: bundle === null || bundle === void 0 ? void 0 : bundle.option_id,
                    quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                    value: values
                  };
                  return obj;
                });
                var cartObj = {
                  bundle_options: bundleOptions,
                  data: {
                    sku: "".concat(item === null || item === void 0 ? void 0 : (_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : _item$product9.sku).toString(),
                    quantity: item === null || item === void 0 ? void 0 : item.quantity
                  },
                  customizable_options: (0,helperServices/* getCustomizableOptions */.cv)(optionId, valueString)
                };
                return cartObj;
              });

              if ((0,helperServices/* isArrayNotEmpty */.wh)(vasProduct)) {
                vasArray = vasProduct.map(function (item) {
                  var _item$product10, _dealGuestProducts$2, _dealGuestProducts$2$;

                  var vasData = {
                    data: {
                      sku: item === null || item === void 0 ? void 0 : (_item$product10 = item.product) === null || _item$product10 === void 0 ? void 0 : _item$product10.sku,
                      quantity: item === null || item === void 0 ? void 0 : item.quantity
                    },
                    parent_product_sku: "".concat(dealGuestProducts === null || dealGuestProducts === void 0 ? void 0 : (_dealGuestProducts$2 = dealGuestProducts[0]) === null || _dealGuestProducts$2 === void 0 ? void 0 : (_dealGuestProducts$2$ = _dealGuestProducts$2.product) === null || _dealGuestProducts$2$ === void 0 ? void 0 : _dealGuestProducts$2$.sku).toString(),
                    monthly_recurring: item === null || item === void 0 ? void 0 : item.monthly_recurring,
                    customizable_options: (0,helperServices/* getCustomizableOptions */.cv)(optionId, valueString),
                    bundle_options: []
                  };
                  return vasData;
                });
              }

              if ((0,helperServices/* isArrayNotEmpty */.wh)(vasArray)) {
                cartItemsArr = [].concat((0,toConsumableArray/* default */.Z)(cartItemsArr), (0,toConsumableArray/* default */.Z)(vasArray));
              }

              _context4.next = 20;
              return addBundleProductToGuestCart(cartId, cartItemsArr);

            case 20:
              if (!(0,helperServices/* isArrayNotEmpty */.wh)(simpleProducts)) {
                _context4.next = 24;
                break;
              }

              cartItemsArr = simpleProducts.map(function (item) {
                var _item$simple_custom_o, _item$simple_custom_o2, _item$product11, _item$product11$optio, _item$product12;

                valueString = item === null || item === void 0 ? void 0 : (_item$simple_custom_o = item.simple_custom_options[0]) === null || _item$simple_custom_o === void 0 ? void 0 : (_item$simple_custom_o2 = _item$simple_custom_o.values[0]) === null || _item$simple_custom_o2 === void 0 ? void 0 : _item$simple_custom_o2.value;
                optionId = item === null || item === void 0 ? void 0 : (_item$product11 = item.product) === null || _item$product11 === void 0 ? void 0 : (_item$product11$optio = _item$product11.options[0]) === null || _item$product11$optio === void 0 ? void 0 : _item$product11$optio.option_id;
                var obj = {
                  data: {
                    quantity: item === null || item === void 0 ? void 0 : item.quantity,
                    sku: item === null || item === void 0 ? void 0 : (_item$product12 = item.product) === null || _item$product12 === void 0 ? void 0 : _item$product12.sku
                  },
                  customizable_options: (0,helperServices/* getCustomizableOptions */.cv)(optionId, valueString)
                };
                return obj;
              });
              _context4.next = 24;
              return addSimpleProductToGuestCart(cartId, cartItemsArr);

            case 24:
              if (!(0,helperServices/* isArrayNotEmpty */.wh)(configurableProducts)) {
                _context4.next = 28;
                break;
              }

              cartItemsArr = configurableProducts.map(function (item) {
                var _item$config_custom_o, _item$config_custom_o2, _item$product13, _item$product13$optio, _item$product15, _item$product16, _selectedVariant$prod;

                valueString = item === null || item === void 0 ? void 0 : (_item$config_custom_o = item.config_custom_options[0]) === null || _item$config_custom_o === void 0 ? void 0 : (_item$config_custom_o2 = _item$config_custom_o.values[0]) === null || _item$config_custom_o2 === void 0 ? void 0 : _item$config_custom_o2.value;
                optionId = item === null || item === void 0 ? void 0 : (_item$product13 = item.product) === null || _item$product13 === void 0 ? void 0 : (_item$product13$optio = _item$product13.options[0]) === null || _item$product13$optio === void 0 ? void 0 : _item$product13$optio.option_id;

                var getLabel = function getLabel(label) {
                  var _item$product14;

                  var headingObj = item === null || item === void 0 ? void 0 : (_item$product14 = item.product) === null || _item$product14 === void 0 ? void 0 : _item$product14.configurable_options.find(function (config) {
                    return config.label === label;
                  });
                  return headingObj === null || headingObj === void 0 ? void 0 : headingObj.attribute_code;
                };

                var optionObj = {};
                item === null || item === void 0 ? void 0 : item.configurable_options.forEach(function (addedOption) {
                  optionObj[getLabel(addedOption.option_label)] = addedOption.value_label;
                });
                var selectedVariant = (0,helperServices/* getSelectedVariant */.c)(item === null || item === void 0 ? void 0 : (_item$product15 = item.product) === null || _item$product15 === void 0 ? void 0 : _item$product15.variants, optionObj);
                var obj = {
                  parent_sku: "".concat(item === null || item === void 0 ? void 0 : (_item$product16 = item.product) === null || _item$product16 === void 0 ? void 0 : _item$product16.sku).toString(),
                  data: {
                    quantity: item === null || item === void 0 ? void 0 : item.quantity,
                    sku: "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (_selectedVariant$prod = selectedVariant.product) === null || _selectedVariant$prod === void 0 ? void 0 : _selectedVariant$prod.sku).toString()
                  },
                  customizable_options: (0,helperServices/* getCustomizableOptions */.cv)(optionId, valueString)
                };
                return obj;
              });
              _context4.next = 28;
              return addConfigurableToGuestCart(cartId, cartItemsArr);

            case 28:
              if (!(0,helperServices/* isArrayNotEmpty */.wh)(bundledProduct)) {
                _context4.next = 32;
                break;
              }

              cartItemsArr = bundledProduct.map(function (item) {
                var _item$bundle_custom_o3, _item$bundle_custom_o4, _item$product17, _item$product17$optio, _item$product18, _item$product19;

                valueString = item === null || item === void 0 ? void 0 : (_item$bundle_custom_o3 = item.bundle_custom_options[0]) === null || _item$bundle_custom_o3 === void 0 ? void 0 : (_item$bundle_custom_o4 = _item$bundle_custom_o3.values[0]) === null || _item$bundle_custom_o4 === void 0 ? void 0 : _item$bundle_custom_o4.value;
                optionId = item === null || item === void 0 ? void 0 : (_item$product17 = item.product) === null || _item$product17 === void 0 ? void 0 : (_item$product17$optio = _item$product17.options[0]) === null || _item$product17$optio === void 0 ? void 0 : _item$product17$optio.option_id;
                var bundleOptions = item === null || item === void 0 ? void 0 : (_item$product18 = item.product) === null || _item$product18 === void 0 ? void 0 : _item$product18.items.map(function (bundle) {
                  var obj = {
                    id: bundle === null || bundle === void 0 ? void 0 : bundle.option_id,
                    quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                    value: [bundle === null || bundle === void 0 ? void 0 : bundle.options[0].id]
                  };
                  return obj;
                });
                var cartObj = {
                  bundle_options: bundleOptions,
                  data: {
                    sku: "".concat(item === null || item === void 0 ? void 0 : (_item$product19 = item.product) === null || _item$product19 === void 0 ? void 0 : _item$product19.sku).toString(),
                    quantity: item === null || item === void 0 ? void 0 : item.quantity
                  },
                  customizable_options: (0,helperServices/* getCustomizableOptions */.cv)(optionId, valueString)
                };
                return cartObj;
              });
              _context4.next = 32;
              return addBundleProductToGuestCart(cartId, cartItemsArr);

            case 32:
              if (!(0,helperServices/* isArrayNotEmpty */.wh)(cartDetails.guestCoupons)) {
                _context4.next = 36;
                break;
              }

              code = cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$guestCou = cartDetails.guestCoupons[0]) === null || _cartDetails$guestCou === void 0 ? void 0 : _cartDetails$guestCou.code;
              _context4.next = 36;
              return addCouponToCart(cartId, code);

            case 36:
              addGuestCartProducts([], 0);
              (0,helperServices/* hideSpinner */.v3)();

              if (action) {
                handleNextStep(action);
              } else {
                handleNextStep("authentication");
              }

            case 39:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleClearCartAndCheckout(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var _handleSecondaryClick = function handleSecondaryClick(url, pageName, label, _skipUrlPrefix) {
    (0,helperServices/* showSpinner */.yh)();
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label)
    });
    addGuestCartProducts([], 0, null);

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  function fetchAddressStateTypes() {
    return _fetchAddressStateTypes.apply(this, arguments);
  }

  function _fetchAddressStateTypes() {
    _fetchAddressStateTypes = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12() {
      var resultsStates, resultsAddressTypes, _resultsStates$errors, _resultsAddressTypes$;

      return regenerator_default().wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return (0,checkoutService/* getSAStatesService */.Ky)();

            case 2:
              resultsStates = _context12.sent;
              _context12.next = 5;
              return (0,checkoutService/* getAddressTypesService */.Fi)();

            case 5:
              resultsAddressTypes = _context12.sent;

              if (resultsStates) {
                if (!resultsStates.fail) {
                  setCountryCode(resultsStates.countryRegions.countryCode);
                  setCountryName(resultsStates.countryRegions.countryName);
                  setRegions(resultsStates.countryRegions.regions);
                }

                if (resultsStates.errors) {
                  analyticsUtag/* link */.p4(post_checkout_objectSpread(post_checkout_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(resultsStates.errors[0] ? (_resultsStates$errors = resultsStates.errors) === null || _resultsStates$errors === void 0 ? void 0 : _resultsStates$errors[0].message : ""),
                    page_errors_code: "chk-dxl-g-states-".concat(resultsStates.status)
                  }));
                }
              }

              if (resultsAddressTypes) {
                if (!resultsAddressTypes.fail) {
                  setAddressTypes(resultsAddressTypes.addressTypeData);
                }

                if (resultsAddressTypes.errors) {
                  analyticsUtag/* link */.p4(post_checkout_objectSpread(post_checkout_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name"])), {}, {
                    page_form_event: "error",
                    page_errors: "".concat(resultsAddressTypes.errors[0] ? (_resultsAddressTypes$ = resultsAddressTypes.errors) === null || _resultsAddressTypes$ === void 0 ? void 0 : _resultsAddressTypes$[0].message : ""),
                    page_errors_code: "chk-dxl-g-at-".concat(resultsAddressTypes.status)
                  }));
                }
              }

            case 8:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));
    return _fetchAddressStateTypes.apply(this, arguments);
  }

  function fetchFaqData() {
    return _fetchFaqData.apply(this, arguments);
  } // Redirecting to order confirmation page on payment success


  function _fetchFaqData() {
    _fetchFaqData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee13() {
      var resultsFaq, len, i, _resultsFaq$sections$;

      return regenerator_default().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "checkoutFaq");

            case 2:
              resultsFaq = _context13.sent;

              if ((resultsFaq === null || resultsFaq === void 0 ? void 0 : resultsFaq.status) == "success") {
                len = resultsFaq.sections.length;

                for (i = 0; i < len; i++) {
                  if (resultsFaq.sections[i]) {
                    if (resultsFaq.sections[i].type == "paragraph_list" && resultsFaq.sections[i].paragraphInfo == "form") {
                      setFormContent(resultsFaq.sections[i]);
                    }

                    if (resultsFaq.sections[i].type == "paragraph_list" && resultsFaq.sections[i].paragraphInfo == "sidebar") {
                      setSidebarContent(resultsFaq.sections[i]);
                    }

                    if (resultsFaq.sections[i].type == "faq") {
                      setFaq(resultsFaq.sections[i]);
                    }

                    if (resultsFaq.sections[i].type == "paragraph_list" && resultsFaq.sections[i].paragraphInfo == "sidebar-notification") {
                      setNotificationContent((_resultsFaq$sections$ = resultsFaq.sections[i]) === null || _resultsFaq$sections$ === void 0 ? void 0 : _resultsFaq$sections$.items[0]);
                    }
                  }
                }
              }

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));
    return _fetchFaqData.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    if (userLoggedIn) {
      checkUserPickedDetails();

      if (Object.keys(paymentStatus).length > 0 && orderId) {
        setLabels(null);
        setActiveStep(null);
        callVerifyStatus();
      } else {
        DependencyHelper.Cookie.remove((config_default()).order_id);
        DependencyHelper.Cookie.remove((config_default()).pay_fail_count);
      }

      analyticsUtag/* setAutoTagging */.fv(false);
    }
  }, [paymentStatus, userLoggedIn]);

  var checkUserPickedDetails = function checkUserPickedDetails() {
    var sessionCartSummary = (0,helperServices/* getSessionStorage */.wJ)(labels/* default.Session_Keys.lbl_cart_summary */.Z.Session_Keys.lbl_cart_summary);

    if (!sessionCartSummary) {
      handleClearCartAndCheckout(null, "checkout: cart read issue", "Clear cart", "pageError");
      setPageErr({
        type: "error",
        title: labels/* default.errors.lbl_something_went_wrong */.Z.errors.lbl_something_went_wrong,
        desc: "There seems to be issue with cart. Please try again",
        primaryLabel: "Browse deals",
        handlePrimaryClick: function () {
          var _handlePrimaryClick3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
            return regenerator_default().wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return router.push("".concat(helperServices/* urlPrefix */.wn, "/deals"));

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function handlePrimaryClick() {
            return _handlePrimaryClick3.apply(this, arguments);
          }

          return handlePrimaryClick;
        }(),
        handleSecondaryClick: function handleSecondaryClick() {},
        imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
        pageName: "checkout: cart read issue"
      });
      handleNextStep("pageError");
    }
  };

  var callVerifyStatus = function callVerifyStatus() {
    (0,helperServices/* showSpinner */.yh)();
    var headers = {
      "Content-Type": "application/json"
    };
    var url = "".concat((config_default()).envConfigs[(config_default()).env].dxl.url).concat((config_default()).api.verifyPayment);
    axios_default().post(url, paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.params, {
      headers: headers
    }).then(function (response) {
      var _response$data, _response$data$result, _paymentStatus$params;

      (0,helperServices/* hideSpinner */.v3)();

      if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$result = _response$data.result) !== null && _response$data$result !== void 0 && _response$data$result.successful || (paymentStatus === null || paymentStatus === void 0 ? void 0 : (_paymentStatus$params = paymentStatus.params) === null || _paymentStatus$params === void 0 ? void 0 : _paymentStatus$params.ErrorCode) == "00") {
        DependencyHelper.Cookie.remove((config_default()).pay_fail_count);
        setPaymentMethodUrl(null);
        setPostOrderResponse({});
        handleNextStep("orderConfirmation");
      } else {
        updatePaymentRetryCount();
        handleNextStep("paymentError");
      }
    })["catch"](function (_err) {
      var _paymentStatus$params2;

      (0,helperServices/* hideSpinner */.v3)();
      DependencyHelper.Cookie.remove((config_default()).order_id);
      DependencyHelper.Cookie.remove((config_default()).pay_fail_count);
      setPaymentMethodUrl(null);
      setPostOrderResponse({});

      if ((paymentStatus === null || paymentStatus === void 0 ? void 0 : (_paymentStatus$params2 = paymentStatus.params) === null || _paymentStatus$params2 === void 0 ? void 0 : _paymentStatus$params2.ErrorCode) !== "00" || paymentStatus !== null && paymentStatus !== void 0 && paymentStatus.error) {
        if (previewMode) {
          handleNextStep("authentication");
        } else {
          setPageErr({
            type: "error",
            title: labels/* default.errors.lbl_something_went_wrong */.Z.errors.lbl_something_went_wrong,
            desc: labels/* default.lbl_checkout_unavailable */.Z.lbl_checkout_unavailable,
            primaryLabel: null,
            secondaryLabel: "Exit checkout",
            handlePrimaryClick: function handlePrimaryClick() {},
            handleSecondaryClick: function handleSecondaryClick() {
              return _handleSecondaryClick("/cart", "checkout: make payment: ".concat(customerStatus), "exit");
            },
            imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
            pageName: "checkout: make payment: ".concat(customerStatus)
          });
          handleNextStep("pageError");
        }
      } else {
        handleNextStep("authentication");
      }
    });
  };

  var updatePaymentRetryCount = function updatePaymentRetryCount() {
    var retryCount = (0,helperServices/* getCookieValue */.Do)((config_default()).pay_fail_count);
    var newCount = retryCount ? parseInt(retryCount) + 1 : 0;
    (0,helperServices/* setCookieConsentWrapper */.ol)("cookie_".concat((config_default()).pay_fail_count), [(config_default()).cookie_category.strictly_necessary], "document.cookie='".concat((config_default()).pay_fail_count, "=").concat(newCount, ";path=/'"));
  };

  (0,react.useEffect)(function () {
    if (cartIdCookie) {
      setCartId(cartIdCookie);
    }
  }, [cartIdCookie]);
  (0,react.useEffect)(function () {
    function getSeoData() {
      return _getSeoData.apply(this, arguments);
    }

    function _getSeoData() {
      _getSeoData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        var results;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return pageService/* getPageComponents */.eU(["checkout/CBU".concat(previewMode ? (config_default()).pageServiceQueryData.preview : (config_default()).pageServiceQueryData.status)]);

              case 2:
                results = _context6.sent;
                setMetaData(results === null || results === void 0 ? void 0 : results.seoMetadata);

                if (results && results.status === "error") {
                  analyticsUtag/* link */.p4({
                    page_name: "checkout: ".concat(customerStatus),
                    page_form_event: "error",
                    page_errors: "".concat(results.reason ? results.reason : ""),
                    page_errors_code: "chck-d-g-seo"
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _getSeoData.apply(this, arguments);
    }

    getSeoData();
  }, []);

  function getCustomerStatus(type) {
    if (type == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
      setCustomerStatus("upgrade");
    } else if (type == checkout_journey_context/* journeyType.newLine */.w.newLine) {
      setCustomerStatus("nc");
    } else {
      setCustomerStatus("ec");
    }
  }

  (0,react.useEffect)(function () {
    var allow_place_order = cartDetails.allow_place_order;

    if (typeof allow_place_order !== "undefined" && Number(allow_place_order) === 0) {
      setPageErr({
        type: "error",
        title: labels/* default.errors.lbl_something_went_wrong */.Z.errors.lbl_something_went_wrong,
        desc: labels/* default.lbl_checkout_unavailable */.Z.lbl_checkout_unavailable,
        primaryLabel: null,
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: function handlePrimaryClick() {
          return _handlePrimaryClick4("/cart", "exit checkout");
        },
        imgUrl: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/error-warning-red.svg"),
        pageName: "checkout: lets get started: ".concat(customerStatus)
      });
      setAllowPlaceOrder(false);
      handleNextStep("pageError");
    } else {
      setAllowPlaceOrder(true);
    }
  }, [cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.allow_place_order]);

  var onClickSubmit = function onClickSubmit() {
    if (allowPlaceOrder && !continueDisabled && postCheckoutPageRef.current && postCheckoutPageRef.current.submit) {
      var _creditVettingDetails;

      if (cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && creditVettingDetails && ((creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pended */.Z.creditVetting.lbl_resultcode_pended || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_pending */.Z.creditVetting.lbl_resultcode_pending || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_referred */.Z.creditVetting.lbl_resultcode_referred || (creditVettingDetails === null || creditVettingDetails === void 0 ? void 0 : creditVettingDetails.resultCode) === labels/* default.creditVetting.lbl_resultcode_offline */.Z.creditVetting.lbl_resultcode_offline || creditVettingDetails !== null && creditVettingDetails !== void 0 && (_creditVettingDetails = creditVettingDetails.resultCode) !== null && _creditVettingDetails !== void 0 && _creditVettingDetails.toUpperCase().includes(labels/* default.creditVetting.lbl_unprocessed */.Z.creditVetting.lbl_unprocessed))) {
        setShowOnceOff(false); //hide once-off info in the Checkout Order Summary
      } else {
        setShowOnceOff(true);
      }

      postCheckoutPageRef.current.submit();
    }
  };

  var handleNextStep = function handleNextStep(newStep) {
    setLabels(newStep);
    setActiveStep(newStep);

    if (newStep !== "login" && newStep !== "authentication" && newStep !== "paymentRedirect" && newStep !== "paymentError" && newStep !== "orderConfirmation" && newStep !== "pageError") {
      history.pushState({
        name: newStep
      }, null, window.location.pathname);
    } else {
      history.pushState(null, null, window.location.pathname);
    }
  };

  var handleBackStep = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
      var currentActiveStep, previousStep, _CHECKOUT_CONFIG$upgr3, _CHECKOUT_CONFIG$upgr4, _CHECKOUT_CONFIG$newL5, _CHECKOUT_CONFIG$newL6, _CHECKOUT_CONFIG$newL7, _CHECKOUT_CONFIG$newL8;

      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              currentActiveStep = activeStep ? activeStep : activeStepRef.current;

              if (postCheckoutPageRef.current && postCheckoutPageRef.current.back) {
                postCheckoutPageRef.current.back();
              }

              if (!(currentActiveStep == "authentication" || currentActiveStep == "creditCheck")) {
                _context7.next = 9;
                break;
              }

              (0,helperServices/* showSpinner */.yh)();
              _context7.next = 6;
              return router.push("".concat(helperServices/* urlPrefix */.wn, "/cart"));

            case 6:
              (0,helperServices/* hideSpinner */.v3)();
              _context7.next = 11;
              break;

            case 9:
              refreshState();

              if (currentActiveStep == "review" && journey !== checkout_journey_context/* journeyType.upgrade */.w.upgrade && checkoutDetails.skipCreditVetting) {
                //Redirect to let's get started page
                handleNextStep("authentication");
              } else {
                previousStep = currentActiveStep;

                if (journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade) {
                  previousStep = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$upgr3 = constants/* CHECKOUT_CONFIG.upgradeJourneyWithPayment */.e9.upgradeJourneyWithPayment[currentActiveStep]) === null || _CHECKOUT_CONFIG$upgr3 === void 0 ? void 0 : _CHECKOUT_CONFIG$upgr3.prevStep : (_CHECKOUT_CONFIG$upgr4 = constants/* CHECKOUT_CONFIG.upgradeJourney */.e9.upgradeJourney[currentActiveStep]) === null || _CHECKOUT_CONFIG$upgr4 === void 0 ? void 0 : _CHECKOUT_CONFIG$upgr4.prevStep;
                } else {
                  previousStep = numberTransferEnabled && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$newL5 = constants/* CHECKOUT_CONFIG.newLineJourneyWithNumberTransferPayment */.e9.newLineJourneyWithNumberTransferPayment[currentActiveStep]) === null || _CHECKOUT_CONFIG$newL5 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL5.prevStep : numberTransferEnabled ? (_CHECKOUT_CONFIG$newL6 = constants/* CHECKOUT_CONFIG.newLineJourneyWithNumberTransfer */.e9.newLineJourneyWithNumberTransfer[currentActiveStep]) === null || _CHECKOUT_CONFIG$newL6 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL6.prevStep : cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? (_CHECKOUT_CONFIG$newL7 = constants/* CHECKOUT_CONFIG.newLineJourneyWithPayment */.e9.newLineJourneyWithPayment[currentActiveStep]) === null || _CHECKOUT_CONFIG$newL7 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL7.prevStep : (_CHECKOUT_CONFIG$newL8 = constants/* CHECKOUT_CONFIG.newLineJourney */.e9.newLineJourney[currentActiveStep]) === null || _CHECKOUT_CONFIG$newL8 === void 0 ? void 0 : _CHECKOUT_CONFIG$newL8.prevStep;
                }

                setLabels(previousStep);
                setActiveStep(previousStep);
              }

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleBackStep() {
      return _ref4.apply(this, arguments);
    };
  }();

  var _handlePrimaryClick4 = function _handlePrimaryClick4(url, label) {
    (0,helperServices/* showSpinner */.yh)();
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": ").concat(label),
      page_name: "".concat(pageName)
    });

    if (url) {
      router.push("".concat(helperServices/* urlPrefix */.wn).concat(url)).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      router.push("".concat(helperServices/* urlPrefix */.wn, "/cart")).then(function () {
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  var setLabels = function setLabels(step) {
    switch (step) {
      case "login":
        heading.title = "How would you like to check out?";
        heading.titleClass = "login-title";
        heading.desc = "";
        heading.descClass = "login-desc";
        heading.id = "login";
        heading["class"] = "login";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back to cart";
        button.backButtonId = "back-login";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;

      case "authentication":
        heading.title = "Let’s get started";
        heading.titleClass = "authentication-title";
        heading.desc = "";
        heading.descClass = "authentication-desc";
        heading.id = "authentication";
        heading["class"] = "authentication";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-authentication";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;

      case "otp":
        heading.title = "Authorise this upgrade";
        heading.titleClass = "otp-title";
        heading.desc = "We’ve sent a One-Time PIN (OTP) to 082****123 in order for you to authorise this upgrade";
        heading.descClass = "otp-desc";
        heading.id = "otp";
        heading["class"] = "otp";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-otp";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "xds":
        heading.title = "Authentication questions";
        heading.titleClass = "xds-title";
        heading.desc = "For your protection, please answer the following questions to authenticate this application.";
        heading.descClass = "xds-desc d-none";
        heading.id = "xds";
        heading["class"] = "xds";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-xds";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "creditCheck":
        heading.title = "Credit check";
        heading.titleClass = "credit-check-title";
        heading.desc = "In order to process your application, we’ll need the following information to submit a credit check";
        heading.descClass = "credit-check-desc";
        heading.id = "credit-check";
        heading["class"] = "credit-check";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-credit-check";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "numberTransfer":
        heading.title = "Transfer a prepaid number";
        heading.titleClass = "number-transfer-title";
        heading.desc = "";
        heading.descClass = "number-transfer-desc";
        heading.id = "number-transfer";
        heading["class"] = "number-transfer";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-number-transfer";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "delivery":
        heading.title = "Delivery details";
        heading.titleClass = "delivery-title";
        heading.desc = "";
        heading.descClass = "delivery-desc";
        heading.id = "delivery";
        heading["class"] = "delivery";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-delivery";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "review":
        heading.title = "Review your order";
        heading.titleClass = "review-title";
        heading.desc = "Make sure you're 100% happy before continuing";
        heading.descClass = "review-desc";
        heading.id = "review";
        heading["class"] = "review";
        button.secure = false;
        button.payment = true;
        button.lable = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && paymentOptionsEnabled ? "Continue" : journey == checkout_journey_context/* journeyType.upgrade */.w.upgrade ? "Submit upgrade" : "Submit application";
        button.backLable = "Back";
        button.backButtonId = "back-review";
        button.backButtonClass = "";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = true;
        break;

      case "payment":
        heading.title = "Payment";
        heading.titleClass = "payment-title";
        heading.desc = "";
        heading.descClass = "payment-desc";
        heading.id = "payment";
        heading["class"] = "payment";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-payment";
        button.backButtonClass = "";
        button.disable = true;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "paymentRedirect":
        heading.title = "";
        heading.titleClass = "payment-redirect-title";
        heading.desc = "";
        heading.descClass = "payment-redirect-desc";
        heading.id = "payment-redirect";
        heading["class"] = "payment-redirect";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-payment-redirect";
        button.backButtonClass = "";
        button.disable = true;
        orderSummery.variant = "pop-up";
        steps.show = true;
        break;

      case "orderConfirmation":
        heading.title = "Order confirmation";
        heading.titleClass = "order-confirmation-title";
        heading.desc = "";
        heading.descClass = "order-confirmation-desc";
        heading.id = "order-confirmation";
        heading["class"] = "order-confirmation";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back";
        button.backButtonId = "back-order-confirmation";
        button.backButtonClass = "d-none";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = true;
        break;

      default:
        heading.title = "";
        heading.titleClass = "";
        heading.desc = "";
        heading.descClass = "";
        heading.id = "";
        heading["class"] = "";
        button.secure = false;
        button.payment = false;
        button.lable = "Continue";
        button.backLable = "Back to cart";
        button.backButtonId = "back-cart";
        button.backButtonClass = "d-none";
        button.disable = false;
        orderSummery.variant = "plain";
        steps.show = false;
        break;
    }

    setState(post_checkout_objectSpread(post_checkout_objectSpread({}, state), {}, {
      heading: heading,
      button: button,
      orderSummery: orderSummery,
      steps: steps
    }));
  };

  var checkContinueDisableStatus = function checkContinueDisableStatus(status) {
    setContinueDisabled(status);
  };

  var refreshState = function refreshState() {
    setContinueDisabled(true);
  };

  var hideLoginModal = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              setShowLoginModal(false);
              _context8.next = 4;
              return router.push("".concat(helperServices/* urlPrefix */.wn, "/cart"));

            case 4:
              (0,helperServices/* hideSpinner */.v3)();

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function hideLoginModal() {
      return _ref5.apply(this, arguments);
    };
  }();

  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;
  var isMiniApp = (0,helperServices/* getCookieValue */.Do)("miniApp") === "true";

  var hideErrorModal = function hideErrorModal() {
    (0,helperServices/* showSpinner */.yh)();
    (0,helperServices/* hideSpinner */.v3)();
    window.location = loginUrl + "?redirectUrl=" + redirectURL + (isMiniApp ? "&app=true" : "");
  };

  var handleHeading = function handleHeading(type, section, value) {
    var classStr = section == "title" ? "titleClass" : "descClass";

    if (Object.prototype.hasOwnProperty.call(heading, section)) {
      if (type == "update") {
        heading[section] = value;
      } else if (type == "hide") {
        heading[classStr] = "d-none";
      } else {
        heading[classStr] = heading.id + "-" + section;
      }

      setState(post_checkout_objectSpread(post_checkout_objectSpread({}, state), {}, {
        heading: heading
      }));
    }
  };

  var leadSubmissonContent = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      var result;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "errorResultDetails", ["NXTLVLLeadSubmitted_multicart"]);

            case 2:
              result = _context9.sent;
              return _context9.abrupt("return", result);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function leadSubmissonContent() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handlePrimaryNxtLvlClick = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
      var pageName, label, nexLvlMulticartFormPayload, _formResponse$respons, _formResponse$respons2, formResponse, formResult, _cartDetails$billing_, _cartDetails$billing_2, result, _formResponse$error, _formResponse$error2;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              pageName = "checkout: credit check: ".concat(customerStatus, ": nxt lvl");
              label = "call me";
              nexLvlMulticartFormPayload = {
                channel: "ONLINE",
                requestType: "next_level_cust",
                idNumber: authDetailsData !== null && authDetailsData !== void 0 && authDetailsData.idNumber ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.idNumber : "",
                idDocType: "SAID",
                name: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.firstName ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.firstName : "",
                surname: personalDetailsData !== null && personalDetailsData !== void 0 && personalDetailsData.surName ? personalDetailsData === null || personalDetailsData === void 0 ? void 0 : personalDetailsData.surName : "",
                msisdn: (0,helperServices/* africaCountryCode */.xJ)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn) ? authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn : (0,helperServices/* appendCountryCode */.yT)(authDetailsData === null || authDetailsData === void 0 ? void 0 : authDetailsData.msisdn),
                emailAddress: contactDetailsData === null || contactDetailsData === void 0 ? void 0 : contactDetailsData.emailAddress
              };
              analyticsUtag/* link */.p4({
                link_type: "o",
                link_name: "".concat(pageName, ": ").concat(label)
              });
              _context10.prev = 5;
              _context10.next = 8;
              return microServices/* default.post */.Z.post("api", "staticFormSubmit", nexLvlMulticartFormPayload, null, false);

            case 8:
              formResponse = _context10.sent;
              formResult = (_formResponse$respons = formResponse.response) === null || _formResponse$respons === void 0 ? void 0 : (_formResponse$respons2 = _formResponse$respons.data) === null || _formResponse$respons2 === void 0 ? void 0 : _formResponse$respons2.result;

              if (!(formResult !== null && formResult !== void 0 && formResult.successful)) {
                _context10.next = 19;
                break;
              }

              _context10.next = 13;
              return leadSubmissonContent();

            case 13:
              result = _context10.sent;
              setPageErr({
                type: "error",
                title: result[0].resultTitle,
                desc: cartDetails !== null && cartDetails !== void 0 && (_cartDetails$billing_ = cartDetails.billing_address) !== null && _cartDetails$billing_ !== void 0 && _cartDetails$billing_.telephone ? "".concat(labels/* default.order_messages_labels.lbl_consultant_phone */.Z.order_messages_labels.lbl_consultant_phone, " ").concat((0,upgradeService/* maskMsisdn */.Ly)(cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$billing_2 = cartDetails.billing_address) === null || _cartDetails$billing_2 === void 0 ? void 0 : _cartDetails$billing_2.telephone)) : result[0].resultText && result[0].resultText !== "" ? result[0].resultText : result[0].resultHTML,
                primaryLabel: result[0].primaryEnabled ? result[0].primaryCTAText : null,
                secondaryLabel: result[0].secondaryEnabled ? result[0].secondaryCTAText : null,
                handlePrimaryClick: function handlePrimaryClick() {
                  return _handleSecondaryClick(result[0].primaryCTAURL, pageName, "exit", true);
                },
                imgUrl: result[0].icon,
                pageName: pageName
              });
              (0,helperServices/* hideSpinner */.v3)();
              handleNextStep("pageError");
              _context10.next = 20;
              break;

            case 19:
              if (formResponse !== null && formResponse !== void 0 && (_formResponse$error = formResponse.error) !== null && _formResponse$error !== void 0 && _formResponse$error.status) {
                fetchErrorDetails("creditVettingOutcome_".concat(formResponse === null || formResponse === void 0 ? void 0 : (_formResponse$error2 = formResponse.error) === null || _formResponse$error2 === void 0 ? void 0 : _formResponse$error2.status));
              } else {
                fetchErrorDetails(labels/* default.auth.errorCodes.api_time_out */.Z.auth.errorCodes.api_time_out);
              }

            case 20:
              _context10.next = 25;
              break;

            case 22:
              _context10.prev = 22;
              _context10.t0 = _context10["catch"](5);
              (0,helperServices/* hideSpinner */.v3)();

            case 25:
              _context10.prev = 25;
              removeCreditCheckStates(null);
              return _context10.finish(25);

            case 28:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[5, 22, 25, 28]]);
    }));

    return function handlePrimaryNxtLvlClick() {
      return _ref7.apply(this, arguments);
    };
  }();

  var replaceStaticAmount = function replaceStaticAmount(str, amount) {
    if (str && str !== "" && amount && str.match(/{{amount}}/g)) {
      return str.replace("{{amount}}", amount);
    } else {
      return str;
    }
  }; //Will be replaced with React components


  var stepLogin = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: profileSyncFail ? /*#__PURE__*/(0,jsx_runtime.jsx)(SyncError/* default */.Z, {
      navigate: handleNextStep,
      handleCancel: hideErrorModal
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
      show: showLoginModal,
      handleCancel: hideLoginModal,
      navigate: handleNextStep,
      applicationType: "normal",
      redirectTo: redirectURL,
      setGuestCart: function setGuestCart() {
        return addGuestCartProducts(cartItems, cartDetails.totalQuantity, cartDetails.applied_coupons);
      },
      resetGuestCart: function resetGuestCart() {
        return addGuestCartProducts([], 0, null);
      }
    })
  });

  var stepAuthentication = /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutAuthentication_CheckoutAuthentication, {
    ref: postCheckoutPageRef,
    formContent: formContent,
    userLoggedIn: userLoggedIn,
    profileData: profileData ? profileData : null,
    authDetails: authDetails ? authDetails : null,
    customerStatus: customerStatus,
    dealID: dealID,
    contractType: contractType,
    navigate: handleNextStep,
    setShowSnackBar: setShowSnackBar,
    setPageErr: setPageErr,
    setJourneyStepTracker: setJourneyStepTracker,
    features: features,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti,
    handlePrimaryNxtLvlClick: handlePrimaryNxtLvlClick
  });

  var stepOtp = /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutMahAuthentication_CheckoutMahAuthentication, {
    ref: postCheckoutPageRef,
    userLoggedIn: userLoggedIn,
    profileData: profileData ? profileData : null,
    authDetails: authDetails ? authDetails : null,
    customerStatus: customerStatus,
    dealID: dealID,
    contractType: contractType,
    continueDisable: checkContinueDisableStatus,
    navigate: handleNextStep,
    setShowTooltip: setShowSnackBar,
    setPageErr: setPageErr,
    setJourneyStepTracker: setJourneyStepTracker,
    handleHeading: handleHeading,
    currentJourney: journey,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti,
    numberTransferEnabled: numberTransferEnabled
  });

  var stepXds = /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutXds_CheckoutXds, {
    ref: postCheckoutPageRef,
    checkoutDetails: checkoutDetails,
    continueDisable: checkContinueDisableStatus,
    userLoggedIn: userLoggedIn,
    profileData: profileData ? profileData : null,
    authDetails: authDetails ? authDetails : null,
    customerStatus: customerStatus,
    navigate: handleNextStep,
    setShowSnackBar: setShowSnackBar,
    handleHeading: handleHeading,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti
  });

  var stepCreditCheck = /*#__PURE__*/(0,jsx_runtime.jsx)(checkoutCreditCheck_CheckoutCreditCheck, {
    ref: postCheckoutPageRef,
    continueDisable: checkContinueDisableStatus,
    userLoggedIn: userLoggedIn,
    profileData: profileData ? profileData : null,
    authDetails: authDetails ? authDetails : null,
    customerStatus: customerStatus,
    addressTypes: addressTypes,
    statesTypes: regions,
    shippingAddress: shippingAddress ? shippingAddress : null,
    countryCode: countryCode,
    countryName: countryName,
    setShowSnackBar: setShowSnackBar,
    navigate: handleNextStep,
    setPageErr: setPageErr,
    setDisableBackButton: setDisableBackButton,
    handleHeading: handleHeading,
    carrierCode: carrierCode,
    methodCode: methodCode,
    dealCategoryId: dealCategoryId,
    currentJourneyType: journey,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti,
    numberTransferEnabled: numberTransferEnabled,
    setShowOnceOff: setShowOnceOff
  });

  var stepNumberTransfer = /*#__PURE__*/(0,jsx_runtime.jsx)(NumberTransfer_NumberTransfer, {
    ref: postCheckoutPageRef,
    continueDisable: checkContinueDisableStatus,
    navigate: handleNextStep,
    setShowSnackBar: setShowSnackBar,
    handleHeading: handleHeading,
    customerStatus: customerStatus,
    currentJourneyType: journey,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti
  });

  var stepDelivery = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutDelivery/* default */.Z, {
    ref: postCheckoutPageRef,
    continueDisable: checkContinueDisableStatus,
    addressTypes: addressTypes,
    statesTypes: regions,
    countryCode: countryCode,
    countryName: countryName,
    cartId: cartId,
    navigate: handleNextStep,
    shippingMessageText: shippingMessageText,
    shippingFeeCalculateAmount: shippingFeeCalculateAmount,
    subTotal: allPrices && allPrices.subtotal_including_tax && allPrices.subtotal_including_tax.value ? allPrices.subtotal_including_tax.value : 0,
    shippingAddress: shippingAddress ? shippingAddress : null,
    billingAddress: billingAddress ? billingAddress : null,
    isGuestUser: userLoggedIn ? false : true,
    profileData: profileData ? profileData : null,
    authDetails: authDetails ? authDetails : null,
    customerStatus: customerStatus,
    setShowSnackBar: setShowSnackBar,
    setPageErr: setPageErr,
    carrierCode: carrierCode,
    methodCode: methodCode,
    applicationType: "contract",
    currentJourneyType: journey,
    clickAndCollectDelivery: clickAndCollectDelivery,
    dealID: primaryProductSku,
    clickAndCollectEnabled: clickAndCollectEnabled
  });

  var stepReview = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutReview/* default */.Z, {
    ref: postCheckoutPageRef,
    cartProducts: cartItems,
    continueDisable: checkContinueDisableStatus,
    addressTypes: addressTypes,
    statesTypes: regions,
    countryCode: countryCode,
    countryName: countryName,
    cartId: cartId,
    navigate: handleNextStep,
    totalPrice: allPrices && allPrices.grand_total && allPrices.grand_total.value ? allPrices.grand_total.value : 0,
    totalQuantity: cartDetails.totalQuantity ? cartDetails.totalQuantity : 0,
    shippingAddress: shippingAddress ? shippingAddress : null,
    userLoggedIn: userLoggedIn,
    profileData: profileData,
    authDetails: authDetails,
    customerStatus: customerStatus,
    applicationType: "contract",
    currentJourneyType: journey,
    cartDetails: cartDetails
  });

  var stepPayment = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutPayment/* default */.Z, {
    ref: postCheckoutPageRef,
    continueDisable: checkContinueDisableStatus,
    cartId: cartId,
    navigate: handleNextStep,
    userLoggedIn: userLoggedIn,
    profileData: profileData,
    authDetails: authDetails,
    paymentConfiguration: paymentConfiguration,
    customerStatus: customerStatus,
    applicationType: "contract",
    currentJourneyType: journey,
    cartDetails: cartDetails
  });

  var stepPaymentRedirect = /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentRedirect/* default */.Z, {
    navigate: handleNextStep,
    customerStatus: customerStatus,
    userLoggedIn: userLoggedIn,
    profileData: profileData,
    authDetails: authDetails,
    paymentConfiguration: paymentConfiguration,
    applicationType: "contract",
    paymentOptionsEnabled: paymentOptionsEnabled
  });

  var stepPaymentError = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutPaymentError/* default */.Z, {
    navigate: handleNextStep,
    userLoggedIn: userLoggedIn,
    profileData: profileData,
    authDetails: authDetails,
    paymentConfiguration: paymentConfiguration,
    customerStatus: customerStatus,
    applicationType: "contract",
    paymentOptionsEnabled: paymentOptionsEnabled
  });

  var stepOrderConfirmation = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutOrderConfirmation/* default */.Z, {
    navigate: handleNextStep,
    cartProducts: cartItems,
    userLoggedIn: userLoggedIn,
    profileData: profileData,
    authDetails: authDetails,
    customerStatus: customerStatus,
    setShowSnackBar: setShowSnackBar,
    setPageErr: setPageErr,
    applicationType: "contract"
  });

  var stepPageError = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutPageError/* default */.Z, {
    type: pageErr.type,
    title: pageErr.title,
    desc: pageErr.desc,
    primaryLabel: pageErr.primaryLabel,
    primaryUrl: pageErr.primaryUrl,
    secondaryLabel: pageErr.secondaryLabel,
    secondaryUrl: pageErr.secondaryUrl,
    handlePrimaryClick: pageErr.handlePrimaryClick,
    handleSecondaryClick: pageErr.handleSecondaryClick,
    imgUrl: pageErr.imgUrl,
    pageName: pageErr.pageName,
    pageErrorType: pageErr.pageErrorType,
    additionalUtagData: pageErr.additionalUtagData,
    applicationType: "contract",
    dividerLine: pageErr.dividerLine,
    subTitle: pageErr.subTitle,
    subDesc: pageErr.subDesc,
    ctaTitle: pageErr.ctaTitle,
    disablePrimary: pageErr.disablePrimary,
    preferences: pageErr.preferences,
    defaultPreference: pageErr.defaultPreference,
    dealProducts: dealCartProducts,
    cartItems: cartItems,
    multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti,
    analyticsPageErrorCode: pageErr.analyticsPageErrorCode,
    analyticsPageErrorMessage: pageErr.analyticsPageErrorMessage,
    onceOffCartProducts: onceOffCartProducts
  });

  var renderLeftSectionDisplay = function renderLeftSectionDisplay(step) {
    var display;

    switch (step) {
      case "login":
        display = stepLogin; //replace with React component

        break;

      case "authentication":
        display = stepAuthentication; //replace with React component

        break;

      case "otp":
        display = stepOtp; //replace with React component

        break;

      case "xds":
        display = stepXds; //replace with React component

        break;

      case "creditCheck":
        display = stepCreditCheck; //replace with React component

        break;

      case "numberTransfer":
        display = stepNumberTransfer; //replace with React component

        break;

      case "delivery":
        display = stepDelivery; //replace with React component

        break;

      case "review":
        display = stepReview; //replace with React component

        break;

      case "payment":
        display = stepPayment; //replace with React component

        break;

      case "paymentRedirect":
        display = stepPaymentRedirect; //replace with React component

        break;

      case "paymentError":
        display = stepPaymentError; //replace with React component

        break;

      case "orderConfirmation":
        display = stepOrderConfirmation; //replace with React component

        break;

      case "pageError":
        display = stepPageError; //replace with React component

        break;

      default:
        //replace with react components
        display = null;
        break;
    }

    return display;
  };

  var renderRightSectionDisplay = function renderRightSectionDisplay(step) {
    var display;

    switch (step) {
      case "authentication":
        display = /*#__PURE__*/(0,jsx_runtime.jsx)(formRightSidebar_FormRightSidebar, {
          content: sidebarContent,
          pageName: "checkout: lets get started: ".concat(customerStatus),
          formName: "faq",
          pageChannel: "checkout",
          linkId: "see-faq-question-link",
          linkPrevent: true
        });
        break;

      default:
        display = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutOrderSummary/* default */.Z, {
            variant: state.orderSummery.variant,
            btnSecure: state.button.secure,
            btnPayment: state.button.payment,
            btnLable: state.button.lable,
            btnDisabled: continueDisabled || !allowPlaceOrder,
            onClickSubmit: onClickSubmit,
            navigate: handleNextStep,
            monthlyCartProducts: monthlyCartProducts,
            dealProducts: dealCartProducts,
            onceOffCartProducts: onceOffCartProducts,
            contractType: contractType,
            pageType: "contract",
            delivery: labels/* default.lbl_free */.Z.lbl_free,
            customerStatus: customerStatus,
            setPageErr: setPageErr,
            currentJourneyType: journey,
            shippingAddress: shippingAddress ? shippingAddress : null,
            addressTypes: addressTypes,
            subTotal: onceOffSubTotal,
            total: (0,helperServices/* getCartGrandTotal */.h_)(cartDetails),
            cartDetails: cartDetails,
            showOnceOffProducts: showOnceOff,
            activeStep: activeStep,
            buttonPaymentPageName: "review order",
            paymentOptionsEnabled: paymentOptionsEnabled,
            continueDisable: checkContinueDisableStatus
          }), (cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti) && showOnceOff && (activeStep === "review" || activeStep === "payment") && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (CheckoutPage_module_default())["notify-wrapper"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationBox/* default */.Z, {
              className: (CheckoutPage_module_default())["notify-container"],
              img_path: notificationContent ? notificationContent.icon : "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/rect.svg"),
              labelBold: notificationContent ? replaceStaticAmount(notificationContent.title, onceOffSubTotal) : "You\u2019ll only pay ".concat(onceOffSubTotal, " now."),
              labelNormal: notificationContent ? notificationContent.description : labels/* default.lbl_multi_onceoff_msg */.Z.lbl_multi_onceoff_msg,
              labelStyling: (CheckoutPage_module_default()).msg,
              textStyle: (CheckoutPage_module_default())["text-style"],
              link: false,
              img_width: "1.5rem",
              img_height: "1.5rem"
            })
          })]
        });
        break;
    }

    return display;
  };

  var renderFullSectionDisplay = function renderFullSectionDisplay(step) {
    var display;

    if (step) {
      switch (step) {
        case "login":
        case "authentication":
          display = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((CheckoutPage_module_default())["top-wrapper"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                text: state.heading.title,
                className: "".concat((CheckoutPage_module_default())["top-wrapper__heading"], " ").concat(state.heading.titleClass, "\n                "),
                id: "checkout-".concat(state.heading.id, "-heading")
              }), state.heading.desc !== "" && /*#__PURE__*/(0,jsx_runtime.jsx)(PageDescription/* default */.Z, {
                text: state.heading.desc,
                className: "".concat((CheckoutPage_module_default())["top-wrapper__desc"], " ").concat(state.heading.descClass),
                id: "checkout-".concat(state.heading.id, "-desc")
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((CheckoutPage_module_default())["post-checkout-main-section"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((CheckoutPage_module_default()).left),
                children: renderLeftSectionDisplay(step)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((CheckoutPage_module_default()).right),
                children: renderRightSectionDisplay(step)
              })]
            })]
          });
          break;

        default:
          display = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((CheckoutPage_module_default())["main-section"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((CheckoutPage_module_default())["col-left"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: "".concat((CheckoutPage_module_default())[heading["class"]], " ").concat((CheckoutPage_module_default())["top-wrapper"]),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                  text: state.heading.title,
                  className: "".concat((CheckoutPage_module_default())["top-wrapper__heading"], " ").concat(state.heading.titleClass),
                  id: "checkout-".concat(state.heading.id, "-heading")
                }), state.heading.desc !== "" && /*#__PURE__*/(0,jsx_runtime.jsx)(PageDescription/* default */.Z, {
                  text: state.heading.desc,
                  className: "".concat((CheckoutPage_module_default())["top-wrapper__desc"], " ").concat(state.heading.descClass),
                  id: "checkout-".concat(state.heading.id, "-desc")
                })]
              }), renderLeftSectionDisplay(step)]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat((CheckoutPage_module_default())["col-right"]),
              children: renderRightSectionDisplay(step)
            })]
          });
          break;
      }
    } else {
      display = null;
    }

    return display;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* default */.Z, {
      title: metadata === null || metadata === void 0 ? void 0 : metadata.title,
      content: metadata === null || metadata === void 0 ? void 0 : metadata.description,
      url: metadata === null || metadata === void 0 ? void 0 : metadata.canonical_url,
      keywords: metadata === null || metadata === void 0 ? void 0 : metadata.keywords,
      robots: metadata === null || metadata === void 0 ? void 0 : metadata.robots
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FlagsContext.Provider, {
      value: {
        vodacomPrepaidTransfer: vodacomPrepaidTransfer,
        otherPrepaidTransfer: otherPrepaidTransfer
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(checkout_journey_context/* CheckoutJourneyContext.Provider */.m.Provider, {
        value: journeyProviderValue,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckoutPage/* default */.Z, {
          steps: state.steps.all,
          stepsShow: state.steps.show,
          stepsWidth: state.steps.width,
          activeStep: activeStep,
          activeStepNo: activeStepNo,
          handleNextStep: handleNextStep,
          className: (CheckoutPage_module_default())[state.heading["class"]],
          customerStatus: customerStatus,
          orderSummeryVariant: state.orderSummery.variant,
          faq: activeStep == "authentication" ? faq : null,
          showSnackBar: showSnackBar,
          setShowSnackBar: setShowSnackBar,
          multicartFlag: cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti,
          children: [activeStep !== "login" && activeStep !== "paymentRedirect" && activeStep !== "paymentError" && activeStep !== "orderConfirmation" && activeStep !== "pageError" ? /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
            className: "".concat((CheckoutPage_module_default())["back-button"], " ").concat(state.button.backButtonClass),
            labelText: state.button.backLable,
            img_url_inactive: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/caret-back.svg"),
            img_url_active: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/caret-back.svg"),
            img_url_disable: "".concat(helperServices/* imagePrefix */.Sj, "/assets/images/disable-caret-back.svg"),
            clickHandler: handleBackStep,
            id: "checkout-".concat(state.button.backButtonId),
            disableBackButton: state.button.disable
          }) : null, activeStep == "login" || activeStep == "paymentRedirect" || activeStep == "paymentError" || activeStep == "orderConfirmation" || activeStep == "pageError" ? renderLeftSectionDisplay(activeStep) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            noGutters: true,
            className: "".concat((CheckoutPage_module_default())["main-row"]),
            children: renderFullSectionDisplay(activeStep)
          })]
        })
      })
    })]
  });
};

var post_checkout_mapStateToProps = function mapStateToProps(state) {
  return {
    cartDetails: state.cartDetails,
    cartProductItems: state.cartDetails.cartProductItems,
    personalDetailsData: state.creditCheckDetails.personalDetails,
    contactDetailsData: state.creditCheckDetails.contactDetails,
    checkoutDetails: state.checkoutDetails,
    profileData: state.navDetails.profileData,
    authDetailsData: state.checkoutDetails.authDetailsData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    creditVettingDetails: state.checkoutDetails.creditVettingResult
  };
};

var post_checkout_mapDispatchToProps = {
  setPostCheckoutCurrentStep: checkoutAction/* setPostCheckoutCurrentStep */.Gr,
  addGuestCartProducts: cartAction/* addGuestCartProducts */.Pj,
  addBundleProductToGuestCart: cartAction/* addBundleProductToGuestCart */.HJ,
  removeCreditCheckStates: checkoutAction/* removeCreditCheckStates */.nK,
  addCouponToCart: cartAction/* addCouponToCart */.vD,
  addSimpleProductToGuestCart: cartAction/* addSimpleProductToGuestCart */.a1,
  addConfigurableToGuestCart: cartAction/* addConfigurableToGuestCart */.bc,
  setCartMulti: cartAction/* setCartMulti */.TX,
  showGuestCart: cartAction/* showGuestCart */.cD,
  setHelpLeadBucket: getHelpAction/* setHelpLeadBucket */.A,
  setPaymentMethodUrl: checkoutAction/* setPaymentMethodUrl */.RL,
  setPostOrderResponse: checkoutAction/* setPostOrderResponse */.wg
};
/* harmony default export */ var post_checkout = ((0,DependencyHelper.connect)(post_checkout_mapStateToProps, post_checkout_mapDispatchToProps)(PostCheckout));

/***/ }),

/***/ 41807:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/post-checkout",
      function () {
        return __webpack_require__(26329);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70542:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ErrorInformation_main-container__G1lqq","icon":"ErrorInformation_icon__nd1uy","title":"ErrorInformation_title___uoPf","subtitle":"ErrorInformation_subtitle__yidr7","subtitle-separator":"ErrorInformation_subtitle-separator__35X8G","desc":"ErrorInformation_desc__Spf_a","button-wrapper":"ErrorInformation_button-wrapper__GqRxH","button":"ErrorInformation_button__Wopxs","success-exit":"ErrorInformation_success-exit__4kpuk","outline-black":"ErrorInformation_outline-black__0S_0_","auto-width":"ErrorInformation_auto-width__dSNMv","success-btn":"ErrorInformation_success-btn__cJDzb"};

/***/ }),

/***/ 43092:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FormRightSidebar_container__Y47lA","heading":"FormRightSidebar_heading__O7Z62","content":"FormRightSidebar_content__UuvF1","item":"FormRightSidebar_item__qdayY","link-button":"FormRightSidebar_link-button__XcqVL"};

/***/ }),

/***/ 83785:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-details-container":"CreditCheckDetails_form-details-container__f_2Hu","pb-1":"CreditCheckDetails_pb-1__QzihO","pb-6":"CreditCheckDetails_pb-6__I6SlN"};

/***/ }),

/***/ 5820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ConsentResultsForm_main-container__TzaLV","main-row":"ConsentResultsForm_main-row__mPdcA","form-group":"ConsentResultsForm_form-group__fpNIE","form-checkbox-label":"ConsentResultsForm_form-checkbox-label__uvk0y"};

/***/ }),

/***/ 38957:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"OutcomeInformation_main-container__WS3Jl","icon":"OutcomeInformation_icon__iM41O","title":"OutcomeInformation_title__Rp8EC","desc":"OutcomeInformation_desc__k_a3G"};

/***/ }),

/***/ 68390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"XdsForm_main-container__PHkjQ","main-row":"XdsForm_main-row__4zokK","form-group":"XdsForm_form-group__s7M8_"};

/***/ }),

/***/ 58333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ResultInformation_main-container__KKIRY","icon":"ResultInformation_icon__LRA0X","title":"ResultInformation_title__ZHiV3","desc":"ResultInformation_desc__y6KPx"};

/***/ }),

/***/ 55452:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"warningTitle":"WarningTitle_warningTitle__5leDB","warningTitle__heading":"WarningTitle_warningTitle__heading__JRc6i","icon":"WarningTitle_icon__XWP5E","title":"WarningTitle_title__TdASJ","warningTitle__content":"WarningTitle_warningTitle__content__9_uxb","desc":"WarningTitle_desc__s2IcS"};

/***/ }),

/***/ 93171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"delivery-container":"NotificationBox_delivery-container__wbQ4f","img":"NotificationBox_img__xvXBp","msg":"NotificationBox_msg__Ulngq","text-style":"NotificationBox_text-style__BNZM9","terms":"NotificationBox_terms___O_gR"};

/***/ }),

/***/ 90356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"number-transfer-step":"numberTransferTypes_number-transfer-step__q9TkW","number-transfer-step__subtitle":"numberTransferTypes_number-transfer-step__subtitle__pg_cq","number-transfer-step__snackbar":"numberTransferTypes_number-transfer-step__snackbar__RH3X8","number-transfer-step__snackbar-close":"numberTransferTypes_number-transfer-step__snackbar-close__l1rvP","number-transfer-snack-bar":"numberTransferTypes_number-transfer-snack-bar__QY8bM","number-transfer-button-wrapper":"numberTransferTypes_number-transfer-button-wrapper__zX65i","number-transfer-button":"numberTransferTypes_number-transfer-button__Ryvsi","number-transfer-button__disabled":"numberTransferTypes_number-transfer-button__disabled___HI74","number-transfer-types__wrapper":"numberTransferTypes_number-transfer-types__wrapper__DTMce","number-transfer-types__option":"numberTransferTypes_number-transfer-types__option__XTAOh","number-transfer-types__option__selected":"numberTransferTypes_number-transfer-types__option__selected__XMGEF","number-transfer-types__option__title":"numberTransferTypes_number-transfer-types__option__title__eynl_","number-transfer-number-main-container":"numberTransferTypes_number-transfer-number-main-container__2xcnu","number-transfer-general-info__box":"numberTransferTypes_number-transfer-general-info__box__PUOyg","number-transfer-general-info__icon":"numberTransferTypes_number-transfer-general-info__icon__DWo4_","number-transfer-general-info__title":"numberTransferTypes_number-transfer-general-info__title__uP7ti","number-transfer-general-info__description":"numberTransferTypes_number-transfer-general-info__description__GPstd","number-transfer-general-info__button":"numberTransferTypes_number-transfer-general-info__button__3njKW","number-transfer-general-info__arrow":"numberTransferTypes_number-transfer-general-info__arrow__gakb8","contact_container":"numberTransferTypes_contact_container__k9WY_"};

/***/ }),

/***/ 21373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutCreditCheck_container__ZaLnk","standard-box":"CheckoutCreditCheck_standard-box__124lP","form-heading":"CheckoutCreditCheck_form-heading__A_G7E","section-icon":"CheckoutCreditCheck_section-icon__WGVtA","section-success-icon":"CheckoutCreditCheck_section-success-icon__rCv3j","section-numbers":"CheckoutCreditCheck_section-numbers__H_i5m","section-description":"CheckoutCreditCheck_section-description__re_4U","warning-box":"CheckoutCreditCheck_warning-box__n2H5j","button-wrapper":"CheckoutCreditCheck_button-wrapper__ADrU9","button":"CheckoutCreditCheck_button__AZJBX","search-wrapper":"CheckoutCreditCheck_search-wrapper__0MrWk","search-wrapper__input":"CheckoutCreditCheck_search-wrapper__input__gwq2P","pt-2":"CheckoutCreditCheck_pt-2__KNyCY"};

/***/ }),

/***/ 46365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mt-m":"DeliveryDetails_mt-m__RjTeK","mtb-m":"DeliveryDetails_mtb-m__oCv0Z","courier":"DeliveryDetails_courier__ST_pd","delivery-selection__heading":"DeliveryDetails_delivery-selection__heading__pC8gO","delivery-selection":"DeliveryDetails_delivery-selection__JuRcc","select-row":"DeliveryDetails_select-row__RWXrA","select-group":"DeliveryDetails_select-group__3zOzx","home-address":"DeliveryDetails_home-address__NhZv_","tiles-section":"DeliveryDetails_tiles-section__UjiiT","another-address__heading":"DeliveryDetails_another-address__heading__nzZYA","contact":"DeliveryDetails_contact__97TDc","contact__heading":"DeliveryDetails_contact__heading__4INiF","contact__value":"DeliveryDetails_contact__value__1B61R","store":"DeliveryDetails_store__tVsV2","seacrh-heading":"DeliveryDetails_seacrh-heading__MXv8Q"};

/***/ }),

/***/ 1421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoWithButton_container__ZFgDR","title":"InfoWithButton_title__DMrPa","description":"InfoWithButton_description__VcfMS","button":"InfoWithButton_button__KMPYp"};

/***/ }),

/***/ 99335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NumberCheckComponent_container__zIb3Q","dropdown-container":"NumberCheckComponent_dropdown-container__9BK2N","checkboxContainer":"NumberCheckComponent_checkboxContainer__6QOxo","checkboxText":"NumberCheckComponent_checkboxText__6MRSU","continueBtn":"NumberCheckComponent_continueBtn__XT8Cc","buttonContainer":"NumberCheckComponent_buttonContainer__XDCC6"};

/***/ }),

/***/ 69739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OtpComponent_container__Nvb_K","title":"OtpComponent_title__rtoiB","otpContainer":"OtpComponent_otpContainer__IfKi8","show-otp-container":"OtpComponent_show-otp-container__yShml","show-otp":"OtpComponent_show-otp__U18IS","buttonContainer":"OtpComponent_buttonContainer__WDgU2","continueBtn":"OtpComponent_continueBtn__eq1Pp","otpInput":"OtpComponent_otpInput__DRYmF","back-button":"OtpComponent_back-button__1gtMI"};

/***/ }),

/***/ 47932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"number-transfer-step":"numberTransfer_number-transfer-step__Ph1sB","number-transfer-step__subtitle":"numberTransfer_number-transfer-step__subtitle__5bgub","number-transfer-step__infobox":"numberTransfer_number-transfer-step__infobox__1_bdj","number-transfer-wrapper":"numberTransfer_number-transfer-wrapper__DmMXH","number-transfer-step__infobox-wraper":"numberTransfer_number-transfer-step__infobox-wraper__Lr_ha","number-transfer-step__infobox-hide":"numberTransfer_number-transfer-step__infobox-hide__gpp9O","number-transfer-step__icon-hide":"numberTransfer_number-transfer-step__icon-hide__2Esy8"};

/***/ }),

/***/ 845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutAuthentication_container__WBw3s","standard-box":"CheckoutAuthentication_standard-box__bP5z8","standard-box__desc":"CheckoutAuthentication_standard-box__desc__QaE0o","form-heading":"CheckoutAuthentication_form-heading__wF3_T","icon":"CheckoutAuthentication_icon__rEHFe","button-wrapper":"CheckoutAuthentication_button-wrapper__vJDec","button":"CheckoutAuthentication_button__m3Nb2","error-container":"CheckoutAuthentication_error-container___ng26"};

/***/ }),

/***/ 7254:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkout-container":"CheckoutCreditCheck_checkout-container__R_tkN","standard-box":"CheckoutCreditCheck_standard-box__fCV4Z","split-cart-message":"CheckoutCreditCheck_split-cart-message__1i1nl","section-icon":"CheckoutCreditCheck_section-icon__hshW7","form-wrapper":"CheckoutCreditCheck_form-wrapper__LpjwO","form-body":"CheckoutCreditCheck_form-body__OkZJc","form-heading":"CheckoutCreditCheck_form-heading__0dK1d"};

/***/ }),

/***/ 6564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutMahAuthentication_container__DRTaN","cantReceiveClass":"CheckoutMahAuthentication_cantReceiveClass__DOTcH","standard-box":"CheckoutMahAuthentication_standard-box___aAmy","information":"CheckoutMahAuthentication_information__lS0Ye","titleSection":"CheckoutMahAuthentication_titleSection__BjI_t","title":"CheckoutMahAuthentication_title__S89VC","description":"CheckoutMahAuthentication_description__Upo5W","otpComponentClass":"CheckoutMahAuthentication_otpComponentClass__UOFYV"};

/***/ }),

/***/ 95183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutXds_container__cWY_Y","standard-box":"CheckoutXds_standard-box__EqMCr","form":"CheckoutXds_form__mgPPn","information":"CheckoutXds_information__zO_zb","button-wrapper":"CheckoutXds_button-wrapper__fKsLX","button":"CheckoutXds_button__V6EpU","error-container":"CheckoutXds_error-container__wgi7j"};

/***/ }),

/***/ 77264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"debi_mandate_container":"DebicheckMandate_debi_mandate_container__OY6xG","debi_mandate_head":"DebicheckMandate_debi_mandate_head__jT6cM","debi_mandate_head_main":"DebicheckMandate_debi_mandate_head_main__nvwyd","debi_mandate_head_minor":"DebicheckMandate_debi_mandate_head_minor__cv8PU","debi_head_icon":"DebicheckMandate_debi_head_icon__EpRkG","debi_mandate_info":"DebicheckMandate_debi_mandate_info__twlBN","debi_mandate_check_container":"DebicheckMandate_debi_mandate_check_container__L6VNz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8282,805,9494,8497,5642,1927,9774,2888,179], function() { return __webpack_exec__(41807); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);